/**
 * Created by sunny on 10/04/17.
 *
 * Access any AnalyticsStore data with the AnalyticsHelper only.
 */
class AnalyticsStore {
    constructor() {
        this.analyticsData = {};
    }
    getAnalyticsData() {
        return this.analyticsData;
    }
    getAnalyticsProp(name) {
        return this.analyticsData[name];
    }
    setAnalyticsProp(name, value) {
        this.analyticsData[name] = value;
    }
    /**
     * Use this only via AnalyticsHelper which filter out client details
     * If used directly, do the filtering to retain host client details
     * @param clientInfo
     */
    resetAnalyticStore(clientInfo) {
        this.analyticsData = JSON.parse(JSON.stringify(clientInfo));
    }
}

/**
 * Created by sunny on 25/04/17.
 *
 * Note: session_id is unique connection session id generated by client
 */
let AnalyticsConstants = {
    memoryType: {
        APP_MEMORY: 'app_memory',
        LOCAL_STORAGE: 'local_storage'
    },
    // Other String required in core analytics files
    stringConstants: {
        TABLE: 'table_name',
        TABLE_TIME: 'table_time',
        event_category: 'event_category',
        LOCAL_STORAGE_Q: '_offlineAnalyticsQ' // key for local storage
    }
};

let AustinConfig = {
    ENABLE_LOGGING: true,
    LOGGING_LEVEL: 1,
    ANALYTICS: {
        URL: 'https://analytics.sling.com/html5',
        PAYLOAD_QUEUE_LIMIT: 21
    },
    PLAYER: {
        PTS_BASED_PROGRESS_UPDATION_ENABLED: true,
        BITMOVIN: {
            LICENCE_KEY: 'ba76e73c-3802-4daa-982b-570843ab82fc',
            MAX_BUFFERING_LEVEL_MS: 10000,
            BUFFERING_TO_START_PLAYBACK_MS: 1500,
            PIPELINE_REQUEST_COUNT: 3,
            PIPELINE_AUDIO_LIMIT: 3,
            PIPELINE_VIDEO_LIMIT: 3,
            //error will be throw if the playback did not start
            PLAYBACK_TIMEOUT_MS: 60000,
            LOAD_RETRY_COUNT: 3,
            PLAYBACK_RETRY_COUNT: 3,
            ANDROID_PLAYBACK_RETRY_COUNT: 0,
            REBUFFERING_THRESHOLD: 6,
            UNLOAD_LOAD_ON_DISCONTINUITY: false,
            TIMESHIFT_ON_DISCONTINUITY: true,
            ANDROID_SELF_INDEXED_SEGMENTS: true,
            MPD_AVAILABILITY_TIME_DRIFT: 0,
            USE_BITMOVIN_ANALYTICS: true
        },
        MULTI_DRM: {
            WIDEVINE_DISABLED: true,
            WIDEVINE_CHANNEL_ID: '904e41a22a9a43a5a4d9d160cbb29f03',
            WIDEVINE_USER_ID: '0925766e-db9b-11e7-aede-0a3eecf5965a',
            WIDEVINE_ENV: 'dev',
            WIDEVINE_LICENCE_FETCH_RETRY_COUNT: 2,
            WIDEVINE_LICENCE_PROXY_CERTIFICATE_URL: 'https://p-dws.dany.movetv.com/widevine/proxy'
        },
        FPS_CERTIFICATE: 'MIIE/DCCA+SgAwIBAgIIUYPegNDLxRswDQYJKoZIhvcNAQEFBQAwfzELMAkGA1UEBhMCVVMxEzARBgNVBAoMCkFwcGxlIEluYy4xJjAkBg\
NVBAsMHUFwcGxlIENlcnRpZmljYXRpb24gQXV0aG9yaXR5MTMwMQYDVQQDDCpBcHBsZSBLZXkgU2VydmljZXMgQ2VydGlmaWNhdGlvbiBBd\
XRob3JpdHkwHhcNMTYwNDEyMTU1MTIyWhcNMTgwNDEzMTU1MTIyWjBsMQswCQYDVQQGEwJVUzEZMBcGA1UECgwQRElTSCBESUdJVEFMIExM\
QzETMBEGA1UECwwKUTU2NlIyVzdFNzEtMCsGA1UEAwwkRmFpclBsYXkgU3RyZWFtaW5nOiBESVNIIERJR0lUQUwgTExDMIGfMA0GCSqGSIb\
3DQEBAQUAA4GNADCBiQKBgQDjSFlXTMdhf84w8L+F7g9fv17oRyn2+fzn6DFfnt0FZkTpT48lgpC8Iu0Z/QVMQdGz2eohEiqLTlaPvYUCj+\
HVq9seh9OGOfiFYubwcgSNoFZPhA8zPFvTy/aRADsEJ2QiU8eIMoo/he8r2p3ODpubwYYM0vrQs9Zd6gwRtrmvowIDAQABo4ICETCCAg0wH\
QYDVR0OBBYEFHquJwaOw7HjM/sTWBOrIFWygg8kMAwGA1UdEwEB/wQCMAAwHwYDVR0jBBgwFoAUY+RHVMuFcVlGLIOszEQxZGcDLL4wgeIG\
A1UdIASB2jCB1zCB1AYJKoZIhvdjZAUBMIHGMIHDBggrBgEFBQcCAjCBtgyBs1JlbGlhbmNlIG9uIHRoaXMgY2VydGlmaWNhdGUgYnkgYW5\
5IHBhcnR5IGFzc3VtZXMgYWNjZXB0YW5jZSBvZiB0aGUgdGhlbiBhcHBsaWNhYmxlIHN0YW5kYXJkIHRlcm1zIGFuZCBjb25kaXRpb25zIG\
9mIHVzZSwgY2VydGlmaWNhdGUgcG9saWN5IGFuZCBjZXJ0aWZpY2F0aW9uIHByYWN0aWNlIHN0YXRlbWVudHMuMDUGA1UdHwQuMCwwKqAoo\
CaGJGh0dHA6Ly9jcmwuYXBwbGUuY29tL2tleXNlcnZpY2VzLmNybDAOBgNVHQ8BAf8EBAMCBSAwSgYLKoZIhvdjZAYNAQMBAf8EOAFlZGRl\
aDNjYXp1dm9sb3JwaHFoa3Jybmp6eXlkdnRvcW5wem04cGhhYWJ2ZHlsbHczdzBrZW43MEUGCyqGSIb3Y2QGDQEEAQH/BDMBdjNtYmo5eGd\
sdmcxZjRqeGFxcjAyemd1ZXlyZW9wY2RucjRwa2ZhbjdwdnF4YXdxbmQwDQYJKoZIhvcNAQEFBQADggEBAM6IoBXzj6LBedOJYGWTIzQfs4\
bwtGXrEqUWKY+1J2+bj1rR7HpAxJFIevNZssDrHCguiD1zcrKVoSOMgeaGX6tL0XyIg5XKN0JsTXMmMlStuaowNPmPvdsN0PhbawTzUGQV8\
zG0lQ6uOzH6KF3zV52LWsA2OshKsW1zDHxjniRxAh6NcIkE08kteppPesGMsGgunRmGDC79ZO9EYS6oobZmKPomzoa1P12G5mUSFoCEKgIC\
PJLnMi1CEBLAH3pmnij4rOWMoyKhfYc1ZuAAOfGYq6gpD490CCJn2fZOVVukUVtSrB9TA65/qRZODH6rejik7TSk4ped2/9aNRDGY+0='
            .replace(/\s/g, '')
    },
    AUSTIN: {
        AJAX_TIMEOUT_MS: 60000,
        HOPPER_FIRMWARE_MIN_VERSION: '05.05.897',
        PROGRAM_INFO_FETCH_INTERVAL: 10000,
        EVENTS_POLL_TIME_MS: 5000 //time in milli sec
    },
    CPS: {
        CONNECTION_RE_ESTABLISHMENT_TIME: 60000,
        CONNECTION_TIMEOUT_MS: 120000,
        HBT_BASE_URL: 'https://hbt.sling.com',
        RELAY_URL: 'https://relay.sling.com',
        RELAY_REVERSE_PROXY_URL: 'https://relay-proxy.sling.com',
        RELAY_REVERSE_PROXY_ENABLED: true,
        RELAY_REVERSE_PROXY_PATH: '/relay-proxy/',
        SPARCS_URL: 'https://device.sling.com',
        ENABLE_WAN_CONNECTION: true,
        ENABLE_PARALLEL_CONNECTION: true,
        RELAY_RM_RETRY_COUNT: 3,
        START_STREAM_FORCE_SELF_CONFLICT_TIMEOUT_MS: 60000,
        START_STREAM_RETRY_COUNT: 2,
        STOP_STREAM_WAIT_TIMEOUT_MAX_MS: 4000,
        STOP_STREAM_WAIT_TIMEOUT_MIN_MS: 1000,
        RELAY_CONNECT_RETRY_COUNT: 2,
        EVENT_RETRY_MAX_COUNT: 5,
        FORCED_RELAY_PROXY: false,
        URL_DOMAIN_FOR_DNS_COMMAND: '-ip-cmd.dishboxes.com',
        URL_DOMAIN_FOR_DNS_DATA: '-ip-data.dishboxes.com'
    },
    STREAMING: {
        HLS_PLAYLIST_SIZE: 3,
        BOX_READY_TIMEOUT_MS: 60000,
        LAN: {
            DASH_SEGMENT_DURATION_MS: 1000,
            HLS_SEGMENT_DURATION_MS: 1000,
            I_FRAME_INTERVAL_MS: 1000,
            MAX_BUFFER_LEVEL_MS: 7000,
            VIDEO_BITRATE_MIN: '200',
            AUDIO_BITRATE_MIN: '64',
            AUDIO_BITRATE_MAX: '96',
            QUALITY_LEVEL_AUTO: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '8000',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_HIGH: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '8000',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_MEDIUM: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '8000',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_LOW: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '8000',
                VIDEO_RESOLUTION: '1920x1080'
            }
        },
        TCP: {
            DASH_SEGMENT_DURATION_MS: 1000,
            HLS_SEGMENT_DURATION_MS: 2000,
            I_FRAME_INTERVAL_MS: 1000,
            MAX_BUFFER_LEVEL_MS: 7000,
            VIDEO_BITRATE_MIN: '200',
            AUDIO_BITRATE_MIN: '64',
            AUDIO_BITRATE_MAX: '96',
            QUALITY_LEVEL_AUTO: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '3368',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_HIGH: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '3368',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_MEDIUM: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '3000',
                VIDEO_RESOLUTION: '960x544'
            },
            QUALITY_LEVEL_LOW: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '1200',
                VIDEO_RESOLUTION: '640x480'
            }
        },
        RELAY: {
            DASH_SEGMENT_DURATION_MS: 2000,
            HLS_SEGMENT_DURATION_MS: 2000,
            I_FRAME_INTERVAL_MS: 1000,
            MAX_BUFFER_LEVEL_MS: 7000,
            VIDEO_BITRATE_MIN: '200',
            AUDIO_BITRATE_MIN: '64',
            AUDIO_BITRATE_MAX: '96',
            QUALITY_LEVEL_AUTO: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '2668',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_HIGH: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '3368',
                VIDEO_RESOLUTION: '1920x1080'
            },
            QUALITY_LEVEL_MEDIUM: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '3000',
                VIDEO_RESOLUTION: '960x544'
            },
            QUALITY_LEVEL_LOW: {
                VIDEO_BITRATE_START: '300',
                VIDEO_BITRATE_MAX: '1200',
                VIDEO_RESOLUTION: '640x480'
            }
        },
        CHROMECAST: {
            VIDEO_BITRATE_START: '1200',
            VIDEO_BITRATE_MAX: '3000',
            VIDEO_BITRATE_MIN: '200',
            VIDEO_RESOLUTION: '960x544'
        },
        THREE_FEET_DEVICE_MAX_RESOLUTION: '1920x1080',
        THREE_FEET_DEVICE_MAX_BITRATE: '8000',
        TEN_FEET_DEVICE_MAX_BITRATE: '8000',
        ANDROID_WAN_SEG_DURATION: 2000,
    },
    //local configuration, not present in MD
    SUPPORTED_CODEC: {
        codec: '',
        level: '',
        profile: ''
    },
    //BM Forward buffer in seconds
    BM_PLAYER_FORWARD_BUFFER: 294,
    //Android BM player forward buffer
    ANDROID_BM_PLAYER_FORWARD_BUFFER: 90,
    //iOS BM player forward buffer
    IOS_BM_PLAYER_FORWARD_BUFFER: 0,
    //BM backward buffer in seconds
    BM_PLAYER_BACKWARD_BUFFER: 35,
    EVENT_RETRY_DELAY_MS: 6000,
    WAN_DELAY_IN_PARALLEL_MS: 1000,
    RELAY_DELAY_IN_PARALLEL_MS: 2000,
    //bufferbar handling
    DVR_END_THRESHOLD_REM_TIME_FOR_FIRING_PAUSE: 60,
    MIN_BUFFER_FOR_SEGMENT_PAUSE_AT_DVR_END: 14,
    MAX_BUFFER_BEFORE_SEGEMENT_RESUME_AT_DVR_END: 8,
    ANDROID_FORWARD_BUFFER_LEVEL_AT_PAUSE: 5,
    ANDROID_DVR_END_THRESHOLD_REM_TIME_FOR_FIRING_PAUSE: 60,
    ANDROID_MAX_BUFFER_BEFORE_RESUME_AT_DVR_END: 9,
    ANDROID_SEGMENT_TIMEOUT_MS: 8000 // time after which box pause will be sent in paused state on android if segment download doesn't happen
};

const AustinConstants = Object.freeze({
    PLATFORM: {
        WEB: 'web',
        ANDROID: 'android',
        IOS: 'ios',
        ANDROIDTV: 'androidtv',
        FIRETV: 'firetv',
        TVOS: 'tvos'
    },
    BOX: {
        CONNECTION_LOST: 'connectionLost',
        CONNECTION_MODE_LAN: 'LAN',
        CONNECTION_MODE_TCP: 'TCP',
        CONNECTION_MODE_RELAY: 'RELAY',
        STATUS: {
            DISCONNECTED: 'disconnected',
            DISCONNECTING: 'disconnecting',
            CONNECTING: 'connecting',
            CONNECTED: 'connected',
            CONNECTION_RE_ESTABLISHING: 'connectionReEstablishing',
            STARTING_STREAMING: 'startingStreaming',
            STOPPING_STREAMING: 'stoppingStreaming',
            STREAMING: 'streaming',
            NO_VIDEO_SIGNAL: 'noVideoSignal'
        },
    },
    STREAMING: {
        BOX_STREAM_STOP: 'boxStreamStop',
        CONTENT_TYPE: {
            NONE: 'none',
            LIVE: 'live',
            LIVE_TIP: 'liveTip',
            LIVE_REC: 'liveRec',
            LIVE_DELAYED: 'liveDelayed',
            LIVE_DELAYED_REC: 'liveDelayedRec',
            DVR: 'dvr',
            DVR_RECORDED: 'dvrRecorded',
            DVR_IN_PROGRESS: 'dvrInProgress'
        },
        CODEC: 'codec',
        CODECS: {
            AVC1: 'avc1',
            AVC3: 'avc3',
            AVC3_AVC1_SPOOFED: 'avc3_with_avc1_spoofing',
            LEVEL: 'level',
            LEVEL_4_0: '4.0',
            LEVEL_3_1: '3.1',
            LEVEL_3_0: '3.0',
            PROFILE: 'profile',
            PROFILE_BASELINE: 'baseline',
            PROFILE_HIGH: 'high',
            PROFILE_MAIN: 'main',
        },
        FIRST_FRAME: {
            STREAM_START: 'streamStart',
            DISCONTINUITY: 'discontinuity',
            SEEK: 'seek'
        },
        DRM_LA_URL: 'LA_URL',
        DRM_MODE: 'drmMode',
        DRM_MODE_FAIRPLAY: 'fairplay',
        DRM_MODE_WIDEVINE: 'widevine',
        PREFETCH_LICENCE: 'prefetchLicence',
        HTML5: 'html5',
        FORCE_HLS: 'forceHls',
        FORCE_DASH: 'forceDash',
        FORCE_TRANSFER: 'forceTransfer',
        HLS_MODE: 'hlsMode',
        HLS_NATIVE: 'native',
        PTS_TYPE: '03',
        SEGMENT_DURATION: 'segmentDuration',
        STREAMING_TYPE: 'streamingType',
        STREAMING_TYPE_DASH: 'dash',
        STREAMING_TYPE_HLS: 'hls',
        VIDEO_LOCK_LOST: 'videoLockLost',
        VIDEO_LOCK_SUCCESS: 'videoLockSuccess'
    },
    QUALITY_LEVELS: {
        AUTO: 'auto',
        HIGH: 'high',
        MEDIUM: 'medium',
        LOW: 'low',
        QUALITY: 'quality',
    },
    PLAYER: {
        BITMOVIN: 'bitMovin',
        BITMOVIN_LICENCE: 'bitmovinLicence',
        BUFFERING_TO_START: 'bufferingToStart',
        CHROMECAST: 'chromeCast',
        CONTAINER: 'playerContainer',
        CONTAINER_ID: 'playerContainerId',
        CUSTOM_PIPELINE: 'customPipeline',
        DONT_HANDLE_PLAYBACK: 'dontHandlePlayback',
        DUMP_SEGMENTS_TO_SERVER: 'dumpSegmentsToServer',
        FPS_CERTIFICATE: 'fpsCertificate',
        MAX_BUFFER_LEVEL: 'maxBufferLevel',
        PLAYBACK_TIMEOUT: 'playbackTimeout',
        PLAYRATE_CONTROL_TIMEOUT: 'playrateControlTimeout',
        REQUEST_TYPE_MEDIA_AUDIO: 'media/audio',
        REQUEST_TYPE_MEDIA_VIDEO: 'media/video',
        REQUEST_TYPE_MPD: 'manifest/dash',
        REQUEST_TYPE_WIDEVINE_LICENCE: 'drm/license/widevine',
        VIDEO_ELEMENT: 'videoElement',
        FORWARD_BUFFER_DURATION: 'ForwardBufferDuration',
        BACKWARD_BUFFER_DURATION: 'BackwardBufferDuration'
    },
    DVR: {},
    /*General String Constants */
    AUSTIN_EVENTS: 'austinEvents',
    AUSTIN_CC_COOKIE: 'austinCcCookie',
    ENV_PROD: 'prod',
    ENV_QA: 'qa',
    LOG: 'log',
    LOG_LEVEL: 'logLevel',
    OFFLINE: 'offline',
    ONLINE: 'online',
    /* Query parameter that can be accepted through application ulr for dev/debugging purpose */
    QUERY_PARAM: {
        BUFFERING_TO_START: 'bufferingToStart',
        FORCED_SERIES_CONNECTION: 'forcedSeriesConnection',
        FORCED_RELAY: 'forcedRelay',
        FORCED_RELAY_PROXY: 'forcedRelayProxy',
        RELAY_HOST: 'relayHost',
        FORCED_WAN: 'forcedWan',
        PIPELINE_COUNT: 'pipelineCount',
        POLL_TIME: 'pollTime'
    },
});

class AustinLogger {
    constructor(moduleName) {
        this.LOG_LEVEL = {
            DEBUG: 1,
            INFO: 2,
            WARN: 3,
            ERROR: 4
        };
        this.module = '';
        if (typeof moduleName === 'string') {
            this.module = moduleName + '::';
        }
    }
    debug(msg) {
        this._writeLog('debug', msg);
    }
    info(msg) {
        this._writeLog('info', msg);
    }
    warn(msg) {
        this._writeLog('warn', msg);
    }
    error(msg) {
        this._writeLog('error', msg);
    }
    log(...msg) {
        this._writeLog('log', msg);
    }
    _writeLog(type, msg) {
        if ('undefined' === typeof console) {
            console = {
                log: (msg) => {
                    return;
                }
            };
        }
        if (true === AustinConfig.ENABLE_LOGGING &&
            ((type === 'debug' && AustinConfig.LOGGING_LEVEL === this.LOG_LEVEL.DEBUG) ||
                (type === 'log' && AustinConfig.LOGGING_LEVEL <= this.LOG_LEVEL.DEBUG) ||
                (type === 'info' && AustinConfig.LOGGING_LEVEL <= this.LOG_LEVEL.INFO) ||
                (type === 'warn' && AustinConfig.LOGGING_LEVEL <= this.LOG_LEVEL.WARN) ||
                (type === 'error' && AustinConfig.LOGGING_LEVEL <= this.LOG_LEVEL.ERROR))) {
            this._callLogFn(type, msg);
        }
    }
    _callLogFn(type, message) {
        this.msg = AustinLogger.LogPrefix + this.module + message;
        let logTime = this.getCurrentTime();
        if (AustinLogger.output !== undefined) {
            AustinLogger.output(type, logTime + this.msg);
            return;
        }
        if ('undefined' === typeof console[type] || 'null' === console[type]) {
            // tslint:disable-next-line:no-console
            console.log(logTime + this.msg);
        }
        else {
            let userAgent = navigator.userAgent.toLowerCase();
            let regEx = /trident\/7.\d+.*rv:/;
            if (userAgent.indexOf('msie') !== -1 || true === regEx.test(userAgent)) {
                console[type](logTime + this.msg);
            }
            else {
                if (type === 'log') {
                    let msg = [];
                    for (let i = 0; i < message.length; i++) {
                        msg.push(message[i]);
                    }
                    this.msg = AustinLogger.LogPrefix + this.module + msg.join(' ');
                }
                // tslint:disable-next-line:no-console
                console[type].apply(console, [logTime + this.msg]); // tslint:disable-line
            }
        }
    }
    getCurrentTime() {
        let now = new Date();
        return now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds() + ' ' + now.getMilliseconds() + ' : ';
    }
}
AustinLogger.LogPrefix = 'AustinJs::';

/**
 * Created by Sunny on 5/03/18.
 *
 */
class RequestDispatcher {
    static setProxy(value) {
        RequestDispatcher.corsProxy = value;
    }
    static setWebPlatform(value) {
        RequestDispatcher.isPlatformWeb = value;
    }
    /**
     * For simple GET request this can be used directly
     *
     * @param {string} url
     * @param {number} timeout - timeout in milli seconds
     * @returns {Promise<any>}
     */
    static get(url, timeout) {
        return RequestDispatcher.makeRequest({ url: url, method: 'GET', timeout: timeout });
    }
    /**
     * For simple POST request this can be used directly
     * @param url
     * @param payload
     * @param {number} timeout - timeout in milli seconds
     * @returns {Promise<any>}
     */
    static post(url, payload, timeout) {
        return RequestDispatcher.makeRequest({ url: url, method: 'POST', data: payload, timeout: timeout });
    }
    /**
     * Generic method which handles all ajax calls. Everything is based on the params object passed
     * Note: no default method, so consumer has to mention method name
     *
     * @param reqObject
     * reqObject can contain
     * {
     *   'method' : '',
     *   'url' : '',
     *   'data' : '',
     *   'customHeaders' : {}
     * }
     * @returns xhr object
     */
    static makeRequest(reqObject) {
        return new Promise((resolve, reject) => {
            let request = Object.create(null);
            const controller = window['AbortController'] ? new AbortController() : null;
            const signal = controller ? controller.signal : null;
            request['signal'] = signal;
            let didTimeOut = false;
            let timoutId = null;
            request['method'] = reqObject.method;
            request['headers'] = reqObject.customHeaders || Object.create(null);
            if (reqObject.method === 'POST') {
                let dataToSent = JSON.stringify(reqObject.data) || '';
                request['body'] = dataToSent || '';
                if (dataToSent.length > 0) {
                    if (RequestDispatcher.isPlatformWeb) {
                        request['headers'] = Object.assign({}, request['headers'], { 'Content-Type': 'text/plain;charset=UTF-8' });
                    }
                    else {
                        RequestDispatcher.logger.log('Setting for non web platforms');
                        request['headers'] = Object.assign({}, request['headers'], { 'Content-Type': 'application/json;charset=UTF-8' });
                    }
                }
                ;
            }
            let debugUrl = reqObject.url + ' ' + request['body'];
            let hasToReadAsBlob = reqObject.hasToReadAsBlob;
            if (reqObject.timeout) {
                timoutId = setTimeout(() => {
                    didTimeOut = true;
                    RequestDispatcher.logger.info('fetch url timeout : ' + debugUrl);
                    reject('AJAX Request timed out');
                    if (controller && controller.abort) {
                        controller.abort();
                    }
                }, reqObject.timeout);
            }
            RequestDispatcher.logger.info('fetch url:' + debugUrl);
            if (typeof RequestDispatcher.corsProxy === 'string') {
                RequestDispatcher.logger.log(`corsProxy: ${RequestDispatcher.corsProxy}`);
                reqObject.url = reqObject.url.replace(/([^\/]+sling\.com)/, `${RequestDispatcher.corsProxy}/$1`);
            }
            let responseObj;
            fetch(reqObject.url, request).then((response) => {
                responseObj = response;
                clearTimeout(timoutId);
                if (response.ok) {
                    if (hasToReadAsBlob) {
                        return response.blob();
                    }
                    return response.json();
                }
                else {
                    throw response;
                }
            }).then((data) => {
                RequestDispatcher.logger.info('fetch url: ' + debugUrl + ' resp: ' + JSON.stringify(data));
                if (didTimeOut) {
                    RequestDispatcher.logger.log('fetch api resolve came after timeout');
                    return;
                }
                resolve({ 'data': data });
            }).catch((e) => {
                RequestDispatcher.logger.warn('fetch url reject ' + debugUrl + ' error: ' + JSON.stringify(e));
                if (didTimeOut) {
                    RequestDispatcher.logger.warn('fetch api rejection came after timeout');
                    return;
                }
                clearTimeout(timoutId);
                if (e.ok !== undefined && e.ok === false && e.status !== undefined) {
                    let contentType = e.headers.get('content-type');
                    if (contentType && contentType.indexOf('text/html') !== -1) {
                        return e.text();
                    }
                    else {
                        e.json().then((data) => {
                            reject({ status: e.status, statusText: e.statusText, body: data });
                        }).catch((err) => {
                            reject({ status: e.status, statusText: e.statusText, body: err });
                        });
                    }
                }
                else {
                    reject(e);
                }
            }).then((data) => {
                if (data) {
                    if (responseObj && responseObj.ok !== undefined && responseObj.ok === false && responseObj.status !== undefined) {
                        reject({ status: responseObj.status, statusText: responseObj.statusText, body: data });
                    }
                }
            });
        });
    }
}
RequestDispatcher.logger = new AustinLogger('RequestDispatcher');
RequestDispatcher.isPlatformWeb = false;
RequestDispatcher.corsProxy = null;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var crypt = createCommonjsModule(function (module) {
(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();
});

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

var charenc_1 = charenc;

/**
 * Determine if an object is Buffer
 *
 * Author:   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * License:  MIT
 *
 * `npm install is-buffer`
 */

var isBuffer = function (obj) {
  return !!(
    obj != null &&
    obj.constructor &&
    typeof obj.constructor.isBuffer === 'function' &&
    obj.constructor.isBuffer(obj)
  )
};

var md5 = createCommonjsModule(function (module) {
(function(){
  var crypt$1 = crypt,
      utf8 = charenc_1.utf8,
      isBuffer$1 = isBuffer,
      bin = charenc_1.bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer$1(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt$1.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt$1.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if(typeof message == 'undefined')
      return;

    var digestbytes = crypt$1.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt$1.bytesToHex(digestbytes);
  };

})();
});

/**
 * Created by Husain on 01/03/17.
 *
 */
class AustinUtils {
    /**
     *  Sample config object
     * {
     *      platform: 'web' / 'android' /' ios' / 'chromecast',
     *      log : {level: 'none' / 'error' / 'warn' / 'info' / 'debug'},
     *      modules: [{name: 'bitmovin', module:  window['bitmovin']}],
     *      protocol: 'http:'/'https:',
     *      endpoint: 'https://hollywood.slingbox.com/austinjs-3.0.14/app/player.html'
     *  }
     * @param config
     * @returns {boolean}
     */
    static init(config) {
        if (config && config.platform) {
            this.platform = config.platform;
            this.protocol = config.protocol || ((config.platform === AustinConstants.PLATFORM.ANDROID) ? 'http:' : 'https:');
            this.endpoint = config.endpoint || ((config.platform === AustinConstants.PLATFORM.WEB) ? location.pathname : null);
            this.corsProxy = config.corsProxy;
            RequestDispatcher.setProxy(this.corsProxy);
            this.setLogLevel(config.log ? config.log.level : 'error');
            if (config.modules) {
                config.modules.forEach(function (element) {
                    AustinUtils.modules.set(element.name, element.module);
                });
            }
            return true;
        }
        else {
            return false;
        }
    }
    static processQueryParams() {
        if (AustinConstants.PLATFORM.WEB === this.platform) {
            AustinUtils.urlQueryParams = {};
            let tmp = [];
            window.location.search
                .substr(1)
                .split('&')
                .forEach(function (item) {
                tmp = item.split('=');
                if (tmp[0] && tmp[1]) {
                    AustinUtils.urlQueryParams[tmp[0]] = decodeURIComponent(tmp[1]);
                }
                else {
                    AustinUtils.urlQueryParams[tmp[0]] = 'true';
                }
            });
        }
        else {
            AustinUtils.logger.log('processQueryParams : not be handled for non web platforms');
        }
    }
    static getQueryValueForKey(key) {
        if (AustinUtils.urlQueryParams && AustinUtils.urlQueryParams[key]) {
            return AustinUtils.urlQueryParams[key];
        }
        else {
            return null;
        }
    }
    static isCodecProfileLevelSupported(codecString) {
        return !!(document.createElement('video').canPlayType(codecString));
    }
    static isBrowserFirefox() {
        return window.navigator.userAgent.indexOf('Mozilla') !== -1 && window.navigator.userAgent.indexOf('Firefox') !== -1;
    }
    static isOsWindows10() {
        return window.navigator.userAgent.indexOf('Windows NT 10.0') !== -1;
    }
    static isOsWindows8_1() {
        return window.navigator.userAgent.indexOf('Windows NT 6.3') !== -1;
    }
    static isDeviceChromeCast() {
        return window.navigator.userAgent.indexOf('CrKey') !== -1;
    }
    static getRelayUrl(url, clientid) {
        if (this.getQueryValueForKey('RelayHttpProxy')) {
            url = url.substr(0, url.indexOf('/', 'http://'.length)) + '/hls/v1/clientid/' +
                clientid + url.substr(url.indexOf('/', 'http://'.length));
        }
        return url;
    }
    // convert a numeric long to 4 char string
    static longToStr4(v) {
        let s = '';
        if (v & 0xFF) {
            s = s + String.fromCharCode(v & 0xFF);
        }
        if (v >> 8 & 0xFF) {
            s = s + String.fromCharCode(v >> 8 & 0xFF);
        }
        if (v >> 16 & 0xFF) {
            s = s + String.fromCharCode(v >> 16 & 0xFF);
        }
        if (v >> 24 & 0xFF) {
            s = s + String.fromCharCode(v >> 24 & 0xFF);
        }
        return (s);
    }
    static HexToTwoByte(str) {
        return (this.HexToByte(str[0]) << 4) | this.HexToByte(str[1]);
    }
    static HexToByte(chHex) {
        if (chHex >= 'a' && chHex <= 'f') {
            return (10 + chHex.charCodeAt(0) - 'a'.charCodeAt(0));
        }
        if (chHex >= 'A' && chHex <= 'F') {
            return (10 + chHex.charCodeAt(0) - 'A'.charCodeAt(0));
        }
        if (chHex >= '0' && chHex <= '9') {
            return (chHex.charCodeAt(0) - '0'.charCodeAt(0));
        }
        return 0xFF;
    }
    static decryptCode(puiValue, puiKey) {
        let y = (puiValue[0] >>> 0);
        let z = (puiValue[1] >>> 0);
        let sum;
        let delta = (0x9E3779B9 >>> 0);
        let k1, k2, k3, k4;
        k1 = puiKey[0] >>> 0;
        k2 = puiKey[1] >>> 0;
        k3 = puiKey[2] >>> 0;
        k4 = puiKey[3] >>> 0;
        //sum = delta << 5;
        sum = ((delta << 5) >>> 0);
        for (let n = 0; n < 32; n++) {
            //z -= ((y<<4) + k3) ^ (y+sum) ^ ((y>>5)+k4);
            z = (z - ((((((y << 4) >>> 0) + k3) >>> 0) ^ ((y + sum) >>> 0) ^ ((((y >>> 5) >>> 0) + k4) >>> 0)) >>> 0)) >>> 0;
            //y -= ((z<<4) + k1) ^ (z+sum) ^ ((z>>5)+k2);
            y = (y - ((((((z << 4) >>> 0) + k1) >>> 0) ^ ((z + sum) >>> 0) ^ ((((z >>> 5) >>> 0) + k2) >>> 0)) >>> 0)) >>> 0;
            //sum -= delta;
            sum = (sum - delta) >>> 0;
            puiValue[0] = y;
            puiValue[1] = z;
        }
    }
    /*
     * decrypt TEA encrypted password
     * eg: E1:A043055F01205331DD05B2B39F525154C3F7C4076C9127C6213D75071C83F26A
     */
    static decryptedPassword(encrypted, signature) {
        let password = encrypted;
        if (!signature) {
            signature = 'E1:';
        }
        /* if password is encrypted with TEA*/
        if (encrypted.startsWith(signature)) {
            password = '';
            let k = [0xBCDEAAAA, 0x87FBBBBA, 0x7CCCCFFA, 0xDDDDAABC];
            let v = new Array(2);
            let s = encrypted.substr(signature.length);
            let iByteSize = s.length / 2;
            let pucRet = new Array(iByteSize);
            let j = 0;
            for (let i = 0; i < iByteSize; i++) {
                pucRet[i] = this.HexToTwoByte(s.substr(j));
                j = j + 2;
            }
            for (let i = 0; i < iByteSize; i += 8) {
                v[0] = pucRet[i + 0] + (pucRet[i + 1] << 8) + (pucRet[i + 2] << 16) + (pucRet[i + 3] << 24);
                v[1] = pucRet[i + 4] + (pucRet[i + 5] << 8) + (pucRet[i + 6] << 16) + (pucRet[i + 7] << 24);
                this.decryptCode(v, k);
                password = password + this.longToStr4(v[0]) + this.longToStr4(v[1]);
            }
        }
        return password;
    }
    static isObject(o) {
        return (o && typeof o === 'object' && !Array.isArray(o) && o !== null);
    }
    static merge(target, source) {
        if (this.isObject(target) && this.isObject(source)) {
            for (const key in source) {
                if (this.isObject(source[key])) {
                    if (!target[key]) {
                        Object.assign(target, { [key]: {} });
                    }
                    this.merge(target[key], source[key]);
                }
                else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return target;
    }
    static digest(digestStr, options) {
        return md5(digestStr, options);
    }
    static getClientLocalIp() {
        AustinUtils.logger.warn('getClientLocalIp enter');
        return new Promise((resolve) => {
            let ipAddress;
            let RTCPeerConnection = window['RTCPeerConnection'] || window['mozRTCPeerConnection'] || window['webkitRTCPeerConnection']; //compatibility for Firefox and chrome
            if (RTCPeerConnection) {
                let onicecandidateTimer = null;
                let pc = new RTCPeerConnection({ iceServers: [] }), noop = () => {
                    ;
                };
                pc['createDataChannel'](''); //create a bogus data channel
                pc.onicecandidate = (ice) => {
                    clearTimeout(onicecandidateTimer);
                    onicecandidateTimer = null;
                    let ipStr;
                    if (ice && ice.candidate) {
                        if (ice.candidate['address']) {
                            ipAddress = ice.candidate['address'];
                        }
                        else {
                            ipStr = ice.candidate.candidate;
                        }
                    }
                    else if (pc.localDescription.sdp) {
                        ipStr = pc.localDescription.sdp.substr(pc.localDescription.sdp.indexOf('c=IN IP4'));
                    }
                    if (ipStr) {
                        let result = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ipStr);
                        if (result) {
                            ipAddress = result[1];
                        }
                        else {
                            //safari case
                            result = /.*local/.exec(ipStr);
                            if (result) {
                                result = /\S+$/.exec(result[0]);
                                if (result) {
                                    ipAddress = result[0];
                                }
                            }
                        }
                    }
                    pc.onicecandidate = noop;
                    pc = null;
                    AustinUtils.logger.warn('getClientLocalIp exit resole ip: ' + ipAddress);
                    resolve(ipAddress);
                };
                pc.createOffer().then((sdp) => {
                    pc.setLocalDescription(sdp);
                    onicecandidateTimer = setTimeout(() => {
                        pc.onicecandidate = noop;
                        pc = null;
                        resolve('0.0.0.0');
                    }, 500);
                });
            }
            else {
                resolve(ipAddress);
            }
        });
    }
    static checkInternetConnection(baseUrl) {
        return new Promise((resolve, reject) => {
            let internetOK = false;
            let apiResolve = () => {
                if (!internetOK) {
                    AustinUtils.logger.warn('INTERNET CONNECTION OK');
                    resolve();
                }
                internetOK = true;
            };
            let apiReject = () => {
                if (!internetOK) {
                    AustinUtils.logger.warn('INTERNET CONNECTION NOT OK');
                    reject();
                }
                internetOK = true;
            };
            let baseImage = new Image();
            baseImage.onload = () => {
                apiResolve();
            };
            baseImage.onerror = () => {
                apiResolve();
            };
            let baseStart = new Date().getTime();
            baseImage.src = baseUrl.command.split('/austin')[0].replace('-cmd', '') + '/?_=' + baseStart;
            setTimeout(() => {
                apiReject();
            }, 4000);
        });
    }
    static isTwoIPsOnSamePrivateNetwork(dottedIp1, dottedIp2) {
        let ip1 = dottedIp1.split('.');
        let ip2 = dottedIp2.split('.');
        if (ip1 && ip2 && ip1.length === ip2.length) {
            if (ip1[0] === ip2[0]) {
                if (ip1[0] === '10') {
                    return true; //10.x.x.x
                }
                if (ip1[0] === '192') {
                    if (ip1[1] === ip2[1] && ip1[1] === '168') {
                        return true; //192.168.x.x
                    }
                }
                if (ip1[0] === '169') {
                    if (ip1[1] === ip2[1] && ip1[1] === '254') {
                        return true; //169.2254.x.x link local
                    }
                }
                if (ip1[0] === '172') {
                    if ((parseInt(ip1[1], 10) >= 16 && parseInt(ip1[1], 10) <= 31) && (parseInt(ip2[1], 10) >= 16 && parseInt(ip2[1], 10) <= 31)) {
                        return true; //172.16-31.x.x
                    }
                }
            }
        }
        return false;
    }
    static camelCase(str) {
        return str.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    }
    static getCookie(name) {
        if (document && document.cookie) {
            const base64Value = document.cookie.match(new RegExp(name + '=([^;]+)'));
            if (base64Value) {
                try {
                    const valueFromCookie = atob(base64Value[1]);
                    if (valueFromCookie) {
                        return JSON.parse(valueFromCookie);
                    }
                }
                catch (e) {
                    AustinUtils.logger.error(e);
                }
            }
        }
        else {
            AustinUtils.logger.info('Cookie is NOT supported for mobiles and tablets');
        }
    }
    static setCookie(name, value) {
        if (document) {
            //store CC in cookie
            let date = new Date();
            date.setHours(23, 59, 59, 999);
            const encryptedValue = btoa(JSON.stringify(value));
            const expires = ';expires=' + date.toUTCString();
            document.cookie = name + '=' + encryptedValue + expires;
        }
        else {
            AustinUtils.logger.info('Cookie is NOT supported for mobiles and tablets');
        }
    }
    static getLocalStorageItem(name) {
        if (!!(window && window.localStorage && window.localStorage.getItem)) {
            return localStorage.getItem(name);
        }
        else {
            AustinUtils.logger.info('local-storage is NOT supported');
        }
    }
    static setLocalStorageItem(name, value) {
        if (!!(window && window.localStorage && window.localStorage.setItem)) {
            localStorage.setItem(name, value);
        }
        else {
            AustinUtils.logger.info('local-storage is NOT supported');
        }
    }
    static getPlatForm() {
        return this.platform;
    }
    static getProtocol() {
        return this.protocol;
    }
    static getModule(moduleName) {
        return this.modules.get(moduleName);
    }
    static isFireTV() {
        return AustinConstants.PLATFORM.FIRETV === this.platform;
    }
    static isTvOS() {
        return AustinConstants.PLATFORM.TVOS === this.platform;
    }
    static isAndroidTV() {
        return AustinConstants.PLATFORM.ANDROIDTV === this.platform;
    }
    static isAndroid() {
        return (AustinConstants.PLATFORM.ANDROID === this.platform || AustinConstants.PLATFORM.ANDROIDTV === this.platform || AustinConstants.PLATFORM.FIRETV === this.platform);
    }
    static isIos() {
        return (AustinConstants.PLATFORM.IOS === this.platform || AustinConstants.PLATFORM.TVOS === this.platform);
    }
    static isWeb() {
        return AustinConstants.PLATFORM.WEB === this.platform;
    }
    static is3FeetDevice() {
        return AustinConstants.PLATFORM.ANDROID === this.platform || AustinConstants.PLATFORM.IOS === this.platform;
    }
    static setLogLevel(level) {
        if (level) {
            switch (level) {
                case 'debug':
                    AustinConfig.LOGGING_LEVEL = 1;
                    break;
                case 'info':
                    AustinConfig.LOGGING_LEVEL = 2;
                    break;
                case 'warn':
                    AustinConfig.LOGGING_LEVEL = 3;
                    break;
                case 'error':
                    AustinConfig.LOGGING_LEVEL = 4;
                    break;
                case 'none':
                default:
                    AustinConfig.LOGGING_LEVEL = 5;
                    AustinConfig.ENABLE_LOGGING = false;
                    break;
            }
        }
    }
    /**
     * Get dash segment duration
     * @returns {number}
     */
    static getDashSegmentDuration(connectionMode) {
        //Setting 2 sec segment duration for Android for WAN Cases
        let dashSegDuration = (AustinUtils.isAndroid() && connectionMode === AustinConstants.BOX.CONNECTION_MODE_TCP) ? AustinConfig.STREAMING.ANDROID_WAN_SEG_DURATION / 1000
            : AustinConfig.STREAMING[connectionMode].DASH_SEGMENT_DURATION_MS / 1000;
        return dashSegDuration;
    }
    /**
     * Generates 16 characters random integer
     * Date has 13 characters, last 3 characters are randomly generated digits
     * @hidden
     */
    static generateUniqueId() {
        const time = Date.now().toString();
        const randomDigit1 = Math.floor(Math.random() * 10).toString();
        const randomDigit2 = Math.floor(Math.random() * 10).toString();
        const randomDigit3 = Math.floor(Math.random() * 10).toString();
        const randomPart = randomDigit1 + randomDigit2 + randomDigit3;
        return time + randomPart;
    }
    static prefetchWidevineCertificate(url) {
        let self = this;
        if (AustinConstants.PLATFORM.WEB === this.platform) {
            if (!this.widevineCertificate && AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_LICENCE_PROXY_CERTIFICATE_URL === url) {
                let request = Object.create(null);
                request['method'] = 'POST';
                //Widevine Certificate request from chrome CDM module will come with payload of int8 array of length 2
                // array content will be [8,4] Base64 encoded value for this binary array is CAQ=
                request['data'] = { message: 'CAQ=' };
                request['hasToReadAsBlob'] = true;
                request['url'] = url;
                AustinUtils.logger.info('Issuing Widevine licence certificate');
                RequestDispatcher.makeRequest(request).then((responseBlob) => {
                    let reader = new FileReader();
                    reader.addEventListener('loadend', function () {
                        AustinUtils.logger.info('Widevine licence certificate received');
                        self.widevineCertificate = reader.result;
                    });
                    reader.readAsArrayBuffer(responseBlob.data);
                }).catch((e) => {
                    AustinUtils.logger.info('Error in fetching Widevine licence certificate ' + JSON.stringify(e));
                });
            }
        }
    }
    static getCachedWidevineCertificate() {
        return AustinConstants.PLATFORM.WEB === this.platform ? this.widevineCertificate : null;
    }
    static updateCachedWidevineCertificate(cert) {
        if (AustinConstants.PLATFORM.WEB === this.platform) {
            this.widevineCertificate = cert;
        }
    }
}
AustinUtils.logger = new AustinLogger('Utils');
AustinUtils.urlQueryParams = null;
AustinUtils.platform = null;
AustinUtils.protocol = null;
AustinUtils.endpoint = null; // this will be used just to check internet
AustinUtils.modules = new Map();
AustinUtils.corsProxy = null;
AustinUtils.widevineCertificate = null;

/**
 * Created by sunny on 11/04/17.
 *
 * Stores, update and remove all payloads for any client analytics data
 */
class StorageService {
    constructor(queueLimit) {
        // These are in app memory
        this.analyticsPayloadQueue = [];
        this.payloadQueueLimit = queueLimit;
    }
    getPayloadQueue() {
        return this.analyticsPayloadQueue;
    }
    addPayload(obj) {
        if (this.analyticsPayloadQueue.length >= this.payloadQueueLimit) {
            this.analyticsPayloadQueue.sort((a, b) => a[AnalyticsConstants.stringConstants.TABLE_TIME] - b[AnalyticsConstants.stringConstants.TABLE_TIME]);
            this.analyticsPayloadQueue.shift(); //Discarding oldest data
        }
        this.analyticsPayloadQueue.push(obj);
    }
    flushPayloadQueue() {
        this.analyticsPayloadQueue = [];
    }
    // OFFLINE_ANALYTICS_Q will be a queue stored in browser local storage
    /**
     * Return array of all analytics info stored in local-storage
     * Used whenever we try to send analytics info stored in local-storage
     * @returns {any} : Array of json with analytic data stored in local storage}
     */
    getOfflineQueue() {
        let offlineQ = AnalyticsConstants.stringConstants.LOCAL_STORAGE_Q;
        let storedQ = AustinUtils.getLocalStorageItem(offlineQ);
        let payloadQueue;
        if (storedQ) {
            AustinUtils.setLocalStorageItem(offlineQ, JSON.stringify([]));
            payloadQueue = JSON.parse(storedQ);
        }
        else {
            payloadQueue = [];
        }
        return payloadQueue;
    }
    /**
     * When sending data to analytic server fails, add captured analytics data to offlineQ
     * @param obj
     */
    addToOfflineQ(obj) {
        let offlineQ = this.getOfflineQueue();
        if (offlineQ.length >= this.payloadQueueLimit) {
            offlineQ.shift(); //Discarding oldest data
        }
        offlineQ.push(obj);
        AustinUtils.setLocalStorageItem(AnalyticsConstants.stringConstants.LOCAL_STORAGE_Q, JSON.stringify(offlineQ));
    }
    /**
     * Removes the payload with all the keys value matching
     * @param keys
     * @param {string} memoryType
     */
    removePayload(keys, memoryType) {
        let queue = (memoryType === AnalyticsConstants.memoryType.APP_MEMORY) ? this.analyticsPayloadQueue : this.getOfflineQueue();
        let index = -1;
        for (let i = 0; i < queue.length; i++) {
            let payload = queue[i];
            let hasToCompare = true;
            for (let key in keys) {
                if (hasToCompare && keys.hasOwnProperty(key) && (payload[key] !== keys[key])) {
                    hasToCompare = false;
                    break;
                }
            }
            if (hasToCompare) {
                index = i;
                break;
            }
        }
        if (index > -1) {
            queue.splice(index, 1);
        }
        if (memoryType === AnalyticsConstants.memoryType.APP_MEMORY) {
            this.analyticsPayloadQueue = queue;
        }
        else {
            AustinUtils.setLocalStorageItem(AnalyticsConstants.stringConstants.LOCAL_STORAGE_Q, JSON.stringify(queue));
        }
    }
}

/**
 * Created by sunny on 06/04/17.
 *
 * Only this file will be used by client to store/sent any analytics data
 */
class AnalyticsService {
    constructor(config, headerFields) {
        AnalyticsService.logger.info('Instance created!');
        this.primaryUrl = config.URL;
        this.payloadQueueLimit = config.PAYLOAD_QUEUE_LIMIT;
        this.store = new AnalyticsStore();
        this.storageService = new StorageService(this.payloadQueueLimit);
        this.headerFields = headerFields;
    }
    /**
     * Sending captured analytics data to server
     * First
     * First trying with primary approach with the 'POST'
     * If it fails, trying with secondary approach by appending data in 'GET' URL of image
     */
    sendStoredAnalytics() {
        let self = this;
        return new Promise((resolve) => {
            try {
                //Loop over stored analytics-module objects of local-storage
                let offlinePayloadQueue;
                // Shifting all saved analytics payload to app memory for sending
                offlinePayloadQueue = this.storageService.getOfflineQueue();
                for (let payload of offlinePayloadQueue) {
                    this.addPayload(payload, AnalyticsConstants.memoryType.APP_MEMORY);
                }
                let payloadQueue = this.storageService.getPayloadQueue();
                this.storageService.flushPayloadQueue();
                AnalyticsService.logger.info('Sending StoredAnalytics, payloadQueue : ' + JSON.stringify(payloadQueue));
                if (payloadQueue.length) {
                    //Send whole queue to analytic server
                    //Success : remove from local storage by StorageService.flushPayloadQueue()
                    //Failure : retain in local storage, do nothing
                    fetch(self.primaryUrl, {
                        method: 'POST',
                        body: self.processPayload(payloadQueue)
                    }).then((response) => {
                        if (response.ok) {
                            AnalyticsService.logger.debug('sendStoredAnalytics success');
                            resolve();
                        }
                        else {
                            throw new Error();
                        }
                    }).catch((error) => {
                        AnalyticsService.logger.info('sendStoredAnalytics failed');
                        for (let payload of payloadQueue) {
                            payload['error_message'] = payload['error_message'] ? payload['error_message'] + ':sendFailed ' : 'sendFailed ';
                            self.storageService.addToOfflineQ(payload);
                        }
                        resolve();
                    });
                }
                else {
                    resolve();
                }
            }
            catch (error) {
                AnalyticsService.logger.warn('Exception :' + JSON.stringify(error));
                resolve();
            }
        });
    }
    /**
     * Restructuring fields into headers, attributes and metrics as given in
     * https://confluence-tsi.sats.corp/display/SLING/Slurry
     * and formatting before sending to analytic server
     *
     * @param data
     * @returns {any}
     */
    processPayload(data) {
        //Sample Input
        // [
        //     {
        //         "table_name":"slingnet_cps",
        //         "finder_id":"70CDC5E0-6F14-C75B0987-91A0-B08857EA",
        //         "host_browser_name":"Chrome",
        //         "host_browser_ver":"58.0.3029",
        //         "outcome":"0","time_till_play":5.97,
        //         "wan_lan":"wan"
        //     },
        //     {
        //         "table_name":"slingnet_connection",
        //         "avg_bitrate":315.09,
        //         "conn_protocol":"DASH",
        //         "conn_type":"TCP",
        //         "disconnect_method":"3",
        //         "finder_id":"70CDC5E0-6F14-C75B0987-91A0-B08857EA",
        //         "session_length":55.4,
        //         "user_app":"HollywoodPlayer"
        //         ,"wan_lan":"wan"
        //     }
        // ]
        let payloads = [];
        for (let info of data) {
            let payload = {
                header: {},
                event_info: {
                    metrics: {},
                    attributes: {}
                }
            };
            for (let field in info) {
                if (info.hasOwnProperty(field)) {
                    // Populating table name in header for each analytic payload
                    let tableName = AnalyticsConstants.stringConstants.TABLE;
                    if (field === tableName) {
                        payload.header[AnalyticsConstants.stringConstants.event_category] = info[tableName];
                    }
                    else if (field === AnalyticsConstants.stringConstants.TABLE_TIME) {
                        continue; //Don't want to do anything when field name is equal to TABLE_TIME
                    }
                    else {
                        if (this.headerFields.indexOf(field) > -1) {
                            payload.header[field] = info[field];
                        }
                        else {
                            // Populating metrics and attributes of each analytic payload
                            if (typeof (info[field]) === 'number') {
                                payload.event_info.metrics[field] = info[field];
                            }
                            else {
                                payload.event_info.attributes[field] = info[field];
                            }
                        }
                    }
                }
            }
            if (Object.keys(payload.event_info.metrics).length === 0) {
                delete payload.event_info.metrics;
            }
            // Assembling structured payload
            payloads.push(payload);
        }
        // As per REST API definition, payloads are restructured by grouping fields in headers, metrics and  attributes
        // [
        //     {
        //         "header":{
        //                 "event_category":"slingnet_cps",
        //                 "finder_id":"70CDC5E0-6F14-C75B0987-91A0-B08857EA",
        //                 "host_browser_name":"Chrome",
        //                 "host_browser_ver":"58.0.3029"
        //             },
        //         "event_info":{
        //             "metrics":{
        //                 "time_till_play":5.97
        //             },
        //             "attributes":{
        //                 "outcome":"0",
        //                 "wan_lan":"wan"
        //             }
        //         }
        //     },{
        //         "header":{
        //             "event_category":"slingnet_connection",
        //             "finder_id":"70CDC5E0-6F14-C75B0987-91A0-B08857EA"
        //         },
        //         "event_info":{
        //             "metrics":{
        //                 "avg_bitrate":315.09,
        //                 "session_length":55.4
        //             },
        //             "attributes":{
        //                 "conn_protocol":"DASH",
        //                 "conn_type":"TCP",
        //                 "disconnect_method":"3",
        //                 "user_app":"HollywoodPlayer",
        //                 "wan_lan":"wan"
        //             }
        //         }
        //     }
        // ]
        // Formatting payload
        if (window['encodeURIComponent']) {
            return encodeURIComponent(JSON.stringify(payloads));
        }
        else {
            return encodeURI(JSON.stringify(payloads));
        }
        // Finally payloads is formatted by replacing special characters
        //"%5B%7B%22header%22%3A%7B%22event_category%22%3A%22slingnet_cps%22%2C%22
        // finder_id%22%3A%2270CDC5E0-6F14-C75B0987-91A0-B08857EA%22%2C%22host_browser_name%22%3A%22Chrome%22%2C%22
        // host_browser_ver%22%3A%2258.0.3029%22%7D%2C%22event_info%22%3A%7B%22metrics%22%3A%7B%22
        // time_till_play%22%3A5.97%7D%2C%22attributes%22%3A%7B%22outcome%22%3A%220%22%2C%22
        // wan_lan%22%3A%22wan%22%7D%7D%7D%2C%7B%22
        // header%22%3A%7B%22event_category%22%3A%22slingnet_connection%22%2C%22
        // finder_id%22%3A%2270CDC5E0-6F14-C75B0987-91A0-B08857EA%22%7D%2C%22event_info%22%3A%7B%22metrics%22%3A%7B%22
        // avg_bitrate%22%3A315.09%2C%22session_length%22%3A55.4%7D%2C%22attributes%22%3A%7B%22
        // conn_protocol%22%3A%22DASH%22%2C%22conn_type%22%3A%22TCP%22%2C%22disconnect_method%22%3A%223%22%2C%22
        // user_app%22%3A%22HollywoodPlayer%22%2C%22wan_lan%22%3A%22wan%22%7D%7D%7D%5D"
    }
    // *** AnalyticsStore WRAPPER ***
    /**
     * Sets the value of mentioned property in AnalyticsStore
     * @param name
     * @param value
     */
    setAnalyticsProp(name, value) {
        this.store.setAnalyticsProp(name, value);
    }
    /**
     * Fetch the value of mentioned property
     * @param name
     * @returns {any}
     */
    getAnalyticsProp(name) {
        return this.store.getAnalyticsProp(name);
    }
    resetAnalyticStore(clientInfo) {
        this.store.resetAnalyticStore(clientInfo);
    }
    /**
     * StorageService WRAPPER to add addPayload
     * @param payload
     * @param {string} memoryType
     */
    addPayload(payload, memoryType) {
        if (memoryType === AnalyticsConstants.memoryType.APP_MEMORY) {
            this.storageService.addPayload(payload);
        }
        else {
            //By default always save analytics payload to localStorage so that it is never lost for web
            this.storageService.addToOfflineQ(payload);
        }
    }
    removePayload(keys) {
        /*
        For platforms (non-web, where localStorage support is not present) using only APP_MEMORY
        this.storageService.removePayload(keys, AnalyticsConstants.memoryType.APP_MEMORY);
        */
        //By default always save analytics payload to localStorage so that it is never lost for web
        this.storageService.removePayload(keys, AnalyticsConstants.memoryType.LOCAL_STORAGE);
    }
}
AnalyticsService.logger = new AustinLogger('AnalyticsService');

/**
 * Created by sunny on 25/04/17.
 *
 * Note: session_id is unique connection session id generated by client
 */
let AnalyticsHelperConstants = {
    memoryType: AnalyticsConstants.memoryType,
    // List of analytics properties
    avgBitrate: 'avg_bitrate',
    bitrateAtQuit: 'bitrate_at_quit',
    bufferingCount: 'buffering_count',
    bufferingDuration: 'buffering_duration',
    clientId: 'client_id',
    clientLanIp: 'client_lan_ip',
    clientWanIp: 'client_wan_ip',
    clientVersion: 'client_version',
    clientConnectedToPort: 'client_connected_to_port',
    clientTimeStamp: 'client_timestamp',
    clientInternetStatus: 'client_internet_status',
    connProtocol: 'conn_protocol',
    connType: 'conn_type',
    disconnectMethod: 'disconnect_method',
    errorCode: 'error_code',
    errorMessage: 'error_message',
    finderId: 'finder_id',
    frameRenderSuccessAt: 'frameRenderSuccessAt',
    hostBrowserName: 'host_browser_name',
    hostBrowserVer: 'host_browser_ver',
    lanWan: 'lan_wan',
    lastSparcsReg: 'last_sparcs_reg',
    localStartTime: 'local_start_time',
    localEndTime: 'local_end_time',
    osName: 'os_name',
    osVer: 'os_ver',
    outcome: 'outcome',
    playerInstanceId: 'player_instance_id',
    receiverId: 'receiver_id',
    relayConnStatus: 'relay_conn_status',
    relayConnTime: 'relay_conn_time',
    relayIp: 'relay_ip',
    relayServer: 'relay_server',
    requestedResolution: 'requested_resolution',
    requestedCodecVideo: 'requested_codec_video',
    requestedCodecAudio: 'requested_codec_audio',
    requestedLeboProfile: 'requested_lebo_profile',
    resolutionAtStart: 'resolution_at_start',
    resolutionAtQuit: 'resolution_at_quit',
    sbFwVersion: 'sb_fw_version',
    sbSessionId: 'sb_session_id',
    sbInputType: 'sb_input_type',
    sbProductName: 'sb_product_name',
    sbProductSignature: 'sb_product_signature',
    sbLanIp: 'sb_lan_ip',
    sbWanIp: 'sb_wan_ip',
    sessionId: 'session_id',
    sessionLength: 'session_length',
    spsdkVersion: 'spsdk_version',
    tcpConnStatus: 'tcp_conn_status',
    tcpConnTime: 'tcp_conn_time',
    timeTillPlay: 'time_till_play',
    totalKbStreamed: 'total_kb_streamed',
    userApp: 'user_app',
    userAgent: 'user_agent',
    usingStreamingProxy: 'using_streaming_proxy',
    uuid: 'uuid',
    wanLan: 'wan_lan',
    productName: {
        '000009': 'slingbox_922s',
        '000010': 'slingbox_sbsdk_xip813',
        '000013': 'slingbox_sbsdk_xip913',
        '000050': 'slingbox_sbsdk_rooster',
        '000070': 'slingbox_sbsdk_zip'
    },
    // Dependent properties on the key mentioned above
    SLINGNET_CPS: {},
    SLINGNET_CONNECTION: {},
    DISH_STREAMS: {},
    webClientProps: [],
    payloadConfig: {
        headers: []
    },
    analytics_outcome: {
        sb_stream_playback_okay: '0',
        unknown_outcome: '1',
        sp_no_internet: '100',
        sb_unregistered: '101',
        sn_connect_failed: '102',
        sn_sparcs_unreachable: '104',
        sn_sparcs_server_error: '105',
        sbsdk_me_reboot: '107',
        sb_offline_hbt: '130',
        sb_bad_state_hbt: '131',
        sb_online_but_unreachable_hbt: '132',
        sb_connection_lost: '133',
        sb_all_ctrl_session_active: '134',
        sb_password_failure: '150',
        sb_unsupported: '302',
        sb_conflict_cancelled: '303',
        sb_conflict_detected: '304',
        sp_render_start_failure: '550',
        //57x is new outcome defined for Austin to reduce 550 counts
        sb_unsupported_firmware: '570',
        sb_not_ready: '571',
        sb_missing_drm: '572',
        sb_play_failed: '573',
        sp_setup_failed: '575',
        sp_licence_error: '576',
        sp_playback_not_started: '577',
        sp_lan_access_denied: '578',
        user_connect_abort_in_0_to_5_sec: '610',
        user_connect_abort_in_5_to_10_sec: '611',
        user_connect_abort_in_10_plus_sec: '612',
    },
    // These are possible reasons for stop streaming
    analytics_disconnect_method: {
        box_taken_over: 1,
        connection_lost: 2,
        user_disconnect: 3,
        client_crashed: 4,
        network_problem: 6,
        media_engine_reboot: 8,
        stb_unknown_reason: 16,
        stb_all_session_active: 30,
        client_window_closed: 31,
        popup_user_action_handling_failed: 32 //popUpUserAction handling failure
    },
};
// Property name for slingnet_cps table
AnalyticsHelperConstants.SLINGNET_CPS = {
    name: 'slingnet_cps_v2',
    props: [
        AnalyticsHelperConstants.clientId,
        AnalyticsHelperConstants.clientVersion,
        AnalyticsHelperConstants.clientConnectedToPort,
        AnalyticsHelperConstants.clientInternetStatus,
        AnalyticsHelperConstants.clientLanIp,
        AnalyticsHelperConstants.clientWanIp,
        AnalyticsHelperConstants.errorCode,
        AnalyticsHelperConstants.errorMessage,
        AnalyticsHelperConstants.finderId,
        AnalyticsHelperConstants.hostBrowserName,
        AnalyticsHelperConstants.hostBrowserVer,
        AnalyticsHelperConstants.lastSparcsReg,
        AnalyticsHelperConstants.localStartTime,
        AnalyticsHelperConstants.osName,
        AnalyticsHelperConstants.osVer,
        AnalyticsHelperConstants.outcome,
        AnalyticsHelperConstants.playerInstanceId,
        AnalyticsHelperConstants.relayConnStatus,
        AnalyticsHelperConstants.relayConnTime,
        AnalyticsHelperConstants.relayIp,
        AnalyticsHelperConstants.relayServer,
        AnalyticsHelperConstants.requestedResolution,
        AnalyticsHelperConstants.requestedCodecAudio,
        AnalyticsHelperConstants.requestedCodecVideo,
        AnalyticsHelperConstants.requestedLeboProfile,
        AnalyticsHelperConstants.sbFwVersion,
        AnalyticsHelperConstants.sbSessionId,
        AnalyticsHelperConstants.sbInputType,
        AnalyticsHelperConstants.sbProductName,
        AnalyticsHelperConstants.sbProductSignature,
        AnalyticsHelperConstants.sbLanIp,
        AnalyticsHelperConstants.sbWanIp,
        AnalyticsHelperConstants.sessionId,
        AnalyticsHelperConstants.spsdkVersion,
        AnalyticsHelperConstants.tcpConnStatus,
        AnalyticsHelperConstants.tcpConnTime,
        AnalyticsHelperConstants.timeTillPlay,
        AnalyticsHelperConstants.userAgent,
        AnalyticsHelperConstants.userApp,
        AnalyticsHelperConstants.usingStreamingProxy,
        AnalyticsHelperConstants.wanLan // connection session data
    ]
};
// Property name for slingnet_connection table
AnalyticsHelperConstants.SLINGNET_CONNECTION = {
    name: 'slingnet_connection_v2',
    props: [
        AnalyticsHelperConstants.avgBitrate,
        AnalyticsHelperConstants.bitrateAtQuit,
        AnalyticsHelperConstants.bufferingCount,
        AnalyticsHelperConstants.bufferingDuration,
        AnalyticsHelperConstants.clientId,
        AnalyticsHelperConstants.clientInternetStatus,
        AnalyticsHelperConstants.clientVersion,
        AnalyticsHelperConstants.connProtocol,
        AnalyticsHelperConstants.connType,
        AnalyticsHelperConstants.disconnectMethod,
        AnalyticsHelperConstants.errorCode,
        AnalyticsHelperConstants.errorMessage,
        AnalyticsHelperConstants.finderId,
        AnalyticsHelperConstants.localStartTime,
        AnalyticsHelperConstants.localEndTime,
        AnalyticsHelperConstants.playerInstanceId,
        AnalyticsHelperConstants.resolutionAtStart,
        AnalyticsHelperConstants.resolutionAtQuit,
        AnalyticsHelperConstants.sbFwVersion,
        AnalyticsHelperConstants.sbProductName,
        AnalyticsHelperConstants.sbProductSignature,
        AnalyticsHelperConstants.sessionId,
        AnalyticsHelperConstants.sessionLength,
        AnalyticsHelperConstants.spsdkVersion,
        AnalyticsHelperConstants.totalKbStreamed,
        AnalyticsHelperConstants.userAgent,
        AnalyticsHelperConstants.userApp,
        AnalyticsHelperConstants.wanLan // connection session data
    ]
};
// Property name for dish_streams table
AnalyticsHelperConstants.DISH_STREAMS = {
    name: 'dish_streams',
    props: [
        AnalyticsHelperConstants.clientId,
        AnalyticsHelperConstants.clientVersion,
        AnalyticsHelperConstants.clientTimeStamp,
        AnalyticsHelperConstants.lanWan,
        AnalyticsHelperConstants.receiverId,
        AnalyticsHelperConstants.uuid,
    ]
};
// These properties will be captured only once per web session
// and will remain same across  different sb-session
AnalyticsHelperConstants.webClientProps = [
    AnalyticsHelperConstants.clientId,
    AnalyticsHelperConstants.clientVersion,
    AnalyticsHelperConstants.hostBrowserName,
    AnalyticsHelperConstants.hostBrowserVer,
    AnalyticsHelperConstants.osName,
    AnalyticsHelperConstants.osVer,
    AnalyticsHelperConstants.spsdkVersion,
    AnalyticsHelperConstants.userAgent,
    AnalyticsHelperConstants.userApp
];
// At present connection and cps tables have these fields in headers
AnalyticsHelperConstants.payloadConfig = {
    headers: [
        AnalyticsHelperConstants.clientId,
        AnalyticsHelperConstants.clientVersion,
        AnalyticsHelperConstants.finderId,
        AnalyticsHelperConstants.hostBrowserName,
        AnalyticsHelperConstants.hostBrowserVer,
        AnalyticsHelperConstants.osName,
        AnalyticsHelperConstants.osVer,
        AnalyticsHelperConstants.playerInstanceId,
        AnalyticsHelperConstants.sessionId,
        AnalyticsHelperConstants.sbFwVersion,
        AnalyticsHelperConstants.sbProductName,
        AnalyticsHelperConstants.sbProductSignature,
        AnalyticsHelperConstants.sbSessionId,
        AnalyticsHelperConstants.spsdkVersion,
        AnalyticsHelperConstants.userAgent
    ]
    // We can also explicitly mention metrics and attributes fields,
    // Now all numeric are in metrics, and remaining non-numerics are in _attributes
    //_metrics: [], // will have all numeric values
    //_attributes: [] // all other fiels will be here
};

/**
 * Created by sunny on 18/04/17.
 * This component can be used to know client information like
 * Browser name, version
 * OS name, version
 */
class ClientInfo {
    constructor(analytics) {
        this.analytics = analytics;
    }
    /**
     * Gathers and set all the client data for analytics
     * @param appInfo
     */
    setAnalyticsClientData(appInfo) {
        let browserDetails = this.getBrowserDetails();
        let osDetails = this.getOsDetails();
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.hostBrowserName, browserDetails.name);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.hostBrowserVer, browserDetails.version);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientId, this.getClientId());
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientVersion, appInfo.appVersion);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.spsdkVersion, appInfo.version);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.osName, osDetails.name);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.osVer, osDetails.version);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.userAgent, navigator.userAgent);
        //Expose API to client to set it
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.userApp, appInfo.name);
    }
    /**
     * Order of if-else with browser keyword is very important.
     * Changing the order will give wrong result
     * @private
     */
    getBrowserDetails() {
        let browser = {
            name: 'NAV',
            version: 'NAV'
        };
        try {
            let nAgt = navigator.userAgent;
            if (nAgt.indexOf('DuckDuckGo/') !== -1) {
                browser.name = 'DuckDuckGo';
                browser.version = JSON.stringify(parseFloat(nAgt.split('DuckDuckGo/')[1]));
            }
            else if (nAgt.indexOf('SamsungBrowser/') !== -1) {
                browser.name = 'SamsungBrowser';
                browser.version = JSON.stringify(parseFloat(nAgt.split('SamsungBrowser/')[1]));
            }
            else if (nAgt.indexOf('Silk/') !== -1) {
                browser.name = 'Silk';
                browser.version = nAgt.split('Silk/')[1].split('.')[0].trim();
            }
            else if (nAgt.indexOf('Avast/') !== -1) {
                browser.name = 'Avast';
                // In Avast, the version is at last after 'Avast/'
                browser.version = nAgt.split('Avast/')[1];
            }
            else if ((nAgt.indexOf('Opera') !== -1) || (nAgt.indexOf('OPR') !== -1)) {
                browser.name = 'Opera';
                // In Opera, the true version is after 'OPR'
                if (nAgt.indexOf('OPR') !== -1) {
                    browser.version = nAgt.split('OPR/')[1];
                }
            }
            else if (nAgt.indexOf('CrKey') !== -1) {
                browser.name = 'Chromecast';
                browser.version = nAgt.split('CrKey/')[1];
            }
            else if (nAgt.indexOf('Edg') !== -1) {
                browser.name = 'Edge';
                browser.version = nAgt.split('Edg')[1].split('/')[1];
            }
            else if (nAgt.indexOf('Chrome') !== -1) {
                browser.name = 'Chrome';
                let versionInfo = nAgt.split('Chrome/')[1].split('.');
                browser.version = versionInfo[0] + '.' + versionInfo[1] + '.' + versionInfo[2];
            }
            else if ((nAgt.indexOf('Safari') !== -1) && (AustinConstants.PLATFORM.WEB === AustinUtils.getPlatForm())) {
                browser.name = 'Safari';
                // In Safari, the true version is after 'Safari' or after 'Version'
                let versionInfo = nAgt.split('Version/')[1].split(' ');
                browser.version = versionInfo[0];
            }
            else if (nAgt.indexOf('Firefox') !== -1) {
                browser.name = 'Firefox';
                browser.version = nAgt.split('Firefox/')[1];
            }
            else if (this.isIE()) {
                browser.name = 'IE';
                if (nAgt.indexOf('rv:') !== -1) {
                    // For IE 11  .....rv:11.0)...
                    browser.version = nAgt.split('rv:')[1].split(')')[0];
                }
                else if (nAgt.indexOf('MSIE') !== -1) {
                    //For IE 10  ....; MSIE 10.0;....
                    browser.version = nAgt.split(';')[1].split('MSIE')[1].trim();
                }
            }
        }
        catch (e) {
            // Change in pattern for userAgent has broken the above code
            // tslint:disable-next-line:no-console
            console.log(e);
        }
        return browser;
    }
    /**
     * //IF IE > 10
     * @returns {boolean}
     */
    isIE() {
        return (navigator.userAgent.indexOf('MSIE') !== -1) || (!!document['documentMode'] === true);
    }
    /**
     * Separate os info from userAgent eg.
     * Macintosh; Intel Mac OS X 10_12_1
     * Macintosh; Intel Mac OS X 10.12; rv:52.0
     * Windows NT 6.3; Win64; x64
     */
    getOsDetails() {
        let os = {
            name: 'NAV',
            version: 'NAV'
        };
        try {
            if (AustinConstants.PLATFORM.WEB === AustinUtils.getPlatForm()) {
                let osString = navigator.userAgent.split('(')[1].split(')')[0];
                // Macintosh, Mac os
                if (osString.indexOf('Mac') !== -1) {
                    os.name = 'Mac';
                    let versionString = osString.split(';')[1];
                    os.version = versionString.split('Mac OS X ')[1];
                }
                // Windows 10
                if (osString.indexOf('Windows NT 10.0') !== -1) {
                    os.name = 'Windows';
                    os.version = '10.0';
                }
                // Windows 8.1
                if (osString.indexOf('Windows NT 6.3') !== -1) {
                    os.name = 'Windows';
                    os.version = '6.3';
                }
                // Windows 8
                if (osString.indexOf('Windows NT 6.2') !== -1) {
                    os.name = 'Windows';
                    os.version = '6.2';
                }
                // Windows 7
                if (osString.indexOf('Windows NT 6.1') !== -1) {
                    os.name = 'Windows';
                    os.version = '6.1';
                }
                if (osString.indexOf('X11; Linux armv7l') !== -1) {
                    os.name = 'Chromecast';
                    os.version = osString.split('; ')[1];
                }
                if (osString.indexOf('CrOS') !== -1) {
                    os.name = 'ChromeOS';
                    os.version = osString.split('CrOS ')[1];
                }
                if (osString.indexOf('X11; Linux') !== -1) {
                    os.name = 'Linux';
                    os.version = osString.split('X11; Linux ')[1];
                }
            }
            else {
                let osString = navigator.userAgent.split('(')[1].split(')')[0];
                if (osString.indexOf('X11; Linux armv7l') !== -1) {
                    os.name = 'Chromecast';
                    os.version = osString.split('; ')[1];
                }
            }
            let ua = navigator.userAgent.toLowerCase();
            let isAndroid = ua.indexOf('android') !== -1;
            let isMobile = ua.indexOf('mobile') !== -1;
            let isIPhone = ua.indexOf('iphone') !== -1;
            let isIPad = ua.indexOf('ipad') !== -1;
            if (AustinUtils.isTvOS()) {
                os.name = 'tvOS';
                os.version = ua.split('CPU iPhone OS')[1].split('like Mac')[0].trim();
            }
            else if (AustinUtils.isAndroidTV()) {
                os.name = 'AndroidTV';
                os.version = ua.split('android')[1].split(';')[0].trim();
            }
            else if (AustinUtils.isFireTV()) {
                os.name = 'FireTV';
                os.version = ua.split('android')[1].split(';')[0].trim();
            }
            else if (isAndroid) {
                os.name = isMobile ? 'Android' : 'Tablet';
                os.version = ua.split('android')[1].split(';')[0].trim();
            }
            else if (isIPad) {
                os.name = 'iPad';
                os.version = ua.split('os')[1].split('like mac')[0].trim();
            }
            else if (isIPhone) {
                os.name = 'iPhone';
                os.version = ua.split('cpu iphone os')[1].split('like mac')[0].trim();
            }
        }
        catch (e) {
            // Change in pattern for userAgent has broken the above code
            // tslint:disable-next-line:no-console
            console.log(e);
        }
        return os;
    }
    /**
     * Returns 'html5-' + (win/mac/android/tablet/ipad/iphone)
     * @returns {string}
     */
    getClientId() {
        let id = 'html5-';
        id += this.getOsDetails().name === 'Windows' ? 'win' : this.getOsDetails().name.toLowerCase();
        return id;
    }
}

/**
 * Created by sunny on 20/04/17.
 * Collects all the data from time when connection is attempted to first frame rendered and modifies required payloads
 */
class ConnectionInfo {
    constructor(analytics) {
        this.outcomePriorityList = [
            AnalyticsHelperConstants.analytics_outcome.unknown_outcome,
            AnalyticsHelperConstants.analytics_outcome.sn_sparcs_unreachable,
            AnalyticsHelperConstants.analytics_outcome.sn_sparcs_server_error,
            AnalyticsHelperConstants.analytics_outcome.sb_conflict_detected,
            AnalyticsHelperConstants.analytics_outcome.sp_render_start_failure,
            AnalyticsHelperConstants.analytics_outcome.sp_lan_access_denied,
            AnalyticsHelperConstants.analytics_outcome.sn_connect_failed,
            AnalyticsHelperConstants.analytics_outcome.sb_all_ctrl_session_active,
            AnalyticsHelperConstants.analytics_outcome.sb_bad_state_hbt,
            AnalyticsHelperConstants.analytics_outcome.sb_online_but_unreachable_hbt,
            AnalyticsHelperConstants.analytics_outcome.sb_connection_lost,
            AnalyticsHelperConstants.analytics_outcome.sb_offline_hbt,
            AnalyticsHelperConstants.analytics_outcome.user_connect_abort_in_0_to_5_sec,
            AnalyticsHelperConstants.analytics_outcome.user_connect_abort_in_5_to_10_sec,
            AnalyticsHelperConstants.analytics_outcome.user_connect_abort_in_10_plus_sec,
            AnalyticsHelperConstants.analytics_outcome.sp_no_internet,
            AnalyticsHelperConstants.analytics_outcome.sb_unregistered,
            AnalyticsHelperConstants.analytics_outcome.sb_unsupported,
            AnalyticsHelperConstants.analytics_outcome.sb_unsupported_firmware,
            AnalyticsHelperConstants.analytics_outcome.sbsdk_me_reboot,
            AnalyticsHelperConstants.analytics_outcome.sp_playback_not_started,
            AnalyticsHelperConstants.analytics_outcome.sb_play_failed,
            AnalyticsHelperConstants.analytics_outcome.sb_password_failure,
            AnalyticsHelperConstants.analytics_outcome.sb_not_ready,
            AnalyticsHelperConstants.analytics_outcome.sp_setup_failed,
            AnalyticsHelperConstants.analytics_outcome.sp_licence_error,
            AnalyticsHelperConstants.analytics_outcome.sb_missing_drm,
            AnalyticsHelperConstants.analytics_outcome.sb_conflict_cancelled,
            AnalyticsHelperConstants.analytics_outcome.sb_stream_playback_okay
        ];
        this.analytics = analytics;
    }
    /**
     * Collects and store all the data from connection is attempted to connection is successful/failed
     * Note: null check is required before processing params properties eg. boxInfo.finderId.replace()
     * @param boxInfo
     * @param relayServerInfo
     * @param sessionInfo
     */
    setAnalyticsCpsConnectionData(boxInfo, relayServerInfo, sessionInfo) {
        if (boxInfo.finderId) {
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.finderId, boxInfo.finderId.replace(/[^a-zA-Z0-9]/g, ''));
        }
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sessionId, sessionInfo.webSessionId);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbSessionId, sessionInfo.boxSessionId);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbFwVersion, boxInfo.firmwareVersion);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.receiverId, boxInfo.receiverId);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.uuid, sessionInfo.uuid);
        if (sessionInfo.clientLocalIp) {
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientLanIp, sessionInfo.clientLocalIp);
        }
        if (sessionInfo.clientPublicIp) {
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientWanIp, sessionInfo.clientPublicIp);
        }
        if (sessionInfo.connectionMode === 'RELAY') {
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.wanLan, 'wan');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.lanWan, 'WAN');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.relayConnStatus, 1);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.relayConnTime, sessionInfo.timeTaken);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.relayIp, relayServerInfo.ip);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.relayServer, relayServerInfo.servername);
            if (sessionInfo.usingStreamingProxy) {
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.usingStreamingProxy, 1);
            }
            // NOTE: Port mentioned is relay server port for relay connection
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientConnectedToPort, relayServerInfo.port);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.connType, 'RELAY');
        }
        else if (sessionInfo.connectionMode === 'LAN' || sessionInfo.connectionMode === 'TCP') {
            let wanLan = sessionInfo.connectionMode === 'LAN' ? 'lan' : 'wan';
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.wanLan, wanLan);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.lanWan, wanLan.toUpperCase());
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.tcpConnStatus, 1);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.tcpConnTime, sessionInfo.timeTaken);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientConnectedToPort, boxInfo.boxPort);
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.connType, 'TCP');
        }
        //From sparcs
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbProductSignature, boxInfo.sbProductSignature || boxInfo.productSignature);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.lastSparcsReg, boxInfo.lastSparcsRegistered);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbLanIp, boxInfo.sbLanIp);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbWanIp, boxInfo.sbWanIp);
        // This will be error sent by box
        //this.analytics.setAnalyticsProp('error_code', null);
        // Client has to do mapping
        let productSignature = this.analytics.getAnalyticsProp(AnalyticsHelperConstants.sbProductSignature);
        if (productSignature && productSignature.length > 5) {
            let key = productSignature.substr(productSignature.length - 6);
            let productName = AnalyticsHelperConstants.productName[key];
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbProductName, productName);
        }
    }
    setOutcome(outcome) {
        if (this.isValidToSet(outcome)) {
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.outcome, outcome);
        }
    }
    /**
     * Decide whether to override previously set outcome or not
     * @param outcome
     * @returns {boolean}
     */
    isValidToSet(outcome) {
        let isValid = true;
        let outcomeLogged = this.analytics.getAnalyticsProp(AnalyticsHelperConstants.outcome);
        // More specific reason for connection disconnect_method has been set before
        if (outcomeLogged &&
            this.outcomePriorityList.indexOf(outcomeLogged) > this.outcomePriorityList.indexOf(outcome)) {
            isValid = false;
        }
        return isValid;
    }
}

/**
 * Created by sunny on 20/04/17.
 * Collects all the data related to streaming for the analytics
 */
class AnalyticsStreamingInfo {
    constructor(analytics) {
        this.disconnectPriorityList = [
            AnalyticsHelperConstants.analytics_disconnect_method.client_window_closed,
            AnalyticsHelperConstants.analytics_disconnect_method.client_crashed,
            AnalyticsHelperConstants.analytics_disconnect_method.stb_unknown_reason,
            AnalyticsHelperConstants.analytics_disconnect_method.stb_all_session_active,
            AnalyticsHelperConstants.analytics_disconnect_method.user_disconnect,
            AnalyticsHelperConstants.analytics_disconnect_method.connection_lost,
            AnalyticsHelperConstants.analytics_disconnect_method.network_problem,
            AnalyticsHelperConstants.analytics_disconnect_method.popup_user_action_handling_failed,
            AnalyticsHelperConstants.analytics_disconnect_method.box_taken_over,
            AnalyticsHelperConstants.analytics_disconnect_method.media_engine_reboot,
        ];
        this.analytics = analytics;
    }
    /**
     * Streaming info used for analytics which are available at the start of streaming session
     * @param streamingInfo
     */
    setRequestedStreamingData(streamingInfo) {
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedResolution, streamingInfo.requested_resolution);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedCodecVideo, streamingInfo.requested_codec_video);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedCodecAudio, streamingInfo.requested_codec_audio);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedLeboProfile, streamingInfo.requested_lebo_profile);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.localStartTime, streamingInfo.local_start_time);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientTimeStamp, streamingInfo.clientTimeStamp);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.timeTillPlay, streamingInfo.time_till_play);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.connProtocol, streamingInfo.conn_protocol);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.frameRenderSuccessAt, streamingInfo.frameRenderSuccessAt);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.resolutionAtStart, streamingInfo.resolution_at_start);
    }
    /**
     * Streaming info used for analytics which are available at the end of streaming session
     * @param streamingSessionInfo
     */
    setStreamingSessionData(streamingSessionInfo) {
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.bitrateAtQuit, streamingSessionInfo.bitrate_at_quit);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.localEndTime, streamingSessionInfo.local_end_time);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.resolutionAtQuit, streamingSessionInfo.resolution_at_quit);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.avgBitrate, streamingSessionInfo.avg_bitrate);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.totalKbStreamed, streamingSessionInfo.total_kb_streamed);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.bufferingCount, streamingSessionInfo.buffering_count);
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.bufferingDuration, streamingSessionInfo.buffering_duration);
        let streamingStartedAt = 0;
        if (this.analytics.getAnalyticsProp(AnalyticsHelperConstants.frameRenderSuccessAt)) {
            streamingStartedAt = this.analytics.getAnalyticsProp(AnalyticsHelperConstants.frameRenderSuccessAt).getTime();
        }
        let streamingStoppedAt = 0;
        if (this.analytics.getAnalyticsProp(AnalyticsHelperConstants.localEndTime)) {
            streamingStoppedAt = this.analytics.getAnalyticsProp(AnalyticsHelperConstants.localEndTime).getTime();
        }
        let duration = 0;
        if (streamingStartedAt && streamingStoppedAt) {
            duration = parseFloat(((streamingStoppedAt - streamingStartedAt) / 1000).toFixed(2));
        }
        this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sessionLength, duration);
    }
    /**
     * Setting root cause of stream stop
     * @param disconnectReason
     */
    setDisconnectMethod(disconnectReason) {
        if (this.isValidToSet(disconnectReason)) {
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.disconnectMethod, disconnectReason);
        }
    }
    isValidToSet(disconnectReason) {
        let isValid = true;
        let reasonLogged = this.analytics.getAnalyticsProp(AnalyticsHelperConstants.disconnectMethod);
        // More specific reason for connection disconnect_method has been set before
        if (reasonLogged &&
            this.disconnectPriorityList.indexOf(reasonLogged) > this.disconnectPriorityList.indexOf(disconnectReason)) {
            isValid = false;
        }
        return isValid;
    }
}

/**
 * Created by sunny on 10/04/17.
 * IMPORTANT:
 * Make sure 'slingnet_connection_v2' payload is always set after 'slingnet_cps_v2' using setAnalyticsPayload()
 *
 *  Missing analytics properties for HTML5 playback in current analytics table
 *  1. Client latency fields
 *  2. Discontinuity data
 *  3. Client player errors
 *  4. Unique key for each streaming session
 */
class AnalyticsHelper {
    constructor(config) {
        this.analytics = new AnalyticsService(config, AnalyticsHelperConstants.payloadConfig.headers);
        this.clientInfo = new ClientInfo(this.analytics);
        this.connectionInfo = new ConnectionInfo(this.analytics);
        this.streamingInfo = new AnalyticsStreamingInfo(this.analytics);
    }
    /**
     * This method returns the AnalyticsHelper instance if already created. Else,
     * create a new instance and then return it.
     * @returns {AnalyticsHelper}
     */
    static getInstance(config) {
        if (!this.instance) {
            this.instance = new AnalyticsHelper(config);
        }
        return this.instance;
    }
    getAnalyticsPayloadForTable(table) {
        let payload = {};
        // Filtering all the payload fields for cps table from store
        payload[AnalyticsConstants.stringConstants.TABLE] = table.name;
        payload[AnalyticsConstants.stringConstants.TABLE_TIME] = new Date().getTime();
        for (let prop of table.props) {
            let value = this.analytics.getAnalyticsProp(prop);
            if (value) {
                payload[prop] = value;
            }
        }
        return payload;
    }
    /**
     * From the all gathered data, these method forms payload for both analytics table
     * __IMPORTANT__ : Make sure 'slingnet_connection_v2' payload is always set after 'slingnet_cps_v2'
     * @param table
     */
    setAnalyticsPayload(table) {
        let self = this;
        // Filtering all the payload fields for given table from store
        let payload = this.getAnalyticsPayloadForTable(table);
        //For web it will be saved to localStorage, for other platforms in APP memory
        // Once stored in payload clean up, analytics props so that it does not mess up with next attempt analytics
        // If not cleaned, higher priority of last session can not be replaced by next session outcome/disconnectMethod
        // Note: we can not clean up all, as few props are common to both table, few are never changed so set only once
        if (table.name === AnalyticsHelperConstants.SLINGNET_CPS['name']) {
            if (payload[AnalyticsHelperConstants.outcome] === AnalyticsHelperConstants.analytics_outcome.sb_stream_playback_okay) {
                let clientId = this.analytics.getAnalyticsProp(AnalyticsHelperConstants.clientId);
                let dishStreamsClientId = clientId;
                switch (clientId) {
                    case 'html5-iphone':
                        dishStreamsClientId = 'dish-sg-iphone';
                        break;
                    case 'html5-ipad':
                        dishStreamsClientId = 'dish-sg-ipad';
                        break;
                    case 'html5-tvos':
                        dishStreamsClientId = 'dish-sg-Tv';
                        break;
                    case 'html5-tablet':
                        dishStreamsClientId = 'DRA_Android_Tablet';
                        break;
                    case 'html5-android':
                        dishStreamsClientId = 'DRA_Android_Phone';
                        break;
                    case 'html5-androidtv':
                        dishStreamsClientId = 'DRA_Android_Tv';
                        break;
                    case 'html5-firetv':
                        dishStreamsClientId = 'DRA_Android_FireTv';
                        break;
                    case 'html5-win':
                        dishStreamsClientId = 'wbsp-win';
                        break;
                    case 'html5-mac':
                        dishStreamsClientId = 'wbsp-mac';
                        break;
                }
                this.setAnalyticProperty(AnalyticsHelperConstants.clientId, dishStreamsClientId);
                this.analytics.addPayload(self.getAnalyticsPayloadForTable(AnalyticsHelperConstants.DISH_STREAMS));
                this.setAnalyticProperty(AnalyticsHelperConstants.clientId, clientId);
            }
            this.analytics.addPayload(payload);
            //resetting analytics props specific to 'slingnet_cps_v2' table after capturing them
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.outcome, '');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedResolution, '');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedCodecAudio, '');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedCodecVideo, '');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.requestedLeboProfile, '');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sbInputType, '');
            this.analytics.setAnalyticsProp(AnalyticsHelperConstants.timeTillPlay, '');
            //Note : Once SLINGNET_CPS payload is created, we should send it to server immediately at calling place
        }
        else if (table.name === AnalyticsHelperConstants.SLINGNET_CONNECTION['name']) {
            //Add for default payload else modify
            if (payload[AnalyticsHelperConstants.disconnectMethod] ===
                AnalyticsHelperConstants.analytics_disconnect_method.client_window_closed) {
                this.analytics.addPayload(payload); //This is payload is supposed to be modified later on stopStreaming
            }
            else {
                let keys = {};
                keys[AnalyticsConstants.stringConstants.TABLE] = table.name;
                keys[AnalyticsHelperConstants.playerInstanceId] = payload[AnalyticsHelperConstants.playerInstanceId];
                this.analytics.removePayload(keys);
                this.analytics.addPayload(payload);
                //resetting analytics props specific to 'slingnet_connection_v2' table after capturing them
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.avgBitrate, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.bitrateAtQuit, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.bufferingCount, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.bufferingDuration, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.clientInternetStatus, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.connProtocol, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.disconnectMethod, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.localEndTime, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.resolutionAtStart, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.resolutionAtQuit, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.sessionLength, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.totalKbStreamed, '');
                //resetting analytics props common to both table
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.errorCode, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.errorMessage, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.localStartTime, '');
                this.analytics.setAnalyticsProp(AnalyticsHelperConstants.playerInstanceId, '');
            }
        }
    }
    /**
     * Retain the client info and remove all others
     */
    resetAnalyticStore() {
        let clientInfo = {};
        for (let prop of AnalyticsHelperConstants.webClientProps) {
            clientInfo[prop] = this.analytics.getAnalyticsProp(prop);
        }
        this.analytics.resetAnalyticStore(clientInfo);
    }
    sendStoredAnalytics() {
        return this.analytics.sendStoredAnalytics();
    }
    setAnalyticsCpsConnectionData(boxInfo, relayServerInfo, sessionInfo) {
        this.connectionInfo.setAnalyticsCpsConnectionData(boxInfo, relayServerInfo, sessionInfo);
    }
    setOutcome(outcome) {
        this.connectionInfo.setOutcome(outcome);
    }
    /**
     *
     * @param hostDetails
     */
    setAnalyticsClientData(hostDetails) {
        this.clientInfo.setAnalyticsClientData(hostDetails);
    }
    setRequestedStreamingData(streamingInfo) {
        this.streamingInfo.setRequestedStreamingData(streamingInfo);
    }
    setStreamingSessionData(streamingSessionInfo) {
        this.streamingInfo.setStreamingSessionData(streamingSessionInfo);
    }
    setDisconnectMethod(disconnectReason) {
        this.streamingInfo.setDisconnectMethod(disconnectReason);
    }
    /**
     * Set the value of mentioned property
     * @param prop
     * @param value
     */
    setAnalyticProperty(prop, value) {
        this.analytics.setAnalyticsProp(prop, value);
    }
    /**
     * Append the value of mentioned property
     * @param prop
     * @param value
     */
    appendAnalyticProperty(prop, value) {
        let oldValue = this.analytics.getAnalyticsProp(prop);
        this.analytics.setAnalyticsProp(prop, oldValue ? (value + ';' + oldValue) : value);
    }
    /**
     * Instance of core analytics service
     * @returns {any}
     */
    getAnalytics() {
        return this.analytics;
    }
    /**
     * Returns an instance of client info
     * @returns {any}
     */
    getAnalyticsClientInfo() {
        return this.clientInfo;
    }
    /**
     * Returns an instance of AnalyticsConnectionInfo service
     * @returns {any}
     */
    getAnalyticsConnectionInfo() {
        return this.connectionInfo;
    }
    /**
     * Returns an instance of AnalyticsStreamingInfo service
     * @returns {any}
     */
    getAnalyticsStreamingInfo() {
        return this.streamingInfo;
    }
    /**
     * Fetch the value of mentioned property
     * @param prop
     * @returns {any}
     */
    getAnalyticProperty(prop) {
        return this.analytics.getAnalyticsProp(prop);
    }
}

/**
 * Created by sunny on 01/03/18.
 * Any possible error should be documented here
 */
let AustinErrors = {
    //Client errors
    ALREADY_CONNECTED: 'alreadyConnected',
    ALREADY_IN_CONNECTING: 'alreadyInConnecting',
    AUSTIN_NOT_INITIALIZED: 'austinNotInitialized',
    BOX_IN_BAD_STATE: 'boxInBadState',
    BOX_OFFLINE: 'boxOffline',
    BOX_ONLINE_BUT_UNREACHABLE: 'boxOnlineButUnreachable',
    CONNECTION_LOST: 'connectionLost',
    CLIENT_CONNECTIVITY_PROBLEM: 'clientConnectivityIssue',
    STREAM_STOP_REQUESTED: 'streamStopRequested',
    HTML5_PLAYBACK_NOT_SUPPORTED: 'html5PlaybackNotSupported',
    INVALID_CREATE_SESSION_PARAM: 'invalidCreateSessionParam',
    HDD_NOT_CONNECTED: 'hddNotConnected',
    MISSING_PLATFORM: 'missingPlatform',
    NOT_ALLOWED: 'notAllowed',
    NOT_ALLOWED_HDD_NOT_CONNECTED: 'notAllowedHddNotConnected',
    NOT_CONNECTED: 'notConnected',
    NOT_STREAMING: 'notStreaming',
    ALL_CRTL_SESS_ACTIVE: 'allCrtlSessActive',
    NO_STREAMING_FOUND: 'noStreamingFound',
    TIMEOUT: 'timeout',
    // Austin API errors : More details/root cause ie. error object received in Austin, will be added in info
    API_FAILED: 'apiFailed',
    AJAX_REQUEST_FAILED: 'ajaxRequestFailed',
    AUTHORIZATION_FAILED: 'authorizationFailed',
    BOX_NOT_READY: 'boxNotReady',
    CONNECT_FAILED: 'connectFailed',
    CONFLICT_RECORDINGS: 'conflictRecordings',
    CREATE_SESSION_FAILED: 'createSessionFailed',
    CREATE_RELAY_INSTANCE_FAILED: 'createRelayInstanceFailed',
    DUPLICATE_ACTIVE_RECORDING: 'duplicateActiveRecording',
    DUPLICATE_CONFLICTS: 'duplicateConflicts',
    DUPLICATE_TIMER: 'duplicateTimer',
    EXPIRED_SESSION_RESPONSE: 'expiredSessionResponse',
    FETCH_SPARCS_FAILED: 'fetchSparcsFailed',
    INVALID_CONTENT_TYPE: 'invalidContentType',
    INVALID_RI_RESPONSE: 'invalidRIResponse',
    INVALID_SPARCS_RESPONSE: 'invalidSparcsResponse',
    LEGACY_BOX_HTML5_DASH_UNSUPPORTED: 'legacyBoxHtml5DashUnsupported',
    MISSING_PLAYER_CONTAINER_ID_OR_ELEMENT: 'missingPlayerContainerIdOrElement',
    MISSING_STREAMING_LINK: 'missingStreamingLink',
    MISSING_LICENCE_URL: 'missingLicenceUrl',
    NO_VIDEO_SIGNAL: 'noVideoSignal',
    STREAM_LOST: 'streamLost',
    SESS_ID_NOT_FOUND: 'sessionIdNotFound',
    START_STREAM_REQUEST_TIMEOUT: 'startStreamRequestTimeout',
    TOO_MANY_STREAMS: 'tooManyStreams',
    TUNE_FAILED: 'tuneFailed',
    UNKNOWN_ERROR: 'unknownError',
    UNREACHABLE_SPARCS: 'unreachableSparcs',
    UNREGISTERED_SPARCS: 'unregisteredSparcs',
    // Player errors : More details/root cause ie. error object received from bitDash or dashJs, will be added in info
    PLAYER_ERROR: 'playerError',
    PLAYER_ERROR_WHILE_STREAMING: 'playerErrorWhileStreaming',
    // message text for detailed description
    INVALID_PARAMS: 'Client did not pass valid parameters',
    PLAYBACK_DID_NOT_START: {
        code: 7000,
        message: 'Playback did not start even after'
    },
    //iOS LAN Internet connection appears to be offline error
    PLAYBACK_DID_NOT_START_LAN_ACCESS_DENIED: {
        code: 7001,
        message: 'The Internet connection appears to be offline.'
    },
    //No Internet case
    PLAYBACK_DID_NOT_START_NO_INTERNET: {
        code: 7002,
        message: 'The Internet connection appears to be offline.'
    },
    //EME errors
    EME_DRM_LICENCE_SET_MEDIAKEY_FAILED: {
        code: 7101,
        message: 'EME DRM Error: setMediaKeys failed'
    },
    EME_DRM_LICENCE_GENERATE_REQUEST_FAILED: {
        code: 7102,
        message: 'EME DRM Error: generateRequest failed'
    },
    EME_DRM_LICENCE_FETCH_FAILED: {
        code: 7103,
        message: 'EME DRM Error: licence fetch failed'
    },
    EME_DRM_LICENCE_UPDATE_FAILED: {
        code: 7104,
        message: 'EME DRM Error: licence update failed'
    },
    BITMOVIN_LOAD_FAILED: {
        code: 7105,
        message: 'Bitmovin load failed'
    },
    EME_DRM_LICENCE_CONTENT_PROTECTION_MISSING_IN_MPD: {
        code: 7106,
        message: 'EME DRM Error: Content Protection init data missing in MPD '
    },
    EME_DRM_LICENCE_FETCH_WV_PROXY_ACCESS_DENIED: {
        code: 7107,
        message: 'EME DRM Error: wv proxy access denied'
    },
};

"use strict";

var isImplemented = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};

"use strict";

var isImplemented$1 = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};

"use strict";

// eslint-disable-next-line no-empty-function
var noop = function () {};

"use strict";

var _undefined = noop(); // Support ES3 engines

var isValue = function (val) { return val !== _undefined && val !== null; };

"use strict";



var keys = Object.keys;

var shim = function (object) { return keys(isValue(object) ? Object(object) : object); };

"use strict";

var keys$1 = isImplemented$1() ? Object.keys : shim;

"use strict";



var validValue = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};

"use strict";

var max   = Math.max;

var shim$1 = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(validValue(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys$1(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};

"use strict";

var assign = isImplemented() ? Object.assign : shim$1;

"use strict";



var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
var normalizeOptions = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};

// Deprecated

"use strict";

var isCallable = function (obj) { return typeof obj === "function"; };

"use strict";

var str = "razdwatrzy";

var isImplemented$2 = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};

"use strict";

var indexOf = String.prototype.indexOf;

var shim$2 = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};

"use strict";

var contains = isImplemented$2() ? String.prototype.contains : shim$2;

var d_1 = createCommonjsModule(function (module) {
'use strict';

var d;

d = module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if ((arguments.length < 2) || (typeof dscr !== 'string')) {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (dscr == null) {
		c = w = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
		w = contains.call(dscr, 'w');
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOptions(options), desc);
};

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== 'string') {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (get == null) {
		get = undefined;
	} else if (!isCallable(get)) {
		options = get;
		get = set = undefined;
	} else if (set == null) {
		set = undefined;
	} else if (!isCallable(set)) {
		options = set;
		set = undefined;
	}
	if (dscr == null) {
		c = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOptions(options), desc);
};
});

"use strict";

var validCallable = function (fn) {
	if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
	return fn;
};

var eventEmitter = createCommonjsModule(function (module, exports) {
'use strict';

var apply = Function.prototype.apply, call = Function.prototype.call
  , create = Object.create, defineProperty = Object.defineProperty
  , defineProperties = Object.defineProperties
  , hasOwnProperty = Object.prototype.hasOwnProperty
  , descriptor = { configurable: true, enumerable: false, writable: true }

  , on, once, off, emit, methods, descriptors, base;

on = function (type, listener) {
	var data;

	validCallable(listener);

	if (!hasOwnProperty.call(this, '__ee__')) {
		data = descriptor.value = create(null);
		defineProperty(this, '__ee__', descriptor);
		descriptor.value = null;
	} else {
		data = this.__ee__;
	}
	if (!data[type]) data[type] = listener;
	else if (typeof data[type] === 'object') data[type].push(listener);
	else data[type] = [data[type], listener];

	return this;
};

once = function (type, listener) {
	var once, self;

	validCallable(listener);
	self = this;
	on.call(this, type, once = function () {
		off.call(self, type, once);
		apply.call(listener, this, arguments);
	});

	once.__eeOnceListener__ = listener;
	return this;
};

off = function (type, listener) {
	var data, listeners, candidate, i;

	validCallable(listener);

	if (!hasOwnProperty.call(this, '__ee__')) return this;
	data = this.__ee__;
	if (!data[type]) return this;
	listeners = data[type];

	if (typeof listeners === 'object') {
		for (i = 0; (candidate = listeners[i]); ++i) {
			if ((candidate === listener) ||
					(candidate.__eeOnceListener__ === listener)) {
				if (listeners.length === 2) data[type] = listeners[i ? 0 : 1];
				else listeners.splice(i, 1);
			}
		}
	} else {
		if ((listeners === listener) ||
				(listeners.__eeOnceListener__ === listener)) {
			delete data[type];
		}
	}

	return this;
};

emit = function (type) {
	var i, l, listener, listeners, args;

	if (!hasOwnProperty.call(this, '__ee__')) return;
	listeners = this.__ee__[type];
	if (!listeners) return;

	if (typeof listeners === 'object') {
		l = arguments.length;
		args = new Array(l - 1);
		for (i = 1; i < l; ++i) args[i - 1] = arguments[i];

		listeners = listeners.slice();
		for (i = 0; (listener = listeners[i]); ++i) {
			apply.call(listener, this, args);
		}
	} else {
		switch (arguments.length) {
		case 1:
			call.call(listeners, this);
			break;
		case 2:
			call.call(listeners, this, arguments[1]);
			break;
		case 3:
			call.call(listeners, this, arguments[1], arguments[2]);
			break;
		default:
			l = arguments.length;
			args = new Array(l - 1);
			for (i = 1; i < l; ++i) {
				args[i - 1] = arguments[i];
			}
			apply.call(listeners, this, args);
		}
	}
};

methods = {
	on: on,
	once: once,
	off: off,
	emit: emit
};

descriptors = {
	on: d_1(on),
	once: d_1(once),
	off: d_1(off),
	emit: d_1(emit)
};

base = defineProperties({}, descriptors);

module.exports = exports = function (o) {
	return (o == null) ? create(base) : defineProperties(Object(o), descriptors);
};
exports.methods = methods;
});
var eventEmitter_1 = eventEmitter.methods;

/**
 * Created by sunny on 05/03/18.
 */
class AustinEventManager {
    constructor() {
        this.emitter = eventEmitter({});
    }
    /**
     * This method returns the AustinEventManager instance if already created. Else,
     * create a new instance and then return it.
     * @returns {AustinEventManager}
     */
    static getInstance() {
        if (!this.instance) {
            this.instance = new AustinEventManager();
        }
        return this.instance;
    }
    fire(event, params) {
        if ('undefined' !== typeof event && null !== event) {
            this.emitter.emit(event, params);
        }
        else {
            AustinEventManager.logger.error('Events name or details missing');
        }
    }
    subscribe(event, handler) {
        if ('undefined' !== typeof event && null !== event) {
            handler = ('function' === typeof handler) ? handler : function () {
                AustinEventManager.logger.error('subscribe handler not found');
            };
            this.emitter.off(event, handler);
            this.emitter.on(event, handler);
        }
    }
    /**
     * Handler should be a callable object ie. function, otherwise error will be thrown
     * While unSubscribing for any event, if handler is same while subscribing,
     * then only mentioned handler will be unSubscribed for the event
     * @param event
     * @param handler
     */
    unSubscribe(event, handler) {
        if ('undefined' !== typeof event && null !== event) {
            if ('function' === typeof handler) {
                this.emitter.off(event, handler);
            }
            else {
                AustinEventManager.logger.error('unSubscribe : invalid handler for event : ' + event);
            }
        }
    }
    subscribeOnce(event, handler) {
        if ('undefined' !== typeof event && null !== event) {
            handler = ('function' === typeof handler) ? handler : function () {
                AustinEventManager.logger.info('subscribeOnce');
            };
            this.emitter.once(event, handler);
        }
    }
}
AustinEventManager.logger = new AustinLogger('AustinEventManager');

/**
 * Created by sunny on 05/03/18.
 * Stores all the event names.
 * Events fired to application should be listed under EVENTS in austin-client.ts
 */
let AustinEvents = {
    // Internal events emitted after processing from box events polling response
    BOX_READY: 'boxReady',
    BOX_BUFFER_BAR: 'boxBufferBar',
    BOX_CONNECTION_LOST: 'boxConnectionLost',
    BOX_DISCONTINUITY_HANDLED: 'boxDiscontinuityHandled',
    BOX_DVR_END: 'boxDvrEnd',
    BOX_POP_UP: 'boxPopUp',
    BOX_STREAM_DISCONTINUITY: 'boxStreamDiscontinuity',
    BOX_STREAM_LOST: 'boxStreamLost',
    BOX_STREAM_STOP: 'boxStreamStop',
    BOX_VIDEO_LOCK_LOST: 'boxVideoLockLost',
    BOX_VIDEO_SIGNAL: 'boxVideoSignal',
    BOX_STREAM_USER_STOP: 'boxStreamUserStop',
    BOX_CONNECTION_RE_ESTABLISHED: 'boxConReEstablished',
    BOX_PROGRAM_INFO_CHANGED: 'boxProgramInfoChanged',
    // Internal events emitted from PLAYER Wrapper
    PLAYER_ERROR: 'playerError',
    PLAYER_MEDIA_DOWNLOAD_FINISHED: 'playerMediaDownloadFinished',
    PLAYER_SEEKED_OR_TIMESHIFTED: 'playerSeekedOrTimeShifted',
    PLAYER_STALL_START: 'playerStallStart',
    PLAYER_STALL_END: 'playerStallEnd',
    PLAYER_READY: 'playerReady',
    PLAYER_PAUSE: 'playerPause',
    PLAYER_PLAY: 'playerPlay',
    PLAYER_PLAYING: 'playerPlaying',
    PLAYER_FIRST_FRAME_RENDERED: 'playerFirstFrameRendered',
    PLAYER_METADATA: 'playerMetadata',
    PLAYER_TIME_UPDATE: 'playerTimeUpdate',
    PLAYER_SUBTITLE_ADDED: 'playerSubtitleAdded',
    PLAYER_WARNING: 'playerWarning',
    SEEK_STARTED: 'onSeekStarted',
    SEEK_ENDED: 'onSeekEnded'
};

/**
 * Created by sunny on 12/07/18.
 */
class PerformanceTimer {
    static addToKeyArray(option, key, value) {
        if (option === PerformanceTimer.performanceMarker.START) {
            if (!PerformanceTimer.startArray[key]) {
                PerformanceTimer.startArray[key] = [];
            }
            PerformanceTimer.startArray[key].push(value);
        }
        else if (option === PerformanceTimer.performanceMarker.END) {
            if (!PerformanceTimer.endArray[key]) {
                PerformanceTimer.endArray[key] = [];
            }
            PerformanceTimer.endArray[key].push(value);
        }
        else if (option === PerformanceTimer.performanceMarker.MEASURE) {
            if (!PerformanceTimer.durationArray[key]) {
                PerformanceTimer.durationArray[key] = [];
            }
            PerformanceTimer.durationArray[key].push(value);
        }
    }
    /**
     * This method start timer for mentioned entity
     * @param name
     */
    static markStart(name) {
        let timeStart = new Date().getTime();
        PerformanceTimer.addToKeyArray(PerformanceTimer.performanceMarker.START, name, timeStart);
    }
    /**
     * This method stop timer for mentioned entity and calculate time taken
     * @param name
     */
    static markEnd(name) {
        if (PerformanceTimer.startArray[name] !== undefined) {
            let lengtha = PerformanceTimer.startArray[name].length;
            let startTime = PerformanceTimer.startArray[name][lengtha - 1];
            PerformanceTimer.logger.info('startTime:' + startTime);
            const endTime = new Date().getTime();
            const elapsedSeconds = (endTime - startTime) / 1000;
            PerformanceTimer.addToKeyArray(PerformanceTimer.performanceMarker.END, name, endTime);
            PerformanceTimer.addToKeyArray(PerformanceTimer.performanceMarker.MEASURE, name, elapsedSeconds);
            PerformanceTimer.logger.info('elapsedTime:' + elapsedSeconds);
        }
    }
    /**
     * returns list of measured valued
     * @param name
     * @returns {Array<any>}
     */
    static getEntriesByName(name) {
        return PerformanceTimer.startArray[name] ? PerformanceTimer.startArray[name] : [];
    }
    /**
     * Does formatting of browser stored data for Austin log
     * @param name
     * @returns {any}
     */
    static getTime(name) {
        let duration = [];
        let details = PerformanceTimer.durationArray[name];
        if (details && details.length) {
            for (let i = 0; i < details.length; i++) {
                duration.push((details[i]).toFixed(3) || 0);
            }
        }
        return duration;
    }
    static clearMeasures() {
        Object.keys(this.startArray).forEach(key => delete this.startArray[key]);
        Object.keys(this.endArray).forEach(key => delete this.endArray[key]);
        Object.keys(this.durationArray).forEach(key => delete this.durationArray[key]);
    }
    static init() {
        PerformanceTimer.logger.info('Initialising Performance Timer');
    }
}
//List all the event points which will be marked
PerformanceTimer.metrics = {
    CONNECT: 'connect',
    SPARCS_LOOKUP: 'sparcsLookup',
    RI_CREATION: 'RICreation',
    LAN_CONNECTION: 'lanConnection',
    TCP_CONNECTION: 'tcpConnection',
    RELAY_CONNECTION: 'relayConnection',
    STREAM_START: 'streamStart',
    BOX_PLAY: 'boxPlay',
    BOX_READY: 'boxReady',
    PLAYER_PLAY: 'playerPlay',
    WIDEVINE_LICENCE_REQ1: 'widevineLicenceReq1',
    WIDEVINE_LICENCE_REQ2: 'widevineLicenceReq2'
};
PerformanceTimer.performanceMarker = {
    START: 'start',
    END: 'end',
    MEASURE: 'measure'
};
PerformanceTimer.logger = new AustinLogger('PerformanceDateTimer');
PerformanceTimer.startArray = {};
PerformanceTimer.endArray = {};
PerformanceTimer.durationArray = {};

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class AustinCore {
    constructor() {
        this.baseUri = { command: '', data: '' };
        this.eventManager = AustinEventManager.getInstance();
        // These fields will keep on changing
        this.isPollingActive = false;
        this.hddConnected = false;
        this.eventsFailedCount = 0;
        this.forceConnectionReEstablish = false;
        this.recentEventResponseTime = 0;
        this.previousEventResponseTime = 0;
        this.reqCounter = Math.round(100000 * Math.random()); //increment by 1 per each request in a session
        this.streamInfo = {
            bitrate: null,
            width: null,
            height: null,
            total: 0,
            count: 0
        };
        // These will be set while creating every new session
        this.capabilities = Object.create(null);
        this.connectionMode = '';
        this.deviceClockFrequencyInKHz = 45; //keeping default 45 in case sparcs fail
        this.deviceLANAddress = '';
        this.deviceWANAddress = '';
        this.devicePort = '';
        this.finderId = '';
        this.firmwareVersion = '';
        this.hardwareVersion = '';
        this.ip = '';
        this.forceHls = false;
        this.clientLocalIp = '';
        this.clientPublicIp = '';
        this.lastSparcsRegistered = '';
        this.port = '';
        this.productSignature = '';
        this.password = '';
        this.receiverId = '';
        this.relayInfo = {
            clientId: '',
            ip: '',
            port: '',
            serverName: ''
        };
        this.firstStreamForCurrentSession = 0;
        this.sessionId = '';
        this.isAllCrtlSessionActive = false;
        this.sbProductSignature = '';
        this.streamingType = '';
        this.streamingOverRelayProxy = false;
        this.user = '';
        this.wanPortForwardingEnabled = false; //default is false because by default we do not want to delay the Relay
        this.webSessionId = ''; // this is client attempted connection session ID
        // streaming data required in Analytics
        this.streamingAnalytics = Object.create(null);
        //flag to indicate user requested stop stream
        this.stopStreamRequested = false;
        this.debugInfo = {};
        this.relayProxy = '';
        this.inActivityDetected = false;
        AustinCore.logger.info('instance created');
        AustinCore.analytics = AnalyticsHelper.getInstance(AustinConfig.ANALYTICS);
    }
    /**
     * This method returns the AustinCore instance if already created. Else,
     * create a new instance and then return it.
     * @returns {AustinCore}
     */
    static getInstance() {
        if (!this.instance) {
            this.instance = new AustinCore();
            window.addEventListener('beforeunload', () => {
                AustinCore.instance.isPollingActive = false;
            });
        }
        return this.instance;
    }
    sanitizeReciverIdFormat(input) {
        let receiverId = '';
        //Input may be 'R1886355072', 'R1886355072-27', 'dish1886355072-27'
        //Output should be 'dish1886355072'
        if (input && (typeof (input) === 'string')) {
            receiverId = input.trim().split('-')[0];
            if (receiverId && receiverId[0].toUpperCase() === 'R') {
                receiverId = 'dish' + receiverId.substring(1);
            }
        }
        return receiverId;
    }
    /**
     * This method connects to the box based on parallel connection flag
     * If parallel connection flag enabled then connection is made in parallel .
     * Else Connection is made serially using the Priority from Sparks response.
     * @param params
     * @returns {Promise<any>}
     * @private
     */
    connect(params) {
        AustinCore.logger.info('connect++' + JSON.stringify(params));
        let self = this;
        this.webSessionId = params.webSessionId;
        this.ip = params.ip;
        this.forceHls = params[AustinConstants.STREAMING.FORCE_HLS];
        this.clientLocalIp = params.localIp;
        this.clientPublicIp = params.publicIp;
        this.port = params.port;
        this.finderId = params.finderId;
        this.receiverId = this.sanitizeReciverIdFormat(params.receiverId);
        this.user = params.user || 'admin';
        this.password = AustinUtils.decryptedPassword(params.pass);
        this.connectionMode = '';
        this.debugInfo = {};
        this.recentEventResponseTime = 0;
        this.firstStreamForCurrentSession = 0;
        this.isAllCrtlSessionActive = false;
        if (AustinUtils.isWeb()) {
            RequestDispatcher.setWebPlatform(true);
            AustinCore.logger.info('Setting platform web');
        }
        return new Promise((resolve, reject) => {
            if (params[AustinConstants.QUERY_PARAM.RELAY_HOST]) {
                AustinConfig.CPS.RELAY_URL = params[AustinConstants.QUERY_PARAM.RELAY_HOST];
            }
            if (params[AustinConstants.QUERY_PARAM.FORCED_RELAY_PROXY] || AustinConfig.CPS.FORCED_RELAY_PROXY) {
                if (AustinConfig.CPS.RELAY_REVERSE_PROXY_ENABLED && AustinConfig.CPS.RELAY_REVERSE_PROXY_URL) {
                    AustinCore.logger.info('Forcing  over Proxy Relay ');
                    AustinConfig.CPS.RELAY_URL = AustinConfig.CPS.RELAY_REVERSE_PROXY_URL;
                    self.relayProxy = AustinConfig.CPS.RELAY_URL + AustinConfig.CPS.RELAY_REVERSE_PROXY_PATH;
                }
            }
            //Todo: remove this before production, this is for helping in debugging
            if (params[AustinConstants.QUERY_PARAM.FORCED_RELAY]) {
                resolve(self.createRIAndConnect(params.webSessionId));
                return;
            }
            self.makeSparcsLookup(params.finderId).then(() => {
                if (params[AustinConstants.QUERY_PARAM.FORCED_WAN]) {
                    resolve(self.makeWanConnection(self.deviceWANAddress, self.devicePort, params.webSessionId));
                    return;
                }
                resolve(AustinConfig.CPS.ENABLE_PARALLEL_CONNECTION ?
                    self.makeParallelConnection(params.webSessionId) : self.makeSerialConnection(params.webSessionId));
            }).catch((e) => {
                AustinCore.logger.error('connect :: fetchSparcsFailed :: ' + JSON.stringify(e));
                if (e.reason === AustinErrors.UNREGISTERED_SPARCS ||
                    e.reason === AustinErrors.LEGACY_BOX_HTML5_DASH_UNSUPPORTED) {
                    reject(e);
                }
                else {
                    resolve(self.createRIAndConnect(params.webSessionId));
                }
            });
        });
    }
    /**
     * This will always be resolved. This method disconnect current active session
     * Reset all values immediately so that event polling stops and no other action from same session is supported
     * Wait to box success/error response to resolve
     * @returns {Promise<any>}
     */
    disconnect() {
        AustinCore.logger.info('disconnect++');
        let self = this;
        this.isPollingActive = false;
        return new Promise((resolve) => {
            self.deleteSession(self.sessionId).then(() => {
                if (AustinConstants.BOX.CONNECTION_MODE_RELAY === self.connectionMode) {
                    self.deleteRI().then(() => AustinCore.logger.info('Assuming RI is deleted'));
                }
                self.resetSessionAttributes();
                resolve();
            });
        });
    }
    /* Reset austin core withot issueing discoonet to box,
     *
     *  this will be used in case case of connection re-establishment
     */
    reset() {
        AustinCore.logger.info('reset++');
        this.isPollingActive = false;
        this.resetSessionAttributes();
    }
    /**
     * This will always be resolved.
     * Makes box disconnect request for mentioned sessionId
     * Wait to box success/error response to resolve
     * @param sessionId
     * @param url
     * @returns {Promise<any>}
     */
    deleteSession(sessionId, url) {
        AustinCore.logger.info('deleteSession++');
        let self = this;
        let data = { session_id: sessionId };
        if (url) {
            data.url = url;
        }
        return new Promise((resolve) => {
            self.makeBoxRequest('disconnect', data).then(() => {
                AustinCore.logger.info('deleteSession::box-disconnect success');
            }).catch(() => {
                AustinCore.logger.warn('deleteSession::box-disconnect failure');
            });
            resolve();
        });
    }
    /**
     * This method makes parallel connection to the box as per priority
     * Promise is resolved at 1st successful connection or rejected when all 3 modes fails
     * If 2nd and 3rd modes are also successful, they are cleaned up in createAustinSession() itself
     * @param webSessionId
     * @returns {Promise<any>}
     * @private
     */
    makeParallelConnection(webSessionId) {
        AustinCore.logger.info('makeParallelConnection++');
        let self = this;
        let failedAttempts = 0;
        let wanDelayedConnectTimer = null;
        let relayDelayedConnectTimer = null;
        let relayError;
        let relayReason;
        let attemptOverLAN = true;
        let attemptOverWAN = true;
        let wanAttemptDelay = AustinConfig.WAN_DELAY_IN_PARALLEL_MS;
        let relayAttemptDelay = AustinConfig.RELAY_DELAY_IN_PARALLEL_MS;
        return new Promise((resolve, reject) => {
            if (!AustinConfig.CPS.ENABLE_WAN_CONNECTION) {
                failedAttempts = failedAttempts + 2; // both WAN and Relay considered as failed
            }
            else {
                if (self.clientLocalIp && !AustinUtils.isTwoIPsOnSamePrivateNetwork(self.deviceLANAddress, self.clientLocalIp)) {
                    AustinCore.logger.info('BOX and client not ON same LAN netwrok, skipping LAN attempt');
                    attemptOverLAN = false;
                    relayAttemptDelay = relayAttemptDelay - wanAttemptDelay;
                    wanAttemptDelay = 0;
                    failedAttempts = failedAttempts + 1;
                    AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'LANSkipped(' + self.clientLocalIp + ')');
                }
                else if (self.deviceLANAddress === self.deviceWANAddress) {
                    AustinCore.logger.info('BOX LAN and WAN IP same, skipping LAN attempt');
                    attemptOverLAN = false;
                    relayAttemptDelay = relayAttemptDelay - wanAttemptDelay;
                    wanAttemptDelay = 0;
                    failedAttempts = failedAttempts + 1;
                    AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'LANSkippedSameWAN(' + self.deviceLANAddress + ')');
                }
                if (self.clientPublicIp && self.deviceWANAddress === self.clientPublicIp && self.wanPortForwardingEnabled === false) {
                    AustinCore.logger.info('Device WAN and client public ip same, and device port forward no done,  skipping WAN attempt');
                    attemptOverWAN = false;
                    if (!attemptOverLAN) {
                        relayAttemptDelay = 0;
                    }
                    failedAttempts = failedAttempts + 1;
                    AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'WANSkipped(' + self.clientPublicIp + ')');
                }
                if (attemptOverWAN) {
                    // keeping gap between LAN and WAN request to avoid ssl errors in box
                    wanDelayedConnectTimer = window.setTimeout(() => {
                        self.makeWanConnection(self.deviceWANAddress, self.devicePort, webSessionId).then(() => {
                            AustinCore.logger.info('makeParallelConnection:: WAN success');
                            if (relayDelayedConnectTimer) {
                                window.clearTimeout(relayDelayedConnectTimer); //No need to try relay now
                                relayDelayedConnectTimer = null;
                            }
                            resolve();
                            return;
                        }).catch((e) => {
                            AustinCore.logger.warn('makeParallelConnection:: WAN fails :: ' + JSON.stringify(e));
                            failedAttempts++;
                            if (failedAttempts === 3 || (e.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE)) {
                                if (relayError && relayReason) {
                                    e['reason'] = relayReason;
                                    e['retryAttemptInfo'] = relayError;
                                }
                                reject(e);
                            }
                        });
                    }, wanAttemptDelay);
                }
                // keeping gap for Relay connect request to avoid ssl errors in box
                // More delay to avoid relay if wanPortForwardingEnabled
                let relayOffset = self.wanPortForwardingEnabled ? 3 * relayAttemptDelay : relayAttemptDelay;
                relayDelayedConnectTimer = window.setTimeout(() => {
                    self.createRIAndConnect(webSessionId).then(() => {
                        AustinCore.logger.info('makeParallelConnection:: Relay success');
                        resolve();
                        return;
                    }).catch((e) => {
                        AustinCore.logger.warn('makeParallelConnection :: createRIAndConnect :: ' + JSON.stringify(e));
                        failedAttempts++;
                        if (failedAttempts === 3 || (e.reason === AustinErrors.AUTHORIZATION_FAILED) || (e.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE) ||
                            (e.reason === AustinErrors.BOX_OFFLINE)) {
                            reject(e);
                        }
                        else {
                            relayReason = e.reason;
                            relayError = e.retryAttemptInfo;
                        }
                    });
                }, relayOffset);
            }
            if (attemptOverLAN) {
                self.makeLanConnection(self.deviceLANAddress, self.devicePort, webSessionId).then(() => {
                    AustinCore.logger.info('makeParallelConnection:: LAN success');
                    if (wanDelayedConnectTimer) {
                        window.clearTimeout(wanDelayedConnectTimer); //No need to try WAN-TCP now
                        wanDelayedConnectTimer = null;
                    }
                    if (relayDelayedConnectTimer) {
                        window.clearTimeout(relayDelayedConnectTimer); //No need to try relay now
                        relayDelayedConnectTimer = null;
                    }
                    resolve();
                    return;
                }).catch((e) => {
                    AustinCore.logger.warn('makeParallelConnection:: LAN fails');
                    failedAttempts++;
                    if (failedAttempts === 3 || (e.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE)) {
                        if (relayError && relayReason) {
                            e['reason'] = relayReason;
                            e['retryAttemptInfo'] = relayError;
                        }
                        reject(e);
                    }
                });
            }
        });
    }
    /**
     * This method makes serial connection to the box by trying all connection modes one by one
     *
     * @param webSessionId
     * @returns {Promise<any>}
     *  @private
     */
    makeSerialConnection(webSessionId) {
        AustinCore.logger.info('makeSerialConnection++');
        let self = this;
        return new Promise((resolve, reject) => {
            self.makeLanConnection(self.deviceLANAddress, self.devicePort, webSessionId).then(() => {
                resolve();
            }).catch((e) => {
                if (e.reason === AustinErrors.AUTHORIZATION_FAILED || e.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE) {
                    reject(e);
                }
                else {
                    AustinCore.logger.info('LAN attempt failed, will try WAN now');
                    // If WAN enabled then only go for TCP and relay
                    if (!AustinConfig.CPS.ENABLE_WAN_CONNECTION) {
                        reject({ reason: AustinErrors.CREATE_SESSION_FAILED });
                        return;
                    }
                    self.makeWanConnection(self.deviceWANAddress, self.devicePort, webSessionId).then(() => {
                        resolve();
                    }).catch((e) => {
                        AustinCore.logger.warn('WAN attempt failed, will try Relay now' + JSON.stringify(e));
                        if (e.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE) {
                            reject(e);
                            return;
                        }
                        self.createRIAndConnect(webSessionId).then(() => {
                            resolve();
                        }).catch((e) => {
                            AustinCore.logger.warn('Relay attempt failed in makeSerialConnection' + JSON.stringify(e));
                            reject(e);
                        });
                    });
                }
            });
        });
    }
    /**
     * return true if the firmware version from SPARC is greater/equal to minimume firmware version mentioned in package.json
     *
     * @param firmwareVersion - firmware version form SPARC
     */
    isMinimumFirmwareSupported(firmwareVersion) {
        // minimum firmware version from package.json
        let minVers = AustinConfig.AUSTIN.HOPPER_FIRMWARE_MIN_VERSION.split('.');
        let firmVers = firmwareVersion.split('.');
        let a = [], b = [];
        // sparc version array
        for (let i = 0; i < firmVers.length; ++i) {
            a[i] = Number(firmVers[i]);
        }
        // min version array
        for (let i = 0; i < minVers.length; ++i) {
            b[i] = Number(minVers[i]);
        }
        // product code 4 or 5
        if (a[1] === 4 || a[1] === 5) {
            a.splice(1, 1);
            b.splice(1, 1);
        }
        else {
            return false;
        }
        const len = Math.min(a.length, b.length);
        for (let i = 0; i < len; i++) {
            // A bigger than B
            if (a[i] > b[i]) {
                return true;
            }
            // B bigger than A
            if (a[i] < b[i]) {
                return false;
            }
        }
        return true;
    }
    isHopperSb(sbProductSignature) {
        return AustinCore.BoxXip === sbProductSignature || AustinCore.BoxZip === sbProductSignature;
    }
    isAirTvSb(sbProductSignature) {
        return AustinCore.BoxAirTv === sbProductSignature || AustinCore.BoxAirTv2 === sbProductSignature;
    }
    /**
     * This method makes a Sparcs lookup for the finderId passed
     * @param finderId
     * @returns {Promise<any>}
     */
    makeSparcsLookup(finderId) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.SPARCS_LOOKUP);
        AustinCore.logger.info('makeSparcsLookup++');
        let self = this;
        return new Promise((resolve, reject) => {
            const url = AustinConfig.CPS.SPARCS_URL + '/rest/v2/slingbox/' + finderId + '.json' + '?_=' + new Date().getTime();
            RequestDispatcher.get(url, AustinConfig.AUSTIN.AJAX_TIMEOUT_MS).then((response) => {
                AustinCore.logger.info('makeSparcsLookup::successfully fetched sparcs data');
                const sparcResponse = response.data;
                let rejectReason = AustinErrors.UNREGISTERED_SPARCS;
                // '0' is considered as sb_unregistered
                if (sparcResponse.isRegistered === '1') {
                    self.deviceLANAddress = sparcResponse.deviceLANAddress;
                    self.deviceWANAddress = sparcResponse.deviceAddress;
                    self.devicePort = sparcResponse.devicePort;
                    self.firmwareVersion = sparcResponse.firmwareVersion;
                    self.hardwareVersion = sparcResponse.hardwareVersion;
                    self.sbProductSignature = sparcResponse.productSignature;
                    self.lastSparcsRegistered = sparcResponse.lastUpdated;
                    rejectReason = AustinErrors.LEGACY_BOX_HTML5_DASH_UNSUPPORTED;
                    if (self.sbProductSignature) {
                        if (this.isHopperSb(self.sbProductSignature)) {
                            if (self.isMinimumFirmwareSupported(self.firmwareVersion)) {
                                rejectReason = '';
                            }
                        }
                        else if (this.isAirTvSb(self.sbProductSignature)) {
                            rejectReason = '';
                        }
                    }
                }
                if (rejectReason) {
                    const outcome = (rejectReason === AustinErrors.UNREGISTERED_SPARCS)
                        ? AnalyticsHelperConstants.analytics_outcome.sb_unregistered :
                        AnalyticsHelperConstants.analytics_outcome.sb_unsupported_firmware;
                    AustinCore.analytics.setOutcome(outcome);
                    reject({
                        reason: rejectReason
                    });
                }
                else {
                    self.wanPortForwardingEnabled = false;
                    if (sparcResponse.connectionModes && sparcResponse.connectionModes.length) {
                        sparcResponse.connectionModes.forEach((mode) => {
                            if (mode.name === 'TCP' && mode.capability === '4') {
                                self.wanPortForwardingEnabled = true;
                            }
                            ;
                        });
                    }
                    resolve();
                }
            }).catch((e) => {
                AustinCore.logger.error('makeSparcsLookup::Error in http request : ' + JSON.stringify(e));
                let errorMessage = 'sparcs';
                if (!navigator.onLine) {
                    errorMessage = errorMessage + 'NoNet'; //sp_no_internet
                    AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_no_internet);
                }
                else if (e.status && e.status === 404) {
                    errorMessage = errorMessage + 'UnReachbl'; // sn_sparcs_unreachable
                    AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sn_sparcs_unreachable);
                }
                else {
                    errorMessage = errorMessage + 'ServerErr'; //sn_sparcs_server_error
                    AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sn_sparcs_server_error);
                }
                //todo: reject for timeout should have explicit reason
                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, errorMessage);
                reject({
                    reason: AustinErrors.FETCH_SPARCS_FAILED
                });
            }).then(() => PerformanceTimer.markEnd(PerformanceTimer.metrics.SPARCS_LOOKUP));
            AustinCore.logger.log('makeSparcsLookup--');
        });
    }
    /**
     * resetEventFailedCount
     */
    resetEventFailedCount() {
        this.eventsFailedCount = 0;
    }
    /**
     * return events fail count
     */
    getEventFailedCount() {
        return this.eventsFailedCount;
    }
    /**
     * resetStreamCounter()
     */
    resetStreamCounter() {
        this.firstStreamForCurrentSession = 0;
    }
    /**
     * This method is just for debugging purpose
     * @param bufferBarFrequency
     */
    configureAccount(bufferBarFrequency) {
        let self = this;
        self.makeBoxRequest('configure_account', { 'buffbarfrequency': bufferBarFrequency }).then(() => {
            AustinCore.logger.info('Success in configureAccount');
        }).catch((error) => {
            AustinCore.logger.warn('Error in configureAccount ' + JSON.stringify(error, Object.getOwnPropertyNames(error)));
        });
    }
    updateResolution(connectionMode, maxResolution) {
        AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_AUTO'].VIDEO_RESOLUTION = maxResolution;
        AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_HIGH'].VIDEO_RESOLUTION = maxResolution;
        if (connectionMode === AustinConstants.BOX.CONNECTION_MODE_LAN) {
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_MEDIUM'].VIDEO_RESOLUTION = maxResolution;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_LOW'].VIDEO_RESOLUTION = maxResolution;
        }
        else if (connectionMode === AustinConstants.BOX.CONNECTION_MODE_TCP && AustinUtils.isAndroid()) {
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_MEDIUM'].VIDEO_RESOLUTION = maxResolution;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_LOW'].VIDEO_RESOLUTION = maxResolution;
        }
    }
    updateBitrate(connectionMode, maxBitrate) {
        //Note: Right now only LAN config has higher bitrate than maxBitrate, so capping only for LAN
        if (connectionMode === AustinConstants.BOX.CONNECTION_MODE_LAN) {
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_AUTO'].VIDEO_BITRATE_MAX = maxBitrate;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_HIGH'].VIDEO_BITRATE_MAX = maxBitrate;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_MEDIUM'].VIDEO_BITRATE_MAX = maxBitrate;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_LOW'].VIDEO_BITRATE_MAX = maxBitrate;
        }
        else if (connectionMode === AustinConstants.BOX.CONNECTION_MODE_TCP && AustinUtils.isAndroid()) {
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_AUTO'].VIDEO_BITRATE_MAX = maxBitrate;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_HIGH'].VIDEO_BITRATE_MAX = maxBitrate;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_MEDIUM'].VIDEO_BITRATE_MAX = maxBitrate;
            AustinConfig.STREAMING[connectionMode]['QUALITY_LEVEL_LOW'].VIDEO_BITRATE_MAX = maxBitrate;
        }
    }
    /**
     * Creates Austin session. And returns the promise object resolving with the xml data when successCallback is called.
     * Setting Austin url and other parameters are done once the connection mode is decided.
     * Note: Do not use makeBoxRequest for connect as we do not have baseUri and sessionId
     * @param reqObject {}
     * @private
     */
    createAustinSession(reqObject) {
        AustinCore.logger.info('createAustinSession++ ip: ' + reqObject.ip + ' port:' + reqObject.port + 'mode:' + reqObject.mode);
        let self = this;
        return new Promise((resolve, reject) => {
            // Checking for existing connection just before making connect request
            if (self.sessionId) {
                reject({ reason: AustinErrors.ALREADY_CONNECTED });
                return;
            }
            for (let key in reqObject) {
                if (reqObject.hasOwnProperty(key) && !reqObject[key]) {
                    reject({
                        reason: AustinErrors.INVALID_CREATE_SESSION_PARAM
                    });
                    return;
                }
            }
            const baseUri = self.generateBaseURI(reqObject.mode, reqObject.ip, reqObject.port);
            const payload = {
                command: 'connect',
                client_type: '3ft'
            };
            const request = {
                url: baseUri.command + '?' + self.getSlingAuthValue(self.user, self.password, ''),
                method: 'POST',
                data: payload,
                timeout: reqObject.timeout ? reqObject.timeout : AustinConfig.CPS.CONNECTION_TIMEOUT_MS
            };
            RequestDispatcher.makeRequest(request).then((response) => {
                AustinCore.logger.info('box connect response : ' + JSON.stringify(response));
                if (response.data.result === AustinCore.apiResults.SUCCESS) {
                    //response has session_id, box properties and capabilities
                    if (self.sessionId || (self.webSessionId !== reqObject.webSessionId)) {
                        let boxUrl = baseUri.command + '?' + self.getSlingAuthValue(self.user, self.password, response.data['session_id'] || '');
                        self.deleteSession(response.data['session_id'], boxUrl).then(() => {
                            AustinCore.logger.info('New session is ignored and deleted');
                            reject({ reason: AustinErrors.ALREADY_CONNECTED });
                        });
                    }
                    else {
                        self.baseUri = baseUri;
                        self.sessionId = response.data['session_id'] || '';
                        self.connectionMode = reqObject.mode;
                        if (reqObject.mode === AustinConstants.BOX.CONNECTION_MODE_RELAY && self.relayProxy) {
                            AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, ':rlyPrxy:');
                            self.streamingOverRelayProxy = true;
                        }
                        if (AustinUtils.isFireTV() || AustinUtils.isAndroidTV()) {
                            AustinCore.logger.info('Setting 10ft Bitrate');
                            self.updateBitrate(reqObject.mode, AustinConfig.STREAMING.TEN_FEET_DEVICE_MAX_BITRATE);
                        }
                        else if (AustinUtils.is3FeetDevice()) {
                            self.updateResolution(reqObject.mode, AustinConfig.STREAMING.THREE_FEET_DEVICE_MAX_RESOLUTION);
                            self.updateBitrate(reqObject.mode, AustinConfig.STREAMING.THREE_FEET_DEVICE_MAX_BITRATE);
                        }
                        self.capabilities = JSON.parse(JSON.stringify(response.data.capabilities));
                        const maxBoxResolution = self.capabilities['max_resolution_supported'];
                        if (maxBoxResolution) {
                            let temp = maxBoxResolution.split('x');
                            const boxMaxWidth = Number(temp[0]);
                            const boxMaxHieght = Number(temp[1]);
                            const auto = AustinConfig.STREAMING[reqObject.mode]['QUALITY_LEVEL_AUTO'].VIDEO_RESOLUTION;
                            temp = auto.split('x');
                            const mdWidth = Number(temp[0]);
                            const mdHeight = Number(temp[1]);
                            if (boxMaxWidth < mdWidth && boxMaxHieght < mdHeight) {
                                self.updateResolution(reqObject.mode, maxBoxResolution);
                            }
                        }
                        if (response.data.box_properties) {
                            // Handling internal_hdd for hopper, Can also use this flag for identifying setup box
                            self.hddConnected = !!(response.data.box_properties.internal_hdd);
                            self.firmwareVersion = response.data.box_properties.firmware_version;
                            self.productSignature = response.data.box_properties.product_id;
                            self.deviceClockFrequencyInKHz = self.isAirTvSb(self.sbProductSignature) ? 90 : 45;
                        }
                        self.debugInfo['boxSessionId'] = self.sessionId;
                        self.debugInfo['connectionMode'] = self.connectionMode;
                        self.debugInfo['connectedAt'] = new Date().toISOString();
                        self.debugInfo['eventFailReason'] = [];
                        self.debugInfo['boxFirmware'] = self.firmwareVersion;
                        self.debugInfo['localIps'] = [];
                        if (!self.debugInfo['oldSessions']) {
                            self.debugInfo['oldSessions'] = [];
                        }
                        self.debugInfo['eventsCount'] = 0;
                        AustinUtils.getClientLocalIp().then(ip => {
                            if (ip) {
                                self.debugInfo.localIps.push({ ip: ip, time: new Date().toISOString() });
                                AustinCore.logger.warn('clientLocalIps ' + JSON.stringify(self.debugInfo.localIps));
                            }
                        });
                        //enable events polling
                        self.isPollingActive = true;
                        self.eventsFailedCount = 0;
                        self.pollForEvents(self.sessionId);
                        if (AustinUtils.isWeb() && !self.relayProxy && !self.forceHls) {
                            self.triggerDnsCachingForDashMediaUrls(baseUri);
                        }
                        resolve();
                    }
                }
                else {
                    response.data['connectionMode'] = reqObject.mode;
                    let reason = AustinCore.apiResults[response.data.result] || AustinErrors.API_FAILED;
                    if (reason === AustinCore.apiResults.REQ_AUTH_FAILED) {
                        reason = AustinErrors.AUTHORIZATION_FAILED;
                    }
                    else if (reason === AustinCore.apiResults.ALL_CRTL_SESS_ACTIVE) {
                        self.isAllCrtlSessionActive = true;
                        reason = AustinErrors.ALL_CRTL_SESS_ACTIVE;
                    }
                    else {
                        reason = AustinErrors.CREATE_SESSION_FAILED;
                    }
                    reject({ reason: reason, data: response.data });
                }
            }).catch((error) => {
                AustinCore.logger.warn('AJAX request failed : ' + JSON.stringify(error));
                reject({ reason: AustinErrors.AJAX_REQUEST_FAILED });
            });
        });
    }
    makeLanConnection(deviceLANAddress, devicePort, webSessionId) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.LAN_CONNECTION);
        AustinCore.logger.info('makeLanConnection++');
        let self = this;
        return new Promise((resolve, reject) => {
            const sessionRequestParam = {
                mode: AustinConstants.BOX.CONNECTION_MODE_LAN,
                ip: deviceLANAddress,
                port: devicePort,
                webSessionId: webSessionId
            };
            self.createAustinSession(sessionRequestParam).then(() => {
                AustinCore.logger.info('Successful LAN connection');
                resolve();
            }).catch((e) => {
                AustinCore.logger.warn('Failed  LAN connection ' + JSON.stringify(e));
                reject(e);
            }).then(() => PerformanceTimer.markEnd(PerformanceTimer.metrics.LAN_CONNECTION));
        });
    }
    makeWanConnection(deviceWANAddress, devicePort, webSessionId) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.TCP_CONNECTION);
        AustinCore.logger.info('makeWanConnection++');
        let self = this;
        return new Promise((resolve, reject) => {
            const sessionRequestParam = {
                mode: AustinConstants.BOX.CONNECTION_MODE_TCP,
                ip: deviceWANAddress,
                port: devicePort,
                webSessionId: webSessionId
            };
            self.createAustinSession(sessionRequestParam).then(() => {
                AustinCore.logger.info('Successful WAN connection');
                resolve();
            }).catch((e) => {
                AustinCore.logger.warn('Failed  WAN connection ' + JSON.stringify(e));
                reject(e);
            }).then(() => PerformanceTimer.markEnd(PerformanceTimer.metrics.TCP_CONNECTION));
        });
    }
    /**
     * This method creates Relay Instance and connects using Relay.
     * @param webSessionId
     * @returns {Promise<any>}
     */
    createRIAndConnect(webSessionId) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.RELAY_CONNECTION);
        AustinCore.logger.info('createRIAndConnect++');
        let self = this;
        return new Promise((resolve, reject) => {
            let createRIFailed = 0;
            let createRIInProgress = true;
            let createRIFailedMsg = '';
            let connectRetryCount = AustinConfig.CPS.RELAY_CONNECT_RETRY_COUNT;
            let requestTimeOut = AustinConfig.CPS.CONNECTION_TIMEOUT_MS;
            let relayBaseUrl = AustinConfig.CPS.RELAY_URL;
            function createRIRetryHandler() {
                self.createRI(webSessionId).then(() => {
                    createRIInProgress = false;
                    createRIFailedMsg = createRIFailedMsg + ' RMAttempts:' + createRIFailed;
                    AustinCore.logger.info('Successful createRI connection : ' + createRIFailedMsg);
                    if (createRIFailed > 0) {
                        AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, createRIFailedMsg);
                    }
                    if (self.sessionId) {
                        self.deleteRI().then(() => reject({ reason: AustinErrors.ALREADY_CONNECTED }));
                    }
                    else if (self.isAllCrtlSessionActive) {
                        self.deleteRI().then(() => reject({ reason: AustinErrors.ALL_CRTL_SESS_ACTIVE }));
                    }
                    else {
                        const sessionRequestParam = {
                            mode: AustinConstants.BOX.CONNECTION_MODE_RELAY,
                            ip: self.relayInfo.ip,
                            port: self.relayInfo.port,
                            clientId: self.relayInfo.clientId,
                            webSessionId: webSessionId,
                            timeout: requestTimeOut
                        };
                        self.createAustinSession(sessionRequestParam).then(() => {
                            AustinCore.logger.info('Successful Relay connection ');
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.RELAY_CONNECTION);
                            resolve();
                        }).catch((error) => {
                            AustinCore.logger.warn('Relay connect  attempt failed ' + JSON.stringify(error));
                            createRIFailedMsg = 'RIF(' + error.reason + ':' + self.relayInfo.ip + ':' + self.relayInfo.port + ')';
                            AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, createRIFailedMsg);
                            createRIFailedMsg = '';
                            self.deleteRI().then(() => {
                                AustinCore.logger.warn('Assuming RI is deleted');
                                if (self.sessionId) {
                                    reject({ reason: AustinErrors.ALREADY_CONNECTED });
                                }
                                else if (error.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE) {
                                    reject({ reason: AustinErrors.ALL_CRTL_SESS_ACTIVE });
                                }
                                else if (connectRetryCount > 0 && (error.reason === AustinErrors.CREATE_SESSION_FAILED ||
                                    error.reason === AustinErrors.AUTHORIZATION_FAILED ||
                                    error.reason === AustinErrors.AJAX_REQUEST_FAILED)) {
                                    connectRetryCount--;
                                    createRIFailed = 0;
                                    if (AustinConfig.CPS.RELAY_CONNECT_RETRY_COUNT) {
                                        let retryAfter = (AustinConfig.CPS.RELAY_CONNECT_RETRY_COUNT - connectRetryCount) * 1000;
                                        requestTimeOut = AustinConfig.CPS.CONNECTION_TIMEOUT_MS / AustinConfig.CPS.RELAY_CONNECT_RETRY_COUNT;
                                        AustinCore.logger.info('Retrying Relay Connect after  ' + retryAfter);
                                        if (error.reason === AustinErrors.AJAX_REQUEST_FAILED) {
                                            if (AustinConfig.CPS.RELAY_REVERSE_PROXY_ENABLED && AustinConfig.CPS.RELAY_REVERSE_PROXY_URL) {
                                                if (!self.relayProxy) {
                                                    AustinCore.logger.info('Retrying over Proxy Relay immediate');
                                                    retryAfter = 0;
                                                    AustinConfig.CPS.RELAY_URL = AustinConfig.CPS.RELAY_REVERSE_PROXY_URL;
                                                    self.relayProxy = AustinConfig.CPS.RELAY_URL + AustinConfig.CPS.RELAY_REVERSE_PROXY_PATH;
                                                }
                                                else {
                                                    AustinCore.logger.info('Relay Proxy failed, trying over normal relay');
                                                    self.relayProxy = '';
                                                    AustinConfig.CPS.RELAY_URL = relayBaseUrl;
                                                }
                                            }
                                        }
                                        setTimeout(createRIRetryHandler, retryAfter);
                                    }
                                }
                                else {
                                    PerformanceTimer.markEnd(PerformanceTimer.metrics.RELAY_CONNECTION);
                                    //NO need to check HBT on AUTHORIZATION_FAILED
                                    if (error.reason === AustinErrors.AUTHORIZATION_FAILED) {
                                        error['retryAttemptInfo'] = { 'retryInfo': AustinConfig.CPS.RELAY_CONNECT_RETRY_COUNT };
                                        reject(error);
                                        return;
                                    }
                                    createRIFailedMsg = createRIFailedMsg + 'RIFailed:' + createRIFailed;
                                    AustinCore.logger.warn('createRIAndConnect::failed to create Relay instance ' + createRIFailed + JSON.stringify(error));
                                    reject({
                                        reason: AustinErrors.BOX_OFFLINE,
                                        retryAttemptInfo: error
                                    });
                                }
                            });
                        });
                    }
                }).catch((e) => {
                    createRIFailed++;
                    if (self.sessionId) {
                        reject({ reason: AustinErrors.ALREADY_CONNECTED });
                    }
                    else if (e.reason === AustinErrors.INVALID_CREATE_SESSION_PARAM) {
                        reject(e);
                    }
                    else if (createRIFailed > AustinConfig.CPS.RELAY_RM_RETRY_COUNT) {
                        if (self.relayProxy) {
                            self.relayProxy = '';
                            AustinConfig.CPS.RELAY_URL = relayBaseUrl;
                        }
                        createRIFailedMsg = createRIFailedMsg + 'RMFailed:' + createRIFailed;
                        AustinCore.logger.warn('createRI::failed to create RM instance ' + createRIFailed + JSON.stringify(e));
                        AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, createRIFailedMsg + ': ' + AustinErrors.BOX_OFFLINE);
                        e['retryAttempInfo'] = createRIFailedMsg;
                        reject({ reason: AustinErrors.BOX_OFFLINE });
                    }
                    else if (createRIFailed === AustinConfig.CPS.RELAY_RM_RETRY_COUNT) {
                        let retryAfter = 0;
                        if (AustinConfig.CPS.RELAY_REVERSE_PROXY_ENABLED && AustinConfig.CPS.RELAY_REVERSE_PROXY_URL) {
                            if (!self.relayProxy) {
                                AustinCore.logger.info('Retrying over Proxy Relay immediate since RI Failed');
                                AustinConfig.CPS.RELAY_URL = AustinConfig.CPS.RELAY_REVERSE_PROXY_URL;
                                self.relayProxy = AustinConfig.CPS.RELAY_URL + AustinConfig.CPS.RELAY_REVERSE_PROXY_PATH;
                            }
                        }
                        setTimeout(createRIRetryHandler, retryAfter);
                    }
                    else {
                        let retryAfter = createRIFailed * 1000;
                        AustinCore.logger.info('Retrying fresh RM Connect after  ' + retryAfter);
                        setTimeout(createRIRetryHandler, retryAfter);
                    }
                });
            }
            createRIRetryHandler();
            AustinCore.logger.info('createRIAndConnect--');
        });
    }
    /**
     * create Relay Instance using client passed Relay Manager host name. Finder ID is mandatory
     * to create an RI.
     * @param webSessionId
     * @returns {*}
     * @private
     */
    createRI(webSessionId) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.RI_CREATION);
        AustinCore.logger.info('createRI++');
        let self = this;
        return new Promise((resolve, reject) => {
            if (!self.finderId) {
                reject({
                    reason: AustinErrors.INVALID_CREATE_SESSION_PARAM
                });
                return;
            }
            const clientTypeUrl = '/operation/start/clienttype/2.json';
            const url = AustinConfig.CPS.RELAY_URL + '/relaymanager/v1/relayrequest/finderid/' + self.finderId + clientTypeUrl;
            RequestDispatcher.get(url, AustinConfig.AUSTIN.AJAX_TIMEOUT_MS).then((responseData) => {
                if (webSessionId === self.webSessionId) {
                    const info = responseData.data;
                    if (info && info.clientId && info.serverIp && info.spPort && info.serverName) {
                        self.relayInfo = {
                            clientId: info.clientId,
                            ip: info.serverIp,
                            port: info.spPort,
                            serverName: info.serverName
                        };
                        resolve();
                    }
                    else {
                        reject({ reason: AustinErrors.INVALID_RI_RESPONSE });
                    }
                }
                else {
                    self.deleteRI().then(() => AustinCore.logger.info('Assuming tangling RI is deleted'));
                    reject({ reason: AustinErrors.INVALID_RI_RESPONSE });
                }
            }).catch((e) => {
                // e will be error from RM or network error, sample RM error
                // {
                //  "status":500,
                //  "statusText":"Internal Server Error",
                //  "body":{
                //      "error":{"code":"0x0001","description":"MSG : Slingbox Not Found (NAK)"}
                //      }
                // };
                let errorDescription = '';
                if (e.body && e.body.error && e.body.error.description) {
                    errorDescription = e.body.error.description; //Ex: 'MSG : Slingbox Not Found (NAK)'
                }
                else {
                    errorDescription = JSON.stringify(e);
                }
                const error = 'RM:' + (e.message || errorDescription);
                AustinCore.logger.warn(error);
                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, error);
                //Sample error_message :
                //'error_message':'sparcs_error_sn_sparcs_unreachable;
                // RIF:MSG : Slingbox Not Responding (TIM);RIF:MSG : Slingbox Not Responding (TIM);
                // RIF:RM : Internal Error;RIF:MSG : Slingbox Not Responding (TIM);createRIFailed 4"
                reject({ reason: AustinErrors.CREATE_RELAY_INSTANCE_FAILED, RMInfo: error });
            }).then(() => PerformanceTimer.markEnd(PerformanceTimer.metrics.RI_CREATION));
            AustinCore.logger.info('createRI--');
        });
    }
    /**
     * stop the created RI using the below function. Client ID and remote ip are mandatory fields to delete an RI Instance.
     * @private
     */
    deleteRI() {
        AustinCore.logger.info('deleteRI++');
        let self = this;
        return new Promise((resolve) => {
            if (self.relayInfo.clientId && self.relayInfo.ip) {
                const url = AustinConfig.CPS.RELAY_URL + '/relaymanager/v1/relayrequest/clientid/' +
                    self.relayInfo.clientId + '/operation/stop/rmip/' + self.relayInfo.ip;
                RequestDispatcher.get(url, AustinConfig.AUSTIN.AJAX_TIMEOUT_MS).then(() => {
                    resolve();
                }).catch(() => {
                    resolve();
                });
            }
            else {
                AustinCore.logger.warn('deleteRI :: No RI available to delete');
                resolve();
            }
        });
    }
    raiseConnectionLostEvent(eventErrorOnSessionId) {
        if (!this.eventsFailedCount) {
            return;
        }
        let self = this;
        const fireConnLostEvent = (disconnectMethod, hbtInfo, online, sessionId) => {
            if (self.inActivityDetected) {
                AustinCore.logger.warn('Not raising connection lost during inactivity detected state');
                return;
            }
            AustinCore.logger.warn('clientLocalIps ' + JSON.stringify(self.debugInfo.localIps));
            if (hbtInfo && hbtInfo.reason) {
                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, hbtInfo.reason);
            }
            if (self.sessionId !== sessionId) {
                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'conLostOld(' + self.sessionId + ')');
            }
            AustinCore.analytics.setDisconnectMethod(disconnectMethod);
            let conLostReason = AustinErrors.CONNECTION_LOST;
            let conLostMessage = 'box connection lost';
            if (disconnectMethod === AnalyticsHelperConstants.analytics_disconnect_method.network_problem) {
                conLostReason = AustinErrors.CLIENT_CONNECTIVITY_PROBLEM;
                conLostMessage = 'box connection lost(client internet issue)';
            }
            self.eventManager.fire(AustinEvents.BOX_CONNECTION_LOST, {
                reason: conLostReason,
                message: conLostMessage,
                hbtInfo: hbtInfo,
                onLine: online,
                sessionIdConLost: sessionId,
                activeSessionId: self.sessionId
            });
            // no point in firing disconnect
            //self.disconnect().then(() => AustinCore.logger.info('All session attributes cleaned up'));
            if (self.sessionId === sessionId) {
                self.resetSessionAttributes();
            }
        };
        let lastEventSuccessAt = new Date(self.recentEventResponseTime).toISOString();
        self.debugInfo['lastEvent'] = lastEventSuccessAt;
        self.debugInfo['prevEvent'] = new Date(self.previousEventResponseTime).toISOString();
        let errorMessage = 'conLost(' + eventErrorOnSessionId + ')' + new Date().toISOString() + ':lstEvt:' + lastEventSuccessAt + ':online:' + navigator.onLine;
        AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, errorMessage);
        self.isPollingActive = false;
        self.debugInfo['message'] = errorMessage;
        //***
        // NOTE : As per current state handling in Austin client, sequence of 1st firing CONNECTION_LOST and
        // then calling disconnect API is mandatory,
        // else Austin will end up getting CONNECTION_LOST in disconnected state and will lead to bugs
        //***
        // Assuming it is box side issue
        if (navigator.onLine) {
            AustinCore.logger.warn('connection lost STB info ' + AustinErrors.BOX_OFFLINE);
            fireConnLostEvent(AnalyticsHelperConstants.analytics_disconnect_method.connection_lost, AustinErrors.BOX_OFFLINE, true, eventErrorOnSessionId);
        }
        else {
            AustinCore.logger.warn('clientLocalIps ' + JSON.stringify(self.debugInfo.localIps));
            fireConnLostEvent(AnalyticsHelperConstants.analytics_disconnect_method.network_problem, '', false, eventErrorOnSessionId);
        }
    }
    /**
     * Polls for Austin Events periodically. This will keep the Austin heart beat alive.
     * Also, this will listen to events generated by box, which gets propagated
     * to the client using the registered Events / Error handlers.
     * @param sessionId
     * @private
     */
    pollForEvents(sessionId) {
        let self = this;
        if (self.isPollingActive && sessionId === self.sessionId) {
            AustinCore.logger.info('Polling for EVENTS....sessionId ' + sessionId);
            const errorCallback = (error) => __awaiter(this, void 0, void 0, function* () {
                let eventErrorOnSessionId = self.sessionId;
                self.eventsFailedCount++;
                AustinCore.logger.info('error failed count:' + self.eventsFailedCount);
                yield AustinUtils.getClientLocalIp().then(ip => {
                    if (ip) {
                        self.debugInfo.localIps.push({ ip: ip, time: new Date().toISOString() });
                        self.debugInfo.eventFailReason.push(JSON.stringify(error));
                    }
                });
                if (self.eventsFailedCount <= AustinConfig.CPS.EVENT_RETRY_MAX_COUNT) {
                    AustinCore.logger.info('Core events failed count: ' + self.eventsFailedCount + ' navigator.onLine: ' + navigator.onLine);
                    setTimeout(() => self.pollForEvents(eventErrorOnSessionId), AustinConfig.EVENT_RETRY_DELAY_MS);
                }
                else {
                    AustinCore.logger.info('Core events failed continuously, so assuming as box connection lost, count: ' +
                        self.eventsFailedCount + ' navigator.onLine: ' + navigator.onLine);
                    AustinCore.analytics.setAnalyticProperty(AnalyticsHelperConstants.errorCode, 'connectionLost');
                    self.raiseConnectionLostEvent(eventErrorOnSessionId);
                }
            });
            // For success/failure if polling sessionId do not matches current sessionId stop this polling thread
            const successCallback = (response) => {
                self.eventsFailedCount = 0;
                self.debugInfo['eventsCount'] = self.debugInfo['eventsCount'] + 1;
                self.previousEventResponseTime = self.recentEventResponseTime;
                self.recentEventResponseTime = new Date().getTime();
                try {
                    self.handleEventResponse(response.event_list);
                }
                catch (e) {
                    AustinCore.logger.warn('Ignoring exception while processing event success call back' + JSON.stringify(response));
                    self.debugInfo.eventFailReason.push(response.event_list);
                }
                self.pollForEvents(self.sessionId);
            };
            let logDroppedEvent = (cmdSucceed, evnetInfo) => {
                if (!self.debugInfo['evtNotProcessed']) {
                    self.debugInfo['evtNotProcessed'] = [];
                }
                else if (self.debugInfo['evtNotProcessed'].length > 10) {
                    self.debugInfo['evtNotProcessed'].shift();
                }
                self.debugInfo['evtNotProcessed'].push(cmdSucceed ? 'CmdOk,' : 'CmdNotOk,' + evnetInfo + ',at:' + new Date().toISOString());
            };
            let reqTimeout = AustinConfig.AUSTIN.AJAX_TIMEOUT_MS / AustinConfig.CPS.EVENT_RETRY_MAX_COUNT;
            self.makeBoxRequest('events', { 'timeout': 5, reqTimeout: reqTimeout }).then((data) => {
                let reqCount = data.reqUrl.substr(data.reqUrl.indexOf('counter='), data.reqUrl.indexOf('&cnonce') - data.reqUrl.indexOf('counter='));
                AustinCore.logger.info('Events request resolved ' + reqCount.replace('=', ' '));
                if (self.isPollingActive && sessionId === self.sessionId) {
                    successCallback(data);
                }
                else {
                    AustinCore.logger.info('Dropping events self.isPollingActive ' + self.isPollingActive + ' sessionId:' + sessionId + ' self.sessionId: ' + self.sessionId);
                    logDroppedEvent(true, 'polling:' + self.isPollingActive + ',sessionId:' + sessionId + ',activeSessId:' + self.sessionId);
                }
            }).catch((error) => {
                AustinCore.logger.warn('Error in event polling ' + JSON.stringify(error, Object.getOwnPropertyNames(error)));
                if (self.isPollingActive && sessionId === self.sessionId || error.reason === AustinErrors.EXPIRED_SESSION_RESPONSE) {
                    errorCallback(error);
                }
                else {
                    logDroppedEvent(false, 'polling:' + self.isPollingActive + ',sessionId:' + sessionId + ',activeSessId:' + self.sessionId);
                }
            });
        }
    }
    handleEventResponse(events) {
        let filteredEvents = this.filterAsyncEvents(events);
        filteredEvents.sort((e1, e2) => { return e1.time - e2.time; });
        filteredEvents.forEach((boxEvent) => {
            if (boxEvent.type === 'streaming') {
                this.handleStreamingEvents(boxEvent);
            }
            else if (boxEvent.type === 'popup') {
                this.handlePopupEvents(boxEvent);
            }
            else if (boxEvent.type === 'dvr') {
                this.handleDvrEvents(boxEvent);
            }
            else {
                AustinCore.logger.info('Event not handled :' + JSON.stringify(boxEvent));
            }
        });
    }
    /**
     * Helper function to filter out multiple buffer bar and discontinuity event
     * @param events
     * @returns {Array}
     */
    filterAsyncEvents(events) {
        let bufferBarEvent = null;
        let discontinuityEvent = null;
        let boxReadyEvent = null;
        let boxProgramInfoChangedEvent = null;
        let filteredEvents = [];
        events.forEach((boxEvent) => {
            if (boxEvent.type === 'streaming' && boxEvent.subtype === 'buffer_bar') {
                bufferBarEvent = boxEvent;
            }
            else if (boxEvent.type === 'streaming' && boxEvent.subtype === 'box_status' && boxEvent.info.status === 'discontinuity') {
                discontinuityEvent = boxEvent;
            }
            else if (boxEvent.type === 'streaming' && boxEvent.subtype === 'box_status' && (boxEvent.info.status === 'stream_ready' || boxEvent.info.status === 'license_fetch_failed')) {
                boxReadyEvent = boxEvent;
            }
            else if (boxEvent.type === 'streaming' && boxEvent.subtype === 'program_info_changed') {
                boxProgramInfoChangedEvent = boxEvent;
            }
            else {
                filteredEvents.push(boxEvent);
            }
        });
        if (bufferBarEvent) {
            filteredEvents.unshift(bufferBarEvent);
        }
        if (discontinuityEvent) {
            filteredEvents.unshift(discontinuityEvent);
        }
        if (boxReadyEvent) {
            filteredEvents.unshift(boxReadyEvent);
        }
        if (boxProgramInfoChangedEvent) {
            filteredEvents.unshift(boxProgramInfoChangedEvent);
        }
        return filteredEvents;
    }
    /**
     * Keep more frequent event higher in if-else
     * @param eventData
     */
    handleStreamingEvents(eventData) {
        if (eventData.subtype === 'stream_adaptation_status') {
            this.streamInfo.bitrate = eventData.info.bitrate; // No need to propagate lebo-zone
            this.streamInfo.width = eventData.info.video_width;
            this.streamInfo.height = eventData.info.video_height;
            this.streamInfo.framerate = eventData.info.framerate || 30;
            this.streamInfo.total += parseFloat(this.streamInfo.bitrate);
            this.streamInfo.count++;
        }
        else if (eventData.subtype === 'box_status') {
            switch (eventData.info.status) {
                case 'discontinuity':
                    AustinCore.logger.info('Discontinuity reason : ' + eventData.info.reason);
                    this.eventManager.fire(AustinEvents.BOX_STREAM_DISCONTINUITY, eventData);
                    break;
                case 'stream_ready':
                case 'license_fetch_failed':
                    this.eventManager.fire(AustinEvents.BOX_READY, eventData.info);
                    break;
                case 'stream_lost':
                    if (eventData.info.reason === 'stream_takeover') {
                        AustinCore.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.box_taken_over);
                        this.eventManager.fire(AustinEvents.BOX_STREAM_LOST, { reason: AustinConstants.STREAMING.FORCE_TRANSFER, message: AustinUtils.camelCase(eventData.info.reason) });
                    }
                    else {
                        AustinCore.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.stb_unknown_reason);
                        this.eventManager.fire(AustinEvents.BOX_STREAM_LOST, { reason: AustinUtils.camelCase(eventData.info.reason), message: AustinUtils.camelCase(eventData.info.reason) });
                    }
                    break;
                case 'stream_stop':
                    if (eventData.info.reason === 'me_reboot') {
                        AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sbsdk_me_reboot);
                        AustinCore.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.media_engine_reboot);
                    }
                    else {
                        AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.unknown_outcome);
                        AustinCore.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.stb_unknown_reason);
                    }
                    this.eventManager.fire(AustinEvents.BOX_STREAM_STOP, { reason: AustinUtils.camelCase(eventData.info.reason), message: AustinUtils.camelCase(eventData.info.reason) });
                    break;
                case 'video_lock_lost':
                    this.eventManager.fire(AustinEvents.BOX_VIDEO_SIGNAL, { type: AustinConstants.STREAMING.VIDEO_LOCK_LOST, reason: eventData.info.reason });
                    break;
                case 'video_lock_success':
                    this.eventManager.fire(AustinEvents.BOX_VIDEO_SIGNAL, { type: AustinConstants.STREAMING.VIDEO_LOCK_SUCCESS, reason: eventData.info.reason });
                    break;
                default:
                    AustinCore.logger.log('box_status event not handled' + JSON.stringify(eventData));
            }
        }
        else if (eventData.subtype === 'buffer_bar') {
            if (eventData.info && eventData.info['duration_secs'] > 0) {
                this.eventManager.fire(AustinEvents.BOX_BUFFER_BAR, {
                    duration: eventData.info['duration_secs'] || 0,
                    remaining: eventData.info['elapsed_time_secs'] || 0,
                    bufferSize: eventData.info['buffer_size_secs'] || 0,
                    contentType: eventData.info['content_type'] || '',
                    originalPts: parseInt(eventData.info['original_pts'], 10) || 0
                });
            }
        }
        else if (eventData.subtype === 'program_info_changed') {
            AustinCore.logger.log('Program info change fired');
            this.eventManager.fire(AustinEvents.BOX_PROGRAM_INFO_CHANGED, eventData);
        }
        else {
            AustinCore.logger.log('Un-handled streaming event ' + JSON.stringify(eventData));
        }
    }
    /**
     * Handling popup events which require user interaction
     * Keep more frequent event higher in if-else
     * @param eventData
     */
    handlePopupEvents(eventData) {
        let popupInfo = eventData.info;
        popupInfo.type = eventData.subtype;
        switch (eventData.subtype) {
            case 'channel':
                popupInfo.input = {
                    'type': 'text',
                    'placeholder': eventData.subtype
                };
                break;
            case 'password':
                popupInfo.input = {
                    'type': 'password',
                    'placeholder': eventData.subtype
                };
                break;
            default:
                AustinCore.logger.log('Pop up event ' + JSON.stringify(eventData.subtype));
        }
        this.eventManager.fire(AustinEvents.BOX_POP_UP, popupInfo);
    }
    /**
     * Keep more frequent event higher in if-else
     * @param eventData
     */
    handleDvrEvents(eventData) {
        if (eventData.subtype === 'hdd_connected') {
            this.hddConnected = true;
        }
        else if (eventData.subtype === 'hdd_disconnected') {
            this.hddConnected = false;
        }
        else {
            AustinCore.logger.log('Un-handled dvr event ' + JSON.stringify(eventData));
        }
    }
    /**
     * initialises MPEG DASH or HLS path
     * by sending dash/hls request to the box
     * @param  params
     * @private
     * @returns promise
     */
    initDashOrHls(params) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.BOX_PLAY);
        let self = this;
        AustinCore.logger.info('initDashOrHls++');
        self.streamingType = params[AustinConstants.STREAMING.FORCE_HLS] ?
            AustinConstants.STREAMING.STREAMING_TYPE_HLS : AustinConstants.STREAMING.STREAMING_TYPE_DASH;
        self.debugInfo['streamingType'] = self.streamingType;
        const unEncrypted = params['unEncrypted'];
        return new Promise((resolve, reject) => {
            let data = {
                'content_type': params.contentType,
                'player_instance_id': params.playerInstanceId,
                'parameters': self.getStreamParams(self.connectionMode, params[AustinConstants.QUALITY_LEVELS.QUALITY]),
                'enable_auto_pause_play': false
            };
            if (self.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                if (AustinUtils.getPlatForm() === AustinConstants.PLATFORM.WEB) {
                    if (!data['parameters'].dash_params['indexed_self_init_segments']) {
                        reject({
                            reason: AustinErrors.LEGACY_BOX_HTML5_DASH_UNSUPPORTED
                        });
                        return;
                    }
                }
            }
            data['retryCount'] = AustinConfig.CPS.START_STREAM_RETRY_COUNT;
            if (data['retryCount']) {
                data['reqTimeout'] = AustinConfig.AUSTIN.AJAX_TIMEOUT_MS / (data['retryCount'] + 1);
            }
            const processedParams = AustinCore.processPlayParams(params);
            if (processedParams.key) {
                data[processedParams.key] = processedParams.value;
            }
            if (params.takeOver) {
                data['force_transfer'] = params.takeOver;
                AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_conflict_detected);
            }
            let readyTimer;
            let aborted = false;
            let boxReadyHandler;
            let streamStopHandler;
            //Streaming can be aborted even before 'start_stream' response
            streamStopHandler = (info) => {
                AustinCore.logger.debug('boxStreamUserStop');
                if (readyTimer) {
                    clearTimeout(readyTimer);
                    readyTimer = 0;
                }
                if (boxReadyHandler) {
                    self.eventManager.unSubscribe(AustinEvents.BOX_READY, boxReadyHandler);
                    boxReadyHandler = null;
                }
                if (self.stopStreamRequested) {
                    aborted = true;
                    self.stopStreamRequested = false;
                    reject({
                        reason: AustinErrors.STREAM_STOP_REQUESTED
                    });
                }
                else {
                    self.eventManager.subscribeOnce(AustinEvents.BOX_STREAM_USER_STOP, streamStopHandler);
                }
            };
            let startStreamReqTime = new Date();
            self.debugInfo['startStreamAt'] = startStreamReqTime.toISOString();
            let startStreamRequestCount = 0;
            let startStreamRequestDispatcher = () => {
                if (AustinConfig.CPS.CONNECTION_RE_ESTABLISHMENT_TIME &&
                    ((self.getEventsInactivityTime() >= AustinConfig.CPS.CONNECTION_RE_ESTABLISHMENT_TIME) ||
                        self.forceConnectionReEstablish)) {
                    self.forceConnectionReEstablish = false;
                    AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'CoreConReAtmpt' /* Connection Re Attempt due to events inactivity */);
                    self.reEstablishConnection(false, params).then(() => {
                        delete data['session_id'];
                        self.eventManager.fire(AustinEvents.BOX_CONNECTION_RE_ESTABLISHED);
                        if (aborted) {
                            AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'CoreConUsrAbort' /* Usr aborted during connection Re Establishment */);
                        }
                        else {
                            startStreamRequestDispatcher();
                        }
                    }).catch((reEstablishError) => {
                        AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'CoreConReAtmptErr' /*  Connection re attempt failure t */);
                        PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                        reject(reEstablishError);
                    });
                    return;
                }
                self.eventManager.subscribeOnce(AustinEvents.BOX_STREAM_USER_STOP, streamStopHandler);
                /*
                    mpd availability time is calculated from the value of utc_time passed as part of start_stream.
                    The UTC time passed is the  current client side system time.
                    if we want to make +/- of some drift from system time, we can use this param to do this.
                    by default is 0 seconds, so no drift from system time
                */
                let drift = AustinUtils.getQueryValueForKey('drift') || AustinConfig.PLAYER.BITMOVIN.MPD_AVAILABILITY_TIME_DRIFT;
                data['reqTimeUtc'] = new Date(Date.now() + (drift * 1000)).toISOString();
                AustinCore.logger.log('reqTimeUtc :  ' + data['reqTimeUtc']);
                self.makeBoxRequest('start_stream', data).then((response) => {
                    if (!aborted) {
                        if (!response.stream_link) {
                            startStreamRequestCount++;
                            if (self.sessionId && startStreamRequestCount <= AustinConfig.CPS.START_STREAM_RETRY_COUNT) {
                                self.stopStreaming().then(() => {
                                    if (!aborted) {
                                        AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'strtStrmMisngMpsLnk' /*startStream_MISSING_MPD_STREAM_LINK'*/);
                                        startStreamRequestDispatcher();
                                    }
                                });
                                return;
                            }
                            self.eventManager.unSubscribe(AustinEvents.BOX_STREAM_USER_STOP, streamStopHandler);
                            reject({ reason: AustinErrors.MISSING_STREAMING_LINK, info: response });
                            return;
                        }
                        PerformanceTimer.markStart(PerformanceTimer.metrics.BOX_READY);
                        const url = self.generateStreamingUrl(response.stream_link);
                        readyTimer = setTimeout(() => {
                            self.eventManager.unSubscribe(AustinEvents.BOX_STREAM_USER_STOP, streamStopHandler);
                            AustinCore.logger.warn('did not got box-ready event !');
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_READY);
                            readyTimer = 0;
                            AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_not_ready);
                            self.stopStreaming().then(() => AustinCore.logger.info('stopping streaming after box-ready timeout!'));
                            reject({
                                reason: AustinErrors.BOX_NOT_READY
                            });
                        }, AustinConfig.STREAMING.BOX_READY_TIMEOUT_MS);
                        // listen to box ready event before publishing MPD url to DASH js
                        boxReadyHandler = (info) => {
                            self.eventManager.unSubscribe(AustinEvents.BOX_STREAM_USER_STOP, streamStopHandler);
                            AustinCore.logger.info('got box-ready event !');
                            clearTimeout(readyTimer);
                            readyTimer = 0;
                            boxReadyHandler = null;
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_READY);
                            if ((AustinCore.BoxZip === self.productSignature) || (AustinCore.BoxXip === self.productSignature)) {
                                let invalidDrmInfo = true;
                                if (info && info.drm_licence_url) {
                                    let key = self.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_HLS ?
                                        AustinConstants.STREAMING.DRM_MODE_FAIRPLAY : AustinConstants.STREAMING.DRM_MODE_WIDEVINE;
                                    invalidDrmInfo = !info.drm_licence_url[key];
                                }
                                if (invalidDrmInfo && !unEncrypted) {
                                    AustinCore.logger.warn('DRM licence info missing');
                                    startStreamRequestCount++;
                                    if (self.sessionId && startStreamRequestCount <= AustinConfig.CPS.START_STREAM_RETRY_COUNT) {
                                        self.stopStreaming().then(() => {
                                            if (!aborted) {
                                                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'startStream_MISSING_LICENCE_URL');
                                                startStreamRequestDispatcher();
                                            }
                                        });
                                        return;
                                    }
                                    AustinCore.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_missing_drm);
                                    AustinCore.analytics.setAnalyticProperty(AnalyticsHelperConstants.errorCode, AustinErrors.MISSING_LICENCE_URL);
                                    reject({ reason: AustinErrors.MISSING_LICENCE_URL, info: info });
                                }
                            }
                            self.firstStreamForCurrentSession++;
                            resolve({ url: url, drmLicenceUrl: info.drm_licence_url });
                        };
                        self.eventManager.subscribeOnce(AustinEvents.BOX_READY, boxReadyHandler);
                        PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                        if (self.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_DASH && AustinUtils.isWeb()) {
                            let preFetchLicence = params[AustinConstants.STREAMING.PREFETCH_LICENCE];
                            if (typeof preFetchLicence === 'undefined' || preFetchLicence !== false) {
                                AustinUtils.prefetchWidevineCertificate(AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_LICENCE_PROXY_CERTIFICATE_URL);
                            }
                        }
                        if (response.drm_licence_url) {
                            this.eventManager.fire(AustinEvents.BOX_READY, response);
                        }
                    }
                }).catch((error) => {
                    AustinCore.logger.warn('Failed in initDashOrHls :' + JSON.stringify(error));
                    if (!aborted) {
                        self.firstStreamForCurrentSession = 0;
                        self.eventManager.unSubscribe(AustinEvents.BOX_STREAM_USER_STOP, streamStopHandler);
                        if (error.reason === AustinCore.apiResults.ALL_STRM_SESS_ACTIVE) {
                            error.reason = AustinErrors.TOO_MANY_STREAMS;
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                            reject(error);
                        }
                        else if (error.reason === AustinErrors.API_FAILED && error.info && error.info.result === 'SESS_ID_NOT_FOUND') {
                            startStreamRequestCount++;
                            if (self.sessionId && startStreamRequestCount <= AustinConfig.CPS.START_STREAM_RETRY_COUNT) {
                                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'strtStrmSesIdNtFnd(' + self.sessionId + '@' + self.getEventsInactivityTime() + ')' /* startStream_SESS_ID_NOT_FOUND*/);
                                self.forceConnectionReEstablish = true;
                                startStreamRequestDispatcher();
                                return;
                            }
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                            reject(error);
                        }
                        else if (error.reason === AustinCore.apiResults.TUNE_FAILED) {
                            error.reason = AustinErrors.TUNE_FAILED;
                            if (params.inputId) {
                                AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'ServiceId(' + params.inputId + ')');
                            }
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                            reject(error);
                        }
                        else if (error.reason === AustinErrors.AJAX_REQUEST_FAILED) {
                            let reqFailedTim = new Date().getTime() - startStreamReqTime.getTime();
                            AustinCore.logger.warn('Start stream failed, in  ' + reqFailedTim);
                            if (self.forceConnectionReEstablish) {
                                startStreamRequestDispatcher();
                                return;
                            }
                            error.reason = AustinErrors.START_STREAM_REQUEST_TIMEOUT;
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                            AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, AustinErrors.BOX_OFFLINE);
                            reject(AustinErrors.BOX_OFFLINE);
                        }
                        else if (error.reason === AustinErrors.API_FAILED && error.info) {
                            AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, '(' + error.info.result + ');');
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                            reject(error);
                        }
                        else {
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.BOX_PLAY);
                            reject(error);
                        }
                    }
                });
            };
            startStreamRequestDispatcher();
        });
    }
    /**
     * Sends box request to stop streaming
     * @param {string} reason : may have reason like boxNotReady, userAborted,playerError etc.
     * @returns {Promise<any>}
     */
    stopStreaming(param) {
        AustinCore.logger.info('stopStreaming++');
        let self = this;
        this.streamInfo.total = 0;
        this.streamInfo.count = 0;
        this.streamInfo.width = 0;
        this.streamInfo.height = 0;
        this.streamInfo.bitrate = 0;
        return new Promise((resolve) => {
            if (self.getEventsInactivityTime() >= AustinConfig.CPS.CONNECTION_RE_ESTABLISHMENT_TIME) {
                self.eventManager.fire(AustinEvents.BOX_STREAM_USER_STOP);
                resolve();
                return;
            }
            if (AustinUtils.getQueryValueForKey('noStopStreamCmd')) {
                self.eventManager.fire(AustinEvents.BOX_STREAM_USER_STOP);
                resolve();
                return;
            }
            self.makeBoxRequest('stop_stream', param).then(() => {
                resolve('success');
            }).catch(() => {
                resolve();
            });
            self.eventManager.fire(AustinEvents.BOX_STREAM_USER_STOP);
        });
    }
    getEventsInactivityTime() {
        let curTime = new Date().getTime();
        let inactivityTime = 0;
        let timeBtwnSuccessEvents = 0;
        if (this.recentEventResponseTime) {
            inactivityTime = curTime - this.recentEventResponseTime;
            if (this.previousEventResponseTime) {
                timeBtwnSuccessEvents = this.recentEventResponseTime - this.previousEventResponseTime;
            }
        }
        return (inactivityTime >= timeBtwnSuccessEvents ? inactivityTime : timeBtwnSuccessEvents);
    }
    /*
     * Re-established Box connection
     * triggerStreaming: issues streaming request to  boc
     */
    reEstablishConnection(triggerStreaming, params) {
        let self = this;
        return new Promise((resolve, reject) => {
            self.isPollingActive = false;
            self.recentEventResponseTime = 0;
            self.debugInfo['oldSessions'].push({ sessionId: self.sessionId, connectionMode: self.connectionMode });
            self.sessionId = '';
            self.connectionMode = '';
            if (AustinConfig.CPS.ENABLE_PARALLEL_CONNECTION) {
                self.makeParallelConnection(self.webSessionId).then(() => {
                    AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'CoreConReEstbshd' /* ConnectionReEstablished*/);
                    resolve();
                }).catch((reason) => {
                    reject(reason);
                });
            }
            else {
                self.makeSerialConnection(self.webSessionId).then(() => {
                    AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'CoreConReEstbshd' /* ConnectionReEstablished*/);
                    resolve();
                }).catch((reason) => {
                    reject(reason);
                });
            }
        });
    }
    joinTuner(params) {
        AustinCore.logger.debug('inside join...');
        let self = this;
        return new Promise((resolve, reject) => {
            self.makeBoxRequest('join_tuner', params).then(() => {
                resolve();
            }).catch((error) => {
                reject({ reason: error.reason });
            });
        });
    }
    /**
     * This method is used to get the channel list on coax input.
     * @returns e.g. '{'channels':[{'name':'BBC1','number':'1-1','frequency':'80','signalstrength':'76'},
     * {'name':'BBC2','number':'2-1','frequency':'80','signalstrength':'76'}]}'
     */
    getChannels() {
        AustinCore.logger.info('inside getChannels()...');
        let self = this;
        return new Promise((resolve, reject) => {
            self.makeBoxRequest('get_channel_list').then((response) => {
                resolve(response.channellist);
            }).catch((error) => {
                reject({ reason: error.reason });
            });
        });
    }
    /**
     *
     * @returns {Promise<T>}
     */
    getProgramInfo() {
        AustinCore.logger.info('inside getProgramInfo()...');
        let self = this;
        return new Promise((resolve, reject) => {
            self.makeBoxRequest('get_program_info').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject({ reason: error.reason });
            });
        });
    }
    /**
     * This method is used to change the channel on coax input with channel number explicitly passed as parameter.
     * Todo: modify this this method to handle dvr content
     * @param params
     */
    changeContent(params) {
        AustinCore.logger.info('inside changeContent()...');
        let self = this;
        return new Promise((resolve, reject) => {
            if (params.contentType === 'live' && (!params.inputType && !params.inputId)) {
                AustinCore.logger.warn('Client did not pass inputType and inputId');
                reject({ reason: AustinErrors.INVALID_PARAMS });
            }
            else {
                let data = {
                    'content_type': params.contentType
                };
                const processedParams = AustinCore.processPlayParams(params);
                if (processedParams.key) {
                    data[processedParams.key] = processedParams.value;
                }
                self.makeBoxRequest('content_change', data).then(() => {
                    resolve();
                }).catch((error) => {
                    let reason = AustinErrors.API_FAILED;
                    if (params.inputId && (error.reason === AustinCore.apiResults.TUNE_FAILED)) {
                        AustinCore.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'ServiceId(' + params.inputId + ')');
                        reason = AustinErrors.TUNE_FAILED;
                    }
                    reject({ reason: reason, info: error });
                });
            }
        });
    }
    /**
     * Sends IR commands to box
     *
     * @param keyCodes
     * @returns {Promise<any>}
     */
    sendIRCommand(keyCodes) {
        return this.makeBoxRequest('ir_command', { key_code: keyCodes });
    }
    /**
     * Sends popUpUserAction to box
     *
     * @param buttonClicked
     * @returns {Promise<any>}
     */
    popUpUserAction(buttonClicked) {
        return this.makeBoxRequest('user_action', { info: buttonClicked });
    }
    /**
     * Fetches all DVR Recordings.
     * @returns {Promise<any>|Promise}
     */
    getDvrRecordings(queryData) {
        let self = this;
        return new Promise((resolve, reject) => {
            self.makeBoxRequest('get_dvr_list', queryData).then((response) => {
                resolve({
                    recordings: response['dvr_list'],
                    count: response['total_size']
                });
            }).catch((error) => {
                reject({ reason: error.reason });
            });
        });
    }
    /**
     * Modify all mentioned DVR Recordings.
     * @param recordingIds
     * @param protecting
     * @returns {Promise<any>}
     */
    modifyDvrRecordings(recordingIds, protecting) {
        const data = {
            'dvr_id_list': recordingIds,
            'protect_recording': protecting
        };
        return this.makeBoxRequest('modify_recordings', data);
    }
    /**
     * Deletes all mentioned DVR Recordings.
     * @param recordingIds
     * @returns {Promise<any>}
     */
    deleteDvrRecordings(recordingIds) {
        return this.makeBoxRequest('delete_recordings', { dvr_id_list: recordingIds });
    }
    /**
     * Create new timers
     * @returns {Promise<any>}
     */
    createTimer(params) {
        AustinCore.logger.info('inside createTimer()...');
        let self = this;
        return new Promise((resolve, reject) => {
            if (params.airing_guid || params.frequency) {
                self.makeBoxRequest('create_timer', params).then((response) => {
                    resolve(response.gtimer_id);
                }).catch((error) => {
                    reject(self.handleCreateTimerResponse(error));
                });
            }
            else {
                AustinCore.logger.warn('createTimer failed for : ' + AustinErrors.INVALID_PARAMS);
                reject({ reason: AustinErrors.INVALID_PARAMS });
            }
        });
    }
    /**
     * Handling different use cases for creteTimer API
     * @param response
     * @returns {any}
     */
    handleCreateTimerResponse(response) {
        let error = {
            reason: AustinErrors.UNKNOWN_ERROR,
            info: null
        };
        // Handling different response result by box
        switch (response.reason) {
            case AustinCore.apiResults.DUPLICATE_ACTIVE_RECORDING:
                error.reason = AustinErrors.DUPLICATE_ACTIVE_RECORDING;
                break;
            case AustinCore.apiResults.DUPLICATE:
                error.reason = AustinErrors.DUPLICATE_TIMER;
                break;
            case AustinCore.apiResults.CONFLICT_RECORDINGS:
                error.reason = AustinErrors.CONFLICT_RECORDINGS;
                error.info = response.info['conflicts'];
                break;
            case AustinCore.apiResults.DUPLICATE_CONFLICT:
                error.reason = AustinErrors.DUPLICATE_CONFLICTS;
                error.info = response.info['data'];
                break;
        }
        return error;
    }
    /**
     * Fetches all timers
     * If client is not passing timers sortKey, taking priority as default
     * @param sortKey: string, accepted values : 'priority'/'title'
     * @returns {Promise<any>}
     */
    getTimers(sortKey) {
        AustinCore.logger.info('inside getTimers()...');
        let self = this;
        return new Promise((resolve, reject) => {
            if (sortKey && !((sortKey === 'priority') || (sortKey === 'title'))) {
                AustinCore.logger.debug('getTimers failed for : ' + AustinErrors.INVALID_PARAMS);
                reject(AustinErrors.INVALID_PARAMS);
            }
            else {
                const data = {
                    sort_key: sortKey || 'priority'
                };
                self.makeBoxRequest('get_global_timers', data).then((response) => {
                    resolve(response.timer_list);
                }).catch((error) => {
                    reject({ reason: error.reason });
                });
            }
        });
    }
    /**
     * Delete a global timers
     * @param timerIds
     * @param forced
     * @returns {Promise<any>|Promise}
     * Promise is resolved to json like {timerId : status}
     * Status is boolean indicating delete request was fulfilled or not for mentioned timer.
     */
    deleteTimers(timerIds, forced) {
        AustinCore.logger.info('inside deleteTimers()...');
        let self = this;
        return new Promise((resolve, reject) => {
            const timerData = {
                timer_ids_list: timerIds,
                force: forced || false
            };
            self.makeBoxRequest('delete_global_timers', timerData).then((response) => {
                let result = Object.create(null);
                for (let timer of response.result_list) {
                    result[timer.timer_id] = timer.result === AustinCore.apiResults.SUCCESS;
                }
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
     * Fetches all daily schedules
     * If client is passing global timerId, schedules for only that is fetched
     * @param params: Object {timerId: string, hideSkipped: boolean}
     * @returns {Promise<any>}
     */
    getRecordingSchedules(params) {
        AustinCore.logger.info('inside getRecordingSchedules()...');
        let self = this;
        return new Promise((resolve, reject) => {
            const data = {
                tmr_id: params.timerId || '',
                hide_skip: params.hideSkipped || false
            };
            self.makeBoxRequest('get_daily_schedule', data).then((response) => {
                resolve(response.schedule_list);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    /**
     * Skip mentioned schedules
     * @param schedules: Array of scheduleIds
     * @returns {Promise<any>}
     */
    skipRecordingSchedules(schedules) {
        return this.makeBoxRequest('skip_schedules', { schedule_ids_list: schedules });
    }
    /**
     * set given EncodeParams for streaming
     * @param quality
     * @returns {Promise<any>}
     */
    setEncodeParams(quality) {
        AustinCore.logger.info('inside setEncodeParams()...' + quality);
        const level = 'QUALITY_LEVEL_' + quality.toUpperCase();
        const streamParams = {
            'stream_adaptation': 'bitrate_and_resolution',
            'video': {
                'max_resolution': AustinConfig.STREAMING[this.connectionMode][level].VIDEO_RESOLUTION,
                'bitrate': {
                    'min': AustinConfig.STREAMING[this.connectionMode].VIDEO_BITRATE_MIN,
                    'max': AustinConfig.STREAMING[this.connectionMode][level].VIDEO_BITRATE_MAX
                },
            },
            'audio': {
                'bitrate': {
                    'min': AustinConfig.STREAMING[this.connectionMode].AUDIO_BITRATE_MIN,
                    'max': AustinConfig.STREAMING[this.connectionMode].AUDIO_BITRATE_MAX
                }
            }
        };
        return this.makeBoxRequest('set_encode_params', { 'parameters': streamParams });
    }
    /**
     * This method is used to pause the playback from the box
     *
     * @returns {Promise<any>}
     */
    pause() {
        return this.makeBoxRequest('pause');
    }
    /**
     * This method is used to resume the playback from the box
     *
     * @returns {Promise<any>}
     */
    resume() {
        return this.makeBoxRequest('resume');
    }
    /**
     * This method is used to seek the playback with relative time and PTS
     *
     * @returns {Promise<any>}
     */
    seek(pts, time) {
        AustinCore.logger.info('inside seek()...time : ' + time + ' pts ' + pts);
        const data = {
            current_pts: pts,
            seek_relative_seconds: time
        };
        return this.makeBoxRequest('seek', data);
    }
    getStreamParams(connectionType, quality) {
        const qualityLevel = 'QUALITY_LEVEL_' + quality.toUpperCase();
        const streamParams = {
            'streaming_format': this.streamingType,
            // Box team  requested to pass bitrate_and_resolution
            'stream_adaptation': 'bitrate_and_resolution',
            'video': {
                'codec': 'H264',
                'profile': AustinConfig.SUPPORTED_CODEC.profile,
                'level': AustinConfig.SUPPORTED_CODEC.level,
                'max_resolution': AustinConfig.STREAMING[connectionType][qualityLevel].VIDEO_RESOLUTION,
                'iframe_interval': AustinConfig.STREAMING[connectionType].I_FRAME_INTERVAL_MS / 1000,
                'bitrate': {
                    'min': AustinConfig.STREAMING[connectionType].VIDEO_BITRATE_MIN,
                    'max': AustinConfig.STREAMING[connectionType][qualityLevel].VIDEO_BITRATE_MAX,
                    'start': AustinConfig.STREAMING[connectionType][qualityLevel].VIDEO_BITRATE_START
                },
            },
            'audio': {
                'codec': 'AAC',
                'mode': 'stereo',
                'sampling_frequency': 32000,
                'bitrate': {
                    'min': AustinConfig.STREAMING[connectionType].AUDIO_BITRATE_MIN,
                    'max': AustinConfig.STREAMING[connectionType].AUDIO_BITRATE_MAX,
                    'start': AustinConfig.STREAMING[connectionType].AUDIO_BITRATE_MIN,
                }
            }
        };
        //setting start bitrate as 1200 for LAN and 800 for Relay/WAN-TCP on Android and fire Tv and tvOS
        if ((AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) || AustinUtils.isTvOS()) {
            if (connectionType === AustinConstants.BOX.CONNECTION_MODE_LAN) {
                streamParams.video.bitrate.start = 1200;
            }
            else if ((connectionType === AustinConstants.BOX.CONNECTION_MODE_RELAY) || (connectionType === AustinConstants.BOX.CONNECTION_MODE_TCP)) {
                streamParams.video.bitrate.start = 800;
            }
        }
        //remembering last stream bitrate only for LAN
        if (this.firstStreamForCurrentSession > 0 && (connectionType === AustinConstants.BOX.CONNECTION_MODE_LAN)) {
            streamParams.video.bitrate.start = 0;
        }
        // if format is dash streamParams need dash_params
        if (this.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
            streamParams.dash_params = {
                'segment_duration': AustinUtils.getDashSegmentDuration(connectionType),
                'codec': AustinConfig.SUPPORTED_CODEC.codec,
                'disable_discontinuity_counter': true
            };
            AustinCore.logger.info('setting dash client forward buffer parameter');
            if (AustinUtils.isAndroid()) {
                streamParams.dash_params['client_forward_buffer'] = AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER;
            }
            else if (AustinUtils.isWeb() && (AustinConstants.STREAMING.STREAMING_TYPE_DASH === this.getStreamingType())) {
                streamParams.dash_params['client_forward_buffer'] = AustinConfig.BM_PLAYER_FORWARD_BUFFER;
            }
            if (AustinUtils.isAndroid() && AustinConfig.PLAYER.BITMOVIN.UNLOAD_LOAD_ON_DISCONTINUITY) {
                streamParams.dash_params['disable_discontinuity_counter'] = false;
            }
            if (AustinUtils.isWeb() || AustinConfig.PLAYER.BITMOVIN.ANDROID_SELF_INDEXED_SEGMENTS) {
                let dashCap = this.capabilities['dash'];
                if (dashCap && dashCap['segment_type'] && dashCap['segment_type'].filter(e => e === 'indexed_self_init').length === 1) {
                    streamParams.dash_params['indexed_self_init_segments'] = true;
                }
            }
        }
        else if (this.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
            streamParams.hls_params = {
                'segment_duration': AustinConfig.STREAMING[connectionType].HLS_SEGMENT_DURATION_MS / 1000,
                'mode': 'native',
                'small_seg_supported': true,
                'id3_support': true
            };
        }
        if (connectionType === AustinConstants.BOX.CONNECTION_MODE_LAN) {
            streamParams.audio.bitrate.start = 96;
        }
        // if (Utils.isDeviceChromeCast()) {
        //     streamParams.video.max_resolution = Config.STREAMING.CHROMECAST.VIDEO_RESOLUTION;
        //     streamParams.video.bitrate = {
        //         'min': Config.STREAMING.CHROMECAST.VIDEO_BITRATE_MIN,
        //         'max': Config.STREAMING.CHROMECAST.VIDEO_BITRATE_MAX,
        //         'start': Config.STREAMING.CHROMECAST.VIDEO_BITRATE_START
        //     };
        // }
        this.streamingAnalytics[AnalyticsHelperConstants.requestedResolution] = streamParams.video.max_resolution;
        this.streamingAnalytics[AnalyticsHelperConstants.requestedCodecAudio] = streamParams.audio.codec;
        this.streamingAnalytics[AnalyticsHelperConstants.requestedCodecVideo] = streamParams.video.codec;
        this.streamingAnalytics[AnalyticsHelperConstants.requestedLeboProfile] = streamParams.stream_adaptation;
        this.streamingAnalytics[AnalyticsHelperConstants.connProtocol] = this.streamingType;
        return streamParams;
    }
    getStreamingStartsAnalytics() {
        return this.streamingAnalytics;
    }
    // public getSessionAverageBitrate(): number {
    //     let averageBitrate = (this.avgBitrate.total / this.avgBitrate.count).toFixed(2);
    //     return parseFloat(averageBitrate);
    // }
    /**
     * This takes cares of starting from given channel_id or service_id
     * Todo: modify this this method to handle all scenarios of dvr content
     * @param params
     * @returns {{key: null, value: {}}}
     */
    static processPlayParams(params) {
        let data = {
            key: null,
            value: Object.create(null)
        };
        if (params.contentType === 'live' && params.inputId) {
            data.key = 'live';
            if (params.inputType === 'channel_id') {
                data.value = {
                    'input_type': 'channel_id',
                    'channel_id': params.inputId
                };
            }
            if (params.inputType === 'service_id') {
                data.value = {
                    'input_type': 'service_id',
                    'service_id': params.inputId
                };
            }
        }
        else if (params.contentType === 'dvr') {
            data.key = 'dvr';
            data.value = {
                'dvr_id': params.dvr.dvr_id,
                'start_over': params.dvr.start_over,
                'autohop': params.dvr.autohop
            };
        }
        return data;
    }
    /**
     * Returns current bitrate, width, height
     * @returns {any}
     */
    getStreamInfo() {
        return this.streamInfo;
    }
    /**
     * Cache dns response for DASH media urls.
     * eg: https://10-100-10-43-ip-audio.dishboxes.com:5101/austin
     *     https://10-100-10-43-ip-video.dishboxes.com:5101/austin
     * we have seen DNS request for audio-video domains being timed out by slow networks
     * @returns {any}
     */
    triggerDnsCachingForDashMediaUrls(baseUri) {
        let self = this;
        let retryCount = 3;
        baseUri = baseUri || this.baseUri;
        let videoUrl = baseUri.command.replace('-cmd', '-video');
        let audioUrl = baseUri.command.replace('-cmd', '-audio');
        let t1 = new Date().getTime();
        function dnsAudRequet() {
            //extract hostname from url;
            let index = audioUrl.indexOf(':');
            index = index + 3; // ://
            let audioDnsHost = audioUrl.substr(index, audioUrl.lastIndexOf(':') - index);
            if (self.debugInfo['dsnLookup'][audioDnsHost]) {
                return;
            }
            let request = {
                'url': audioUrl,
                'method': 'POST',
                'timeout': AustinConfig.AUSTIN.AJAX_TIMEOUT_MS / retryCount
            };
            RequestDispatcher.makeRequest(request).then((response) => {
                AustinCore.logger.warn('Response came forAudio DNS resolved ');
                let t2 = new Date().getTime();
                AustinCore.logger.warn('DASH_VIDEO_DNS ' + (t2 - t1));
                self.debugInfo['dsnLookup'][audioDnsHost] = '' + (t2 - t1);
            }).catch((error) => {
                if (retryCount > 0 && !self.sessionId) {
                    retryCount--;
                    setTimeout(dnsAudRequet, 0);
                }
                else {
                    AustinCore.logger.warn('AJAX request failed : ' + JSON.stringify(error));
                }
            });
        }
        function dnsVidRequet() {
            //extract hostname from url;
            let index = audioUrl.indexOf(':');
            index = index + 3; // ://
            let videoDnsHost = videoUrl.substr(index, videoUrl.lastIndexOf(':') - index);
            if (self.debugInfo['dsnLookup'][videoDnsHost]) {
                return;
            }
            let request = {
                'url': videoUrl,
                'method': 'POST',
                'timeout': AustinConfig.AUSTIN.AJAX_TIMEOUT_MS / retryCount
            };
            RequestDispatcher.makeRequest(request).then((response) => {
                AustinCore.logger.warn('Response came for Video url, DNS resolved ');
                let t2 = new Date().getTime();
                AustinCore.logger.warn('DASH_VIDEO_DNS ' + (t2 - t1));
                self.debugInfo['dsnLookup'][videoDnsHost] = '' + (t2 - t1);
            }).catch((error) => {
                if (retryCount > 0) {
                    retryCount--;
                    setTimeout(dnsAudRequet, 0);
                }
                else {
                    AustinCore.logger.warn('AJAX request failed : ' + JSON.stringify(error));
                }
            });
        }
        if (!self.debugInfo['dsnLookup']) {
            self.debugInfo['dsnLookup'] = {};
        }
        dnsAudRequet();
        dnsVidRequet();
    }
    getDebugInfo() {
        return this.debugInfo;
    }
    /**
     * A wrapper for making BOX request as per V3 standard
     * Any status other than SUCCESS is rejected.
     * So, if any API is interested in other status, it has to handle inline in catch block
     * @param command
     * @param data
     * @returns {Promise<any>}
     */
    makeBoxRequest(command, data) {
        let self = this;
        const user = this.user;
        const pass = this.password;
        let url;
        let timeout = AustinConfig.AUSTIN.AJAX_TIMEOUT_MS;
        if (data && data.reqTimeout) {
            timeout = data.reqTimeout;
            delete data.reqTimeout;
        }
        let retryCount = 0;
        if (data && data.retryCount) {
            retryCount = data.retryCount;
            delete data.retryCount;
        }
        if (data && data.url) {
            url = data.url;
            delete data.url;
        }
        else {
            url = this.getUrlWithAuth(user, pass);
        }
        let payload = data || Object.create(null);
        payload['command'] = command;
        //Disconnecting mentioned session while one is active
        payload['session_id'] = (data && data.session_id) ? data.session_id : this.sessionId;
        if (data && data.reqTimeUtc) {
            payload['current_utc_time'] = data.reqTimeUtc;
            delete data.reqTimeUtc;
        }
        else {
            payload['current_utc_time'] = new Date().toISOString();
        }
        let request = {
            'url': url,
            'method': 'POST',
            'data': payload,
            'timeout': timeout
        };
        return new Promise((resolve, reject) => {
            function makeRequestHandler() {
                RequestDispatcher.makeRequest(request).then((response) => {
                    response.data['command'] = payload['command'];
                    response.data['commandAt'] = payload['current_utc_time'];
                    response.data['lastEventAt'] = new Date(self.recentEventResponseTime).toISOString();
                    response.data['prevEventAt'] = new Date(self.previousEventResponseTime).toISOString();
                    response.data['reqUrl'] = request.url;
                    response.data['reqSessionId'] = payload.session_id;
                    response.data['activeSessionId'] = self.sessionId;
                    if (payload['session_id'] === self.sessionId) {
                        if (response.data.result === AustinCore.apiResults.SUCCESS) {
                            resolve(response.data);
                        }
                        else {
                            reject({
                                reason: AustinCore.apiResults[response.data.result] || AustinErrors.API_FAILED,
                                info: response.data
                            });
                        }
                    }
                    else {
                        AustinCore.logger.warn('Old session response came : ' + payload['session_id']);
                        reject({ reason: AustinErrors.EXPIRED_SESSION_RESPONSE, info: response.data }); // Todo: This reject is not handled in calling place
                    }
                }).catch((error) => {
                    if (self.connectionMode === AustinConstants.BOX.CONNECTION_MODE_LAN &&
                        payload['command'] === 'start_stream' &&
                        self.eventsFailedCount) {
                        retryCount = 0;
                        self.forceConnectionReEstablish = true;
                        AustinCore.logger.warn('start_stream failed, may be client connection lost, re-establishing fresh connection');
                    }
                    if (retryCount > 0) {
                        retryCount--;
                        AustinCore.logger.warn('AJAX request failed : ' + JSON.stringify(error) + ' Retrying..');
                        setTimeout(makeRequestHandler, 0);
                    }
                    else {
                        payload['lastEventAt'] = new Date(self.recentEventResponseTime).toISOString();
                        payload['prevEventAt'] = new Date(self.previousEventResponseTime).toISOString();
                        payload['reqUrl'] = request.url;
                        payload['activeSessionId'] = self.sessionId;
                        AustinCore.logger.warn('AJAX request failed : ' + JSON.stringify(error));
                        reject({ reason: AustinErrors.AJAX_REQUEST_FAILED, data: Object.assign({}, payload) });
                    }
                });
            }
            makeRequestHandler();
        });
    }
    /**
     * forms Austin base URI based on ip and port set.
     * This URI is mainly used for creating Austin Session.
     *
     * @returns {command: string , data: string}
     * @private
     */
    generateBaseURI(mode, ip, port) {
        ip = ip || this.ip;
        port = port || this.port;
        let portPath = ':' + port + '/austin';
        let protocol = AustinUtils.getProtocol();
        if (mode === AustinConstants.BOX.CONNECTION_MODE_RELAY && this.relayProxy) {
            let urlCmd = protocol + '//' + this.relayInfo.serverName + AustinConfig.CPS.RELAY_REVERSE_PROXY_PATH + btoa('http://localhost' + portPath);
            return { command: urlCmd, data: urlCmd };
        }
        let urlCmd = protocol + '//' + ip;
        let urlData = urlCmd;
        if (protocol === 'https:') {
            urlCmd = urlCmd.replace(/\./g, '-') + AustinConfig.CPS.URL_DOMAIN_FOR_DNS_COMMAND;
            urlData = urlData.replace(/\./g, '-') + AustinConfig.CPS.URL_DOMAIN_FOR_DNS_DATA;
        }
        urlCmd = urlCmd + portPath;
        urlData = urlData + portPath;
        return { command: urlCmd, data: urlData };
    }
    generateStreamingUrl(streamLink) {
        /* in case of HLS and DASH without segment manager, will use the same URL as that of AUSTIN commans
         this will avoid DNS resolution,
         For DASH with segment manager, separate audio video url will be created inside segment manager.
         */
        return this.baseUri.command + streamLink;
    }
    /**
     * Fetch auth url
     * If callee dont have username and password, it can pass empty string and then this API will use stored value
     * @param user : string username
     * @param pass : string password
     * @returns {string}
     */
    getUrlWithAuth(user, pass) {
        return this.baseUri.command + '?' + this.getSlingAuthValue(user || this.user, pass || this.password, this.sessionId);
    }
    /**
     * Generates Austin authorization string which will be used as URL query parameters.
     * @param user : string username
     * @param pass : string password
     * @param sessionId : string sessionId
     * @returns {string}
     * @private
     */
    getSlingAuthValue(user, pass, sessionId) {
        this.reqCounter++;
        const cnonce = new Date().getTime().toString();
        const digestInputStr = user + ':' + sessionId + ':' + cnonce + ':'
            + this.reqCounter + ':' + pass;
        return 'account=' + user + '&counter=' + this.reqCounter + '&cnonce=' + cnonce
            + '&digest=' + AustinUtils.digest(digestInputStr);
    }
    /**
     * Returns  sessionId or ''
     * @returns {string}
     */
    getSessionId() {
        return this.sessionId;
    }
    /**
     * Returns streamingOverRelayProxy : {false : default, true: for reverse proxy}
     * @returns {boolean}
     */
    getStreamingOverRelayProxy() {
        return this.streamingOverRelayProxy;
    }
    /**
     * Returns  connectionMode or ''
     * @returns {string}
     */
    getConnectionMode() {
        return this.connectionMode;
    }
    /**
     * Returns  streamingType(hls/dash) or ''
     * @returns {string}
     */
    getStreamingType() {
        return this.streamingType;
    }
    getDeviceClockFrequencyInKHz() {
        return this.deviceClockFrequencyInKHz;
    }
    /**
     * Reset Box details
     */
    resetBoxDetails() {
        this.deviceLANAddress = '';
        this.deviceWANAddress = '';
        this.devicePort = '';
        this.finderId = '';
        this.firmwareVersion = '';
        this.hardwareVersion = '';
        this.ip = '';
        this.lastSparcsRegistered = '';
        this.password = '';
        this.productSignature = '';
        this.port = '';
        this.receiverId = '';
        this.sbProductSignature = '';
        this.user = '';
        this.previousEventResponseTime = 0;
        this.recentEventResponseTime = 0;
        this.streamingOverRelayProxy = false;
    }
    /**
     * All session details will also get reset here
     */
    resetSessionAttributes() {
        this.resetBoxDetails();
        this.hddConnected = false;
        this.webSessionId = '';
        this.sessionId = '';
        this.connectionMode = '';
    }
    /**
     * Decides if mentioned box is already interacting with Austin
     * @param finderId
     */
    isSameBox(finderId) {
        return (this.finderId === finderId);
    }
    getBoxInfo() {
        return {
            boxPort: this.devicePort,
            finderId: this.finderId,
            firmwareVersion: this.firmwareVersion,
            hardwareVersion: this.hardwareVersion,
            lastSparcsRegistered: this.lastSparcsRegistered,
            productSignature: this.productSignature,
            receiverId: this.receiverId,
            sbProductSignature: this.sbProductSignature,
            sbLanIp: this.deviceLANAddress,
            sbWanIp: this.deviceWANAddress,
        };
    }
    getRelayInfo() {
        return this.relayInfo;
    }
    getClientLocalIp() {
        return this.clientLocalIp;
    }
    getClientPublicIp() {
        return this.clientPublicIp;
    }
    /**
     * Gives HDD is connected or not
     * @returns boolean
     */
    isHddConnected() {
        return this.hddConnected;
    }
    setStopStreamRequested() {
        this.stopStreamRequested = true;
    }
    istStopStreamRequested() {
        return this.stopStreamRequested === true;
    }
    isInActivityDetected() {
        return this.inActivityDetected;
    }
    setInActivityDetected(value) {
        this.inActivityDetected = value;
    }
    /**
     * Sends TV remote key to box
     *
     * @param remoteKey
     * @param remoteReceiverId
     * @returns {Promise<any>}
     */
    tvRemoteKey(remoteKey, remoteReceiverId) {
        return this.makeBoxRequest('tv_remote_key', { key_name: remoteKey, receiver_id: remoteReceiverId });
    }
}
AustinCore.BoxXip = '000013';
AustinCore.BoxZip = '000070';
AustinCore.BoxAirTv = '000050';
AustinCore.BoxAirTv2 = '000051';
AustinCore.logger = new AustinLogger('AustinCore');
// Only box errors which need explicit handling is listed, others are mapped to apiFailed
// All these errors are mapped to one of error in error.ts in appropriate API
AustinCore.apiResults = Object.freeze({
    ALL_STRM_SESS_ACTIVE: 'ALL_STRM_SESS_ACTIVE',
    ALL_CRTL_SESS_ACTIVE: 'ALL_CRTL_SESS_ACTIVE',
    CONFLICT_RECORDINGS: 'CONFLICT_RECORDINGS',
    DUPLICATE_ACTIVE_RECORDING: 'DUPLICATE_ACTIVE_RECORDING',
    DUPLICATE_CONFLICT: 'DUPLICATE_CONFLICT',
    DUPLICATE: 'DUPLICATE_TIMER',
    REQ_AUTH_FAILED: 'REQ_AUTH_FAILED',
    SUCCESS: 'SUCCESS',
    TUNE_FAILED: 'TUNE_FAILED'
});

/**
 * Created by sunny on 03/01/19.
 * This file contains logic and data for Austin explicit pipeline feature
 */
class SegmentManager {
    constructor(austin) {
        this.activeVideoRequest = 0;
        this.activeAudioRequest = 0;
        this.waitingForResumeAudio = false;
        this.waitingForResumeVideo = false;
        this.lookUpLimit = 20;
        this.videoLookupLimitReachedForUrl = '';
        this.audioLookupLimitReachedForUrl = '';
        this.videoLookupLimitReached = false;
        this.audioLookupLimitReached = false;
        this.segmentsDataStore = null;
        this.segmentDuration = 0; // in seconds
        this.austin = null;
        this.dumpSegmentTo = null;
        this.licencePrefetch = true;
        this.baseUrl = null;
        this.baseUrlAudio = null;
        this.baseUrlVideo = null;
        this.discontinuityCount = 0;
        this.waitingForFirstSegReq = true;
        this.pausePipeLine = false;
        this.maxParallelReqCount = 0;
        this.maxBufferLevel = 0;
        this.isTransitioning = false;
        SegmentManager.logger.info('created!');
        this.austin = austin;
    }
    setTransition(value) {
        this.isTransitioning = value;
    }
    resetSegmentManager() {
        this.segmentsDataStore = Object.create(null);
        this.segmentsDataStore[AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO] = new Map();
        this.segmentsDataStore[AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO] = new Map();
        this.segmentsDataStore[AustinConstants.PLAYER.REQUEST_TYPE_MPD] = new Map();
        this.activeVideoRequest = 0;
        this.activeAudioRequest = 0;
        this.pausePipeLine = false;
        this.audioLookupLimitReached = false;
        this.videoLookupLimitReached = false;
        this.audioLookupLimitReachedForUrl = '';
        this.videoLookupLimitReachedForUrl = '';
    }
    flushSegmentsStore(discontinuityCount) {
        if (this.segmentsDataStore) {
            SegmentManager.logger.info('flushSegmentsStore');
            this.rejectPendingSegmentRequests();
            this.segmentsDataStore[AustinConstants.PLAYER.REQUEST_TYPE_MPD].clear();
            this.segmentsDataStore[AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO].clear();
            this.segmentsDataStore[AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO].clear();
            this.resetSegmentManager();
            if (discontinuityCount >= 0) {
                this.discontinuityCount = discontinuityCount;
                this.startPipeline();
            }
            else {
                this.segmentsDataStore = null;
            }
        }
        else {
            //without custom pipeline
            this.discontinuityCount = discontinuityCount || this.discontinuityCount;
        }
    }
    startPipeline(params) {
        SegmentManager.logger.info('segment manager startPipeline');
        if (this.baseUrl !== null) {
            this.maxParallelReqCount = 1;
            this.waitingForFirstSegReq = true;
            this.initiatePipeline(this.discontinuityCount + '/video/vid-1.m4s', AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO);
            this.initiatePipeline(this.discontinuityCount + '/audio/aud-1.m4s', AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO);
        }
        else {
            if (params) {
                let mpdUrl = params.url;
                let urlParts = mpdUrl.split('dash/');
                this.baseUrl = urlParts[0] + 'dash/';
                this.maxBufferLevel = params[AustinConstants.PLAYER.MAX_BUFFER_LEVEL] * (params['rebufferingThreshold'] || 1);
                this.baseUrlAudio = this.baseUrl.replace('-cmd', '-audio');
                this.baseUrlVideo = this.baseUrl.replace('-cmd', '-video');
                this.segmentRequestHandler(urlParts[1], AustinConstants.PLAYER.REQUEST_TYPE_MPD);
            }
        }
    }
    getNextSegmentUrl(url, type) {
        let nextUrl = '';
        if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
            let urlParts = url.split('video/vid-');
            nextUrl = urlParts[0] + 'video/vid-' + (parseInt(urlParts[1], 10) + 1) + '.m4s';
        }
        else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO) {
            let urlParts = url.split('audio/aud-');
            nextUrl = urlParts[0] + 'audio/aud-' + (parseInt(urlParts[1], 10) + 1) + '.m4s';
        }
        else {
            SegmentManager.logger.error('getNextSegmentUrl :: should not be here, url : ' + url);
        }
        return nextUrl;
    }
    segmentRequestHandler(url, type) {
        let self = this;
        let segInfo = self.segmentsDataStore[type].get(url);
        if (segInfo) {
            if (segInfo.downloadStatus) {
                SegmentManager.logger.log('segmentRequestHandler :: already requested ' + url);
                return;
            }
        }
        else {
            // create and request
            segInfo = {
                downloadStatus: '',
                downloadTime: '',
                url: '',
                hasBitmovinRequested: false,
                promise: null,
                resolve: null,
                reject: null,
                cancel: null,
                controller: window['AbortController'] ? new AbortController() : null
            };
            self.segmentsDataStore[type].set(url, segInfo);
            segInfo.promise = new Promise((resolve, reject) => {
                segInfo.resolve = resolve;
                segInfo.reject = reject;
            }).catch((reason) => SegmentManager.logger.warn('Promise rejected for ' + url + ' with error ' + JSON.stringify(reason)));
        }
        // Initiate request
        segInfo.downloadStatus = SegmentManager.DOWNLOAD_STATUS.IN_PROGRESS;
        let signal = segInfo.controller ? segInfo.controller.signal : null;
        let segmentResponse = null;
        //pause-resume handling
        let fetchUrlBase = this.baseUrl;
        if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
            this.activeVideoRequest++;
            fetchUrlBase = this.baseUrlVideo;
        }
        else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO) {
            this.activeAudioRequest++;
            fetchUrlBase = this.baseUrlAudio;
        }
        SegmentManager.logger.log('segmentRequestHandler, Issuing fetch ' + url);
        let requestTime = Date.now();
        fetch(fetchUrlBase + url, { 'signal': signal }).then((response) => {
            SegmentManager.logger.log('segmentRequestHandler, got fetch response for ' + url, response.status);
            if (response.ok) {
                if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
                    self.activeVideoRequest = Math.max(self.activeVideoRequest - 1, 0);
                }
                else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO) {
                    self.activeAudioRequest = Math.max(self.activeAudioRequest - 1, 0);
                }
                segmentResponse = response;
                SegmentManager.logger.info('segmentRequestHandler, Austin.waitingForPause : ' + self.austin.waitingForPause +
                    ' activeAudioRequest :' + self.activeAudioRequest +
                    ' activeVideoRequest :' + self.activeVideoRequest);
                if (type === AustinConstants.PLAYER.REQUEST_TYPE_MPD) {
                    self.startPipeline();
                }
                else {
                    // To replace just finished slot and To occupy any lost slot
                    if (self.isTransitioning) {
                        SegmentManager.logger.info('Stop requests from seg manager');
                    }
                    else {
                        for (let count = 0; count < self.maxParallelReqCount; count++) {
                            self.keepPipelineEngaged(url, type);
                        }
                    }
                }
                if (!self.hasToRequestNext(type) && self.austin.waitingForPause &&
                    self.activeAudioRequest === 0 && self.activeVideoRequest === 0) {
                    //pause-resume handling
                    self.austin.waitingForPause = false;
                    self.austin.corePause();
                }
                return type === AustinConstants.PLAYER.REQUEST_TYPE_MPD ? response.text() : response.arrayBuffer();
            }
            else {
                throw response;
            }
        }).then((data) => {
            //check to filter out error response and success response after stopStream
            let segInfo = self.segmentsDataStore[type].get(url);
            if (segInfo) {
                segInfo.downloadStatus = SegmentManager.DOWNLOAD_STATUS.COMPLETED;
                let response = {
                    url: this.baseUrl + url,
                    request: segInfo.request,
                    headers: segmentResponse.headers,
                    status: segmentResponse.status,
                    statusText: segmentResponse.statusText,
                    length: data.byteLength,
                    body: data
                };
                if (self.isTransitioning || response.length < 4000) {
                    SegmentManager.logger.info('Override Init segment response with 410');
                    response.status = 410;
                    response.length = 0;
                    response.body = null;
                }
                const downloadTime = Date.now() - requestTime;
                SegmentManager.logger.debug('segmentRequestHandler, fetch segment load-end success for ' + url +
                    ' size ' + data.byteLength +
                    ' downloadTime ' + downloadTime +
                    ' speed: ' + (Math.round(((data.byteLength || 0) / downloadTime) * (1000 / 1024))) + 'kbps');
                segInfo.downloadTime = downloadTime;
                segInfo.url = url;
                if (this.isTransitioning && response.status !== 200) {
                    SegmentManager.logger.info('Rejecting segment promise in case of Discontinuity');
                    segInfo.reject({ status: response.status });
                    return;
                }
                segInfo.resolve(response);
                if (this.dumpSegmentTo) {
                    if (type === AustinConstants.PLAYER.REQUEST_TYPE_MPD) {
                        let body = response.body.replace(/type=\"dynamic\"/g, 'type=\"static\"');
                        body = body.replace(/timeShiftBufferDepth=\"PT48H\"/, 'mediaPresentationDuration=\"PT48H\"');
                        let request = Object.create(null);
                        request['method'] = 'POST';
                        request['body'] = body.slice();
                        request['mode'] = 'no-cors';
                        request['headers'] = { 'Content-Type': 'application/octet-stream' };
                        let dumpUrl = this.dumpSegmentTo + response.url.substr(response.url.indexOf('austin') + 'austin'.length);
                        fetch(dumpUrl, request).then(() => {
                            SegmentManager.logger.log('dump ok');
                        }).catch((err) => {
                            SegmentManager.logger.warn('dump not ok' + JSON.stringify(err));
                        });
                    }
                    else {
                        let request = Object.create(null);
                        request['method'] = 'POST';
                        request['body'] = response.body.slice();
                        request['mode'] = 'no-cors';
                        request['headers'] = { 'Content-Type': 'application/octet-stream' };
                        let dumpUrl = this.dumpSegmentTo + response.url.substr(response.url.indexOf('austin') + 'austin'.length);
                        fetch(dumpUrl, request).then((response) => {
                            SegmentManager.logger.log('dump ok');
                        }).catch((err) => {
                            SegmentManager.logger.warn('dump not ok ' + JSON.stringify(err));
                        });
                    }
                }
            }
        }).catch((error) => {
            SegmentManager.logger.warn('segmentRequestHandler, fetch segment error for ' + fetchUrlBase + url + ' error : ' +
                (error.status || 404) + ' ' + JSON.stringify(error));
            segInfo.reject({ status: error.status || 404 });
            self.deleteSegmentInfo(fetchUrlBase + url, type);
        });
    }
    hasToRequestNext(type) {
        let hasToRequest = false;
        if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO &&
            this.activeVideoRequest < AustinConfig.PLAYER.BITMOVIN.PIPELINE_VIDEO_LIMIT) {
            hasToRequest = true;
        }
        else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO &&
            this.activeAudioRequest < AustinConfig.PLAYER.BITMOVIN.PIPELINE_AUDIO_LIMIT) {
            hasToRequest = true;
        }
        return hasToRequest && !this.pausePipeLine;
    }
    keepPipelineEngaged(url, type) {
        if (this.hasToRequestNext(type)) {
            let requestCandidateUrl = this.getRequestCandidate(url, type);
            SegmentManager.logger.log('keepPipelineEngaged ' + url
                + ' requestCandidateUrl ' + requestCandidateUrl);
            if (requestCandidateUrl !== url) {
                if (this.segmentsDataStore) {
                    this.segmentRequestHandler(requestCandidateUrl, type);
                }
            }
            else {
                if (this.austin.waitingForPause) {
                    //Segment manager will fire pause once lookup limit is reached and there are no active pending segment requests
                    if (!this.getActiveRequestsCount() && this.isLookUpLimitReached()) {
                        SegmentManager.logger.info('Pausing from SegManager');
                        this.austin.waitingForPause = false;
                        this.austin.corePause();
                    }
                }
                SegmentManager.logger.log('keepPipelineEngaged, next url not Requested');
                //Here one of the pipeline thread will be deactivated
            }
        }
        else {
            if (this.pausePipeLine) {
                SegmentManager.logger.log('keepPipelineEngaged, segmentManager paused');
            }
        }
    }
    isLookUpLimitReached() {
        if (this.segmentsDataStore) {
            if (this.videoLookupLimitReached || this.audioLookupLimitReached) {
                SegmentManager.logger.info('lookuplimit reached in pause state');
                return true;
            }
        }
        return false;
    }
    getRequestCandidate(url, type) {
        let tempUrl = url;
        if (this.segmentsDataStore[type].size > this.lookUpLimit) {
            SegmentManager.logger.log('lookUpLimit has reached for ' + type);
            if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
                this.videoLookupLimitReachedForUrl = url;
                this.videoLookupLimitReached = true;
            }
            else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO) {
                this.audioLookupLimitReachedForUrl = url;
                this.audioLookupLimitReached = true;
            }
            return tempUrl;
        }
        for (let i = 0; this.segmentsDataStore[type].get(tempUrl) &&
            this.segmentsDataStore[type].get(tempUrl).downloadStatus &&
            i < this.lookUpLimit &&
            this.segmentsDataStore[type].size <= this.lookUpLimit; i++) {
            tempUrl = this.getNextSegmentUrl(tempUrl, type);
        }
        return tempUrl;
    }
    resumeHandler(url, type) {
        let firstRequestCandidateUrl = this.getRequestCandidate(url, type);
        //second condition is for not having segment just after resume
        if (firstRequestCandidateUrl !== url ||
            !(this.segmentsDataStore[type].get(firstRequestCandidateUrl) && this.segmentsDataStore[type].get(firstRequestCandidateUrl).downloadStatus)) {
            if (this.austin.waitingForResume) {
                SegmentManager.logger.info('resumeHandler :: has to resume box');
                this.austin.boxResume();
                this.austin.waitingForResume = false;
            }
            this.initiatePipeline(firstRequestCandidateUrl, type);
            if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
                this.waitingForResumeVideo = false;
            }
            else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO) {
                this.waitingForResumeAudio = false;
            }
        }
        else {
            SegmentManager.logger.info('resumeHandler :: lookUpLimit has reached');
            //Here one of the pipeline thread will be deactivated
        }
    }
    initiatePipeline(url, type) {
        this.segmentRequestHandler(url, type);
        //only one segment is requested in the start, later pipelining is configured through setMaxParallelReq
        //let secondRequestCandidateUrl = this.getNextSegmentUrl(url, type);
        //this.segmentRequestHandler(secondRequestCandidateUrl, type);
        // Starting with pipeline count as 2 to improve latency, it will auto catch up to 3
        // let thirdRequestCandidateUrl = this.getNextSegmentUrl(secondRequestCandidateUrl, type);
        // this.segmentRequestHandler(thirdRequestCandidateUrl, type);
    }
    /**
     * Without this method sometime only audio or only video request can be seen on resume
     * This handles when user resumes when last requested segment is still not served.
     * In that use case one of audio/video pipeline is paused
     */
    handlePauseResumeTransition() {
        this.waitingForResumeAudio = !this.activeAudioRequest;
        this.waitingForResumeVideo = !this.activeVideoRequest;
    }
    setPipelineResumingStatus(status) {
        this.waitingForResumeAudio = status;
        this.waitingForResumeVideo = status;
    }
    pause() {
        this.pausePipeLine = true;
    }
    resume() {
        this.pausePipeLine = false;
    }
    isPaused() {
        return this.pausePipeLine;
    }
    setMaxParallelReq(maxReqCount) {
        this.maxParallelReqCount = maxReqCount;
    }
    noSegmentsDownloadedLength(type) {
        let noDownloadedSgements = 0;
        if (this.segmentsDataStore) {
            this.segmentsDataStore[type].forEach(e => {
                if (e.downloadStatus === 'completed') {
                    noDownloadedSgements++;
                }
            });
        }
        return noDownloadedSgements * this.segmentDuration;
    }
    getAudioSegmentsLength() {
        return this.noSegmentsDownloadedLength(AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO);
    }
    getVideoSegmentsLength() {
        return this.noSegmentsDownloadedLength(AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO);
    }
    getSegmentInfo(url, type) {
        if (this.segmentsDataStore) {
            return this.segmentsDataStore[type].get(url.split('dash/')[1]);
        }
        return null;
    }
    /**
     * Used to delete once segment is downloaded and fetched to player
     * @param url
     * @param type
     */
    deleteSegmentInfo(url, type) {
        if (this.segmentsDataStore) {
            SegmentManager.logger.log('clearSegmentInfo :: clearing data for segment ' + url);
            if (this.segmentsDataStore[type]) {
                this.segmentsDataStore[type].delete(url.split('dash/')[1]);
                //Code below is just for debugging purpose
                this.segmentsDataStore[type].forEach((value, key, map) => {
                    SegmentManager.logger.log('segmentsDataStore has info for : ', key);
                });
                if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO && this.videoLookupLimitReached) {
                    SegmentManager.logger.log('clearSegmentInfo :: Resuming Video after lookup limit' + this.videoLookupLimitReachedForUrl);
                    this.keepPipelineEngaged(this.videoLookupLimitReachedForUrl, type);
                    this.videoLookupLimitReached = false;
                    this.videoLookupLimitReachedForUrl = '';
                }
                else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO && this.audioLookupLimitReached) {
                    SegmentManager.logger.log('clearSegmentInfo :: Resuming Audio after lookup limit' + this.audioLookupLimitReachedForUrl);
                    this.keepPipelineEngaged(this.audioLookupLimitReachedForUrl, type);
                    this.audioLookupLimitReached = false;
                    this.audioLookupLimitReachedForUrl = '';
                }
            }
        }
    }
    rejectPendingSegmentRequests() {
        if (this.segmentsDataStore) {
            Object.keys(this.segmentsDataStore).forEach((type) => {
                this.segmentsDataStore[type].forEach((value, key, map) => {
                    if (value.downloadStatus === SegmentManager.DOWNLOAD_STATUS.IN_PROGRESS) {
                        SegmentManager.logger.log('rejectPendingSegmentRequests abort/reject inprogress segment request, ' + value['url']);
                        if (value.controller && value.controller.abort) {
                            value.controller.abort();
                        }
                        else {
                            value.reject();
                        }
                    }
                    else {
                        SegmentManager.logger.log('rejectPendingSegmentRequests ignore future segment request, ' + value['url']);
                    }
                });
            });
        }
    }
    getActiveRequestsCount() {
        return this.segmentsDataStore ? this.activeAudioRequest + this.activeVideoRequest : this.austin.pendingSegmentsRequests;
    }
    getNetworkConfig(params) {
        let playerNetworkInterceptor;
        let self = this;
        this.dumpSegmentTo = params[AustinConstants.PLAYER.DUMP_SEGMENTS_TO_SERVER];
        this.licencePrefetch = params[AustinConstants.STREAMING.PREFETCH_LICENCE];
        this.segmentDuration = params[AustinConstants.STREAMING.SEGMENT_DURATION];
        if (params[AustinConstants.PLAYER.CUSTOM_PIPELINE]) {
            this.resetSegmentManager();
            if (AustinUtils.isDeviceChromeCast()) {
                this.lookUpLimit = 12;
            }
            playerNetworkInterceptor = {
                sendHttpRequest: (type, request) => {
                    if (!this.licencePrefetch) {
                        if (type === AustinConstants.PLAYER.REQUEST_TYPE_WIDEVINE_LICENCE) {
                            SegmentManager.logger.log('networkConfig : not handling licence request: licencePrefetch disabled');
                            return;
                        }
                    }
                    let urlParts = request.url.split('dash/');
                    let url = urlParts[1];
                    SegmentManager.logger.log('networkConfig : bitmoving calling sendHttpRequest type: ' + type + ' raw url : ' + url);
                    if (type === AustinConstants.PLAYER.REQUEST_TYPE_MPD) {
                        this.baseUrl = urlParts[0] + 'dash/';
                        this.baseUrlAudio = this.baseUrl.replace('-cmd', '-audio');
                        this.baseUrlVideo = this.baseUrl.replace('-cmd', '-video');
                        if (!self.segmentsDataStore[type].get(url)) {
                            SegmentManager.logger.log('MPD request not present: ' + type + ' raw url : ' + url);
                            this.segmentRequestHandler(url, type);
                        }
                    }
                    url = url.replace(/\d+/, self.discontinuityCount);
                    let segInfo = self.segmentsDataStore[type].get(url);
                    if (segInfo) {
                        if (self.waitingForFirstSegReq && (type !== AustinConstants.PLAYER.REQUEST_TYPE_MPD)) {
                            let numbers = url.match(/\d+/g).map(Number);
                            if (numbers && numbers.length > 1 && numbers[1] === 1) {
                                SegmentManager.logger.info('networkConfig : segment request 1  come after pipeline start');
                                self.waitingForFirstSegReq = false;
                                self.pausePipeLine = false;
                            }
                            else {
                                SegmentManager.logger.info('networkConfig : segment request 1 did not come after pipeline start');
                                if (!self.pausePipeLine) {
                                    self.austin.checkPlaybackStarted();
                                }
                                self.pausePipeLine = true;
                                return;
                            }
                        }
                        SegmentManager.logger.log('networkConfig : sendHttpRequest : found in data store ' + url);
                        segInfo.hasBitmovinRequested = true;
                        segInfo.request = request;
                    }
                    else {
                        SegmentManager.logger.info('networkConfig : sendHttpRequest : Not found in data store ' + url);
                        let numbers = url.match(/\d+/g).map(Number);
                        if (numbers && numbers.length > 1 && numbers[1] === 1) {
                            SegmentManager.logger.info('Seg -1 not found, might have deleted after receiving 404/410 , fetching request again');
                            self.segmentRequestHandler(url, type);
                            self.waitingForFirstSegReq = false;
                            self.pausePipeLine = false;
                            segInfo = self.segmentsDataStore[type].get(url);
                            if (segInfo) {
                                segInfo.hasBitmovinRequested = true;
                                segInfo.request = request;
                            }
                        }
                        else {
                            self.austin.checkAndTriggerSeek();
                        }
                    }
                    if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO && self.waitingForResumeAudio) {
                        self.resumeHandler(url, type);
                    }
                    else if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO && self.waitingForResumeVideo) {
                        self.resumeHandler(url, type);
                    }
                    let networkConfig = {
                        getResponse: () => {
                            SegmentManager.logger.log('networkConfig bitmoving calling getResponse ' + url);
                            //Segment download may be inProgress
                            if (self.segmentsDataStore[type].get(url).downloadStatus === SegmentManager.DOWNLOAD_STATUS.COMPLETED) {
                                setTimeout(() => {
                                    if (self.austin.waitingForPause && self.getActiveRequestsCount() === 0 && self.isLookUpLimitReached()) {
                                        self.austin.waitingForPause = false;
                                        self.austin.corePause();
                                    }
                                }, 1000);
                            }
                            return Promise.resolve(segInfo.promise);
                        },
                        setProgressListener: () => {
                            SegmentManager.logger.log('networkConfig :: bitmoving calling setProgressListener');
                        },
                        cancel: () => {
                            SegmentManager.logger.log('networkConfig :: bitmoving calling cancel ' + url);
                        }
                    };
                    if (segInfo) {
                        segInfo.cancel = networkConfig.cancel;
                    }
                    else {
                        SegmentManager.logger.info('networkConfig :: segInfo empty for ' + url);
                        return;
                    }
                    return networkConfig;
                }
            };
        }
        else {
            playerNetworkInterceptor = {
                preprocessHttpRequest: (type, request) => {
                    if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO ||
                        type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
                        self.austin.pendingSegmentsRequests++;
                        SegmentManager.logger.log('networkConfig : preprocessHttpRequest : ' + request.url +
                            ' PendingSegmentsRequestsCount: ' + self.austin.pendingSegmentsRequests);
                        if (self.austin.waitingForResume && self.austin.pendingSegmentsRequests > 0) {
                            self.austin.boxResume();
                        }
                        request.url = request.url.replace(/dash\/\d+/, 'dash\/' + self.discontinuityCount);
                        SegmentManager.logger.log('networkConfig : preprocessHttpRequest Segment Request rewrite url, ', request.url);
                    }
                },
                preprocessHttpResponse: (type, response) => {
                    if (type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_AUDIO ||
                        type === AustinConstants.PLAYER.REQUEST_TYPE_MEDIA_VIDEO) {
                        // For bitmovin 7.x.x, for failure it will not come in  preprocessHttpResponse
                        if (response.status === 200) {
                            self.austin.pendingSegmentsRequests = Math.max(self.austin.pendingSegmentsRequests - 1, 0);
                            if (self.austin.waitingForPause && self.austin.pendingSegmentsRequests === 0) {
                                self.austin.waitingForPause = false;
                                self.austin.corePause();
                            }
                        }
                        else {
                            SegmentManager.logger.log('networkConfig : preprocessHttpResponse : response.status: ' + response.status +
                                ' PendingSegmentsRequestsCount: ' + self.austin.pendingSegmentsRequests);
                        }
                        SegmentManager.logger.log('networkConfig : preprocessHttpResponse : ' + response.url +
                            ' PendingSegmentsRequestsCount: ' + self.austin.pendingSegmentsRequests);
                        // dump segments and mpd to remote server
                        if (this.dumpSegmentTo) {
                            let request = Object.create(null);
                            request['method'] = 'POST';
                            request['body'] = response.body.slice();
                            request['mode'] = 'no-cors';
                            request['headers'] = { 'Content-Type': 'application/octet-stream' };
                            let dumpUrl = this.dumpSegmentTo + response.url.substr(response.url.indexOf('austin') + 'austin'.length);
                            fetch(dumpUrl, request).then((response) => {
                                SegmentManager.logger.log('dump ok');
                            }).catch((err) => {
                                SegmentManager.logger.warn('dump not ok' + JSON.stringify(err));
                            });
                        }
                    }
                    else if (type === 'manifest/dash' && response.status === 200) {
                        // dump mpd and mpd to remote server
                        //response.body = response.body.replace(/<UTCTiming .*<\/UTCTiming>/, '');
                        //response.body = response.body.replace(/timeShiftBufferDepth=\"PT48H\"/, '');
                        let utc = '<\/Period>\r\n' + response.body.substring(response.body.indexOf('<UTCTiming'), response.body.indexOf('</UTCTiming>') + '</UTCTiming>'.length);
                        response.body = response.body.replace(/<UTCTiming .*<\/UTCTiming>\r\n/, '');
                        response.body = response.body.replace('</Period>', utc);
                        response.body = response.body.replace('qualityRanking=\"vid-0\"', 'qualityRanking=\"0\"');
                        //response.body = response.body.replace(/timeShiftBufferDepth/, 'suggestedPresentationDelay=\"PT0S\" timeShiftBufferDepth');
                        if (this.dumpSegmentTo) {
                            let body = response.body.replace(/type=\"dynamic\"/g, 'type=\"static\"');
                            body = body.replace(/timeShiftBufferDepth=\"PT1H\"/, 'mediaPresentationDuration=\"PT1H\"');
                            let request = Object.create(null);
                            request['method'] = 'POST';
                            request['body'] = body.slice();
                            request['mode'] = 'no-cors';
                            request['headers'] = { 'Content-Type': 'application/octet-stream' };
                            let dumpUrl = this.dumpSegmentTo + response.url.substr(response.url.indexOf('austin') + 'austin'.length);
                            fetch(dumpUrl, request).then((response) => {
                                SegmentManager.logger.log('dump ok');
                            }).catch((err) => {
                                SegmentManager.logger.warn('dump not ok' + JSON.stringify(err));
                            });
                        }
                    }
                    else {
                        return;
                    }
                },
                retryHttpRequest: (type, response) => {
                    // delay the retry by 1 second
                    SegmentManager.logger.info('networkConfig : retryHttpRequest : ' + type + response.url +
                        ' PendingSegmentsRequestsCount: ' + self.austin.pendingSegmentsRequests);
                    self.austin.pendingSegmentsRequests = Math.max(self.austin.pendingSegmentsRequests - 1, 0);
                    return new Promise((resolve) => {
                        // Retry only for 404 - Not Found
                        if (response.status === 404) {
                            setTimeout(() => {
                                self.austin.pendingSegmentsRequests++;
                                resolve(response.request);
                            }, 500);
                        }
                        else {
                            resolve();
                        }
                    });
                }
            };
        }
        return playerNetworkInterceptor;
    }
}
SegmentManager.logger = new AustinLogger('SegmentManager');
SegmentManager.DOWNLOAD_STATUS = {
    IN_PROGRESS: 'inProgress',
    COMPLETED: 'completed',
};

/**
 * Created by Sunny on 01/12/16.
 *
 * This class is responsible for fetching MDConfig and merge all
 * the required values with the constants and configs.
 */
/**
 * MD Config fetch service
 */
class MDConfig {
    /**
     * * Note *  md-config server does not expose ETag
     * Browser takes care of the cache and returns 304 if not modified
     * It fires MD config request to server and saves the new config in the cache.
     * Merges them with the app config.
     * @returns {Promise|Promise<T>}
     */
    static fetch(version, env) {
        return new Promise((resolve) => {
            let url = 'https://' + (env === AustinConstants.ENV_QA ? 'qa' : '') +
                'mdconfig.sling.com/config/type/services/product/HollywoodPlayer/version/' +
                version.match(/\d+\.\d+\.\d+/g) + '.json' + '?_=' + new Date().getTime();
            RequestDispatcher.get(url, AustinConfig.AUSTIN.AJAX_TIMEOUT_MS).then((response) => {
                if (response.data && response.data.config) {
                    AustinUtils.merge(AustinConfig, response.data.config);
                }
                resolve();
            }).catch((error) => {
                MDConfig.logger.info('MD fetch error! ' + JSON.stringify(error));
                resolve();
            });
        });
    }
}
MDConfig.logger = new AustinLogger('MDConfigService');

/**
 * Created by sunny on 12/03/18.
 */
class Html5Player {
    constructor() {
        this.emitter = eventEmitter({});
        Html5Player.baseLogger.info('created!');
    }
    subscribe(event, handler) {
        this.emitter.off(event, handler);
        this.emitter.on(event, handler);
    }
    subscribeOnce(event, handler) {
        this.emitter.once(event, handler);
    }
    unSubscribe(event, handler) {
        this.emitter.off(event, handler);
    }
    getVersion() {
        return undefined;
    }
    playUrl(url, params) {
        return undefined;
    }
    isPaused() {
        return undefined;
    }
    isVideoElementPaused() {
        return undefined;
    }
    play() {
        return undefined;
    }
    pause() {
        return undefined;
    }
    seek(seekPos) {
        return undefined;
    }
    timeShift(seekPos) {
        return undefined;
    }
    getCurrentTime() {
        return undefined;
    }
    getDuration() {
        return undefined;
    }
    destroy() {
        return undefined;
    }
    getSnapshot() {
        return undefined;
    }
    isFullScreen() {
        return undefined;
    }
    fullScreenEnter() {
        return undefined;
    }
    fullScreenExit() {
        return undefined;
    }
    unloadLoad(reason) {
        return undefined;
    }
    getCurrentPTS() {
        return undefined;
    }
    getCurrentBitRate() {
        return undefined;
    }
    checkPlaybackStarted() {
        return undefined;
    }
    getDroppedFrames() {
        return undefined;
    }
    getPlayer() {
        return undefined;
    }
    getPlaybackSpeed() {
        return undefined;
    }
    getAudioBufferLength() {
        return undefined;
    }
    setBufferLevel(bufferType, level) {
        return undefined;
    }
    getVideoBufferLength() {
        return undefined;
    }
    isMuted() {
        return undefined;
    }
    mute() {
        return undefined;
    }
    unMute() {
        return undefined;
    }
    getVolume() {
        return undefined;
    }
    setVolume(volume) {
        return undefined;
    }
    getDownloadedSize() {
        return undefined;
    }
    getCCList() {
        return undefined;
    }
    getCCChannel() {
        return undefined;
    }
    setCCChannel(ccChannel) {
        return undefined;
    }
    applyCC(cc) {
        return undefined;
    }
    setLogLevel(level) {
        return undefined;
    }
}
Html5Player.baseLogger = new AustinLogger('Html5Player');

class CustomCC {
    constructor(playerContainer, cc) {
        this.subsArray = [];
        CustomCC.logger.debug('CustomSubtitleDisplay created!');
        this.playerContainer = playerContainer;
        this.cc = cc;
        this.init();
    }
    updateFontSize(param) {
        ;
    }
    createHTMLElement(type, attributes, content) {
        var el = document.createElement(type);
        var prop;
        if (attributes) {
            for (prop in attributes) {
                if (attributes.hasOwnProperty(prop)) {
                    el.setAttribute(prop, attributes[prop]);
                }
            }
        }
        if (content) {
            el.innerHTML = content;
        }
        return el;
    }
    getCssFromCEAPosition(row, col) {
        var left = CustomCC.PERCENTAGE_WIDTH * (col + 1);
        var top = CustomCC.PERCENTAGE_HEIGHT * (row + 1);
        return 'top:' + Math.round(top) + '%;left:' + Math.round(left) + '%;';
    }
    showCue(event) {
        var attributes = {
            style: 'position:absolute;padding:1px;'
        };
        if (event.position) {
            attributes.style += this.getCssFromCEAPosition(event.position.row, event.position.column);
        }
        attributes.style += this.spanStyle;
        var elem = this.createHTMLElement('div', attributes);
        elem.innerHTML = event.text.replace(/\n/g, '<br/>');
        this.subtitleArea.appendChild(elem);
        this.subsArray.push({
            data: event,
            element: elem
        });
    }
    isSameCue(cue1, cue2) {
        var samePosition = true;
        if (cue1.position && cue2.position) {
            samePosition = cue1.position.row === cue2.position.row && cue1.position.column === cue2.position.column;
        }
        return samePosition && cue1.text === cue2.text && cue1.start === cue2.start && cue1.end === cue2.end;
    }
    hideCue(event) {
        for (var i = 0; i < this.subsArray.length; i++) {
            if (this.isSameCue(this.subsArray[i].data, event) && this.subsArray[i].element.parentNode) {
                this.subsArray[i].element.parentNode.removeChild(this.subsArray[i].element);
                this.subsArray.splice(i, 1);
                break;
            }
        }
    }
    clear(event) {
        if (this.subtitleArea) {
            this.subtitleArea.innerHTML = '';
        }
    }
    destroy() {
        if (this.subtitleArea && this.subtitleArea.parentNode) {
            this.subtitleArea.parentNode.removeChild(this.subtitleArea);
            this.subtitleArea = null;
            this.subsArray = [];
        }
    }
    init() {
        this.subtitleArea = this.createHTMLElement('div');
        this.subtitleArea.setAttribute('id', 'austin-custom-subtitles');
        this.subtitleArea.style.position = 'absolute';
        this.subtitleArea.style.bottom = '0%';
        this.subtitleArea.style.width = '100%';
        this.subtitleArea.style.height = '100%';
        this.subtitleArea.style.margin = '0';
        this.subtitleArea.style.padding = '0';
        this.subtitleArea.style.pointerEvents = 'none';
        var renderingElement = this.playerContainer.getElementsByTagName('video')[0] || this.playerContainer.getElementsByTagName('object')[0];
        if (renderingElement && renderingElement.nextSibling) {
            this.playerContainer.insertBefore(this.subtitleArea, renderingElement.nextSibling);
        }
        else {
            this.playerContainer.appendChild(this.subtitleArea);
        }
    }
    updateCC(cc) {
        this.cc = cc;
        let ccStyle = '';
        let shadow = '';
        if (this.cc.CCFontColor !== '') {
            if (this.cc.CCFontOpacity !== '') {
                let c = CustomCC.rgbMap[this.cc.CCFontColor.toLocaleLowerCase()];
                if (c !== undefined) {
                    ccStyle = ccStyle + ';color: rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + this.cc.CCFontOpacity + ')';
                }
            }
            else {
                ccStyle = ccStyle + ';color:' + this.cc.CCFontColor;
            }
        }
        // SlingTV sets to '32px', so we parse for this input
        if (this.cc.CCFontSize !== '') {
            if (this.cc.CCFontSize.search('px') >= 0) {
                ccStyle = ccStyle + ';font-size:' + this.cc.CCFontSize;
            }
            else {
                ccStyle = ccStyle + ';font-size:' + this.cc.CCFontSize + '%';
            }
        }
        if (this.cc.CCFontStyle !== '') {
            ccStyle = ccStyle + ';font-family:' + this.cc.CCFontStyle;
            if (this.cc.CCFontStyle === 'SmallCaps') {
                ccStyle = ccStyle + ';font-variant: small-caps';
            }
        }
        if (this.cc.CCBGColor !== '') {
            if (this.cc.CCBGOpacity !== '') {
                let c = CustomCC.rgbMap[this.cc.CCBGColor.toLocaleLowerCase()];
                if (c !== undefined) {
                    ccStyle = ccStyle + ';background-color: rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + this.cc.CCBGOpacity + ')';
                }
            }
            else {
                ccStyle = ccStyle + ';background-color:' + this.cc.CCBGColor;
            }
        }
        if (this.cc.CCFontWeight !== '') {
            ccStyle = ccStyle + ';font-weight:' + this.cc.CCFontWeight;
        }
        if (this.cc.CCFontEdgeColor !== '') {
            shadow = '1px 1px 1px COLOR, 1px -1px 1px COLOR, -1px 1px 1px COLOR,-1px -1px 1px COLOR';
            shadow = shadow.replace(/COLOR/g, this.cc.CCFontEdgeColor);
        }
        if (this.cc.CCFontEdgeStyle !== '') {
            shadow = (shadow.length ? (shadow + ',') : '') + this.cc.CCFontEdgeStyle.replace(/text-shadow:|;/g, '');
        }
        if (this.cc.CCTextShadow !== '') {
            shadow = (shadow.length ? (shadow + ',') : '') + this.cc.CCFontEdgeStyle.replace(/text-shadow:|;/g, '');
        }
        if (shadow.length) {
            ccStyle = ccStyle + ';text-shadow: ' + shadow + ';';
        }
        this.spanStyle = ccStyle;
        let children = this.subsArray;
        let len = children.length;
        let child;
        for (var i = 0; i < len; i++) {
            child = children[i];
            if (child) {
                child.style = this.spanStyle;
            }
        }
    }
}
CustomCC.logger = new AustinLogger();
CustomCC.rgbMap = {
    'red': { r: 255, g: 0, b: 0 },
    'green': { r: 0, g: 255, b: 0 },
    'blue': { r: 0, g: 0, b: 255 },
    'cyan': { r: 0, g: 255, b: 255 },
    'magenta': { r: 255, g: 0, b: 255 },
    'yellow': { r: 255, g: 255, b: 0 },
    'white': { r: 255, g: 255, b: 255 },
    'black': { r: 0, g: 0, b: 0 },
};
CustomCC.CEA_ROWS = 15;
CustomCC.CEA_COLUMNS = 32;
CustomCC.PERCENTAGE_HEIGHT = 90 / CustomCC.CEA_ROWS;
CustomCC.PERCENTAGE_WIDTH = 90 / CustomCC.CEA_COLUMNS;

var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class EmeSessionInfo {
    constructor(session, playerSession) {
        this.session = session;
        this.valid = true;
        this.playerSession = playerSession;
        this.licenceUpdate = 0;
    }
}
class EmeSession {
    constructor(player) {
        this.mediaKeys = null;
        this.sessionInfo = null;
        EmeSession.logger.info('created!');
        this.player = player;
    }
    createMediaKeySession(initData) {
        let self = this;
        let videoElement = this.player.player.getVideoElement();
        let setMediaKeys = videoElement.setMediaKeys(self.mediaKeys);
        setMediaKeys.then(() => {
            let playerSession = self;
            if (self.sessionInfo) {
                EmeSession.logger.info('EME DRM MediaSession already found id ' + self.id);
                self.sessionInfo.valid = false;
            }
            EmeSession.logger.info('EME DRM creating new MediaSession');
            let session = self.mediaKeys.createSession();
            self.sessionInfo = new EmeSessionInfo(session, self);
            session.addEventListener('message', self.handleMediaKeySessionMessage.bind(self.sessionInfo), false);
            session.generateRequest('cenc', initData.buffer).catch((error) => {
                EmeSession.logger.info('EME DRM license generateRequest failed' + JSON.stringify(error));
                let errorObj = AustinErrors.EME_DRM_LICENCE_GENERATE_REQUEST_FAILED;
                errorObj['info'] = JSON.stringify(error);
                playerSession.player.emitEvent(AustinEvents.PLAYER_ERROR, errorObj);
            }).then(() => {
                playerSession.id = session.sessionId;
                EmeSession.logger.warn('EME DRM license generateRequest success, session id ' + self.id);
            });
        }).catch((err) => {
            EmeSession.logger.warn('EME DRM videoElement.setMediaKeys failed:' + JSON.stringify(err));
            let errorObj = AustinErrors.EME_DRM_LICENCE_SET_MEDIAKEY_FAILED;
            errorObj['info'] = JSON.stringify(err);
            self.player.emitEvent(AustinEvents.PLAYER_ERROR, errorObj);
        });
    }
    updateSessionLicence(emeSession, licence) {
        let self = emeSession;
        if (emeSession.valid) {
            EmeSession.logger.info('EME DRM calling lince upadte id' + emeSession.session.sessionId);
            emeSession.session.update(licence).catch((error) => {
                EmeSession.logger.warn('EME DRM licence mediaKeySession.update failed for id:' + emeSession.session.sessionId + ' error:' + JSON.stringify(error));
                let errorObj = AustinErrors.EME_DRM_LICENCE_UPDATE_FAILED;
                errorObj['info'] = JSON.stringify(error);
                errorObj['licenceResp'] = Array.apply(null, new Uint8Array(licence));
                errorObj['licenceRspLen'] = licence.byteLength;
                self.playerSession.player.emitEvent(AustinEvents.PLAYER_ERROR, errorObj);
            }).then(() => {
                EmeSession.logger.info('EME DRM licence mediaKeySession.update success id : ' + emeSession.session.sessionId);
                emeSession.licenceUpdate++;
            });
        }
        else {
            EmeSession.logger.info('EME DRM licence mediaKeySession.update: Not Updating for old session, id: ' + emeSession.session.sessionId);
        }
    }
    /*
     fetches the licence key form licence server and update the media session key
     either with fetched/cached licecne.
     please refer for more details on EME https://www.w3.org/TR/encrypted-media/
     */
    handleMediaKeySessionMessage(event) {
        //this context is EmeSessionInfo, is set by calling bind
        let markName = PerformanceTimer.metrics.WIDEVINE_LICENCE_REQ1;
        const drmEntry = PerformanceTimer.getEntriesByName(markName);
        if (drmEntry.length) {
            markName = PerformanceTimer.metrics.WIDEVINE_LICENCE_REQ2;
        }
        PerformanceTimer.markStart(markName);
        let sessionInfo = this;
        let playerSession = sessionInfo.playerSession;
        EmeSession.logger.info('EME DRM handleMediaKeySessionMessage callback mediaKeySession sessionId' + sessionInfo.session.sessionId);
        let payload = '';
        if (event.message.byteLength === 2) {
            payload = btoa(String.fromCharCode(...new Uint8Array(event.message)));
            //Widevine Certificate request from chrome CDM module will come with payload of int8 array of length 2
            // array content will be [8,4] Base64 encoded value for this binary array is CAQ=
            if (payload === 'CAQ=' && playerSession.player.licenceUrl === AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_LICENCE_PROXY_CERTIFICATE_URL) {
                let licence = AustinUtils.getCachedWidevineCertificate();
                if (licence) {
                    EmeSession.logger.info('EME DRM Update session licence using Cached licence' + event.message + ' for id:' + sessionInfo.session.sessionId);
                    PerformanceTimer.markEnd(markName);
                    return playerSession.updateSessionLicence(sessionInfo, licence);
                }
            }
        }
        let request = Object.create(null);
        request['method'] = 'POST';
        let msg = {
            user_id: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_USER_ID,
            channel_id: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_CHANNEL_ID,
            disabled: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_DISABLED,
            env: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_ENV,
            message: Array.apply(null, new Uint8Array(event.message))
        };
        request['data'] = msg;
        request['hasToReadAsBlob'] = true;
        request['url'] = playerSession.player.licenceUrl;
        EmeSession.logger.info('EME DRM fetching licence request' + event.message);
        let retryCount = AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_LICENCE_FETCH_RETRY_COUNT;
        function requestHandler() {
            RequestDispatcher.makeRequest(request).then((responseBlob) => {
                EmeSession.logger.info('EME DRM licence fetch success');
                let reader = new FileReader();
                reader.addEventListener('loadend', function () {
                    if (payload === 'CAQ=') {
                        AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_LICENCE_PROXY_CERTIFICATE_URL = playerSession.player.licenceUrl;
                        AustinUtils.updateCachedWidevineCertificate(reader.result);
                    }
                    EmeSession.logger.info('EME DRM licence fetched, keySession.updating ' + reader.result + ' for id:' + sessionInfo.session.sessionId);
                    PerformanceTimer.markEnd(markName);
                    playerSession.updateSessionLicence(sessionInfo, reader.result);
                });
                reader.readAsArrayBuffer(responseBlob.data);
            }).catch((e) => {
                if (e.status && e.body === 'ACCESS_DENIED') {
                    EmeSession.logger.warn('EME licence request failed : ' + JSON.stringify(e));
                    let errorObj = AustinErrors.EME_DRM_LICENCE_FETCH_WV_PROXY_ACCESS_DENIED;
                    errorObj['info'] = JSON.stringify(e);
                    errorObj['licenceReqData'] = request['data'];
                    errorObj['dataLength'] = request['data']['message'].length;
                    playerSession.player.emitEvent(AustinEvents.PLAYER_ERROR, errorObj);
                    return;
                }
                if (retryCount > 0) {
                    retryCount--;
                    EmeSession.logger.warn('EME licence request failed : ' + JSON.stringify(e) + ' Retrying..');
                    setTimeout(requestHandler, 500);
                }
                else {
                    EmeSession.logger.warn('EME DRM licence fetch failure' + JSON.stringify(e));
                    let errorObj = AustinErrors.EME_DRM_LICENCE_FETCH_FAILED;
                    errorObj['info'] = JSON.stringify(e);
                    errorObj['licenceReqData'] = request['data'];
                    errorObj['dataLength'] = request['data']['message'].length;
                    playerSession.player.emitEvent(AustinEvents.PLAYER_ERROR, errorObj);
                }
            });
        }
        requestHandler();
    }
    getContentProtectionInitData(mpdText) {
        function base64ToAarry(str) {
            // atob creates a "raw string" where each character is interpreted as a byte.
            let bytes = window.atob(str.replace(/-/g, '+').replace(/_/g, '/'));
            let result = new Uint8Array(bytes.length);
            for (let i = 0; i < bytes.length; ++i) {
                result[i] = bytes.charCodeAt(i);
            }
            return result;
        }
        let initDta = [];
        let parser = new DOMParser();
        let mpd = parser.parseFromString(mpdText, 'text/xml');
        let periodIndex = undefined;
        for (let i = 0; i < mpd.documentElement.children.length; i++) {
            let child = mpd.documentElement.children[i];
            if (child.nodeName.toLowerCase() === 'period') {
                periodIndex = i;
                break;
            }
        }
        if (periodIndex !== undefined) {
            let adaptations = mpd.documentElement.children[periodIndex].children;
            for (let i = 0; i < adaptations.length; i++) {
                const a = adaptations[i];
                for (let j = 0; j < a.children.length; j++) {
                    const child = a.children[j];
                    if (child.nodeName.toLowerCase() === 'contentprotection') {
                        for (let k = 0; k < child.children.length; k++) {
                            const cpChild = child.children[k];
                            const cencs = cpChild.nodeValue || cpChild.textContent || cpChild.innerHTML;
                            if (cencs) {
                                initDta.push(base64ToAarry(cencs));
                            }
                        }
                    }
                    else if (child.nodeName.toLowerCase() === 'representation') {
                        for (let k = 0; k < child.children.length; k++) {
                            const contentProtectionNode = child.children[k];
                            for (let l = 0; l < contentProtectionNode.children.length; l++) {
                                const cpChild = contentProtectionNode.children[l];
                                const cencs = cpChild.nodeValue || cpChild.textContent || cpChild.innerHTML;
                                if (cencs) {
                                    initDta.push(base64ToAarry(cencs));
                                }
                            }
                        }
                    }
                }
            }
        }
        return initDta;
    }
    licencePrefetch(mpdText) {
        let self = this;
        let initDatas = self.getContentProtectionInitData(mpdText);
        let initData;
        for (let i = 0; i < initDatas.length; i++) {
            initData = initDatas[0];
        }
        if (!initData) {
            EmeSession.logger.info('EME DRM conent protection initdata not extracted from MPD');
            let errorObj = AustinErrors.EME_DRM_LICENCE_CONTENT_PROTECTION_MISSING_IN_MPD;
            errorObj['info'] = mpdText;
            self.player.emitEvent(AustinEvents.PLAYER_ERROR, errorObj);
            return;
        }
        if (self.mediaKeys == null) {
            let codecs = mpdText.match(/(audio|video)\/mp4\" codecs=\".*\"/g);
            let audioContentType = 'audio/mp4;codecs=\"mp4a.40.2\"';
            let videoContentType = 'video/mp4;codecs=\"avc3.640028\"';
            for (const codec of codecs) {
                if (codec.search('audio') !== -1) {
                    let search = 'audio/mp4" codecs="';
                    let audioCodec = codec.substring(search.length, codec.substring(search.length).indexOf('"') + search.length);
                    audioContentType = 'audio/mp4;codecs=\"' + audioCodec + '\"';
                }
                else if (codec.search('video') !== -1) {
                    let search = 'video/mp4" codecs="';
                    let videoCodec = codec.substring(search.length, codec.substring(search.length).indexOf('"') + search.length);
                    videoContentType = 'video/mp4;codecs=\"' + videoCodec + '\"';
                }
            }
            let config = [{
                    'initDataTypes': ['cenc'],
                    'audioCapabilities': [{ 'contentType': audioContentType }],
                    'videoCapabilities': [{ 'contentType': videoContentType }]
                }];
            navigator.requestMediaKeySystemAccess('com.widevine.alpha', config).then((keySystemAccess) => {
                return keySystemAccess.createMediaKeys();
            }).then((mediaKeys) => {
                self.mediaKeys = mediaKeys;
                EmeSession.logger.info('EME DRM new self.mediaKeys set');
                self.createMediaKeySession(initData);
            });
        }
        else {
            EmeSession.logger.info('EME DRM self.mediaKeys != null, calling EME DRM createMediaKeySession');
            self.createMediaKeySession(initData);
        }
    }
    isLicenceUpdated() {
        return this.sessionInfo.licenceUpdate === 2;
    }
    licenceClose() {
        return __awaiter$1(this, void 0, void 0, function* () {
            let self = this;
            return new Promise((resolve) => {
                if (!this.sessionInfo) {
                    resolve();
                    return;
                }
                let emeSessionInfo = this.sessionInfo.session;
                EmeSession.logger.info('EME DRM closing session licence, id: ' + emeSessionInfo.sessionId);
                let videoElement = this.player.player.getVideoElement();
                let promiseResolved = false;
                function setMediaKeyNullAndResolve() {
                    if (!promiseResolved) {
                        promiseResolved = true;
                        videoElement.setMediaKeys(null).catch(() => {
                            EmeSession.logger.info('EME DRM error in setMediaKeys to null');
                        });
                        self.mediaKeys = null;
                        resolve();
                    }
                }
                setTimeout(() => {
                    setMediaKeyNullAndResolve();
                }, 500);
                this.sessionInfo.session.close().then(() => {
                    EmeSession.logger.info('EME DRM closed session licence id' + emeSessionInfo.sessionId);
                    setMediaKeyNullAndResolve();
                });
                this.sessionInfo.valid = false;
            });
        });
    }
}
EmeSession.logger = new AustinLogger('EmeSession');

// @ts-ignore
class AustinBitmovinWrapper extends window.bitmovin.player.Player {
    constructor(id, config, austin) {
        super(id, config);
        this.austin = null;
        this.austin = austin;
        AustinBitmovinWrapper.baseLogger.info('created!');
    }
    isSlinging() {
        return this.austin && this.austin.core && this.austin.core.getSessionId() !== '';
    }
    pause(issuer) {
        // @ts-ignore
        if (issuer && this.isSlinging()) {
            // @ts-ignore
            this.austin.pause();
        }
        else {
            super.pause();
        }
    }
    play(issuer) {
        if (issuer && this.isSlinging()) {
            // @ts-ignore
            this.austin.resume();
        }
        else {
            super.play(issuer);
        }
    }
    seek(time, issuer) {
        if (issuer && this.isSlinging()) {
            // @ts-ignore
            this.austin.seek(time);
        }
        else {
            super.seek(time);
        }
    }
    getMaxTimeShift(issuer) {
        // @ts-ignore
        if (!this.isSlinging() || issuer === 'austin') {
            return super.getMaxTimeShift();
        }
        // @ts-ignore
        let val = this.austin.getMaxTimeShift();
        return -1 * (val / 1000);
    }
    getTimeShift(issuer) {
        // @ts-ignore
        if (!this.isSlinging() || issuer === 'austin') {
            return super.getTimeShift();
        }
        // @ts-ignore
        let val = this.austin.getTimeShift();
        return -1 * (val / 1000);
    }
    getCurrentTime(mode) {
        if (mode || !this.isSlinging()) {
            return super.getCurrentTime(mode);
        }
        // @ts-ignore
        let val = this.austin.getCurrentTime();
        return (val / 1000);
    }
    getDuration() {
        // @ts-ignore
        if (this.isSlinging()) {
            // @ts-ignore
            let val = this.austin.getDuration();
            return (val / 1000);
        }
        else {
            return super.getDuration();
        }
    }
    sendIRCommand(keyCodes) {
        // @ts-ignore
        this.austin.sendIRCommand(keyCodes);
    }
}
AustinBitmovinWrapper.baseLogger = new AustinLogger('AustinBitmovinWrapper');

var __awaiter$2 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let bitmovinlib;
class BitmovinPlayer extends Html5Player {
    constructor() {
        super();
        this.player = null;
        this.noVidSegDownloaded = 0;
        this.noAudSegDownloaded = 0;
        this.subtitleDisplay = null;
        this.destroying = false;
        this.initialized = false;
        this.errorObject = null;
        this.errorFired = false;
        this.unloading = false;
        this.downloadedSize = 0;
        this.waitingForFirstFrame = false;
        this.firstFrameReason = '';
        this.playbackTimer = 0;
        this.licenceUrl = null;
        this.playerVersion = [];
        this.playerEvents = {};
        this.emeSession = null;
        this.eventsHistory = '';
        this.retryCount = 0;
        this.segmentBuffered = 0;
        this.isContentTypeLive = false;
        this.playrateUpdateTimer = null;
        this.seekedOrTimeShiftedEvent = null;
        this.pauseEventOnVideoElementHandler = () => {
            let element = this.player.getVideoElement();
            this.eventsHistory = this.eventsHistory + 'VideoElement_pause';
            BitmovinPlayer.logger.info('bitmovin paused event  pasued= ' + element.paused + ' aud level : ' + this.getAudioBufferLength() +
                ' video level: ' + this.getVideoBufferLength());
        };
        this.playingEventOnVideoElementHandler = (data) => {
            let self = this;
            let element = this.player.getVideoElement();
            this.eventsHistory = this.eventsHistory + 'VideoElement_play:';
            BitmovinPlayer.logger.info('bitmovin playing event paused= ' + element.paused + ' aud level : ' + self.getAudioBufferLength() +
                ' video level: ' + self.getVideoBufferLength());
            if (self.seekedOrTimeShiftedEvent) {
                let data = self.seekedOrTimeShiftedEvent;
                self.seekedOrTimeShiftedEvent = null;
                let element = self.player.getVideoElement();
                data['paused'] = element.paused;
                data.audioBuffer = self.player.getAudioBufferLength() * 1000 || 0;
                data.videoBuffer = self.player.getVideoBufferLength() * 1000 || 0;
            }
            else if (self.waitingForFirstFrame && element.paused) {
                let onPlayingHandlerBound = self.onPlayingHandler.bind(self);
                //Added playing event handler directly to videoElement
                //because bitmovin is suppressing playing event when paused due to Auto play policy
                onPlayingHandlerBound(data);
            }
        };
        this.waitingEventOnVideoElementHandler = () => {
            let self = this;
            BitmovinPlayer.logger.info('bitmovin waiting ' + ' aud level : ' + self.getAudioBufferLength() + ' video level: ' + self.getVideoBufferLength());
        };
        this.suspendEventOnVideoElementHandler = () => {
            let self = this;
            BitmovinPlayer.logger.info('bitmovin suspend' + ' aud level : ' + self.getAudioBufferLength() + ' video level: ' + self.getVideoBufferLength());
        };
        this.timeupdateEventOnVideoElementHandler = () => {
            let self = this;
            let element = this.player && this.player.getVideoElement();
            if (element && !self.destroying) {
                BitmovinPlayer.logger.info('bitmovin timeupdate time:' + element.currentTime + ' aud level : ' + self.getAudioBufferLength() +
                    ' video level: ' + self.getVideoBufferLength());
            }
        };
        this.errorEventOnVideoElementHandler = (e) => {
            let self = this;
            BitmovinPlayer.logger.info('Error event fired on Video Element' + JSON.stringify(e));
            if (!self.errorFired && e && (e.errorObject || e.errorMessage || e.message)) {
                let data = { error: 'Error event fired on Video Element', errorObject: e.errorObject, errorMessage: (e.errorMessage || e.message) };
                self.emitEvent(AustinEvents.PLAYER_ERROR, data);
                self.errorFired = true;
            }
        };
        this.emeSession = new EmeSession(this);
        bitmovinlib = AustinUtils.getModule('bitmovin');
        if (!bitmovinlib) {
            if (window !== undefined && window['bitmovin'] !== undefined) {
                bitmovinlib = window['bitmovin'];
            }
        }
        if (!bitmovinlib) {
            throw ('bitmovin library not found');
        }
        BitmovinPlayer.logger.info('created!');
    }
    getVersion() {
        if (this.playerVersion.length === 0) {
            if (typeof bitmovinlib !== 'undefined' && typeof bitmovinlib.player !== 'undefined') {
                if (typeof bitmovinlib.player.version !== 'undefined') {
                    this.playerVersion = bitmovinlib.player.version.split('');
                }
                else if (typeof bitmovinlib.player.Player !== 'undefined' && typeof bitmovinlib.player.Player.version !== 'undefined') {
                    this.playerVersion = bitmovinlib.player.Player.version.split('');
                }
            }
        }
        return this.playerVersion.join('');
    }
    emitEvent(event, data) {
        if (event === AustinEvents.PLAYER_ERROR) {
            let bufferedAndPlayed = this.getBufferAndPlayedInfoFromVideo();
            data['playerStatus'] = bufferedAndPlayed;
            data['events'] = this.eventsHistory;
            data['segmentsDownloaded'] = { audio: this.noAudSegDownloaded, video: this.noVidSegDownloaded };
            if (this.playbackTimer !== 0) {
                clearTimeout(this.playbackTimer);
                this.playbackTimer = 0;
            }
            BitmovinPlayer.logger.info('Emitting player error to austin client  ' + JSON.stringify(data));
        }
        if (this.destroying) {
            BitmovinPlayer.logger.warn('Player already destroyed ' + data);
        }
        else {
            this.emitter.emit(event, data);
        }
    }
    addEventHandler(event, handler) {
        if (this.player) {
            this.player.on(event, handler);
        }
    }
    removeEventHandler(event, handler) {
        if (this.player) {
            this.player.off(event, handler);
        }
    }
    updateFairplayParams(params) {
        this.config.source.drm = {};
        this.config.source.drm.fairplay = {};
        let certifcicate = params[AustinConstants.PLAYER.FPS_CERTIFICATE];
        let binaryCertificateString = window.atob(certifcicate);
        let len = binaryCertificateString.length;
        let certificateBytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            certificateBytes[i] = binaryCertificateString.charCodeAt(i);
        }
        this.config.source.drm.fairplay.serverCertificate = certificateBytes.buffer;
        //this.config.source.drm.fairplay.certificateURL = 'https://eststag-fp.echodata.tv/fairplay/certificate',
        this.config.source.drm.fairplay.LA_URL = params[AustinConstants.STREAMING.DRM_LA_URL].replace('skd:', 'https:');
        BitmovinPlayer.logger.info('his.config.source.drm.fairplay.LA_URL ' + this.config.source.drm.fairplay.LA_URL);
        this.config.source.drm.fairplay.prepareMessage = function (event, session) {
            return event.message;
        };
        this.config.source.drm.fairplay.prepareContentId = function (contentId) {
            let link = document.createElement('a');
            link.href = contentId.substring(2);
            return contentId.split('fairplay/')[1];
        };
        this.config.source.drm.fairplay.prepareLicense = function (license) {
            return new Uint8Array(license);
        };
        this.config.source.drm.fairplay.useUint16InitData = true;
        this.config.source.drm.fairplay.licenseResponseType = 'arraybuffer';
    }
    logEvent(data) {
        data['audioBuffer'] = this.getAudioBufferLength() * 1000;
        data['videoBuffer'] = this.getVideoBufferLength() * 1000;
        data['paused'] = this.isVideoElementPaused();
        data['playerPaused'] = this.isPaused();
        BitmovinPlayer.logger.info(JSON.stringify(data));
    }
    logBfferLevel() {
        let bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.ForwardDuration, bitmovinlib.player.MediaType.Audio);
        BitmovinPlayer.logger.info('Audio(Forward) using getLevel: ' + JSON.stringify(bufferLevel));
        bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.ForwardDuration, bitmovinlib.player.MediaType.Video);
        BitmovinPlayer.logger.info('Video(Forward) using getLevel: ' + JSON.stringify(bufferLevel));
        bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.BackwardDuration, bitmovinlib.player.MediaType.Audio);
        BitmovinPlayer.logger.info('Audio(Backward) using getLevel: ' + JSON.stringify(bufferLevel));
        bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.BackwardDuration, bitmovinlib.player.MediaType.Video);
        BitmovinPlayer.logger.info('Video(Backward) using getLevel: ' + JSON.stringify(bufferLevel));
    }
    registerEventHandlers() {
        let playerWrapperObj = this;
        BitmovinPlayer.EventError = bitmovinlib.player.PlayerEvent.Error;
        BitmovinPlayer.EventWarning = bitmovinlib.player.PlayerEvent.Warning;
        BitmovinPlayer.EventReady = bitmovinlib.player.PlayerEvent.Ready;
        BitmovinPlayer.EventSourceLoaded = bitmovinlib.player.PlayerEvent.SourceLoaded;
        BitmovinPlayer.EventSourceUnLoaded = bitmovinlib.player.PlayerEvent.SourceUnloaded;
        BitmovinPlayer.EventStallStarted = bitmovinlib.player.PlayerEvent.StallStarted;
        BitmovinPlayer.EventStallEnded = bitmovinlib.player.PlayerEvent.StallEnded;
        BitmovinPlayer.EventDownloadFinished = bitmovinlib.player.PlayerEvent.DownloadFinished;
        BitmovinPlayer.EventMetadata = bitmovinlib.player.PlayerEvent.Metadata;
        BitmovinPlayer.EventMetadataParsed = bitmovinlib.player.PlayerEvent.MetadataParsed;
        BitmovinPlayer.EventPlay = bitmovinlib.player.PlayerEvent.Play;
        BitmovinPlayer.EventPaused = bitmovinlib.player.PlayerEvent.Paused;
        BitmovinPlayer.EventPlaying = bitmovinlib.player.PlayerEvent.Playing;
        BitmovinPlayer.EventSubtitleAdded = bitmovinlib.player.PlayerEvent.SubtitleAdded;
        BitmovinPlayer.EventSubtitleChanged = bitmovinlib.player.PlayerEvent.SubtitleDisabled;
        BitmovinPlayer.EventCueEnter = bitmovinlib.player.PlayerEvent.CueEnter;
        BitmovinPlayer.EventCueExit = bitmovinlib.player.PlayerEvent.CueExit;
        BitmovinPlayer.EventPlayerResize = bitmovinlib.player.PlayerEvent.PlayerResized;
        BitmovinPlayer.EventPlayerSeek = bitmovinlib.player.PlayerEvent.Seek;
        BitmovinPlayer.EventPlayerSeeked = bitmovinlib.player.PlayerEvent.Seeked;
        BitmovinPlayer.EventPlayerTimeShift = bitmovinlib.player.PlayerEvent.TimeShift;
        BitmovinPlayer.EventPlayerTimeShifted = bitmovinlib.player.PlayerEvent.TimeShifted;
        playerWrapperObj.playerEvents[BitmovinPlayer.EventError] = (data) => {
            BitmovinPlayer.logger.info('ON_ERROR An error occurred: ' + JSON.stringify(data));
            if (data.data && typeof (data.data) === 'object') {
                data.data = JSON.stringify(data.data);
            }
            let mesasge = 'bitmovinError';
            if (data.code) {
                mesasge = mesasge + '_' + data.code;
            }
            if (data.name || data.message) {
                mesasge = mesasge + '_' + (data.name || data.message);
            }
            //Bitmovin error code": 2202 , "message": "The Internet connection appears to be offline."
            if (data.code === 2202 && data.message && data.message === AustinErrors.PLAYBACK_DID_NOT_START_LAN_ACCESS_DENIED.message
                && AustinUtils.isIos() && playerWrapperObj.params.connectionMode === AustinConstants.BOX.CONNECTION_MODE_LAN) {
                data = AustinErrors.PLAYBACK_DID_NOT_START_LAN_ACCESS_DENIED;
            }
            else if (data.code === 2202 && data.message && data.message === AustinErrors.PLAYBACK_DID_NOT_START_NO_INTERNET.message && AustinUtils.isIos()) {
                data = AustinErrors.PLAYBACK_DID_NOT_START_NO_INTERNET;
            }
            else {
                data['message'] = mesasge;
            }
            if (playerWrapperObj.initialized && !playerWrapperObj.errorFired) {
                BitmovinPlayer.logger.info('unloading ' + playerWrapperObj.unloading + ' first frame reason ' + playerWrapperObj.firstFrameReason);
                //Ignore source error during unload {"message":"Source Error","code":1020,"class":"ErrorEvent","timestamp":1617365381857}
                if (AustinUtils.isAndroid() &&
                    playerWrapperObj.unloading &&
                    playerWrapperObj.firstFrameReason === AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY &&
                    data['code'] === 1020) {
                    BitmovinPlayer.logger.info('Ignoring Bitmovin error while unload in progress');
                }
                else {
                    playerWrapperObj.emitEvent(AustinEvents.PLAYER_ERROR, data);
                    playerWrapperObj.errorFired = true;
                }
            }
            else {
                playerWrapperObj.errorObject = data;
            }
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventWarning] = (data) => {
            BitmovinPlayer.logger.warn('ON_WARNING:' + JSON.stringify(data));
            //Bitmovin warning code": 5008 || 1303 ,"message": "Playback could not be started, user interaction required"
            if (data.code === 5008 || data.code === 1303) {
                let element = playerWrapperObj.player.getVideoElement();
                data['paused'] = element.paused;
                if (element.paused) {
                    playerWrapperObj.eventsHistory = playerWrapperObj.eventsHistory + data.message + ':';
                }
                if (playerWrapperObj.playbackTimer) {
                    clearTimeout(playerWrapperObj.playbackTimer);
                    playerWrapperObj.playbackTimer = 0;
                }
                if (!playerWrapperObj.unloading && !playerWrapperObj.destroying && !playerWrapperObj.errorFired) {
                    playerWrapperObj.emitEvent(AustinEvents.PLAYER_WARNING, data);
                }
            }
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventReady] = (data) => {
            BitmovinPlayer.logger.info('ON_READY: ' + JSON.stringify(data));
            playerWrapperObj.logBfferLevel();
            playerWrapperObj.eventsHistory = playerWrapperObj.eventsHistory + 'ON_READY:';
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_READY, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventSourceLoaded] = (data) => {
            BitmovinPlayer.logger.info('ON_SOURCE_LOADED: ' + JSON.stringify(data));
            playerWrapperObj.logBfferLevel();
            playerWrapperObj.eventsHistory = playerWrapperObj.eventsHistory + 'ON_SOURCE_LOADED:';
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventStallStarted] = (data) => {
            data.audioBuffer = playerWrapperObj.player.getAudioBufferLength() * 1000 || 0;
            data.videoBuffer = playerWrapperObj.player.getVideoBufferLength() * 1000 || 0;
            let element = playerWrapperObj.player.getVideoElement();
            data['paused'] = element.paused;
            BitmovinPlayer.logger.info('ON_STALL_STARTED: ' + JSON.stringify(data));
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_STALL_START, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventStallEnded] = (data) => {
            data.audioBuffer = playerWrapperObj.player.getAudioBufferLength() * 1000 || 0;
            data.videoBuffer = playerWrapperObj.player.getVideoBufferLength() * 1000 || 0;
            let element = playerWrapperObj.player.getVideoElement();
            data['paused'] = element.paused;
            BitmovinPlayer.logger.info('ON_STALL_ENDED: ' + JSON.stringify(data));
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_STALL_END, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventMetadata] = (data) => {
            BitmovinPlayer.logger.info('EventMetadata ' + JSON.stringify(data));
            if (data.metadata) {
                if (playerWrapperObj.params.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                    if (data.metadata.value === AustinConstants.STREAMING.PTS_TYPE) {
                        playerWrapperObj.currentPTS = data.metadata.messageData || '';
                    }
                }
                else {
                    playerWrapperObj.noVidSegDownloaded = playerWrapperObj.noVidSegDownloaded + 1;
                    playerWrapperObj.noAudSegDownloaded = playerWrapperObj.noAudSegDownloaded + 1;
                    playerWrapperObj.currentPTS = data.metadata.TXXX || '';
                    if (this.params[AustinConstants.STREAMING.STREAMING_TYPE] !== AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
                        playerWrapperObj.updatePlayrateOnBufferLevel();
                    }
                    BitmovinPlayer.logger.error('EventMetadata ID3 buffer level' + JSON.stringify(playerWrapperObj.player.buffer.getLevel('forwardduration', 'video')));
                }
                if (playerWrapperObj.currentPTS) {
                    playerWrapperObj.emitEvent(AustinEvents.PLAYER_METADATA, {
                        currentPTS: playerWrapperObj.currentPTS
                    });
                }
            }
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventMetadataParsed] = (data) => {
            BitmovinPlayer.logger.info('EventMetadataParsed ' + JSON.stringify(data));
            if (data.metadata && playerWrapperObj.params.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                if (data.metadata.value === AustinConstants.STREAMING.PTS_TYPE) {
                    if ((!playerWrapperObj.currentPTS || this.isPaused()) && data.metadata.messageData) {
                        playerWrapperObj.currentPTS = data.metadata.messageData;
                        playerWrapperObj.emitEvent(AustinEvents.PLAYER_METADATA, {
                            currentPTS: playerWrapperObj.currentPTS
                        });
                    }
                }
            }
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventDownloadFinished] = (data) => {
            BitmovinPlayer.logger.info('ON_DOWNLOAD_FINISHED' + JSON.stringify(data));
            playerWrapperObj.logBfferLevel();
            if (data.success && data.size > 0) {
                //BitmovinPlayer.logger.info('ON_DOWNLOAD_FINISHED getTimeShift' +  playerWrapperObj.player.getTimeShift('austin'));
                data['segmentDuration'] = playerWrapperObj.params[AustinConstants.STREAMING.SEGMENT_DURATION];
                playerWrapperObj.downloadedSize = playerWrapperObj.downloadedSize + data.size;
                let isMediaSegment = false;
                if (data.url.search('vid') > 0) {
                    isMediaSegment = true;
                    playerWrapperObj.noVidSegDownloaded = playerWrapperObj.noVidSegDownloaded + 1;
                }
                else if (data.url.search('aud') > 0) {
                    isMediaSegment = true;
                    playerWrapperObj.noAudSegDownloaded = playerWrapperObj.noAudSegDownloaded + 1;
                }
                //ON_DOWNLOAD_FINISHED comes even for fairplay licenses
                if (playerWrapperObj.params.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_DASH && isMediaSegment) {
                    let playrateTimer = () => {
                        BitmovinPlayer.logger.info('Setting update playrate timeout');
                        playerWrapperObj.updatePlayrateOnBufferLevel();
                        clearTimeout(this.playrateUpdateTimer);
                        this.playrateUpdateTimer = null;
                    };
                    if (!this.playrateUpdateTimer) {
                        this.playrateUpdateTimer = setTimeout(playrateTimer, 10000);
                    }
                }
            }
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_MEDIA_DOWNLOAD_FINISHED, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventPlay] = (data) => {
            BitmovinPlayer.logger.info('ON_PLAY' + JSON.stringify(data));
            playerWrapperObj.eventsHistory = playerWrapperObj.eventsHistory + 'ON_PLAY:';
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_PLAY, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventPaused] = (data) => {
            BitmovinPlayer.logger.info('ON_PAUSE' + JSON.stringify(data));
            playerWrapperObj.eventsHistory = playerWrapperObj.eventsHistory + 'ON_PAUSE:';
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_PAUSE, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventSubtitleAdded] = (data) => {
            BitmovinPlayer.logger.info('ON_SUBTITLE_ADDED' + JSON.stringify(data));
            playerWrapperObj.emitEvent(AustinEvents.PLAYER_SUBTITLE_ADDED, data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventPlayerSeek] = (data) => {
            BitmovinPlayer.logger.info('EventPlayerSeek' + JSON.stringify(data));
            if (playerWrapperObj.params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                playerWrapperObj.logEvent(data);
                data.audioBuffer = 0;
                data.videoBuffer = 0;
                let eventMessage = ':ON_SEEK(position:' + data.position + ',seekTarget:' + data.seekTarget + ')';
                if (playerWrapperObj.waitingForFirstFrame && data.seekTarget !== 0.001) {
                    playerWrapperObj.checkPlaybackStarted();
                }
                playerWrapperObj.eventsHistory = playerWrapperObj.eventsHistory + eventMessage;
                playerWrapperObj.emitEvent(AustinEvents.PLAYER_STALL_START, data);
            }
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventPlayerSeeked] = (data) => {
            playerWrapperObj.logEvent(data);
            if (playerWrapperObj.params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                if (data['paused']) {
                    playerWrapperObj.seekedOrTimeShiftedEvent = data;
                    BitmovinPlayer.logger.log('After seek, video paused', JSON.stringify(data));
                }
                playerWrapperObj.emitEvent(AustinEvents.PLAYER_SEEKED_OR_TIMESHIFTED, data);
            }
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventPlayerTimeShift] = (data) => {
            playerWrapperObj.logEvent(data);
        };
        playerWrapperObj.playerEvents[BitmovinPlayer.EventPlayerTimeShifted] = (data) => {
            playerWrapperObj.logEvent(data);
            if (playerWrapperObj.params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                playerWrapperObj.currentPTS = '';
                if (data['paused']) {
                    playerWrapperObj.seekedOrTimeShiftedEvent = data;
                    BitmovinPlayer.logger.log('After timeShifted, video paused', JSON.stringify(data));
                }
                playerWrapperObj.emitEvent(AustinEvents.PLAYER_SEEKED_OR_TIMESHIFTED, data);
            }
        };
    }
    playUrl(params) {
        if (params) {
            this.params = params;
        }
        else {
            params = this.params;
        }
        let self = this;
        self.errorFired = false;
        self.waitingForFirstFrame = true;
        self.firstFrameReason = params.firstFrameReason;
        self.retryCount = 0;
        self.segmentBuffered = 0;
        this.config = {
            key: params[AustinConstants.PLAYER.BITMOVIN_LICENCE],
            source: {},
            playback: {},
            skin: {
                screenLogoImage: ''
            },
            style: {
                aspectratio: '16:9',
                playOverlay: false,
                mouse: false,
                keyboard: false,
                controls: false,
                bufferingOverlay: false,
                watermark: false,
                ux: false
                //ux          : true
            },
            tweaks: {
                autoqualityswitching: false,
                ENABLE_SEEK_FOR_LIVE: true,
                context_menu_entries: ['']
            }
        };
        if (params.playerNetworkInterceptor !== undefined) {
            this.config.network = params.playerNetworkInterceptor;
        }
        if (params.pipelineCount) {
            this.config.tweaks['SEGMENT_LOADER_POOL_SIZE'] = {
                audio: params.pipelineCount,
                video: params.pipelineCount
            };
        }
        if (typeof URLSearchParams !== 'undefined' && location && location.search) {
            let p = new URLSearchParams(location.search.slice(1));
            if (p && p.get('pipelineCount')) {
                this.config.tweaks['SEGMENT_LOADER_POOL_SIZE'] = {
                    audio: Number(p.get('pipelineCount')),
                    video: Number(p.get('pipelineCount'))
                };
            }
        }
        BitmovinPlayer.logger.log('SEGMENT_LOADER_POOL_SIZE: ', JSON.stringify(this.config.tweaks.SEGMENT_LOADER_POOL_SIZE));
        if (params[AustinConstants.STREAMING.PREFETCH_LICENCE]) {
            if (params[AustinConstants.STREAMING.DRM_MODE] === AustinConstants.STREAMING.DRM_MODE_WIDEVINE) {
                this.licenceUrl = params[AustinConstants.STREAMING.DRM_LA_URL];
            }
            else if (params[AustinConstants.STREAMING.DRM_MODE] === AustinConstants.STREAMING.DRM_MODE_FAIRPLAY) {
                this.updateFairplayParams(params);
            }
        }
        else {
            this.config.source.drm = {};
            if (params[AustinConstants.STREAMING.DRM_MODE] === AustinConstants.STREAMING.DRM_MODE_WIDEVINE) {
                this.config.source.drm[AustinConstants.STREAMING.DRM_MODE_WIDEVINE] = {
                    LA_URL: params[AustinConstants.STREAMING.DRM_LA_URL],
                    maxLicenseRequestRetries: 3,
                    licenseRequestRetryDelay: 5,
                    prepareMessage: (keyMessage) => {
                        return JSON.stringify({
                            user_id: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_USER_ID,
                            channel_id: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_CHANNEL_ID,
                            disabled: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_DISABLED,
                            env: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_ENV,
                            message: Array.apply(null, new Uint8Array(keyMessage.message))
                        });
                        //BitmovinPlayer.logger.log('DRM ' + keyMessage.message);
                        //return keyMessage.message;
                    }
                };
            }
            else if (params[AustinConstants.STREAMING.DRM_MODE] === AustinConstants.STREAMING.DRM_MODE_FAIRPLAY) {
                this.updateFairplayParams(params);
            }
        }
        if (params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
            this.config.source.hls = params.url;
            this.config.playback.preferredTech = [{ player: params[AustinConstants.STREAMING.HLS_MODE], streaming: AustinConstants.STREAMING.STREAMING_TYPE_HLS }];
        }
        else {
            this.config.source.dash = params.url;
            this.config.playback.preferredTech = [{ player: AustinConstants.STREAMING.HTML5, streaming: AustinConstants.STREAMING.STREAMING_TYPE_DASH }];
        }
        if (params.poster) {
            this.config.source.poster = params.poster;
        }
        this.config.source.options = {};
        //this.config.source.options = {startOffset: 0, startOffsetTimelineReference: 'start'} ;
        this.config.playback.autoplay = true;
        //this.config.playback.muted = false;
        this.noVidSegDownloaded = 0;
        this.noAudSegDownloaded = 0;
        if (params.query_parameters) {
            this.config.tweaks.query_parameters = params.query_parameters;
        }
        let bufferingToStart = params[AustinConstants.PLAYER.BUFFERING_TO_START];
        if (bufferingToStart) {
            this.config.tweaks.startup_threshold = bufferingToStart / 1000;
            this.config.tweaks.restart_threshold = bufferingToStart / 1000;
        }
        self.destroying = false;
        BitmovinPlayer.logger.info('Bitmovin player loading Url: ' + params.url + ' technology: ' + JSON.stringify(this.config.playback.preferredTech));
        return new Promise((resolve, reject) => {
            let player;
            if (params[AustinConstants.LOG]) {
                self.config.logs = { level: this.getBitmovinLogLevel(params[AustinConstants.LOG_LEVEL]) };
            }
            let maxBufferLevel = params[AustinConstants.PLAYER.MAX_BUFFER_LEVEL];
            if (maxBufferLevel && params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_DASH) {
                maxBufferLevel = maxBufferLevel * (params['rebufferingThreshold'] || 1);
                if (bitmovinlib.player.MediaType && bitmovinlib.player.BufferType) {
                    self.config['buffer'] = {
                        [bitmovinlib.player.MediaType.Video]: {
                            [bitmovinlib.player.BufferType.ForwardDuration]: maxBufferLevel,
                            [bitmovinlib.player.BufferType.BackwardDuration]: AustinConfig.BM_PLAYER_BACKWARD_BUFFER,
                        },
                        [bitmovinlib.player.MediaType.Audio]: {
                            [bitmovinlib.player.BufferType.ForwardDuration]: maxBufferLevel,
                            [bitmovinlib.player.BufferType.BackwardDuration]: AustinConfig.BM_PLAYER_BACKWARD_BUFFER,
                        }
                    };
                }
                else {
                    self.config.tweaks['max_buffer_level'] = maxBufferLevel;
                }
            }
            self.registerEventHandlers();
            self.config.events = self.playerEvents;
            if (params['defaultUi']) {
                self.config.style.ux = true;
                self.config.events[BitmovinPlayer.EventStallStarted] = null;
                self.config.events[BitmovinPlayer.EventStallEnded] = null;
            }
            else {
                self.config.ui = false;
            }
            if (params.analytics && AustinConfig.PLAYER.BITMOVIN.USE_BITMOVIN_ANALYTICS) {
                self.config.analytics = params.analytics;
            }
            player = new AustinBitmovinWrapper(params.playerContainer, self.config, params.austin);
            if (params.videoElement) {
                player.setVideoElement(params.videoElement);
            }
            self.player = player;
            if (AustinUtils.isAndroid()) {
                AustinConfig.PLAYER.BITMOVIN.PLAYBACK_RETRY_COUNT = AustinConfig.PLAYER.BITMOVIN.ANDROID_PLAYBACK_RETRY_COUNT;
            }
            player.load(self.config.source).then(() => {
                self.errorObject = null;
                self.logBfferLevel();
                BitmovinPlayer.logger.info('Successfully created bit-dash player instance, Media-Internal url: ' +
                    (self.player.getVideoElement() ? self.player.getVideoElement().src : '')); // Success!
                if (self.config.source.dash) {
                    let mpd = self.player.getManifest();
                    BitmovinPlayer.logger.info('MPD:\n' + mpd);
                    if (params[AustinConstants.STREAMING.PREFETCH_LICENCE] && self.licenceUrl) {
                        self.emeSession.licencePrefetch(mpd);
                    }
                }
                //player.play();
                self.checkPlaybackStarted();
                self.registerVideoElementEventHandlers();
                self.initialized = true;
                if (self.params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
                    self.player.setPlaybackSpeed(1);
                }
                else {
                    self.player.setPlaybackSpeed(0.9);
                }
                BitmovinPlayer.logger.info('initial after load and after setting playrate ' + self.player.getPlaybackSpeed());
                resolve();
            }).catch((reason) => {
                let error = { code: AustinErrors.BITMOVIN_LOAD_FAILED.code, message: AustinErrors.BITMOVIN_LOAD_FAILED.message };
                if (reason) {
                    error.message += reason;
                }
                if (self.destroying) {
                    error.message += '(destroying)';
                }
                if (self.errorObject) {
                    self.errorObject['extra'] = error.message;
                }
                BitmovinPlayer.logger.error(error.message);
                self.player = player;
                reject(self.errorObject || error);
            });
        });
    }
    registerVideoElementEventHandlers() {
        let element = this.player && this.player.getVideoElement();
        if (element) {
            element.addEventListener('pause', this.pauseEventOnVideoElementHandler.bind(this));
            element.addEventListener('playing', this.playingEventOnVideoElementHandler.bind(this));
            element.addEventListener('waiting', this.waitingEventOnVideoElementHandler.bind(this), false);
            element.addEventListener('suspend', this.suspendEventOnVideoElementHandler.bind(this), false);
            element.addEventListener('timeupdate', this.timeupdateEventOnVideoElementHandler.bind(this), false);
            element.addEventListener('error', this.errorEventOnVideoElementHandler.bind(this), false);
        }
    }
    unregisterVideoElementEventHandlers() {
        let element = this.player && this.player.getVideoElement();
        if (element) {
            element.removeEventListener('pause', this.pauseEventOnVideoElementHandler);
            element.removeEventListener('playing', this.playingEventOnVideoElementHandler);
            element.removeEventListener('waiting', this.waitingEventOnVideoElementHandler);
            element.removeEventListener('suspend', this.suspendEventOnVideoElementHandler);
            element.removeEventListener('timeupdate', this.timeupdateEventOnVideoElementHandler);
            element.removeEventListener('error', this.errorEventOnVideoElementHandler);
        }
    }
    updatePlayrateOnBufferLevel() {
        BitmovinPlayer.logger.info('Clearing Timeout');
        clearTimeout(this.playrateUpdateTimer);
        this.playrateUpdateTimer = null;
        let vidBufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.ForwardDuration, bitmovinlib.player.MediaType.Video);
        let audBufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.ForwardDuration, bitmovinlib.player.MediaType.Audio);
        let audBufLen = audBufferLevel.level;
        let vidBufLen = vidBufferLevel.level;
        let segmentManagerBuffer = this.getSegmentBuffer();
        BitmovinPlayer.logger.info('Player segemntBuffer' + segmentManagerBuffer);
        let videoElement = this.player.getVideoElement();
        BitmovinPlayer.logger.info('updatePlayrateOnBufferLevel audBufLen: ' + audBufLen + ' vidBufLen: ' + vidBufLen);
        if (audBufLen || vidBufLen) {
            let minBuff = ((audBufLen <= vidBufLen ? audBufLen : vidBufLen) + segmentManagerBuffer) * 1000;
            let playrate, prevPlayrate = this.player.getPlaybackSpeed();
            let extraBufferToReduceRebuffering = (vidBufferLevel.targetLevel / 7) || 1;
            BitmovinPlayer.logger.info('extrabuffer' + extraBufferToReduceRebuffering);
            if (this.isLiveContent()) {
                if (minBuff > 2000 * extraBufferToReduceRebuffering) {
                    playrate = 1.0;
                }
                else if (minBuff < 1000 * extraBufferToReduceRebuffering) {
                    playrate = .90;
                }
            }
            else {
                if (minBuff > 7500 * extraBufferToReduceRebuffering) {
                    playrate = 1.04;
                }
                else if (minBuff > 7000 * extraBufferToReduceRebuffering) {
                    if (prevPlayrate !== 1.04) {
                        playrate = 1.02;
                    }
                }
                else if (minBuff > 5500 * extraBufferToReduceRebuffering) {
                    if (prevPlayrate !== 1.02) {
                        playrate = 1.0;
                    }
                }
                else if (minBuff > 5000 * extraBufferToReduceRebuffering) {
                    if (prevPlayrate !== 1.0) {
                        playrate = .98;
                    }
                }
                else if (minBuff > 4500 * extraBufferToReduceRebuffering) {
                    if (prevPlayrate !== 0.98) {
                        playrate = .96;
                    }
                }
                else if (minBuff > 4000 * extraBufferToReduceRebuffering) {
                    if (prevPlayrate !== 0.96) {
                        playrate = .94;
                    }
                }
                else if (minBuff > 2500 * extraBufferToReduceRebuffering) {
                    if (prevPlayrate !== 0.94) {
                        playrate = .92;
                    }
                }
                else if (minBuff < 1000 * extraBufferToReduceRebuffering) {
                    playrate = .90;
                }
            }
            BitmovinPlayer.logger.info('updatePlayrateOnBufferLevel audBufLen: ' + audBufLen + ' vidBufLen: ' + vidBufLen + ' bufferLevl: ' + minBuff +
                ' current playbackRate: ' + prevPlayrate);
            //Min steps are 0.02 and multiply by 100 to avoid js decimal precision problem
            //Making going into 1 easy and going out of 1 tough
            if (videoElement && (playrate === 1 || Math.abs(100 * playrate - 100 * prevPlayrate) >= 2)) {
                this.player.setPlaybackSpeed(playrate);
                BitmovinPlayer.logger.info('updatePlayrateOnBufferLevel audBufLen: ' + audBufLen + ' vidBufLen: ' + vidBufLen + ' minBuff: ' + minBuff +
                    ' new playbackRate:' + playrate);
            }
        }
        else {
            BitmovinPlayer.logger.info('Both audio and video buffer is zero.Hence setting playrate tp 0.9');
            this.player.setPlaybackSpeed(0.9);
        }
    }
    onPlayingHandler(data) {
        let self = this;
        if (self.playbackTimer) {
            clearTimeout(self.playbackTimer);
            self.playbackTimer = 0;
            BitmovinPlayer.logger.info('clearing time out ');
        }
        if (data) {
            BitmovinPlayer.logger.info('ON_PLAYING' + JSON.stringify(data));
            if (self.waitingForFirstFrame) {
                BitmovinPlayer.logger.info('BM event history' + self.eventsHistory);
                self.eventsHistory = '';
                self.waitingForFirstFrame = false;
                let data = {
                    reason: self.firstFrameReason,
                    segmentCnt: { aud: self.noAudSegDownloaded, vid: self.noVidSegDownloaded }
                };
                self.emitEvent(AustinEvents.PLAYER_FIRST_FRAME_RENDERED, data);
            }
        }
        else {
            if (self.params[AustinConstants.STREAMING.PREFETCH_LICENCE] && self.licenceUrl && self.config.source.dash) {
                if (!self.emeSession.isLicenceUpdated()) {
                    BitmovinPlayer.logger.info('Waiting for Widevine licence download ');
                    return;
                }
            }
            if (AustinConfig.PLAYER.BITMOVIN.PLAYBACK_RETRY_COUNT) {
                self.retryCount++;
                if (self.retryCount < AustinConfig.PLAYER.BITMOVIN.PLAYBACK_RETRY_COUNT) {
                    self.eventsHistory = self.eventsHistory + 'RetryOnPlaybackDidNotStart:';
                    self.unloadLoad(self.firstFrameReason);
                    return;
                }
            }
            let err = AustinErrors.PLAYBACK_DID_NOT_START;
            err.message = 'Playback did not start even after ' + self.params[AustinConstants.PLAYER.PLAYBACK_TIMEOUT] / 1000 + ' second';
            BitmovinPlayer.logger.warn(AustinErrors.PLAYBACK_DID_NOT_START.message);
            self.emitEvent(AustinEvents.PLAYER_ERROR, AustinErrors.PLAYBACK_DID_NOT_START);
        }
    }
    checkPlaybackStarted() {
        BitmovinPlayer.logger.info('checkPlaybackStarted...');
        let self = this;
        let onPlayingHandlerBound = self.onPlayingHandler.bind(this);
        if (self.playbackTimer !== 0) {
            clearTimeout(self.playbackTimer);
            self.removeEventHandler(BitmovinPlayer.EventPlaying, onPlayingHandlerBound);
            self.playbackTimer = 0;
        }
        else {
            self.removeEventHandler(BitmovinPlayer.EventPlaying, onPlayingHandlerBound);
        }
        self.addEventHandler(BitmovinPlayer.EventPlaying, onPlayingHandlerBound);
        if (AustinUtils.getQueryValueForKey('playBackTimeout')) {
            self.params[AustinConstants.PLAYER.PLAYBACK_TIMEOUT] = AustinUtils.getQueryValueForKey('playBackTimeout');
        }
        let timeOut = self.params[AustinConstants.PLAYER.PLAYBACK_TIMEOUT];
        if (AustinConfig.PLAYER.BITMOVIN.PLAYBACK_RETRY_COUNT) {
            timeOut = self.params[AustinConstants.PLAYER.PLAYBACK_TIMEOUT] / AustinConfig.PLAYER.BITMOVIN.PLAYBACK_RETRY_COUNT;
        }
        self.playbackTimer = setTimeout(onPlayingHandlerBound, timeOut);
    }
    play() {
        if (this.player != null && this.player.isPaused()) {
            this.player.play();
        }
    }
    pause() {
        if (this.player != null && !this.player.isPaused()) {
            this.player.pause();
        }
    }
    isPaused() {
        if (this.player != null) {
            return this.player.isPaused();
        }
    }
    seek(seekPos) {
        if (this.player != null) {
            BitmovinPlayer.logger.info('bitmovin calling seek ' + seekPos);
            this.retryCount = 0;
            return this.player.seek(seekPos);
        }
    }
    timeShift(pos) {
        if (this.player != null) {
            BitmovinPlayer.logger.info('Test: bitmovin calling timeShift ' + pos);
            if (!this.waitingForFirstFrame) {
                this.retryCount = 0;
            }
            this.player.timeShift(pos);
        }
    }
    /**
     * On buffering state bitmovin isPaused is false but videoElement paused will be true
     * @returns {boolean}
     */
    isVideoElementPaused() {
        return this.player && this.player.getVideoElement() ? this.player.getVideoElement().paused : false;
    }
    getPlayer() {
        return this.player;
    }
    /**
     * Returns currentTime in milliseconds
     * @returns {number}
     */
    getCurrentTime() {
        let time = this.player != null ? this.player.getCurrentTime() : 0;
        if (time != null && time !== 'undefined' && (time < 0 || !isFinite(time))) {
            BitmovinPlayer.logger.error('bitmovin getCurrentTime returned wrong value ' + time);
        }
        return time * 1000;
    }
    getSnapshot() {
        try {
            if (this.player != null) {
                let snapShot = this.player.getSnapshot();
                if (snapShot && snapShot.data) {
                    return snapShot;
                }
            }
        }
        catch (e) {
            BitmovinPlayer.logger.warn('Exception on getSnapshot ' + e);
        }
    }
    getDuration() {
        return this.player != null ? this.player.getDuration() : 0;
    }
    destroy() {
        let self = this;
        return new Promise((resolve) => __awaiter$2(this, void 0, void 0, function* () {
            BitmovinPlayer.logger.info('calling bitmovin destroy this.player: ' + self.player);
            try {
                if (self.player != null) {
                    self.destroying = true;
                    if (self.playbackTimer !== 0) {
                        clearTimeout(self.playbackTimer);
                        self.playbackTimer = 0;
                    }
                    if (self.playrateUpdateTimer) {
                        BitmovinPlayer.logger.info('clearing playrate update timer on player destroy');
                        clearTimeout(self.playrateUpdateTimer);
                        self.playrateUpdateTimer = null;
                    }
                    self.unregisterVideoElementEventHandlers();
                    self.destroySubtitleDisplay();
                    if (self.params[AustinConstants.STREAMING.PREFETCH_LICENCE] && self.config.source.dash) {
                        yield self.emeSession.licenceClose();
                    }
                    self.player.destroy().then(() => {
                        self.player = null;
                        self.params = null;
                        self.downloadedSize = 0;
                        BitmovinPlayer.logger.info('bitmovin Successfully player destroyed'); // Success!
                        resolve();
                    }).catch((error) => {
                        BitmovinPlayer.logger.info('bitmovin player destroy failed ' + error);
                        resolve();
                    });
                }
                else {
                    resolve();
                }
            }
            catch (error) {
                BitmovinPlayer.logger.warn('bitmovin destroy error' + JSON.stringify(error, Object.getOwnPropertyNames(error)));
                resolve();
            }
        }));
    }
    unload() {
        this.player.unload();
    }
    unloadLoad(reason) {
        let self = this;
        return new Promise((resolve, reject) => {
            if (self.player != null) {
                if (!self.initialized) {
                    BitmovinPlayer.logger.info('unload rejected, initial load has not completed ');
                    reject('bitmovin player initial load not completed');
                    return;
                }
                self.waitingForFirstFrame = true;
                self.firstFrameReason = reason;
                let snapShot = this.getSnapshot();
                let videoElement = this.player.getVideoElement();
                if (snapShot && snapShot.data && videoElement) {
                    videoElement.poster = snapShot.data;
                    //console.log('snapShot.data: ', snapShot.data);
                }
                let muted = self.player.isMuted();
                function onSourceUnloaded(data) {
                    BitmovinPlayer.logger.info('ON_SOURCE_UNLOADED: ' + JSON.stringify(data));
                    self.eventsHistory = self.eventsHistory + 'ON_SOURCE_UNLOADED:';
                    self.currentPTS = '';
                    function loadSource() {
                        self.removeEventHandler(BitmovinPlayer.EventSourceUnLoaded, onSourceUnloaded);
                        self.player.load(self.config.source).then(() => {
                            if (self.params[AustinConstants.STREAMING.STREAMING_TYPE] === AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
                                self.player.setPlaybackSpeed(1);
                            }
                            else {
                                self.player.setPlaybackSpeed(0.9);
                            }
                            BitmovinPlayer.logger.info('after load and after setting playrate: ' + self.player.getPlaybackSpeed());
                            self.errorObject = null;
                            self.unloading = false;
                            BitmovinPlayer.logger.info('bitmovin load API Success, Media-Internal url: ' +
                                (self.player.getVideoElement() ? self.player.getVideoElement().src : ''));
                            if (self.config.source.dash) {
                                let mpd = self.player.getManifest();
                                BitmovinPlayer.logger.info('MPD:\n' + mpd);
                                if (self.params[AustinConstants.STREAMING.PREFETCH_LICENCE] && self.licenceUrl) {
                                    self.emeSession.licencePrefetch(mpd);
                                }
                            }
                            if (muted) {
                                self.player.mute();
                            }
                            if (snapShot && snapShot.data && videoElement) {
                                videoElement.poster = snapShot.data;
                                //console.log('snapShot.data: ', snapShot.data);
                            }
                            self.checkPlaybackStarted();
                            resolve();
                        }).catch((e) => {
                            BitmovinPlayer.logger.warn('bitmovin load API Failed' + JSON.stringify(e));
                            reject(e || self.errorObject || AustinErrors.BITMOVIN_LOAD_FAILED);
                        });
                    }
                    if (self.params[AustinConstants.STREAMING.PREFETCH_LICENCE] && self.config.source.dash) {
                        BitmovinPlayer.logger.info('calling licenceClose');
                        self.emeSession.licenceClose().then(() => {
                            BitmovinPlayer.logger.info('calling licenceClose completed ');
                            setTimeout(loadSource, 0);
                        });
                    }
                    else {
                        setTimeout(loadSource, 0);
                    }
                }
                self.destroySubtitleDisplay();
                self.addEventHandler(BitmovinPlayer.EventSourceUnLoaded, onSourceUnloaded);
                BitmovinPlayer.logger.info('bitmovin calling unload');
                self.unloading = true;
                self.unload();
            }
            else {
                reject('bitmovin player instance not found');
            }
        });
    }
    getBitmovinLogLevel(logLevel) {
        let bitmovinLevel = '';
        if (logLevel === 1) {
            bitmovinLevel = bitmovinlib.player.LogLevel.DEBUG;
        }
        else if (logLevel === 2) {
            bitmovinLevel = bitmovinlib.player.LogLevel.LOG;
        }
        else if (logLevel === 3) {
            bitmovinLevel = bitmovinlib.player.LogLevel.WARN;
        }
        else if (logLevel === 4) {
            bitmovinLevel = bitmovinlib.player.LogLevel.ERROR;
        }
        else {
            bitmovinLevel = bitmovinlib.player.LogLevel.OFF;
        }
        return bitmovinLevel;
    }
    setLogLevel(level) {
        if (this.player != null) {
            this.player.setLogLevel(this.getBitmovinLogLevel(AustinConfig.LOGGING_LEVEL));
        }
    }
    /**
     * Checks player is in full-screen mode or not
     * @returns {any}
     */
    isFullScreen() {
        let isFullscreen = false;
        if (this.player != null && typeof this.player.getViewMode !== 'undefined') {
            isFullscreen = this.player.getViewMode() === bitmovinlib.player.ViewMode.Fullscreen;
        }
        return isFullscreen;
    }
    /**
     * Switch to full-screen mode
     */
    fullScreenEnter() {
        if (this.player != null && typeof this.player.setViewMode !== 'undefined') {
            this.player.setViewMode(bitmovinlib.player.ViewMode.Fullscreen);
        }
    }
    /**
     * Exit from full-screen mode
     */
    fullScreenExit() {
        if (this.player != null && typeof this.player.setViewMode !== 'undefined') {
            this.player.setViewMode(bitmovinlib.player.ViewMode.Inline);
        }
    }
    /**
     * Returns PTS (in hexadecimal string) of segment player is playing now
     * @returns {string}
     */
    getCurrentPTS() {
        return this.currentPTS || '';
    }
    /**
     * Return the current bitrate from getDownloadedVideoData
     * @returns {number}
     */
    getCurrentBitRate() {
        let bitrate;
        let videoData = this.player != null ? this.player.getDownloadedVideoData() : 0;
        if (videoData && videoData.bitrate) {
            bitrate = videoData.bitrate;
        }
        return bitrate;
    }
    /**
     * Returns the number of dropped frames until now.
     * @returns {number}
     */
    getDroppedFrames() {
        let droppedFrames = 0;
        if (this.player) {
            if (typeof this.player.getDroppedFrames !== 'undefined') {
                droppedFrames = this.player.getDroppedFrames();
            }
            else if (typeof this.player.getDroppedVideoFrames !== 'undefined') {
                droppedFrames = this.player.getDroppedVideoFrames();
            }
        }
        return droppedFrames;
    }
    /**
     * Returns current playback speed.
     * @returns {number}
     */
    getPlaybackSpeed() {
        return this.player != null ? this.player.getPlaybackSpeed() : 0;
    }
    /**
     * Returns current Internet Status.
     * @returns {boolean}
     */
    isInternetReachable() {
        return (this.player != null && this.player.isInternetReachable) ? this.player.isInternetReachable() : false;
    }
    /**
     * Returns the seconds of already buffered audio data.
     * @returns {number}
     */
    getAudioBufferLength(backward) {
        let buffer = 0;
        if (this.player) {
            let bufferLevel = null;
            if (backward) {
                bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.BackwardDuration, bitmovinlib.player.MediaType.Audio);
            }
            else {
                bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.ForwardDuration, bitmovinlib.player.MediaType.Audio);
            }
            if (this.config.source.dash) {
                buffer = bufferLevel.level;
            }
            else {
                BitmovinPlayer.logger.info('getAudioBufferLength using getLevel: ' + JSON.stringify(bufferLevel));
                //Handling for hls
                buffer = this.getBufferedInfoFromVideo();
            }
        }
        return buffer;
    }
    /**
     * Returns the seconds of already buffered video data.
     * @returns {number}
     */
    getVideoBufferLength(backward) {
        let buffer = 0;
        if (this.player) {
            let bufferLevel = null;
            if (backward) {
                bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.BackwardDuration, bitmovinlib.player.MediaType.Video);
            }
            else {
                bufferLevel = this.player.buffer.getLevel(bitmovinlib.player.BufferType.ForwardDuration, bitmovinlib.player.MediaType.Video);
            }
            if (this.config.source.dash) {
                buffer = bufferLevel.level;
            }
            else {
                //Handling for hls
                BitmovinPlayer.logger.info('getVideoBufferLength using getLevel: ' + JSON.stringify(bufferLevel));
                buffer = this.getBufferedInfoFromVideo();
            }
        }
        return buffer;
    }
    setLiveContentType(value) {
        this.isContentTypeLive = value;
    }
    isLiveContent() {
        return this.isContentTypeLive;
    }
    setSegmentBuffer(value) {
        this.segmentBuffered = value;
    }
    getSegmentBuffer() {
        return this.segmentBuffered;
    }
    setBufferLevel(bufferType, value) {
        if (this.player) {
            if (bufferType === AustinConstants.PLAYER.FORWARD_BUFFER_DURATION) {
                BitmovinPlayer.logger.info('SettingForwardbuffer');
                this.player.buffer.setTargetLevel(bitmovinlib.player.BufferType.ForwardDuration, value, bitmovinlib.player.MediaType.Audio);
                this.player.buffer.setTargetLevel(bitmovinlib.player.BufferType.ForwardDuration, value, bitmovinlib.player.MediaType.Video);
            }
            else if (bufferType === AustinConstants.PLAYER.BACKWARD_BUFFER_DURATION) {
                BitmovinPlayer.logger.info('SettingBackwardbuffer');
                this.player.buffer.setTargetLevel(bitmovinlib.player.BufferType.BackwardDuration, value, bitmovinlib.player.MediaType.Audio);
                this.player.buffer.setTargetLevel(bitmovinlib.player.BufferType.BackwardDuration, value, bitmovinlib.player.MediaType.Video);
            }
        }
    }
    /**
     * Returns buffer in ms
     * @returns {number}
     */
    getBufferAndPlayedInfoFromVideo() {
        let buffer = 0;
        let played = 0;
        try {
            let videoELm = this.player.getVideoElement();
            //Todo : remove info logs
            for (let i = 0; i < videoELm.buffered.length; i++) {
                BitmovinPlayer.logger.info('Buffered range ' + i + ' start: ' + videoELm.buffered.start(i) + ' ,end: ' + videoELm.buffered.end(i));
            }
            if (this.player.getBufferedRanges) {
                BitmovinPlayer.logger.info('getBufferedRanges ' + JSON.stringify(this.player.getBufferedRanges()));
            }
            for (let i = 0; i < videoELm.played.length; i++) {
                BitmovinPlayer.logger.info('Played range ' + i + ' start: ' + videoELm.played.start(i) + ' ,end: ' + videoELm.played.end(i));
            }
            if (videoELm.buffered.length > 1) {
                BitmovinPlayer.logger.warn('Possible Gap detected');
                let lastIndex = videoELm.buffered.length - 1;
                if (videoELm.buffered.length === videoELm.played.length) {
                    buffer = videoELm.buffered.end(lastIndex) - videoELm.played.end(lastIndex);
                }
                else {
                    buffer = (videoELm.buffered.end(lastIndex) + videoELm.buffered.start(lastIndex)) +
                        (videoELm.buffered.end(lastIndex - 1) - videoELm.played.end(lastIndex - 1));
                }
            }
            else if (videoELm.buffered.length === 1) {
                let bufEnd = videoELm.buffered.end(0);
                let bufStart = videoELm.buffered.start(0);
                let playEnd = videoELm.played.end(0);
                let playStart = videoELm.played.start(0);
                if (videoELm.played.length === 1) {
                    buffer = videoELm.buffered.end(0) - videoELm.played.end(0);
                    played = videoELm.played.end(0) - videoELm.played.start(0);
                }
                else {
                    buffer = videoELm.buffered.end(0) - videoELm.buffered.start(0);
                }
                BitmovinPlayer.logger.info('Buffered start: ' + bufStart + ' end: ' + bufEnd + ' buffer: ' + buffer +
                    ' end-start: ' + (bufEnd - bufStart) + ' played start:' + playStart + ' playEnd:' + playEnd + ' played: ' + played);
            }
        }
        catch (e) {
            BitmovinPlayer.logger.warn('Error in getBufferAndPlayedInfoFromVideo : ' + JSON.stringify(e));
        }
        BitmovinPlayer.logger.info('Buffered data: ' + buffer + ' Played data: ' + played);
        return { buffered: buffer, played: played };
    }
    /**
     * Returns buffer in ms
     * @returns {number}
     */
    getBufferedInfoFromVideo() {
        let buffer = 0;
        let bufferedPlayed = this.getBufferAndPlayedInfoFromVideo();
        if (bufferedPlayed && bufferedPlayed.buffered) {
            buffer = bufferedPlayed.buffered;
        }
        return parseFloat(buffer.toFixed(3));
    }
    /**
     * Returns true if the player has been muted.
     * @returns {boolean}
     */
    isMuted() {
        return this.player != null ? this.player.isMuted() : undefined;
    }
    /**
     * Mutes the player if an audio track is available. Has no effect if the player is already muted.
     *
     * @returns {*|void}
     */
    mute() {
        return this.player != null ? this.player.mute() : undefined;
    }
    /**
     * The player will unmute if muted.
     *
     * @returns {any}
     */
    unMute() {
        return this.player != null ? this.player.unmute() : undefined;
    }
    /**
     * Returns the player’s volume in the range zero to 100 including
     *
     * @returns {number}
     */
    getVolume() {
        return this.player != null ? this.player.getVolume() : undefined;
    }
    /**
     * Sets the player’s volume to the value specified by volume which is an integer in the range zero to 100 including.
     * If the player is muted when calling this, the player is unMuted.
     * @param volume
     */
    setVolume(volume) {
        return this.player != null ? this.player.setVolume(volume) : undefined;
    }
    /**
     * Fetches video size downloaded till now in bits
     */
    getDownloadedSize() {
        return this.player != null ? this.downloadedSize : undefined;
    }
    /**
     * Get the CC list available with stream
     *
     */
    getCCList() {
        return this.player != null ? this.player.getAvailableSubtitles() : undefined;
    }
    /**
     * return the current CC channel active in the stream
     *
     */
    getCCChannel() {
        return this.player != null ? this.player.getSubtitle() : undefined;
    }
    /**
     * Sets player CC channel .
     *
     * @param ccChannel
     */
    setCCChannel(ccChannel) {
        try {
            if (this.player != null) {
                this.enableSubtitle(this.getAvailableSubtitles()[0].id);
            }
        }
        catch (e) {
            BitmovinPlayer.logger.error(e);
        }
    }
    getPlayerContainer() {
        return this.player.getContainer();
    }
    getAvailableSubtitles() {
        let subtitles = this.player.subtitles.list();
        return subtitles;
    }
    enableSubtitle(id) {
        this.player.subtitles.enable(id, true);
    }
    disableSubtitle(id) {
        this.player.subtitles.disable(id);
    }
    createSubtitleDisplay(cc) {
        BitmovinPlayer.logger.info('createSubtitleDisplay ++');
        if (this.subtitleDisplay === null) {
            BitmovinPlayer.logger.info('createSubtitleDisplay create custom');
            let playerContainer = this.getPlayerContainer();
            let subtitleDisplay = new CustomCC(playerContainer, cc);
            this.addEventHandler(BitmovinPlayer.EventCueEnter, (e) => {
                BitmovinPlayer.logger.info('onCueEnter :' + JSON.stringify(e));
                subtitleDisplay.showCue(e);
            });
            this.addEventHandler(BitmovinPlayer.EventCueExit, (e) => {
                BitmovinPlayer.logger.info('onCueExit :' + e);
                subtitleDisplay.hideCue(e);
            });
            this.addEventHandler(BitmovinPlayer.EventSubtitleChanged, (e) => {
                BitmovinPlayer.logger.info('SubtitleChange :' + e);
                subtitleDisplay.clear(e);
            });
            this.addEventHandler(BitmovinPlayer.EventPlayerResize, (e) => {
                BitmovinPlayer.logger.info('onPlayerResize :' + e);
                subtitleDisplay.updateFontSize(e);
            });
            this.subtitleDisplay = subtitleDisplay;
        }
        else {
            BitmovinPlayer.logger.info('createSubtitleDisplay already present');
        }
        this.subtitleDisplay.updateCC(cc);
        BitmovinPlayer.logger.info('createSubtitleDisplay --');
    }
    destroySubtitleDisplay() {
        BitmovinPlayer.logger.info('destroySubtitleDisplay ++');
        if (this.subtitleDisplay !== null) {
            this.removeEventHandler(BitmovinPlayer.EventCueEnter, this.subtitleDisplay.showCue);
            this.removeEventHandler(BitmovinPlayer.EventCueExit, this.subtitleDisplay.hideCue);
            this.removeEventHandler(BitmovinPlayer.EventSubtitleChanged, this.subtitleDisplay.clear);
            this.removeEventHandler(BitmovinPlayer.EventPlayerResize, this.subtitleDisplay.updateFontSize);
            this.subtitleDisplay.destroy();
            this.subtitleDisplay = null;
            BitmovinPlayer.logger.info('destroySubtitleDisplay _subtitleDisplay = null');
        }
        BitmovinPlayer.logger.info('destroySubtitleDisplay --');
    }
    applyCC(cc) {
        BitmovinPlayer.logger.info('applyCC ++');
        if (this.player !== null) {
            BitmovinPlayer.logger.info('applyCC ++ player not null');
            if (cc.CCVisible) {
                BitmovinPlayer.logger.info('applyCC ++ player not null CCVisible true');
                if (cc.CCChannel !== '') {
                    this.enableSubtitle(cc.CCChannel);
                }
                else {
                    let subtitles = this.getAvailableSubtitles();
                    if (subtitles[0]) {
                        cc.CCChannel = subtitles[0].id;
                        this.enableSubtitle(cc.CCChannel);
                    }
                }
                if (cc.CCCustomize) {
                    BitmovinPlayer.logger.info('applyCC ++ player not null CCCustomize true calling createSubtitleDisplay');
                    this.createSubtitleDisplay(cc);
                }
                else {
                    let playerContainer = this.getPlayerContainer();
                    let subtitle = playerContainer.getElementsByClassName('austin-custom-subtitles');
                    if (subtitle && subtitle.length > 0) {
                        BitmovinPlayer.logger.info('applyCC ++ player not null CCCustomize false calling destroySubtitleDisplay');
                        this.destroySubtitleDisplay();
                    }
                    else {
                        BitmovinPlayer.logger.info('applyCC ++ player not null CCCustomize false calling createSubtitleDisplay');
                        this.createSubtitleDisplay(cc);
                    }
                }
            }
            else {
                BitmovinPlayer.logger.info('applyCC ++ player not null CCVisible false, setting setSubtitle null');
                this.disableSubtitle(cc.CCChannel);
                if (this.subtitleDisplay != null) {
                    this.subtitleDisplay.clear();
                }
            }
        }
        BitmovinPlayer.logger.info('applyCC --');
    }
}
BitmovinPlayer.logger = new AustinLogger('BitmovinPlayer');
BitmovinPlayer.EventError = '';
BitmovinPlayer.EventWarning = '';
BitmovinPlayer.EventReady = '';
BitmovinPlayer.EventSourceLoaded = '';
BitmovinPlayer.EventSourceUnLoaded = '';
BitmovinPlayer.EventStallStarted = '';
BitmovinPlayer.EventStallEnded = '';
BitmovinPlayer.EventDownloadFinished = '';
BitmovinPlayer.EventMetadata = '';
BitmovinPlayer.EventMetadataParsed = '';
BitmovinPlayer.EventPlay = '';
BitmovinPlayer.EventPaused = '';
BitmovinPlayer.EventPlaying = '';
BitmovinPlayer.EventSubtitleAdded = '';
BitmovinPlayer.EventSubtitleChanged = '';
BitmovinPlayer.EventCueEnter = '';
BitmovinPlayer.EventCueExit = '';
BitmovinPlayer.EventPlayerResize = '';
BitmovinPlayer.EventPlayerSeek = '';
BitmovinPlayer.EventPlayerSeeked = '';
BitmovinPlayer.EventPlayerTimeShift = '';
BitmovinPlayer.EventPlayerTimeShifted = '';

/**
 * Created by Sunnykesh on 14/03/19.
 */
class ChromeCastPlayer extends Html5Player {
    constructor() {
        super();
        this.playbackTime = 0;
        this.downloadedSize = 0;
        this.downloadedTime = 0;
        this.bitrate = 0;
        this.playbackTime = 0;
        ChromeCastPlayer.logger.log('Created');
    }
    getVersion() {
        ChromeCastPlayer.logger.log(cast.framework.VERSION);
        return (cast.framework !== undefined && cast.framework.VERSION !== undefined) ? cast.framework.VERSION : super.getVersion();
    }
    /* Structure of Events.
     *  { type : 'TYPE',
     *    members (varaiable number depending on the event)
     *  }
     */
    initializeEventMonitor() {
        let self = this;
        ChromeCastPlayer.logger.log('Event Monitor Initialized');
        this.castPlayerManager.addEventListener(cast.framework.events.category.CORE, (event) => {
            ChromeCastPlayer.logger.log('CORE', event);
            if (event.mediaStatus !== null) {
                ChromeCastPlayer.logger.log(event.mediaStatus);
            }
        });
        this.castPlayerManager.addEventListener(cast.framework.events.category.DEBUG, (event) => {
            ChromeCastPlayer.logger.log('DEBUG', event);
            var debugEvents = cast.framework.events.category.DEBUG;
            if (event.type === debugEvents[1]) {
                ChromeCastPlayer.logger.log('BITRATE_CHANGED :', event);
                self.bitrate = event.totalBitrate;
            }
        });
        this.castPlayerManager.addEventListener(cast.framework.events.category.FINE, (event) => {
            ChromeCastPlayer.logger.log('FINE', event);
        });
    }
    playUrl(config, params) {
        let self = this;
        this.loadRequestData = new cast.framework.messages.LoadRequestData();
        let media = new cast.framework.messages.MediaInformation();
        //media.contentUrl = 'https://192-168-1-4-ip.dishboxes.com:9443/2019-3-13/3470/dash/dash.mpd';
        media.contentUrl = config.url;
        this.loadRequestData.media = media;
        this.castPlayerManager = cast.framework.CastReceiverContext.getInstance().getPlayerManager();
        this.videoElement = document.querySelector('cast-media-player').shadowRoot.querySelector('video');
        const playbackConfig = (Object.assign(new cast.framework.PlaybackConfig(), this.castPlayerManager.getPlaybackConfig()));
        playbackConfig.manifestHandler = (manifest) => {
            ChromeCastPlayer.logger.log('@@@@@@ manifest', manifest);
            function decode(text) {
                let byteArray = new Uint8Array(text.length * 2);
                for (let i = 0; i < text.length; i++) {
                    byteArray[i * 2] = text.charCodeAt(i); // & 0xff;
                    byteArray[i * 2 + 1] = text.charCodeAt(i) >> 8; // & 0xff;
                }
                return String.fromCharCode.apply(String, byteArray);
            }
            function encode(text) {
                let cp = [];
                for (let i = 0; i < text.length; i += 2) {
                    cp.push(text.charCodeAt(i) | (text.charCodeAt(i + 1) << 8));
                }
                return String.fromCharCode.apply(String, cp);
            }
            let decodedManifest = decode(manifest);
            if (decodedManifest.search('id="0" mimeType="audio/mp4') !== -1 && decodedManifest.search('id="0" qualityRanking="0" mimeType="video/mp4"') !== -1) {
                decodedManifest = decodedManifest.replace('id="0" mimeType="audio/mp4', 'id="1" mimeType="audio/mp4');
            }
            if (decodedManifest.search('mediaPresentationDuration') === -1) {
                decodedManifest = decodedManifest.replace('minimumUpdatePeriod="PT24H"', 'minimumUpdatePeriod="PT24H" mediaPresentationDuration="PT24H"');
            }
            ChromeCastPlayer.logger.log('manifest', decodedManifest, typeof (decodedManifest));
            return encode(decodedManifest);
        };
        playbackConfig.manifestRequestHandler = function (requestInfo) {
            ChromeCastPlayer.logger.log('@@@@@@ ', requestInfo);
            return requestInfo;
        };
        playbackConfig.licenseUrl = config[AustinConstants.STREAMING.DRM_LA_URL];
        playbackConfig.protectionSystem = cast.framework.ContentProtection.WIDEVINE;
        let licenseRequestHandler = function (requestInfo) {
            // let request = {};
            // request['method'] = 'POST';
            // let msg1 = JSON.stringify({
            //     user_id: '0925766e-db9b-11e7-aede-0a3eecf5965a',
            //     channel_id: '904e41a22a9a43a5a4d9d160cbb29f03',
            //     disabled: true, // remove this if you really want to test entitlements
            //     env: 'dev',
            //     message: Array.apply(null, new Uint8Array(requestInfo.content))
            // });
            // request['body'] = msg1;
            // console.log('EME DRM fetching licence request', requestInfo.content);
            // fetch(playbackConfig.licenseUrl, request).then((response) => {
            //    console.log('EME DRM fetching licence response.ok ' , response.ok, response.status, response.statusText);
            //     if (response.ok) {
            //         return response.blob();
            //     } else {
            //         throw response;
            //     }
            // });
            let msg = JSON.stringify({
                user_id: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_USER_ID,
                channel_id: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_CHANNEL_ID,
                disabled: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_DISABLED,
                env: AustinConfig.PLAYER.MULTI_DRM.WIDEVINE_ENV,
                message: Array.apply(null, new Uint8Array(requestInfo.content))
            });
            requestInfo.content = new TextEncoder().encode(msg);
            requestInfo.withCredentials = true;
            //requestInfo.headers['content-type'] = 'text/xml;charset=utf-8';
            return requestInfo;
        };
        playbackConfig.licenseRequestHandler = licenseRequestHandler;
        ChromeCastPlayer.logger.log('@@@@@@@ castplaybackConfig', playbackConfig);
        this.castPlayerManager.setPlaybackConfig(playbackConfig);
        return new Promise((resolve, reject) => {
            ChromeCastPlayer.logger.log('Successfully created player instance'); // Success!
            self.initializeEventMonitor();
            var loadstatus = self.castPlayerManager.load(self.loadRequestData);
            ChromeCastPlayer.logger.log('loadstatus', loadstatus);
            loadstatus.then(() => {
                self.castPlayerManager.play();
                resolve();
            }).catch((data) => {
                ChromeCastPlayer.logger.log('Load Failed', data);
                ChromeCastPlayer.logger.error('setup promise failed ' + data);
                reject(data);
            });
        });
    }
    unloadLoad() {
        ChromeCastPlayer.logger.log('UnloadLoad called');
        var self = this;
        if (this.videoElement !== undefined && this.castPlayerManager !== null) {
            ChromeCastPlayer.logger.log('ChromeCastPlayer Unloading this.playbackTime: ' + this.playbackTime);
            var time = this.videoElement.currentTime;
            ChromeCastPlayer.logger.log('ChromeCastPlayer Unloading this._player.getCurrentTime: ' + time);
            if (time != null && time !== undefined) {
                if (time < 0 || !isFinite(time)) {
                    ChromeCastPlayer.logger.error('ChromeCastPlayer getCurrentTime returned wrong value ' + time);
                }
                else {
                    this.playbackTime = this.playbackTime + time;
                }
            }
            ChromeCastPlayer.logger.log('ChromeCastPlayer Paused for Unloading ....');
            var loadstatus = this.castPlayerManager.load(this.loadRequestData);
            ChromeCastPlayer.logger.log('loadstatus', loadstatus);
            ChromeCastPlayer.logger.log('ChromeCastPlayer load API called');
            loadstatus.then(() => {
                self.castPlayerManager.play();
                ChromeCastPlayer.logger.log('ChromeCastPlayer play after unloadLoad');
            }).catch((data) => {
                ChromeCastPlayer.logger.log('Load Failed', data);
                ChromeCastPlayer.logger.error('ChromeCastPlayer load promise failed at UnloadLoad ' + data);
            });
        }
        else {
            ChromeCastPlayer.logger.log('videoElement undefined. UnloadLoad failed. videoElement :', this.videoElement, ' castPlayerManager ', this.castPlayerManager);
        }
    }
    /**
     * Returns the currentTime
     */
    getCurrentTime() {
        var time = this.castPlayerManager != null ? this.castPlayerManager.getCurrentTimeSec() : 0;
        if (time != null && time !== 'undefined') {
            if (time < 0 || !isFinite(time)) {
                ChromeCastPlayer.logger.error('castPlayerManager getCurrentTime returned wrong value ' + time);
            }
            else {
                time = this.playbackTime + time;
            }
        }
        return time;
    }
    /**
     * Destroys the player and reassigns values null/0 to varibales used.
     */
    destroy() {
        ChromeCastPlayer.logger.log('calling castPlayerManager stop this.castPlayerManager: ' + this.castPlayerManager);
        if (this.castPlayerManager !== null) {
            this.castPlayerManager.stop();
            var KBps = ((this.downloadedSize / this.downloadedTime) / 1024);
            ChromeCastPlayer.logger.log('Download Speed (KBps) ' + KBps); // Success!
            this.downloadedSize = 0;
            this.downloadedTime = 0;
            this.playbackTime = 0;
            this.castPlayerManager = null;
            this.loadRequestData = 0;
            this.bitrate = 0;
            this.videoElement = null;
            ChromeCastPlayer.logger.log('Successfully player destroyed'); // Success!
        }
    }
    /**
     * Return the current bitrate from getDownloadedVideoData
     * @returns {number}
     */
    getCurrentBitRate() {
        let bitrate;
        let videoData = this.castPlayerManager !== null ? this.castPlayerManager.getDownloadedVideoData() : 0;
        if (videoData && videoData.bitrate) {
            bitrate = videoData.bitrate;
        }
        return bitrate;
    }
    /**
     * Returns true if the player has been muted.
     * @returns {boolean}
     */
    isMuted() {
        return (this.castPlayerManager !== null && this.videoElement !== null) ? this.videoElement.muted : undefined;
    }
    /**
     * Mutes the player if an audio track is available. Has no effect if the player is already muted.
     * @returns {boolean}
     */
    mute() {
        return (this.castPlayerManager !== null && this.videoElement !== null) ? this.videoElement.muted = true : undefined;
    }
    /**
     * The player will unmute if muted.
     * @returns {boolean}
     */
    unMute() {
        return (this.castPlayerManager !== null && this.videoElement !== null) ? this.videoElement.muted = false : undefined;
    }
    /**
     * Returns the player’s volume in the range zero to 100 including
     * @returns {number}
     */
    getVolume() {
        return (this.castPlayerManager !== null && this.videoElement !== null) ? this.videoElement.volume : undefined;
    }
    /**
     * Sets the player’s volume (Value between 0 and 1) to the value specified from the sender which is a value in the range 0 to 100 after necessary changes.
     * @param volume
     */
    setVolume(volume) {
        return (this.castPlayerManager !== null && this.videoElement !== null) ? this.videoElement.volume = (volume / 100) : undefined;
    }
    /**
     * Fetches video size downloaded till now in bytes
     */
    getDownloadedSize() {
        return this.downloadedSize;
    }
    play() {
        if (this.castPlayerManager != null && this.videoElement.paused) {
            this.playStartTime = new Date().getTime();
            this.castPlayerManager.play();
        }
    }
    pause() {
        if (this.castPlayerManager != null && !this.videoElement.paused) {
            this.castPlayerManager.pause();
        }
    }
    calculateBufferLength() {
        var bufferLength = 0;
        if (this.videoElement !== null && this.castPlayerManager !== null) {
            if (this.videoElement.buffered.length > 0) {
                if (this.videoElement.played.length > 0) {
                    bufferLength = this.videoElement.buffered.end(0) - this.videoElement.played.end(0);
                }
                else {
                    bufferLength = this.videoElement.buffered.end(0) - this.videoElement.buffered.start(0);
                }
            }
        }
        return bufferLength;
    }
    /**
     * Returns the seconds of already buffered audio data.
     * @returns {number}
     */
    getAudioBufferLength() {
        return parseFloat(this.calculateBufferLength().toPrecision(3));
    }
    /**
     * Returns the seconds of already buffered video data.
     * @returns {number}
     */
    getVideoBufferLength() {
        return parseFloat(this.calculateBufferLength().toPrecision(3));
    }
}
ChromeCastPlayer.logger = new AustinLogger('ChromeCastPlayer');

/**
 * Created by Sunny on 29/09/16.
 * This files contains logic to decide which player bitDash or chromecast or dash player to use
 */
class PlayerManager {
    constructor() {
        PlayerManager.logger.info('created!');
    }
    static getPlayer(type) {
        try {
            if (this.html5Player) {
                this.html5Player.destroy();
                this.html5Player = null;
            }
            if (type === AustinConstants.PLAYER.BITMOVIN) {
                this.html5Player = new BitmovinPlayer();
            }
            if (type === AustinConstants.PLAYER.CHROMECAST) {
                this.html5Player = new ChromeCastPlayer();
            }
            if (this.html5Player === null) {
                this.html5Player = Object.create(new Html5Player());
            }
        }
        catch (e) {
            this.logger.error(e);
        }
        return this.html5Player;
    }
}
PlayerManager.logger = new AustinLogger();
PlayerManager.html5Player = null;

var __awaiter$3 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class RenewableTimer {
}
RenewableTimer.remainingDuration = 0;
RenewableTimer.isPaused = false;
RenewableTimer.startingTimestamp = 0;
RenewableTimer.setTimeout = () => {
    RenewableTimer.timer = setTimeout(() => {
        if (RenewableTimer.callback !== null) {
            RenewableTimer.callback();
        }
        RenewableTimer.timer = null;
        RenewableTimer.callback = null;
    }, RenewableTimer.remainingDuration);
};
RenewableTimer.setTimer = (callback, time) => {
    RenewableTimer.startingTimestamp = Date.now();
    RenewableTimer.callback = callback;
    RenewableTimer.remainingDuration = time;
    RenewableTimer.setTimeout();
};
RenewableTimer.pause = () => {
    if (RenewableTimer.timer && !RenewableTimer.isPaused) {
        clearTimeout(RenewableTimer.timer);
        const pausingTimestamp = Date.now();
        const spentTime = pausingTimestamp - RenewableTimer.startingTimestamp;
        RenewableTimer.isPaused = true;
        RenewableTimer.remainingDuration -= spentTime;
    }
};
RenewableTimer.resume = () => {
    if (RenewableTimer.timer && RenewableTimer.isPaused) {
        RenewableTimer.startingTimestamp = Date.now();
        RenewableTimer.isPaused = false;
        RenewableTimer.setTimeout();
    }
};
class Austin {
    /**
     * constructor
     * @hidden
     */
    constructor() {
        Austin.logger.info('Instance created!');
    }
    /**
     * Initialises the Austin library by looking for MD (Master Directory) config data when application starts.
     * <br/> a.) By default library will be initialized with prod environment.
     * <br/> b.) platform is mandatory as web supported features ex: localStorage etc. may throw exception
     *      for other platforms. <br/> Expected value is string for one of the supported platform : 'web' / 'android'/'ios'/'chromecast'
     * <br/> c.) protocol will be used to make all network communication. Austin will take default as 'https:'
     * <br/> d.) endpoint is reliable server endpoint to check internet connectivity in suspected scenarios. Please make sure
     *      that endpoint server has white-listed host domain using Austin to avoid CORS blocking.
     *
     * Checks if the browser supports the required codecs and initialises various modules in Austin.
     * <br/>Promise is resolved if codecs are supported on browser or rejected to error object with reason as
     * <pre>
     *     1. html5PlaybackNotSupported
     *     2. missingPlatform
     * </pre>
     *
     * @param clientConfig - library consumer configurable json data object
     * <pre>
     * a sample config object,
     * clientConfig = {
     *     env : 'prod',
     *     platform: 'web',
     *     log: {level: 'debug'}
     *     modules: [ {name: 'bitmovin', module:  window['bitmovin']}],
     *     protocol: location.protocol,
     *     endpoint : location.pathname
     *  }
     * </pre>
     * @returns {Promise<void|IAustinError>}
     */
    static bootstrap(clientConfig) {
        Austin.logger.info('Bootstrapping : ' + JSON.stringify(clientConfig));
        return new Promise((resolve, reject) => {
            if (!AustinUtils.init(clientConfig)) {
                reject({
                    reason: AustinErrors.MISSING_PLATFORM
                });
                return;
            }
            if (this.initialized) {
                Austin.logger.info('Austin Already Initialized');
                resolve();
                return;
            }
            if (clientConfig.env === AustinConstants.ENV_QA) {
                this.appConfig.env = AustinConstants.ENV_QA;
            }
            this.libInfo.appVersion = clientConfig.appVersion || '';
            let codecSupported = Austin.codecProfileLevelSupported();
            Austin.logger.info('codecProfileLevelSupported ' + JSON.stringify(codecSupported));
            if (codecSupported[AustinConstants.STREAMING.CODEC]) {
                MDConfig.fetch(this.libInfo.version, this.appConfig.env).then(() => {
                    if (codecSupported[AustinConstants.STREAMING.CODEC] === AustinConstants.STREAMING.CODECS.AVC1) {
                        if (AustinUtils.isOsWindows10()) {
                            codecSupported[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3_AVC1_SPOOFED;
                        }
                    }
                    if (AustinUtils.isBrowserFirefox()) {
                        codecSupported[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC1;
                    }
                    AustinConfig.SUPPORTED_CODEC[AustinConstants.STREAMING.CODEC] = codecSupported[AustinConstants.STREAMING.CODEC];
                    AustinConfig.SUPPORTED_CODEC[AustinConstants.STREAMING.CODECS.PROFILE] = codecSupported[AustinConstants.STREAMING.CODECS.PROFILE];
                    AustinConfig.SUPPORTED_CODEC[AustinConstants.STREAMING.CODECS.LEVEL] = codecSupported[AustinConstants.STREAMING.CODECS.LEVEL];
                    Austin.init();
                    Austin.ccDefault = JSON.parse(JSON.stringify(this.cc));
                    let ccFromCookie = AustinUtils.getCookie(AustinConstants.AUSTIN_CC_COOKIE);
                    if (ccFromCookie) {
                        Austin.cc = ccFromCookie;
                        Austin.cc.CCChannel = '';
                    }
                    Austin.logger.info('Austin Initialized');
                    resolve();
                });
            }
            else {
                Austin.logger.warn('html5 video codec not supported on this browser');
                reject({
                    reason: AustinErrors.HTML5_PLAYBACK_NOT_SUPPORTED
                });
            }
        });
    }
    /**
     * Finds the Codec profile supported by client
     * @returns {{}}
     * @hidden
     */
    static codecProfileLevelSupported() {
        let result = Object.create(null);
        if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.640028"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_HIGH;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_4_0;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.64001F"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_HIGH;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_1;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.64001E"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_HIGH;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_0;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.4D4028"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_MAIN;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_4_0;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.4D401F"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_MAIN;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_1;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.4D401E"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_MAIN;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_0;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.42E028"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_BASELINE;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_4_0;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.42E01F"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_BASELINE;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_1;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc3.42E01E"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC3;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_BASELINE;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_0;
        }
        else if (AustinUtils.isCodecProfileLevelSupported('video/mp4; codecs="avc1.42E01E"')) {
            result[AustinConstants.STREAMING.CODEC] = AustinConstants.STREAMING.CODECS.AVC1;
            result[AustinConstants.STREAMING.CODECS.PROFILE] = AustinConstants.STREAMING.CODECS.PROFILE_BASELINE;
            result[AustinConstants.STREAMING.CODECS.LEVEL] = AustinConstants.STREAMING.CODECS.LEVEL_3_0;
        }
        return result;
    }
    /**
     * Encrypted Media Extension (EME) WIDEVINE supported not
     * Returns tue if widevine DRM is supported
     * @returns resolve to true if EME support is present else false
     */
    static isEMEWidevineSupported() {
        return __awaiter$3(this, void 0, void 0, function* () {
            let eme = 'MediaKeys' in window || 'WebKitMediaKeys' in window || 'MSMediaKeys' in window;
            if (!eme) {
                Austin.logger.log('no MediaKeys support');
                return false;
            }
            let requestMediaKeySystemAccess = 'requestMediaKeySystemAccess' in window.navigator;
            if (!requestMediaKeySystemAccess) {
                Austin.logger.log('no requestMediaKeySystemAccess support');
                return false;
            }
            let audioContentType = 'audio/mp4;codecs=\"mp4a.40.2\"';
            let videoContentType = 'video/mp4;codecs=\"avc3.640028\"';
            let config = [{
                    'initDataTypes': ['cenc'],
                    'audioCapabilities': [{ 'contentType': audioContentType }],
                    'videoCapabilities': [{ 'contentType': videoContentType }]
                }];
            try {
                let mediaKeySystemAccess = yield navigator.requestMediaKeySystemAccess('com.widevine.alpha', config);
                if (mediaKeySystemAccess) {
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (e) {
                Austin.logger.log('no widevine support');
                return false;
            }
        });
    }
    /**
     * Initializes the austin client wrapper
     * @hidden
     */
    static init() {
        this.logger.info('instantiated!');
        AustinUtils.processQueryParams();
        const eventsPollTime = AustinUtils.getQueryValueForKey(AustinConstants.QUERY_PARAM.POLL_TIME);
        const seriesEnabled = AustinUtils.getQueryValueForKey(AustinConstants.QUERY_PARAM.FORCED_SERIES_CONNECTION);
        if (eventsPollTime) {
            AustinConfig.AUSTIN.EVENTS_POLL_TIME_MS = eventsPollTime;
        }
        if (seriesEnabled) {
            AustinConfig.CPS.ENABLE_PARALLEL_CONNECTION = !seriesEnabled;
        }
        this.core = AustinCore.getInstance();
        this.libInfo.streamInfo = this.core.getStreamInfo();
        this.core.eventManager.subscribe(AustinEvents.BOX_STREAM_DISCONTINUITY, Austin.boxDiscontinuityHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_BUFFER_BAR, Austin.boxBufferBarHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_VIDEO_SIGNAL, Austin.boxVideoSignalHandler);
        //Handling continuous event failure
        this.core.eventManager.subscribe(AustinEvents.BOX_CONNECTION_LOST, Austin.boxConnectionLostHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_POP_UP, Austin.boxPopUpHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_STREAM_LOST, Austin.boxStreamLostHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_STREAM_STOP, Austin.boxStreamStopHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_PROGRAM_INFO_CHANGED, Austin.programInfoChangedHandler);
        this.core.eventManager.subscribe(AustinEvents.BOX_CONNECTION_RE_ESTABLISHED, Austin.boxConReEstablishedHandler);
        window.addEventListener(AustinConstants.OFFLINE, Austin.offlineHandle);
        window.addEventListener(AustinConstants.ONLINE, Austin.onlineHandle);
        this.analytics = AnalyticsHelper.getInstance(AustinConfig.ANALYTICS);
        this.analytics.setAnalyticsClientData(this.libInfo);
        PerformanceTimer.init();
        this.initialized = true;
    }
    /**
     * Register an event handler to be fired for the passed event
     * @param event {string} -  event name
     * @param handler {function } - event handler
     * @returns {void}
     * @see [[Austin.EVENTS]]
     */
    static subscribe(event, handler) {
        this.eventManager.subscribe(event, handler);
    }
    /**
     * UnRegister an event handler
     * @param event {string} event name
     * @param handler {function } event handler
     * @returns {void}
     * @see [[Austin.EVENTS]]
     */
    static unSubscribe(event, handler) {
        this.eventManager.unSubscribe(event, handler);
    }
    static errorWithSessionInfo(error) {
        if (!error.info) {
            error.info = {};
        }
        error.info['version'] = Austin.getVersion();
        error.info['boxSessionId'] = Austin.core.getSessionId();
        error.info['clientSessionId'] = Austin.connectionSessionId;
        error.info['playbackSessionId'] = Austin.playerInstanceId;
        error.info['discontinuityCount'] = Austin.discontinuityCount;
        error.info['sessionDuration'] = Austin.sessionDuration;
        error.info['libStatus'] = Austin.getStatus();
        let streamedFor = Number(Austin.sessionDuration);
        if (streamedFor > 0) {
            let streamingDuration;
            if (streamedFor >= 3600) {
                streamingDuration = ((streamedFor / 3600) >> 0) + ' hour +';
            }
            else {
                let minutes = streamedFor / 60;
                if (minutes >= 50) {
                    streamingDuration = '50 minutes +';
                }
                else if (minutes >= 40) {
                    streamingDuration = '40 minutes +';
                }
                else if (minutes >= 30) {
                    streamingDuration = '30 minutes +';
                }
                else if (minutes >= 20) {
                    streamingDuration = '20 minutes +';
                }
                else if (minutes >= 10) {
                    streamingDuration = '10 minutes +';
                }
                else if (minutes >= 5) {
                    streamingDuration = '5 minutes +';
                }
                else if (minutes >= 2) {
                    streamingDuration = '2 minutes +';
                }
                else if (minutes >= 1) {
                    streamingDuration = '1 minutes +';
                }
                else if (minutes >= 0) {
                    streamingDuration = 'less than a minute';
                }
            }
            error.info['streamedFor'] = streamingDuration;
        }
        error.info['debugInfo'] = JSON.parse(JSON.stringify(Austin.core.getDebugInfo()));
        error.info['austinInfo'] = Austin.debugInfo.toString();
        error.info['timeStamp'] = new Date().toISOString();
        return error;
    }
    /**
     * Fires the event with required data
     * @param event
     * @param params
     * @hidden
     */
    static fire(event, params) {
        if (Austin.EVENTS.onError === event) {
            params = Austin.errorWithSessionInfo(params);
        }
        this.eventManager.fire(event, params);
    }
    /**
     * Set up the control connection with the Sling box using the passed Box's finder Id and credentials.
     * **[[play]]** api needs to be called to start the streaming playback.
     * <br/>Promise resolved on successful connection or rejected to error object with possible reason as
     * <pre>
     *     1. austinNotInitialized
     *     2. alreadyConnected
     *     3. authorizationFailed
     *     4. connectFailed
     * </pre>
     * @param params - connection parameters
     * <pre>
     *     params = {
     *       finderId: string,  //string: - Box finder id
     *       pass: string,      //string: - Password for the user account on Box
     *       receiverId: string,   //string: - receiverId for the user box
     *       uuid: string,      //string: - uuid for the user account
     *       user: string       //string: - Username for the user account (default is 'admin')
     *       forcedRelay: boolean // boolean: - Austin connection attempt(forced) over RELAY.
     *     }
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static connect(params) {
        PerformanceTimer.markStart(PerformanceTimer.metrics.CONNECT);
        Austin.logger.info('connect called');
        let self = this;
        //hardcoding buffer bar frequency as 4 sec
        params.bufferBarFrequency = 4;
        return new Promise((resolve, reject) => {
            let currentStatus = Austin.libInfo.status;
            if (!Austin.initialized) {
                Austin.logger.error(AustinErrors.AUSTIN_NOT_INITIALIZED);
                PerformanceTimer.markEnd(PerformanceTimer.metrics.CONNECT);
                reject(Austin.errorWithSessionInfo({
                    reason: AustinErrors.AUSTIN_NOT_INITIALIZED
                }));
                return;
            }
            Austin.analytics.sendStoredAnalytics();
            //check for compulsory params
            if (!(params.finderId && params.pass && params.receiverId && params.uuid)) {
                Austin.logger.error(AustinErrors.INVALID_CREATE_SESSION_PARAM);
                PerformanceTimer.markEnd(PerformanceTimer.metrics.CONNECT);
                reject(Austin.errorWithSessionInfo({
                    reason: AustinErrors.INVALID_CREATE_SESSION_PARAM
                }));
                return;
            }
            if (AustinConstants.BOX.STATUS.DISCONNECTED !== currentStatus) {
                if (Austin.core.isSameBox(params.finderId)) {
                    let reason = '';
                    if (AustinConstants.BOX.STATUS.CONNECTING === currentStatus) {
                        reason = AustinErrors.ALREADY_IN_CONNECTING;
                    }
                    else {
                        reason = AustinErrors.ALREADY_CONNECTED;
                    }
                    Austin.logger.error(reason);
                    PerformanceTimer.markEnd(PerformanceTimer.metrics.CONNECT);
                    reject(Austin.errorWithSessionInfo({
                        reason: reason // this also includes connecting status
                    }));
                }
                else {
                    Austin.logger.info('Connect request to different box');
                    self.debugInfo.push(new Date().toISOString() + 'NewBoxConReq(' + params.finderId + ' prev:' + self.core.getBoxInfo()['finderId'] + ')');
                    let sessionId = self.core.getSessionId();
                    self.disconnect().then(() => {
                        self.debugInfo.push(new Date().toISOString() + 'Disconnected(' + sessionId + ')');
                        self.connect(params).then((data) => {
                            self.debugInfo.push(new Date().toISOString() + 'Connected(' + self.core.getSessionId() + ')');
                            resolve();
                        }).catch((connectError) => {
                            self.debugInfo.push(new Date().toISOString() + 'ConnectFailed');
                            reject(Austin.errorWithSessionInfo(connectError));
                        });
                    }).catch((disconnectErr) => {
                        self.debugInfo.push(new Date().toISOString() + 'DisconnectFailed');
                        reject(Austin.errorWithSessionInfo(disconnectErr));
                    });
                }
            }
            else {
                Austin.logger.info('changing status to connecting');
                //Changing status to connecting and emitting status change event
                Austin.analytics.resetAnalyticStore(); //cleaning up last session analytics data
                Austin.setStatus(AustinConstants.BOX.STATUS.CONNECTING);
                Austin.connectionSessionId = AustinUtils.generateUniqueId();
                params.webSessionId = Austin.connectionSessionId;
                Austin.uuid = params.uuid;
                Austin.core.connect(params).then(() => {
                    Austin.connectParams = Object.assign({}, params);
                    Austin.logger.info('Box Session created');
                    Austin.setStatus(AustinConstants.BOX.STATUS.CONNECTED);
                    PerformanceTimer.markEnd(PerformanceTimer.metrics.CONNECT);
                    Austin.setAnalyticsConnectionData(Austin.getConnectionMode());
                    if (params.bufferBarFrequency) {
                        Austin.core.configureAccount(params.bufferBarFrequency);
                    }
                    resolve();
                }).catch((e) => {
                    Austin.logConnectionFailure(e).then((error) => {
                        reject(error);
                    });
                });
            }
        });
    }
    static checkPlaybackStarted() {
        Austin.logger.info('Clearing playback time as first segment request didnt come after disocntinuity');
        if (Austin.player) {
            Austin.player.checkPlaybackStarted();
        }
    }
    static logConnectionFailure(e) {
        return new Promise((resolve) => {
            Austin.setStatus(AustinConstants.BOX.STATUS.DISCONNECTED);
            let error = {
                reason: AustinErrors.CONNECT_FAILED,
                info: { message: e.reason, retryAttemptInfo: e.retryAttemptInfo }
            };
            if (e.data) {
                Object.assign(error.info, e.data);
            }
            if (e.reason === AustinErrors.BOX_OFFLINE) {
                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sn_connect_failed);
            }
            else if (e.reason === AustinErrors.AUTHORIZATION_FAILED) {
                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_password_failure);
            }
            else if (e.reason === AustinErrors.ALL_CRTL_SESS_ACTIVE) {
                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_all_ctrl_session_active);
            }
            else if ((e.reason === AustinErrors.FETCH_SPARCS_FAILED || e.reason === AustinErrors.AJAX_REQUEST_FAILED) && ((Austin.player && !Austin.player.isInternetReachable()) || !navigator.onLine)) {
                Austin.logger.info('No Internet');
                Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, e.reason + 'InternetDown');
                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_no_internet);
            }
            else {
                Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, e.reason + 'noHBT' /* box hbt was not detected*/);
                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sn_connect_failed);
            }
            PerformanceTimer.markEnd(PerformanceTimer.metrics.CONNECT);
            Austin.setAnalyticsConnectionData(e.data && e.data.connectionMode || '');
            Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CPS);
            error = Austin.errorWithSessionInfo(error);
            Austin.core.resetBoxDetails();
            Austin.logger.error('Failed to create box session : ' + JSON.stringify(error));
            Austin.analytics.sendStoredAnalytics().then(() => resolve(error));
        });
    }
    /**
     * This API starts playback from the Sling box for any requested content ie. live/recorded.
     * <br/>Promise is resolved if streaming starts else rejected to error object with possible reason as
     * <pre>
     *     1. notConnected
     *     2. invalidContentType
     *     3. missingPlayerContainerIdOrElement
     *     4. playerError
     *     5. unknownError
     * </pre>
     *
     * @param params - streaming parameters, playerContainerId must be passed with param object
     * <pre>
     * params = {
     *       playerContainer: object,   //player container html element (div element),
     *                                  //either playerContainer or playerContainerId should be passed
     *       playerContainerId: string, //player container html element id
     *       videoElement: object,      //optional video element, if passed, video get render on this video element
     *       bitmovinLicence: string,   //Bitmovin player licence
     *       contentType: string,       //'live' or 'dvr'
     *       dvr: {                     //required for dvr playback
     *         resuming: boolean,       //false for start over, true for resume
     *         programId: string,       //dvrId is recordingId
     *       }
     *       inputType: string  // optional 'channel_id' or 'service_id'
     *       inputId: string    // optional channel/service id based on input type
     *       takeOver: boolean  // optional boolean for forced takeOver
     * }
     *
     * Use case 1: For playing live channel, sample parameter looks like
     *      params = {
     *       playerContainer: '',   // a valid html div element
     *       bitmovinLicence: '',   // a valid Bitmovin licence key
     *       contentType: 'live'
     *      }
     *
     * Use case 2: For playing live channel with session take over (on getting error tooManyStreams), sample parameter looks like
     *      params = {
     *       playerContainer: '', // a valid html div element
     *       bitmovinLicence: '',   // a valid Bitmovin licence key
     *       contentType: 'live',
     *       takeOver: true
     *      }
     *
     * Use case 3: For playing DRV recording, sample parameter looks like
     *      params = {
     *       playerContainer: '',   // a valid html div element
     *       bitmovinLicence: '',   // a valid Bitmovin licence key
     *       contentType: 'dvr',
     *       dvr: {
     *         resuming: false,     // false for start over, true for resume
     *         programId: '',       // valid dvrId
     *       }
     *      }
     *
     * Use case 4: Live content change, sample parameter for AirTv box looks like
     *      params = {
     *       playerContainerId: '', // a valid html div element
     *       bitmovinLicence: '',   // a valid Bitmovin licence key
     *       contentType: 'live',
     *       inputType: 'channel_id', // channel id type
     *       inputId: ''              //  valid channel number. eg: 11.1
     *      }
     *
     * Use case 5: Live content change, sample parameter for Hopper Box looks like
     *      params = {
     *       playerContainerId: '', // a valid html div element
     *       bitmovinLicence: '',   // a valid Bitmovin licence key
     *       contentType: 'live',
     *       inputType: 'service_id', // service id type
     *       inputId: ''              // valid service number. eg: 1584896
     *      }
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static play(params) {
        Austin.logger.info('play called  params' + JSON.stringify(params, (name, val) => {
            return name === 'playerContainer' || name === 'videoElement' ? (val.tagName || undefined) : val;
        }));
        Austin.firstFrameRendered = false;
        let self = this;
        let requestedContentType = '';
        params = Object.assign({}, params);
        return new Promise((resolve, reject) => {
            Austin.logger.info('self.core.getEventsInactivityTime() ' + self.core.getEventsInactivityTime());
            if (AustinConfig.CPS.CONNECTION_RE_ESTABLISHMENT_TIME && (self.core.getEventsInactivityTime() >= AustinConfig.CPS.CONNECTION_RE_ESTABLISHMENT_TIME)) {
                if (Austin.core.isInActivityDetected()) {
                    Austin.logger.info('Already Attempting conn reEstablishment on longer inactivity');
                    Austin.debugInfo.push(new Date().toISOString() + 'ConReAttemptInProgress(' + Austin.core.getSessionId() + ')');
                    return;
                }
                Austin.logger.info('Attempting conn reEstablishment on longer inactivity');
                self.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'ConReAtmpt' /* Connection Re Attempt due to events inactivity */);
                Austin.debugInfo.push(new Date().toISOString() + 'ConReAttempt(' + Austin.core.getSessionId() + ')');
                Austin.core.setInActivityDetected(true);
                Austin.stopStreamingInternal(false).then(() => {
                    Austin.logger.info('Attempting conn reEstablishment param ' + JSON.stringify(params));
                    Austin.core.reset();
                    Austin.setStatus(AustinConstants.BOX.STATUS.CONNECTION_RE_ESTABLISHING);
                    params.webSessionId = Austin.connectionSessionId;
                    PerformanceTimer.markStart(PerformanceTimer.metrics.CONNECT);
                    Austin.core.connect(Austin.connectParams).then(() => {
                        Austin.core.setInActivityDetected(false);
                        Austin.logger.warn('Box connection re-established, updating analytics');
                        Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'ConReEstbshd(' + Austin.core.getSessionId() + ')' /* ConnectionReEstablished*/);
                        Austin.debugInfo.push(new Date().toISOString() + 'ConReEstablished(' + Austin.core.getSessionId() + ')');
                        PerformanceTimer.markEnd(PerformanceTimer.metrics.CONNECT);
                        Austin.setAnalyticsConnectionData(Austin.getConnectionMode());
                        Austin.play(params).then(() => {
                            resolve();
                        }).catch((error) => {
                            Austin.logger.warn('Austin.play failed after connection re-estabished');
                            reject(error);
                        });
                    }).catch((e) => {
                        Austin.debugInfo.push(new Date().toISOString() + 'ConReAttemptFailed');
                        Austin.logger.warn('Box connection re-establishing failed');
                        Austin.logConnectionFailure(e).then((error) => {
                            reject(error);
                        });
                    });
                });
                return;
            }
            if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STOPPING_STREAMING) {
                Austin.logger.warn('Box stop stream action is not completed');
                let stopStreamWaitHandler = () => {
                    if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STOPPING_STREAMING) {
                        params['stopStreamWaitCounter'] = params['stopStreamWaitCounter'] + 1;
                        if (params['stopStreamWaitCounter'] === (AustinConfig.CPS.STOP_STREAM_WAIT_TIMEOUT_MAX_MS / AustinConfig.CPS.STOP_STREAM_WAIT_TIMEOUT_MIN_MS)) {
                            reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NOT_ALLOWED, info: { api: 'play' } }));
                        }
                        else {
                            Austin.logger.info('Waiting for stopping_streaming to complete');
                            setTimeout(stopStreamWaitHandler, AustinConfig.CPS.STOP_STREAM_WAIT_TIMEOUT_MIN_MS);
                        }
                    }
                    else {
                        Austin.logger.info('start_stream handled immediately after stopping_stream');
                        Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'playAftrStopStrmWait');
                        Austin.play(params).then(() => {
                            resolve();
                            Austin.debugInfo = [];
                        }).catch((err) => {
                            Austin.logger.warn('Austin.play failed after box was in connected state' + JSON.stringify(err));
                            reject(err);
                        });
                    }
                };
                if (!params['stopStreamWaitCounter']) {
                    params['stopStreamWaitCounter'] = 0;
                    Austin.logger.info('Waiting for stopping_streaming to complete');
                    setTimeout(stopStreamWaitHandler, AustinConfig.CPS.STOP_STREAM_WAIT_TIMEOUT_MIN_MS);
                }
                return;
            }
            if (!(params.contentType === AustinConstants.STREAMING.CONTENT_TYPE.LIVE || params.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR)) {
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.INVALID_CONTENT_TYPE }));
                return;
            }
            if (Austin.core.isHddConnected()) {
                if (params.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR) {
                    requestedContentType = params.dvr.dvrDetails.inProgress ?
                        AustinConstants.STREAMING.CONTENT_TYPE.DVR_IN_PROGRESS : AustinConstants.STREAMING.CONTENT_TYPE.DVR_RECORDED;
                    params.dvr = {
                        dvr_id: params.dvr.programId,
                        start_over: !params.dvr.resuming,
                        autohop: params.dvr.dvrDetails.autohop
                    };
                }
                else {
                    requestedContentType = AustinConstants.STREAMING.CONTENT_TYPE.LIVE_TIP;
                }
            }
            else {
                if (params.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR) {
                    // handling if client trying to play dvr without hdd
                    reject(Austin.errorWithSessionInfo({ reason: AustinErrors.HDD_NOT_CONNECTED }));
                    return;
                }
                else {
                    requestedContentType = AustinConstants.STREAMING.CONTENT_TYPE.LIVE;
                }
            }
            // if streaming call changeContent else start_streaming
            if ((self.libInfo.status === AustinConstants.BOX.STATUS.STREAMING) ||
                (self.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING) ||
                (self.libInfo.status === AustinConstants.BOX.STATUS.NO_VIDEO_SIGNAL)) {
                Austin.segmentManager.setTransition(true);
                Austin.changeContent(params).then((data) => {
                    Austin.logger.info('Content change success : ' + JSON.stringify(data));
                    Austin.userTriggeredDiscontinuityWaiting = true;
                    Austin.debugInfo = [];
                    resolve();
                }).catch((error) => {
                    Austin.logger.error('Content change error : ' + JSON.stringify(error));
                    reject(Austin.errorWithSessionInfo(error));
                });
            }
            else {
                const connectionAttemptedAt = new Date();
                const playerContainer = params[AustinConstants.PLAYER.CONTAINER];
                if (!playerContainer) {
                    reject(Austin.errorWithSessionInfo({ reason: AustinErrors.MISSING_PLAYER_CONTAINER_ID_OR_ELEMENT }));
                    return;
                }
                if (Austin.isConnected()) {
                    Austin.stallEndCount = 0;
                    Austin.stallStartCount = 0;
                    Austin.trickFlushCount = 0;
                    Austin.sessionDuration = 0;
                    Austin.androidPauseAtEndOfDVR = false;
                    Austin.androidBufferLevelAtPauseFired = 0;
                    Austin.discontinuityCount = 0;
                    Austin.playerMetadataEventCount = 0;
                    Austin.inBufferSeekDuration = 0;
                    Austin.androidBackwardBuffer = 0;
                    Austin.fireBoxSeekinPaused = false;
                    PerformanceTimer.markStart(PerformanceTimer.metrics.STREAM_START);
                    Austin.setStatus(AustinConstants.BOX.STATUS.STARTING_STREAMING);
                    Austin.playerInstanceId = AustinUtils.generateUniqueId(); //Unique for each startStreaming request
                    Austin.analytics.setAnalyticProperty(AnalyticsHelperConstants.playerInstanceId, Austin.playerInstanceId);
                    params.playerInstanceId = Austin.playerInstanceId;
                    params[AustinConstants.QUALITY_LEVELS.QUALITY] = Austin.qualityLevel ? Austin.qualityLevel : AustinConstants.QUALITY_LEVELS.AUTO;
                    let boxInfo = self.core.getBoxInfo();
                    if (!params.takeOver) {
                        let storageFinderId = AustinUtils.getLocalStorageItem('finderId');
                        let storageStartStream = Number(AustinUtils.getLocalStorageItem('startStreamReq'));
                        let curTime = new Date().getTime();
                        let updateTime = Number(AustinUtils.getLocalStorageItem('timeUpdate'));
                        Austin.logger.info('self-conflict checking  start_stream curTime: ' + curTime + ' updateTime: ' + updateTime + ' storageStartStream : ' + storageStartStream);
                        if (storageFinderId && storageStartStream && boxInfo.finderId === storageFinderId &&
                            ((curTime - updateTime) < AustinConfig.CPS.START_STREAM_FORCE_SELF_CONFLICT_TIMEOUT_MS) ||
                            (curTime - storageStartStream) < AustinConfig.CPS.START_STREAM_FORCE_SELF_CONFLICT_TIMEOUT_MS) {
                            Austin.logger.info('self-conflict forecing start_stream curTime: ' + curTime + ' updateTime: ' + updateTime + ' storageStartStream : ' + storageStartStream);
                            params['takeOver'] = true;
                        }
                    }
                    Austin.core.initDashOrHls(params).then((data) => {
                        AustinUtils.setLocalStorageItem('finderId', boxInfo.finderId);
                        AustinUtils.setLocalStorageItem('startStreamReq', new Date().getTime());
                        Austin.logger.info('Austin streaming url : ' + data.url);
                        Austin.handlingDiscontinuity = false;
                        Austin.playbackTime = 0;
                        //Austin.contentType = requestedContentType;
                        Austin.streamingData = Austin.core.getStreamingStartsAnalytics();
                        Austin.streamingData[AnalyticsHelperConstants.localStartTime] = connectionAttemptedAt;
                        params.url = data.url;
                        if (data.drmLicenceUrl) {
                            if (params[AustinConstants.STREAMING.FORCE_HLS]) {
                                params[AustinConstants.STREAMING.DRM_LA_URL] = data.drmLicenceUrl.fairplay;
                                params[AustinConstants.STREAMING.DRM_MODE] = AustinConstants.STREAMING.DRM_MODE_FAIRPLAY;
                            }
                            else {
                                params[AustinConstants.STREAMING.DRM_MODE] = AustinConstants.STREAMING.DRM_MODE_WIDEVINE;
                                params[AustinConstants.STREAMING.DRM_LA_URL] = data.drmLicenceUrl.widevine;
                            }
                        }
                        self.startHtml5StreamingPlayer(params).then(() => {
                            resolve();
                            Austin.debugInfo = [];
                        }).catch((error) => {
                            Austin.logger.error('Failed to load and start web player' + JSON.stringify(error, Object.getOwnPropertyNames(error)));
                            //For failure status will remain STARTING_STREAMING,
                            //Even if calling stopStream in transition, flow may come here
                            //but ignore those as those are handled as part of stopStream
                            if (self.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING) {
                                Austin.streamStartAnalyticsHandler(false);
                                Austin.core.resetStreamCounter();
                                Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.client_crashed);
                                Austin.stopStreamingInternal(true).then(() => {
                                    Austin.logger.info('Internal stopStreaming resolved after player error');
                                    reject(Austin.errorWithSessionInfo(error));
                                });
                            }
                        });
                    }).catch((e) => {
                        Austin.logger.warn('play failed reason:' + JSON.stringify(e));
                        // If Disconnect/stopStream requested while in starting streaming,
                        // analytics is handled in calling place itself
                        if (AustinConstants.BOX.STATUS.DISCONNECTING === self.libInfo.status ||
                            AustinConstants.BOX.STATUS.DISCONNECTED === self.libInfo.status || e.reason === AustinErrors.STREAM_STOP_REQUESTED) {
                            e.reason = AustinErrors.STREAM_STOP_REQUESTED;
                            PerformanceTimer.markEnd(PerformanceTimer.metrics.STREAM_START);
                            reject(Austin.errorWithSessionInfo(e));
                        }
                        else {
                            if (e.reason === AustinErrors.TOO_MANY_STREAMS) {
                                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_conflict_cancelled);
                                Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.stb_all_session_active);
                            }
                            else {
                                let internetStatus = Austin.analytics.getAnalyticProperty(AnalyticsHelperConstants.clientInternetStatus);
                                if (e.reason === AustinErrors.LEGACY_BOX_HTML5_DASH_UNSUPPORTED) {
                                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_unsupported_firmware);
                                }
                                else if ((e.reason === AustinErrors.START_STREAM_REQUEST_TIMEOUT && internetStatus === 'Down')
                                    && (!Austin.player.isInternetReachable() || !navigator.onLine)) {
                                    Austin.logger.info('No Internet');
                                    Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, e.reason + 'InternetDown');
                                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_no_internet);
                                }
                                else {
                                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_play_failed);
                                }
                                Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.stb_unknown_reason);
                            }
                            Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, e.reason || e.message || JSON.stringify(e));
                            // Even if streaming fails logging connectionAttemptedAt
                            Austin.streamingData = Austin.core.getStreamingStartsAnalytics();
                            Austin.streamingData[AnalyticsHelperConstants.localStartTime] = connectionAttemptedAt;
                            Austin.setAnalyticsStreamingData(false);
                            Austin.stopStreamingInternal(false).then(() => {
                                Austin.logger.info('internal stopStreaming resolved after box start_stream failed');
                                PerformanceTimer.markEnd(PerformanceTimer.metrics.STREAM_START);
                                reject(Austin.errorWithSessionInfo(e));
                            });
                        }
                    });
                }
                else {
                    let error = {
                        reason: AustinErrors.NOT_CONNECTED,
                        info: {
                            api: 'play',
                            message: status
                        }
                    };
                    Austin.logger.error('play error :' + JSON.stringify(error));
                    reject(Austin.errorWithSessionInfo(error));
                }
            }
        });
    }
    /**
     * Tries to disconnect current Box session if available and reset all session attributes.
     * Ongoing streaming will be stopped on calling this API.
     * <br/>Promise resolved for successful disconnect or rejected to error object with reason as
     * <pre>
     *  1. notConnected
     *  2. notAllowed
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static disconnect() {
        Austin.logger.info('disconnect called');
        let self = this;
        return new Promise((resolve, reject) => {
            let currentStatus = Austin.libInfo.status;
            if (AustinConstants.BOX.STATUS.CONNECTING === currentStatus ||
                AustinConstants.BOX.STATUS.DISCONNECTING === currentStatus) {
                Austin.logger.error(AustinErrors.NOT_ALLOWED);
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NOT_ALLOWED, info: { api: 'disconnect' } }));
            }
            else if (AustinConstants.BOX.STATUS.DISCONNECTED === currentStatus) {
                Austin.logger.error(AustinErrors.NOT_CONNECTED);
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NOT_CONNECTED, info: { api: 'disconnect' } }));
            }
            else {
                Austin.setStatus(AustinConstants.BOX.STATUS.DISCONNECTING);
                if (AustinConstants.BOX.STATUS.STARTING_STREAMING === currentStatus ||
                    AustinConstants.BOX.STATUS.STREAMING === currentStatus) {
                    // Handling aborting playback
                    if (AustinConstants.BOX.STATUS.STARTING_STREAMING === currentStatus) {
                        Austin.streamStartAnalyticsHandler(false, true);
                    }
                    Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.user_disconnect);
                    self.stopStreamingInternal(true).then(() => {
                        Austin.logger.info('Internal stopStreaming resolved. Now can safely disconnect');
                        Austin.core.disconnect().then(() => {
                            Austin.reset();
                            resolve();
                        });
                    });
                }
                else {
                    Austin.core.disconnect().then(() => {
                        Austin.reset();
                        resolve();
                    });
                }
            }
            Austin.logger.info('connect time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.CONNECT));
            Austin.logger.info('sparcsLookup time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.SPARCS_LOOKUP));
            Austin.logger.info('LAN attempt time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.LAN_CONNECTION));
            Austin.logger.info('TCP attempt time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.TCP_CONNECTION));
            Austin.logger.info('Relay attempt time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.RELAY_CONNECTION));
            Austin.logger.info('RI create time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.RI_CREATION));
            Austin.logger.info('1st Playback total time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.STREAM_START));
            Austin.logger.info('Box play time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.BOX_PLAY));
            Austin.logger.info('Box ready time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.BOX_READY));
            Austin.logger.info('Player play time: ' + PerformanceTimer.getTime(PerformanceTimer.metrics.PLAYER_PLAY));
            PerformanceTimer.clearMeasures();
        });
    }
    /**
     * Tries to join one of the active Tuner
     * <br/>Promise resolved for successful disconnect or rejected to error object with reason as
     * <pre>
     *  1. notConnected
     *  2. notAllowed
     * </pre>
     *
     * <pre>
     * params = {
     *             index: integer,      // Tuner index as in landing page data
     *             service_id: integer, // Service id for the tuner
     *             connect_id: integer  // Connect id for the tuner
     *          }
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static joinTuner(params) {
        Austin.logger.debug('join called');
        return new Promise((resolve, reject) => {
            let currentStatus = Austin.libInfo.status;
            if (AustinConstants.BOX.STATUS.CONNECTING === currentStatus ||
                AustinConstants.BOX.STATUS.DISCONNECTING === currentStatus) {
                Austin.logger.error(AustinErrors.NOT_ALLOWED);
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NOT_ALLOWED, info: { api: 'joinTuner' } }));
            }
            else if (AustinConstants.BOX.STATUS.DISCONNECTED === currentStatus) {
                Austin.logger.error(AustinErrors.NOT_CONNECTED);
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NOT_CONNECTED, info: { api: 'joinTuner' } }));
            }
            else {
                resolve(Austin.core.joinTuner(params));
            }
        });
    }
    /**
     * Reset Austin fields after Box get disconnected
     * @hidden
     */
    static reset() {
        Austin.setStatus(AustinConstants.BOX.STATUS.DISCONNECTED);
        Austin.qualityLevel = '';
        Austin.bufferBarData = {};
        Austin.libInfo.playerType = null;
        Austin.libInfo.playerVersion = null;
    }
    /**
     * This API can be used for direct url playback
     * In ths case of Sling Box streaming, url is fetched through austin path
     * and fetched url is passed to Bitmovin player through this api
     *
     * @param params {any} player Container Id
     * @returns {Promise }
     * @hidden
     */
    static startHtml5StreamingPlayer(params) {
        //Depending on host Player will be initialized
        return new Promise((resolve, reject) => {
            Austin.initializePlayer(AustinConstants.PLAYER.BITMOVIN);
            if (!Austin.player) {
                reject({
                    reason: AustinErrors.PLAYER_ERROR,
                    info: AustinConstants.PLAYER.BITMOVIN + ' NOT FOUND'
                });
                return;
            }
            //default custom pipeline and licence pre fetch enabled
            let customPipeline = params[AustinConstants.PLAYER.CUSTOM_PIPELINE];
            if (typeof customPipeline !== 'undefined' && customPipeline === false) {
                params[AustinConstants.PLAYER.CUSTOM_PIPELINE] = false;
            }
            else {
                params[AustinConstants.PLAYER.CUSTOM_PIPELINE] = true;
            }
            let preFetchLicence = params[AustinConstants.STREAMING.PREFETCH_LICENCE];
            if ((typeof preFetchLicence !== 'undefined' && preFetchLicence === false) ||
                (AustinConstants.STREAMING.STREAMING_TYPE_HLS === Austin.core.getStreamingType())) {
                //For HLS we override application passed value and it will be always false
                params[AustinConstants.STREAMING.PREFETCH_LICENCE] = false;
            }
            else {
                params[AustinConstants.STREAMING.PREFETCH_LICENCE] = true;
            }
            if (params[AustinConstants.STREAMING.FORCE_HLS]) {
                params.streamingType = AustinConstants.STREAMING.STREAMING_TYPE_HLS;
                if (params[AustinConstants.STREAMING.HLS_MODE] === AustinConstants.STREAMING.HTML5) {
                    params[AustinConstants.STREAMING.HLS_MODE] = AustinConstants.STREAMING.HTML5;
                }
                else {
                    params[AustinConstants.STREAMING.HLS_MODE] = AustinConstants.STREAMING.HLS_NATIVE;
                }
            }
            else {
                params.streamingType = AustinConstants.STREAMING.STREAMING_TYPE_DASH;
            }
            params.firstFrameReason = AustinConstants.STREAMING.FIRST_FRAME.STREAM_START;
            if (AustinConfig.ENABLE_LOGGING) {
                params[AustinConstants.LOG] = true;
                params[AustinConstants.LOG_LEVEL] = AustinConfig.LOGGING_LEVEL;
            }
            if (!params[AustinConstants.PLAYER.BITMOVIN_LICENCE]) {
                params[AustinConstants.PLAYER.BITMOVIN_LICENCE] = AustinConfig.PLAYER.BITMOVIN.LICENCE_KEY;
            }
            if (!params[AustinConstants.PLAYER.FPS_CERTIFICATE]) {
                params[AustinConstants.PLAYER.FPS_CERTIFICATE] = AustinConfig.PLAYER.FPS_CERTIFICATE;
            }
            let connectionMode = Austin.core.getConnectionMode();
            if (!connectionMode) {
                connectionMode = 'LAN';
                params['rebufferingThreshold'] = AustinConfig.PLAYER.BITMOVIN['REBUFFERING_THRESHOLD'] || 1;
                let reBufferingThreshold = AustinUtils.getQueryValueForKey('rebufferingThreshold');
                if (reBufferingThreshold) {
                    params['rebufferingThreshold'] = reBufferingThreshold;
                }
            }
            if (!params[AustinConstants.PLAYER.MAX_BUFFER_LEVEL]) {
                if (connectionMode) {
                    params[AustinConstants.PLAYER.MAX_BUFFER_LEVEL] = AustinConfig.STREAMING[connectionMode].MAX_BUFFER_LEVEL_MS / 1000;
                }
            }
            if (!params[AustinConstants.QUERY_PARAM.BUFFERING_TO_START]) {
                params[AustinConstants.QUERY_PARAM.BUFFERING_TO_START] = AustinConfig.PLAYER.BITMOVIN.BUFFERING_TO_START_PLAYBACK_MS;
            }
            if (!params[AustinConstants.QUERY_PARAM.PIPELINE_COUNT] && !params[AustinConstants.PLAYER.CUSTOM_PIPELINE]) {
                params[AustinConstants.QUERY_PARAM.PIPELINE_COUNT] = AustinConfig.PLAYER.BITMOVIN.PIPELINE_REQUEST_COUNT;
            }
            /* if streaming from STB */
            if (Austin.core.getSessionId() !== '') {
                let useNetworkIntercceptor = true;
                Austin.unloadLoadOnDiscontinuity = false;
                params['rebufferingThreshold'] = AustinConfig.PLAYER.BITMOVIN['REBUFFERING_THRESHOLD'] * 7;
                let reBufferingThreshold = AustinUtils.getQueryValueForKey('rebufferingThreshold');
                if (reBufferingThreshold) {
                    params['rebufferingThreshold'] = reBufferingThreshold;
                }
                if (params.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
                    params[AustinConstants.STREAMING.SEGMENT_DURATION] = AustinConfig.STREAMING[connectionMode].HLS_SEGMENT_DURATION_MS / 1000;
                }
                else {
                    params[AustinConstants.STREAMING.SEGMENT_DURATION] = AustinUtils.getDashSegmentDuration(connectionMode);
                }
                if (AustinUtils.isAndroid() || AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) {
                    useNetworkIntercceptor = false;
                    if (AustinConfig.PLAYER.BITMOVIN.UNLOAD_LOAD_ON_DISCONTINUITY) {
                        Austin.unloadLoadOnDiscontinuity = true;
                    }
                }
                else {
                    if (params.streamingType === AustinConstants.STREAMING.STREAMING_TYPE_HLS) {
                        Austin.unloadLoadOnDiscontinuity = true;
                        useNetworkIntercceptor = false;
                    }
                }
                if (useNetworkIntercceptor && params[AustinConstants.PLAYER.CUSTOM_PIPELINE]) {
                    params.playerNetworkInterceptor = Austin.segmentManager.getNetworkConfig(params);
                    Austin.logger.info('Starting pipeline ');
                    Austin.logSegmentInfo = true;
                    Austin.segmentsInfo = [];
                    Austin.segmentManager.startPipeline(params);
                }
            }
            if (this.getConnectionMode() !== AustinConstants.BOX.CONNECTION_MODE_LAN || AustinUtils.isDeviceChromeCast()) {
                params[AustinConstants.PLAYER.PLAYBACK_TIMEOUT] = AustinConfig.PLAYER.BITMOVIN.PLAYBACK_TIMEOUT_MS * 1.5;
            }
            else {
                params[AustinConstants.PLAYER.PLAYBACK_TIMEOUT] = AustinConfig.PLAYER.BITMOVIN.PLAYBACK_TIMEOUT_MS;
            }
            PerformanceTimer.markStart(PerformanceTimer.metrics.PLAYER_PLAY);
            Austin.playerError = false;
            Austin.pendingSegmentsRequests = 0;
            params.austin = Austin;
            params['connectionMode'] = Austin.getConnectionMode();
            let playerLoadFailed = 0;
            function playbackHandler() {
                Austin.player.playUrl(params).then(() => {
                    Austin.logger.info('Html5 player started');
                    resolve();
                }).catch((error) => {
                    playerLoadFailed++;
                    if (error.code === AustinErrors.BITMOVIN_LOAD_FAILED.code && playerLoadFailed < AustinConfig.PLAYER.BITMOVIN.LOAD_RETRY_COUNT) {
                        Austin.logger.log('Retrying player load : ');
                        setTimeout(playbackHandler, 0);
                    }
                    else {
                        const errorString = typeof error === 'string' ? error : error.message ? error.message : JSON.stringify(error);
                        Austin.logger.error('Html5 player starting failed : ' + errorString);
                        Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_setup_failed);
                        Austin.analytics.setAnalyticProperty(AnalyticsHelperConstants.errorCode, AustinErrors.PLAYER_ERROR);
                        Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, errorString);
                        reject({
                            reason: AustinErrors.PLAYER_ERROR,
                            info: error
                        });
                    }
                });
            }
            playbackHandler();
        });
    }
    /**
     * Stops the streaming from Sling Box.
     * <br/>Promise resolved for successful stopStreaming
     * or rejected to error object with reason as
     * <pre>
     *     1. noStreamingFound
     * </pre>
     *
     * @returns {Promise<void|IAustinError> }
     */
    static stopStreaming() {
        Austin.logger.info('stopStreaming called status ' + Austin.libInfo.status);
        let self = this;
        return new Promise((resolve, reject) => {
            let currentStatus = Austin.libInfo.status;
            if ((AustinConstants.BOX.STATUS.STREAMING === currentStatus) ||
                (AustinConstants.BOX.STATUS.STARTING_STREAMING === currentStatus)) {
                Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.user_disconnect);
                Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'UsrAbort' /* Normal user abort */);
                // Handling aborting playback
                if (AustinConstants.BOX.STATUS.STARTING_STREAMING === currentStatus) {
                    Austin.core.setStopStreamRequested();
                    let playerInstanceId = Austin.analytics.getAnalyticProperty(AnalyticsHelperConstants.playerInstanceId);
                    if (playerInstanceId) {
                        Austin.streamStartAnalyticsHandler(false, true);
                    }
                    else {
                        Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'NoLogdUsrAbort' /* Normal user abort */);
                    }
                }
                self.stopStreamingInternal(true).then(() => {
                    resolve();
                });
            }
            else {
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NOT_STREAMING }));
            }
        });
    }
    static resetLocalStorageEntriesOfSelfConflict() {
        AustinUtils.setLocalStorageItem('timeUpdate', 0);
        AustinUtils.setLocalStorageItem('startStreamReq', 0);
    }
    static stopStreamingInternal(stopBoxStream) {
        Austin.logger.info('stopStreamingInternal called');
        let self = this;
        return new Promise((resolve) => {
            // Collecting session average and closing info for analytics
            let streamingSessionInfo = Object.create(null);
            const stoppedAt = new Date();
            const stoppingResolution = self.libInfo.streamInfo.width + 'x' + self.libInfo.streamInfo.height;
            const kbStreamed = Austin.player ? parseFloat(((Austin.player.getDownloadedSize() / 1024).toFixed(2))) : 0;
            const stoppingBitrate = self.libInfo.streamInfo.bitrate;
            Austin.logger.info('Stall(S:' + Austin.stallStartCount + ':E:' + Austin.stallEndCount + ':T:' + Austin.trickFlushCount + ')');
            Austin.logger.info('Buffering Count is ' + Austin.bufferingCount + ' and Buffering Duration is ' + parseFloat(Austin.bufferingDuration.toFixed(3)));
            Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'Stall(S:' + Austin.stallStartCount + ':E:' + Austin.stallEndCount + ':T:' + Austin.trickFlushCount + ')');
            streamingSessionInfo[AnalyticsHelperConstants.localEndTime] = stoppedAt;
            streamingSessionInfo[AnalyticsHelperConstants.bitrateAtQuit] = stoppingBitrate;
            streamingSessionInfo[AnalyticsHelperConstants.resolutionAtQuit] = stoppingResolution;
            streamingSessionInfo[AnalyticsHelperConstants.totalKbStreamed] = kbStreamed;
            streamingSessionInfo[AnalyticsHelperConstants.avgBitrate] = Austin.getAverageBitrate();
            streamingSessionInfo[AnalyticsHelperConstants.bufferingCount] = Austin.bufferingCount;
            streamingSessionInfo[AnalyticsHelperConstants.bufferingDuration] = parseFloat(Austin.bufferingDuration.toFixed(3));
            self.analytics.setStreamingSessionData(streamingSessionInfo);
            Austin.sessionDuration = self.analytics.getAnalyticProperty(AnalyticsHelperConstants.sessionLength);
            let params = (Austin.isContentDVR() && Austin.player && Austin.player.getCurrentPTS()) ? { 'last_played_pts': Austin.player.getCurrentPTS() } : null;
            self.stopHtml5StreamingPlayer().then(() => {
                //Stopping streaming, core stopStreaming is always resolved
                if (stopBoxStream) {
                    Austin.setStatus(AustinConstants.BOX.STATUS.STOPPING_STREAMING);
                    Austin.core.stopStreaming(params).then((data) => {
                        Austin.logger.info('core stopStreaming success');
                        if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STOPPING_STREAMING) {
                            //To handle if user calls disconnect in stopping streaming and box disconnect response comes first
                            //So, ignoring if library is in disconnected/disconnecting by the time stopStreaming response come
                            Austin.setStatus(AustinConstants.BOX.STATUS.CONNECTED);
                        }
                        if (data && data === 'success') {
                            Austin.resetLocalStorageEntriesOfSelfConflict();
                        }
                        Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CONNECTION);
                        //Note : Austin should not block API in happy path which may lead to delay in application handling like iframe closing
                        //So either we participate in race condition with risk of losing analytics or send in next session
                        resolve();
                    });
                }
                else {
                    if (Austin.core.isInActivityDetected()) {
                        Austin.logger.info('Not setting connected  state due inactivity');
                        Austin.debugInfo.push(new Date().toISOString() + 'InActivityDetected(' + Austin.core.getSessionId() + ')');
                        Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'InActivityDetected(' + Austin.core.getSessionId() + ')');
                        Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.connection_lost);
                    }
                    else {
                        Austin.setStatus(AustinConstants.BOX.STATUS.CONNECTED);
                    }
                    Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CONNECTION);
                    Austin.analytics.sendStoredAnalytics().then(() => {
                        resolve();
                    });
                }
            });
        });
    }
    /**
     * Stop the underlying player streaming playback and reset all related fields
     * @hidden
     */
    static stopHtml5StreamingPlayer() {
        return new Promise((resolve) => {
            if (!Austin.player) {
                resolve();
                return;
            }
            Austin.segmentManager.flushSegmentsStore();
            Austin.player.destroy().then(() => {
                Austin.player = null;
                Austin.poster = null;
                Austin.seekPos = null;
                Austin.firstFrameRenderedTime = 0;
                Austin.seekTime = 0;
                Austin.androidBackwardBuffer = 0;
                Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.NONE;
                Austin.duration = 0;
                Austin.playbackTime = 0;
                Austin.playbackPaused = false;
                Austin.playerError = false;
                Austin.waitingForPause = false;
                Austin.waitingForResume = false;
                Austin.segmentManager.setPipelineResumingStatus(false);
                AustinUtils.setCookie(AustinConstants.AUSTIN_CC_COOKIE, Austin.cc);
                Austin.bufferingCount = 0;
                Austin.bufferingDuration = 0;
                Austin.bufferingStartTime = 0;
                resolve();
            });
        });
    }
    /**
     * Handles user action after clicking any of button of box pop-up like dvr-end,
     * Input param is button info of user clicked button as given in box popUp events
     * <pre>
     *    userActions: {
     *      buttonInfo: {
     *          text: string,      //string: button text
     *          url: string,       //string: url associated with button
     *           payload: string    //string: payload associated with button
     *      },
     *      inputInfo: {
     *          value: string,          // input value entered by user
     *          type: input type,       // text/ password/ number
     *          placeholder': string    // text to be replaced with value
     *      }
     *     }
     * </pre>
     * <br/>Promise resolved for successful popUpUserAction
     * or rejected to error object with reason as
     * <pre>
     *     1. apiFailed
     * </pre>
     *
     *
     * @returns {Promise<void|IAustinError> }
     */
    static popUpUserAction(userActions) {
        Austin.logger.info('popUpUserAction called');
        return new Promise((resolve, reject) => {
            let userInput = userActions.inputInfo;
            if (userInput) {
                if (userInput.value) {
                    userActions.buttonInfo.payload = userActions.buttonInfo.payload.replace(':_' + userInput.placeholder, userInput.value);
                }
                else {
                    reject({ reason: AustinErrors.INVALID_PARAMS });
                    return;
                }
            }
            Austin.core.popUpUserAction(userActions.buttonInfo)
                .then(() => {
                Austin.logger.info('popUpUserAction handled successfully');
                resolve();
            }).catch((error) => {
                const warning = 'Internally stopping Streaming after popUpUserAction failure';
                Austin.logger.warn(warning);
                Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, warning);
                Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.popup_user_action_handling_failed);
                Austin.stopStreamingInternal(true).then(() => {
                    reject(Austin.errorWithSessionInfo({
                        reason: AustinErrors.API_FAILED,
                        info: error
                    }));
                });
            });
        });
    }
    /**
     * Returns true if session has been established with Box
     * @returns {boolean}
     */
    static isConnected() {
        return !!(Austin.core ? Austin.core.getSessionId() : false);
    }
    /**
     * Returns true if Box is in streaming state.
     * @returns {boolean}
     */
    static isStreaming() {
        return !Austin.playerError && ((Austin.libInfo.status === AustinConstants.BOX.STATUS.STREAMING)
            || (Austin.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING)
            || (Austin.libInfo.status === AustinConstants.BOX.STATUS.CONNECTION_RE_ESTABLISHING)
            || (Austin.libInfo.status === AustinConstants.BOX.STATUS.STOPPING_STREAMING));
    }
    /**
     * Returns the Austin lib status string
     * <pre>
     * returned status string will be any of the following,
     *  1. disconnected      - Austin is in disconnected state with Box
     *  2. connecting        - Austin is in trying to connect with Box
     *  3. connected         - Austin is in connected state with Box
     *  4. startingStreaming - Austin is starting streaming with Box
     *  5. stoppingStreaming - Austin is stopping streaming with Box
     *  6. streaming         - Austin is in streaming state with Box
     *  7. noVideoSignal     - Austin has revived No Video Signal from the Box
     *  8. tooManyStreams    - Max. concurrent streaming supported limit reached on Box
     *  9. streamLost        - Ongoing streaming is lost with Box.
     * </pre>
     * @returns {string}
     */
    static getStatus() {
        return this.libInfo.status;
    }
    /**
     * Get Austin library version
     *
     * @returns {string}
     */
    static getVersion() {
        return this.libInfo.version;
    }
    /**
     * Get player reference which can be used to listen to player events.
     *
     * @returns {any}
     */
    static getAustinPlayer() {
        return this.player && this.player.getPlayer(); // this.player is Austin player wrapper
    }
    /**
     * Get streaming info like Bitrate, Width, Height
     * <pre>
     * A sample returned json object is,
     *   {
     *      width: 1280,
     *      height: 720,
     *      bitrate: 3532,
     *      framerate: 30,
     *    }
     * </pre>
     * @returns {Object}
     */
    static getStreamInfo() {
        let connectionMode = Austin.core.getConnectionMode();
        let streamUrl = (Austin.player && Austin.player.params.url) ? Austin.player.params.url : '';
        return {
            width: Austin.libInfo.streamInfo.width,
            height: Austin.libInfo.streamInfo.height,
            bitrate: Austin.libInfo.streamInfo.bitrate,
            framerate: Austin.libInfo.streamInfo.framerate,
            connectionMode: connectionMode + (Austin.core.getStreamingOverRelayProxy() ? '-PROXY' : ''),
            relayIp: connectionMode === 'RELAY' ? Austin.core.getRelayInfo()['ip'] : '',
            lanOrWan: connectionMode && (connectionMode === 'LAN' ? 'lan' : 'wan') || '',
            sessionId: Austin.core.getSessionId(),
            contentType: Austin.contentType,
            streamUrl: streamUrl
        };
    }
    /**
     * Get player details like type and version
     * <pre>
     * A sample returned json object is,
     *   {
     *      playerType: bitMovin,
     *      playerVersion: 7.7.3,
     *    }
     * </pre>
     * @returns {Object}
     */
    static getPlayerInfo() {
        return {
            playerType: this.libInfo.playerType,
            playerVersion: this.libInfo.playerVersion
        };
    }
    /**
     * Get dash segment duration
     * @returns {number}
     */
    static getDashSegmentDuration(connectionMode) {
        let dashSegDuration = (AustinUtils.isAndroid() && connectionMode === AustinConstants.BOX.CONNECTION_MODE_TCP) ? 2 : AustinConfig.STREAMING[connectionMode].DASH_SEGMENT_DURATION_MS / 1000;
        return dashSegDuration;
    }
    /**
     * Returns the Box connection mode
     * @returns {string}
     * @hidden
     */
    static getConnectionMode() {
        return Austin.core.getConnectionMode();
    }
    static isRelayProxyConnection() {
        return Austin.core.getStreamingOverRelayProxy();
    }
    /**
     * Returns the box details in JSON format
     * @returns  {Object}
     * @example
     *  <pre>
     *     <code>
     *      {
     *          boxPort: '',         // box port number
     *          finderId: '',        // box finder id (device id)
     *          firmwareVersion: '', // box firmware version
     *          hardwareVersion: '', // box hardware version
     *          lastSparcsRegistered: '', // last Sparcs Registered time
     *          productSignature: '',     // productSignature from box response data
     *          receiverId: '',           // receiverId of box
     *          sbProductSignature: '',   // productSignature from sparcs data
     *          sbLanIp: '',     // box LAN Ip address
     *          sbWanIp: '',     // box WAN Ip address
     *      }
     *    </code>
     *  </pre>
     */
    static getBoxDetails() {
        return JSON.parse(JSON.stringify(Austin.core.getBoxInfo()));
    }
    /**
     * Returns current contentType player is streaming
     * @returns {string}
     *
     * <pre>
     * Possible values are
     *    none                  // none
     *    live                  // LIVE without HDD
     *    liveTip               // LIVE with HDD available, user will remain at tip
     *    liveDelayed           // LIVE with HDD available
     *    dvrRecorded           // Completed DVR recordings
     *    dvrInProgress         // In-progress DVR recordings
     * </pre>
     */
    static getContentType() {
        return Austin.contentType;
    }
    /**
     * Returns the current playback time in milliseconds
     * @returns {any|number|void}
     */
    static getCurrentTime() {
        let playedTime = 0;
        if (Austin.player) {
            switch (Austin.contentType) {
                case AustinConstants.STREAMING.CONTENT_TYPE.LIVE_TIP:
                case AustinConstants.STREAMING.CONTENT_TYPE.LIVE_REC:
                case AustinConstants.STREAMING.CONTENT_TYPE.LIVE:
                    if (Austin.inBufferSeekDuration !== 0) {
                        playedTime = Austin.getDuration() + Austin.inBufferSeekDuration;
                        Austin.logger.warn('inbuffer seek duration on LIVE: ' + Austin.inBufferSeekDuration);
                        Austin.inBufferSeekDuration = 0;
                    }
                    else {
                        /* inBufferSeekDuration should always be a negative value for live */
                        playedTime = Austin.getDuration();
                    }
                    Austin.previousPlayedTime = playedTime;
                    Austin.playbackTime = playedTime;
                    Austin.logger.info('Austin.playbackTime : ' + Austin.playbackTime);
                    break;
                case AustinConstants.STREAMING.CONTENT_TYPE.LIVE_DELAYED:
                    if (Austin.previousPlayedTime > 0) {
                        Austin.playbackTime = Austin.previousPlayedTime;
                        Austin.previousPlayedTime = 0;
                    }
                    playedTime = Austin.playbackTime;
                    break;
                case AustinConstants.STREAMING.CONTENT_TYPE.DVR:
                case AustinConstants.STREAMING.CONTENT_TYPE.LIVE_DELAYED_REC:
                case AustinConstants.STREAMING.CONTENT_TYPE.DVR_RECORDED:
                case AustinConstants.STREAMING.CONTENT_TYPE.DVR_IN_PROGRESS:
                    playedTime = Austin.playbackTime;
                    Austin.logger.info('getCurrentTime   Austin.playbackTime; ' + Austin.playbackTime);
                    break;
            }
        }
        return playedTime;
    }
    /**
     * Returns the duration of the playing content in milliseconds
     * In case of live, returns zero
     * @returns {number}
     */
    static getDuration() {
        // Note: Doing duration as playbackTime for LIVE_TIP may lead to bug
        // as playbackTime may not be updated in stalled/paused state
        return Austin.player ? Austin.duration : 0;
    }
    /**
     * Returns the number of dropped frames until now.
     * @returns {number}
     */
    static getDroppedFrames() {
        return Austin.player ? Austin.player.getDroppedFrames() : 0;
    }
    /**
     * Returns current playback speed.
     * @returns {number}
     */
    static getPlaybackSpeed() {
        return Austin.player ? Austin.player.getPlaybackSpeed() : 0;
    }
    /**
     * Returns the seconds of already buffered audio data.
     * @returns {number}
     */
    static getAudioBufferLength() {
        let bufferLevel = 0;
        if (Austin.player) {
            bufferLevel = Austin.player.getAudioBufferLength();
        }
        return bufferLevel ? bufferLevel : 0;
    }
    /**
     * Returns the seconds of already buffered video data.
     * @returns {number}
     */
    static getVideoBufferLength() {
        let bufferLevel = 0;
        if (Austin.player) {
            bufferLevel = Austin.player.getVideoBufferLength();
        }
        return bufferLevel ? bufferLevel : 0;
    }
    /**
     * Returns the seconds audio segments data.
     * @returns {number}
     */
    static getAudioSegmentsBufferedLength() {
        let bufferLevel = 0;
        if (Austin.player && Austin.segmentManager) {
            bufferLevel = Austin.segmentManager.getAudioSegmentsLength();
        }
        return bufferLevel;
    }
    /**
     * Returns the seconds video segments data.
     * @returns {number}
     */
    static getVideoSegmentsBufferedLength() {
        let bufferLevel = 0;
        if (Austin.player && Austin.segmentManager) {
            bufferLevel = Austin.segmentManager.getVideoSegmentsLength();
        }
        return bufferLevel;
    }
    /**
     * Analytics helper method, to log data for SLINGNET_CPS table
     * Whenever attempt to start a streaming session is success/fails, this method is called
     * @param streamSuccess: boolean, true if 1st frame is rendered
     * @param userAborted : boolean, true if user called stopStreaming/disconnect before rendering of 1st frame
     * @hidden
     */
    static setAnalyticsStreamingData(streamSuccess, userAborted) {
        let outcome = AnalyticsHelperConstants.analytics_outcome.sp_render_start_failure;
        if (streamSuccess) {
            outcome = AnalyticsHelperConstants.analytics_outcome.sb_stream_playback_okay;
        }
        else {
            if (userAborted) {
                let timeTillPlay = parseFloat(Austin.streamingData[AnalyticsHelperConstants.timeTillPlay]);
                if (timeTillPlay > 10) {
                    outcome = AnalyticsHelperConstants.analytics_outcome.user_connect_abort_in_10_plus_sec;
                }
                else if (timeTillPlay > 5) {
                    outcome = AnalyticsHelperConstants.analytics_outcome.user_connect_abort_in_5_to_10_sec;
                }
                else {
                    outcome = AnalyticsHelperConstants.analytics_outcome.user_connect_abort_in_0_to_5_sec;
                }
            }
        }
        //For failure these two field should have no value
        if (!streamSuccess) {
            Austin.streamingData[AnalyticsHelperConstants.frameRenderSuccessAt] = null;
            Austin.streamingData[AnalyticsHelperConstants.resolutionAtStart] = null;
        }
        else {
            //For outcome 0, we need clientTimeStamp for dish_streams table in '2019-12-11T08:39:02.900Z' format
            Austin.streamingData.clientTimeStamp = new Date().toISOString();
        }
        Austin.analytics.setRequestedStreamingData(Austin.streamingData);
        Austin.analytics.setOutcome(outcome);
        Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CPS);
        Austin.analytics.sendStoredAnalytics().then(() => Austin.logger.info('sendStoredAnalytics completed'));
    }
    /**
     * Preserving all data of connection session
     * @hidden
     */
    static setAnalyticsConnectionData(connectionMode) {
        const boxInfo = Austin.core.getBoxInfo();
        const relayServerInfo = Austin.core.getRelayInfo();
        const sessionInfo = {
            connectionMode: connectionMode,
            boxSessionId: Austin.core.getSessionId(),
            webSessionId: Austin.connectionSessionId,
            timeTaken: PerformanceTimer.getTime(PerformanceTimer.metrics.CONNECT).pop(),
            usingStreamingProxy: Austin.core.getStreamingOverRelayProxy(),
            uuid: Austin.uuid,
            clientLocalIp: Austin.core.getClientLocalIp(),
            clientPublicIp: Austin.core.getClientPublicIp()
        };
        Austin.analytics.setAnalyticsCpsConnectionData(boxInfo, relayServerInfo, sessionInfo);
    }
    /**
     * Network Offline Handler
     * Fires Austin.EVENTS.onError on Network going offline
     * @hidden
     */
    static offlineHandle() {
        Austin.logger.info('Offline detected');
    }
    /**
     * Network Online Handler
     * Fires Austin.EVENTS.onError on Network going online
     * @hidden
     */
    static onlineHandle() {
        Austin.logger.info('Online detected');
    }
    /**
     * It updates the Box connection status and fire status change event
     * @param status
     * @hidden
     */
    static setStatus(status) {
        if (Austin.libInfo.status !== status) {
            Austin.libInfo.status = status;
            //raise the event to application from timeout context, to avoid blocking
            //of austin context by application, if application does lengthy operation
            //on event call back. If they do lengthy, our connect time etc will be more
            // because of application code execution time.
            setTimeout(() => {
                Austin.fire(Austin.EVENTS.onStatusChange, status);
            }, 0);
        }
    }
    static boxConnectionLostHandler(data) {
        Austin.logger.warn('Disconnecting internally after continuous events failure');
        if (Austin.isStreaming()) {
            //For streaming SLINGNET_CPS payload is formed at first frameRender itself
            if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING) {
                Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, 'strtingStrming');
                Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sb_connection_lost);
                Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CPS);
            }
            if (Austin.libInfo.status === AustinConstants.BOX.STATUS.CONNECTION_RE_ESTABLISHING) {
                Austin.logger.warn('Ignoring connection lost in ConLost in Con ReEstablishing ');
                Austin.debugInfo.push(new Date().toISOString() + 'conLostInConReEstablishing');
                return;
            }
            // disconnectMethod has been set in core
            Austin.stopStreamingInternal(false).then(() => {
                Austin.resetLocalStorageEntriesOfSelfConflict();
                Austin.reset();
                Austin.fire(Austin.EVENTS.onError, data);
            });
        }
        else {
            if (Austin.isConnected()) {
                Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CONNECTION);
                Austin.analytics.sendStoredAnalytics().then(() => {
                    Austin.reset();
                    Austin.fire(Austin.EVENTS.onError, data);
                });
            }
            else {
                //Box connection lost event should not come in  NOT-CONNECTED state
                Austin.logger.warn('Box connection lost came in not connected');
                data['extra'] = 'Box connection lost in not connected state';
                Austin.fire(Austin.EVENTS.onError, data);
            }
        }
    }
    static isDashOnWeb() {
        return AustinUtils.isWeb() && AustinConstants.STREAMING.STREAMING_TYPE_DASH === Austin.core.getStreamingType();
    }
    /**
     * Transfer popup info to client
     */
    static boxPopUpHandler(info) {
        Austin.fire(Austin.EVENTS.onPopUp, info);
    }
    static boxBufferBarHandler(data) {
        if (!Austin.player) {
            return;
        }
        Austin.duration = data.duration * 1000;
        Austin.bufferBarData = data;
        if (!Austin.isContentDVR() && Austin.playbackPaused && (AustinUtils.isAndroid() || AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) && Austin.duration < 3600000) {
            Austin.logger.info('Austin.duration update: ' + Austin.duration);
            setTimeout(() => {
                Austin.duration = Austin.duration + 1000;
            }, 1000);
            setTimeout(() => {
                Austin.duration = Austin.duration + 1000;
            }, 2000);
            setTimeout(() => {
                Austin.duration = Austin.duration + 1000;
            }, 3000);
        }
        if (data.contentType) {
            switch (data.contentType) {
                case 'LIVE':
                    Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.LIVE_TIP;
                    break;
                case 'LIVE_REC':
                    Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.LIVE_REC;
                    break;
                case 'LIVE_DELAYED':
                    Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.LIVE_DELAYED;
                    break;
                case 'LIVE_DELAYED_REC':
                    Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.LIVE_DELAYED_REC;
                    break;
                case 'DVR':
                    Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.DVR_RECORDED;
                    break;
                default:
                    Austin.logger.warn('Content type not handled : ' + data.contentType);
            }
        }
        //this is added to handle DVR end async popup coming much before
        //DVR END due to buffer build up on client side
        if (AustinUtils.isAndroid() && Austin.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR_RECORDED &&
            Austin.bufferBarData.remaining < AustinConfig.ANDROID_DVR_END_THRESHOLD_REM_TIME_FOR_FIRING_PAUSE) {
            let videoBuffer = Austin.getVideoBufferLength();
            if (videoBuffer >= AustinConfig.MIN_BUFFER_FOR_SEGMENT_PAUSE_AT_DVR_END && !Austin.androidPauseAtEndOfDVR) {
                Austin.logger.info('Setting forward buffer to 5 near EOD');
                Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.ANDROID_FORWARD_BUFFER_LEVEL_AT_PAUSE);
                Austin.logger.info('Android : Pausing from Austin');
                Austin.androidPauseAtEndOfDVR = true;
                Austin.waitingForPause = false;
                Austin.corePause();
            }
            else if (Austin.androidPauseAtEndOfDVR) {
                if (videoBuffer <= AustinConfig.ANDROID_MAX_BUFFER_BEFORE_RESUME_AT_DVR_END) {
                    Austin.logger.info('Android : Resuming from Austin');
                    Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER);
                    Austin.androidPauseAtEndOfDVR = false;
                    Austin.boxResume();
                }
            }
        }
        else if (Austin.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR_RECORDED &&
            Austin.bufferBarData.remaining < AustinConfig.DVR_END_THRESHOLD_REM_TIME_FOR_FIRING_PAUSE &&
            Austin.isDashOnWeb()) {
            let videoBuffer = Austin.getVideoBufferLength();
            let videoSegmentsBuffer = Austin.getVideoSegmentsBufferedLength();
            if (videoBuffer + videoSegmentsBuffer >= AustinConfig.MIN_BUFFER_FOR_SEGMENT_PAUSE_AT_DVR_END) {
                if (!Austin.segmentManager.isPaused()) {
                    Austin.logger.info('Pausing From Austin');
                    Austin.segmentManager.pause();
                    Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.ANDROID_FORWARD_BUFFER_LEVEL_AT_PAUSE);
                    if (Austin.segmentManager.getActiveRequestsCount()) {
                        Austin.waitingForPause = true;
                    }
                    else {
                        Austin.corePause();
                    }
                }
            }
            else if (Austin.segmentManager.isPaused()) {
                if (videoBuffer + videoSegmentsBuffer <= AustinConfig.MAX_BUFFER_BEFORE_SEGEMENT_RESUME_AT_DVR_END) {
                    Austin.logger.info('Resuming From Austin');
                    Austin.segmentManager.resume();
                    Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.BM_PLAYER_FORWARD_BUFFER);
                    Austin.boxResume();
                }
            }
        }
    }
    static updatePlaybackTime(metadata) {
        AustinUtils.setLocalStorageItem('timeUpdate', new Date().getTime());
        // Update playback time for 'live' || 'playing dvr'
        // If playbackTime is not increased for live, after one hour in paused state liveTip distance will not increase
        // because total duration remain constant as 3600 seconds
        let previousPlaybackTime = Austin.playbackTime;
        if (!Austin.isContentDVR() || (Austin.isContentDVR() && !Austin.player.isVideoElementPaused())) {
            if (Austin.bufferBarData.duration && Austin.bufferBarData.remaining) {
                //PlaybackTime should be always updated to at least this.
                Austin.playbackTime = (Austin.bufferBarData.duration - Austin.bufferBarData.remaining) * 1000;
                //Code Below is luxury, it is just for playbackTime correction on PTS diffs
                let currentRenderedPTS = parseInt(metadata.currentPTS, 16);
                if (currentRenderedPTS && Austin.bufferBarData.originalPts) {
                    let clientBoxDiff = Math.round((Austin.bufferBarData.originalPts - currentRenderedPTS) / Austin.core.getDeviceClockFrequencyInKHz());
                    //Ignoring wrong value during content transition/seek
                    if ((clientBoxDiff > 0) && (Austin.playbackTime > clientBoxDiff)) {
                        Austin.playbackTime = Austin.playbackTime - clientBoxDiff; //all time is in ms
                    }
                    else if (clientBoxDiff < 0) {
                        Austin.playbackTime = previousPlaybackTime;
                    }
                }
            }
        }
    }
    static isContentDVR() {
        return Austin.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR_RECORDED ||
            Austin.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR_IN_PROGRESS ||
            Austin.contentType === AustinConstants.STREAMING.CONTENT_TYPE.DVR;
    }
    static getMaxForwardBufLevelAtPause() {
        let maxBufferLevelAtPause;
        if (Austin.isContentDVR()) {
            // For Android Forward buffer level is 90. We should fire pause at 0.8 of Forward buffer level so as player has sufficient cushion
            // to accumulate buffer further whenever resume is called
            maxBufferLevelAtPause = 0.8 * AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER;
        }
        else {
            // For live we dont want to fall much behind the live edge therefore setting max buffer as 45 before pause is sent to box
            maxBufferLevelAtPause = AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER / 2;
        }
        return maxBufferLevelAtPause;
    }
    static boxVideoSignalHandler(data) {
        Austin.fire(Austin.EVENTS.onInfo, data);
    }
    static boxStreamLostHandler(data) {
        Austin.logger.warn('changing status to connected as streamLost event received');
        // disconnectMethod has been set in core
        Austin.stopStreamingInternal(false).then(() => {
            Austin.resetLocalStorageEntriesOfSelfConflict();
            Austin.fire(Austin.EVENTS.onError, data);
        });
    }
    static boxStreamStopHandler(data) {
        Austin.logger.warn('changing status to connected as streamStop event received');
        // disconnectMethod has been set in core
        Austin.stopStreamingInternal(false).then(() => {
            Austin.resetLocalStorageEntriesOfSelfConflict();
            Austin.fire(Austin.EVENTS.onError, data);
        });
    }
    static programInfoChangedHandler(data) {
        Austin.logger.info('Program Info Change Event Received');
        Austin.programInfo = null;
        Austin.getProgramInfo(true).then((data) => {
            Austin.contentType = data['content_type'];
            if (Austin.isContentDVR()) {
                Austin.player.setLiveContentType(false);
            }
            else {
                Austin.player.setLiveContentType(true);
            }
            if (AustinUtils.isAndroid() || AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) {
                Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER);
            }
            else if (AustinUtils.isIos()) {
                Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.IOS_BM_PLAYER_FORWARD_BUFFER);
            }
            else {
                Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.BM_PLAYER_FORWARD_BUFFER);
            }
            Austin.player.setBufferLevel(AustinConstants.PLAYER.BACKWARD_BUFFER_DURATION, AustinConfig.BM_PLAYER_BACKWARD_BUFFER);
        }).catch((reason) => {
            Austin.logger.warn('getProgramInfo failed : ' + JSON.stringify(reason));
        });
    }
    static boxConReEstablishedHandler(data) {
        Austin.logger.warn('Box connection re-established, updating analytics');
        Austin.setAnalyticsConnectionData(Austin.getConnectionMode());
    }
    static playerErrorHandler(errorMessage) {
        Austin.playerError = true;
        let sessionId = Austin.core.getSessionId();
        if (sessionId !== '') {
            //Todo: Need HTML5 specific analytics field to log this,
            // Now disconnect_method as client_crashed
            Austin.analytics.setAnalyticProperty(AnalyticsHelperConstants.errorCode, AustinErrors.PLAYER_ERROR);
            Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, errorMessage.message);
            if (errorMessage.code) {
                if (AustinErrors.EME_DRM_LICENCE_SET_MEDIAKEY_FAILED.code === errorMessage.code ||
                    AustinErrors.EME_DRM_LICENCE_GENERATE_REQUEST_FAILED.code === errorMessage.code ||
                    AustinErrors.EME_DRM_LICENCE_CONTENT_PROTECTION_MISSING_IN_MPD.code === errorMessage.code ||
                    AustinErrors.EME_DRM_LICENCE_FETCH_FAILED.code === errorMessage.code ||
                    AustinErrors.EME_DRM_LICENCE_FETCH_WV_PROXY_ACCESS_DENIED.code === errorMessage.code ||
                    AustinErrors.EME_DRM_LICENCE_UPDATE_FAILED.code === errorMessage.code) {
                    Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, errorMessage.info);
                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_licence_error);
                }
                else if (AustinErrors.PLAYBACK_DID_NOT_START.code === errorMessage.code) {
                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_playback_not_started);
                }
                else if (AustinErrors.PLAYBACK_DID_NOT_START_LAN_ACCESS_DENIED.code === errorMessage.code) {
                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_lan_access_denied);
                }
                else if (AustinErrors.PLAYBACK_DID_NOT_START_NO_INTERNET.code === errorMessage.code) {
                    Austin.logger.info('No Internet Case');
                    Austin.analytics.setOutcome(AnalyticsHelperConstants.analytics_outcome.sp_no_internet);
                }
            }
            let status = Austin.libInfo.status;
            if (status === AustinConstants.BOX.STATUS.STARTING_STREAMING) {
                Austin.core.resetStreamCounter();
                Austin.streamStartAnalyticsHandler(false);
            }
            else if (status === AustinConstants.BOX.STATUS.STREAMING) {
                let eventFailCount = Austin.core.getEventFailedCount();
                if (eventFailCount) {
                    Austin.logger.info('Player error occurred and event failure' + eventFailCount + ' occurred, raising box connection lost');
                    Austin.core.raiseConnectionLostEvent(sessionId);
                    return;
                }
            }
            Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.client_crashed);
            Austin.stopStreamingInternal(true).then(() => {
                Austin.logger.info('Internal stopStreaming resolved after player error');
                Austin.fire(Austin.EVENTS.onError, {
                    reason: status === AustinConstants.BOX.STATUS.STREAMING ? AustinErrors.PLAYER_ERROR_WHILE_STREAMING : AustinErrors.PLAYER_ERROR,
                    info: errorMessage
                });
            });
        }
        else {
            Austin.fire(Austin.EVENTS.onError, {
                reason: AustinErrors.PLAYER_ERROR,
                info: errorMessage
            });
        }
    }
    static playerWarningHandler(data) {
        Austin.logger.info('playerWarningHandler data.paused ' + data.paused);
        if (data.paused) {
            const warning = 'Player paused ' + data.message;
            Austin.logger.warn(warning);
            if (Austin.libInfo.status !== AustinConstants.BOX.STATUS.STREAMING) {
                Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, warning);
            }
            Austin.pauseInternal();
        }
        Austin.fire(Austin.EVENTS.onInfo, data);
    }
    static playerDownLoadFinishedHandler(data) {
        if (Austin.logSegmentInfo) {
            let segInfo = Austin.segmentManager.getSegmentInfo(data.url, data.downloadType);
            if (segInfo) {
                let url = segInfo['url'];
                let dlTime = segInfo['downloadTime'];
                Austin.logger.info('playerDownLoadFinishedHandler url ' + url + ' dldTime ' + dlTime);
                Austin.segmentsInfo.push({ url, dlTime });
            }
        }
        if (Austin.isDashOnWeb()) {
            let audioSegmentsBuffer = Austin.getAudioSegmentsBufferedLength();
            let videoSegmentsBuffer = Austin.getVideoSegmentsBufferedLength();
            let minBuff = (audioSegmentsBuffer < videoSegmentsBuffer ? audioSegmentsBuffer : videoSegmentsBuffer);
            if (Austin.player) {
                Austin.player.setSegmentBuffer(minBuff);
            }
        }
        Austin.segmentManager.deleteSegmentInfo(data.url, data.downloadType);
        if (AustinUtils.isAndroid() || AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) {
            if (data.httpStatus === Austin.segmentDownloadStatus.COMPLETED) {
                Austin.logger.info('segment download success');
                clearTimeout(Austin.androidPauseTimer);
                Austin.androidPauseTimer = null;
                Austin.downloadTimeSec = new Date().getTime();
            }
            if (data.httpStatus === Austin.segmentDownloadStatus.NOT_FOUND) {
                if (!Austin.waitingForPause) {
                    Austin.fireBoxSeekinPaused = true;
                }
            }
            else {
                Austin.fireBoxSeekinPaused = false;
            }
            if (data.downloadType === 'media/video' && data.httpStatus === Austin.segmentDownloadStatus.COMPLETED &&
                Austin.androidBackwardBuffer <= AustinConfig.BM_PLAYER_BACKWARD_BUFFER && !Austin.player.isPaused()) {
                Austin.androidBackwardBuffer += AustinConfig.STREAMING[Austin.core.getConnectionMode()].DASH_SEGMENT_DURATION_MS / 1000;
            }
            Austin.logger.info('Android:: Backward buffer: ' + Austin.androidBackwardBuffer);
            if (Austin.waitingForPause) {
                let androidBoxPauseHandler = () => {
                    let currentTimeSec = new Date().getTime();
                    if (currentTimeSec - Austin.downloadTimeSec >= AustinConfig.ANDROID_SEGMENT_TIMEOUT_MS) {
                        Austin.waitingForPause = false;
                        Austin.logger.info('Flush Avoided');
                        Austin.corePause();
                        clearTimeout(Austin.androidPauseTimer);
                        Austin.androidPauseTimer = null;
                        return;
                    }
                };
                if (!Austin.androidPauseTimer) {
                    Austin.androidPauseTimer = setTimeout(androidBoxPauseHandler, AustinConfig.ANDROID_SEGMENT_TIMEOUT_MS);
                }
                if (data.downloadType === 'media/video' && data.httpStatus === Austin.segmentDownloadStatus.COMPLETED) {
                    if (data.url.search('vid-1.m4s') > 0 || data.url.search('vid-2.m4s') > 0 || data.url.search('vid-3.m4s') > 0) {
                        Austin.logger.info('Dont update the buffer');
                        Austin.androidBufferLevelAtPauseFired = 0;
                    }
                    else {
                        Austin.logger.info('Update the buffer');
                        Austin.androidBufferLevelAtPauseFired = Austin.getVideoBufferLength();
                    }
                }
                Austin.logger.info('playerDownLoadFinishedHandler : androidBufferLevelAtPauseFired: ' + Austin.androidBufferLevelAtPauseFired);
                let maxBufferLevelAtPause = Austin.getMaxForwardBufLevelAtPause();
                if (Austin.androidBufferLevelAtPauseFired > maxBufferLevelAtPause) {
                    Austin.waitingForPause = false;
                    if (Austin.isContentDVR()) {
                        Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, 20);
                    }
                    else {
                        Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, 45);
                    }
                    Austin.logger.info('Firing Pause to box since sufficient buffer built up');
                    Austin.corePause();
                }
            }
            else {
                clearTimeout(Austin.androidPauseTimer);
                Austin.androidPauseTimer = null;
            }
        }
    }
    static playerPauseHandler(data) {
        Austin.fire(Austin.EVENTS.onPause, data);
    }
    static playerPlayHandler(data) {
        Austin.logger.info('playerPlayHandler playing');
        Austin.fire(Austin.EVENTS.onPlaying, data);
    }
    static playerReadyHandler(data) {
        Austin.fire(Austin.EVENTS.onReady, data);
    }
    static playerStallStartHandler(data) {
        Austin.stallStartCount++;
        if ((Austin.libInfo.status !== AustinConstants.BOX.STATUS.STARTING_STREAMING) && (Austin.bufferingStartTime === 0)) {
            Austin.bufferingCount++;
            Austin.bufferingStartTime = new Date().getTime();
        }
        Austin.fire(Austin.EVENTS.onStallStart, data);
    }
    static playerSeekedOrTimeShiftedHandler(data) {
        Austin.segmentManager.setMaxParallelReq(2);
        if (Austin.player.isPaused() && AustinConstants.STREAMING.STREAMING_TYPE_DASH === Austin.core.getStreamingType()) {
            Austin.logger.info('Setting pause flags as true after seek');
            Austin.waitingForPause = true;
            Austin.playbackPaused = true;
        }
        if (Austin.playbackPaused) {
            Austin.pause().then(() => {
                Austin.logger.info('Pausing after seek completed');
            });
        }
        Austin.trickFlushCount++;
        if (data.type === 'seeked') {
            Austin.logger.info('Entering seek');
            Austin.fire(Austin.EVENTS.onStallEnd, data);
        }
        if (Austin.seekTriggered) {
            Austin.logger.info('Emitting Seek End Event');
            Austin.seekTriggered = false;
            Austin.fire(Austin.EVENTS.onSeekEnded, {
                type: 'seek'
            });
        }
    }
    static playerStallEndHandler(data) {
        Austin.stallEndCount++;
        let bufferingEndTime = new Date().getTime();
        if (Austin.bufferingStartTime) {
            Austin.logger.info('Buffering duration being added: ' + (bufferingEndTime - Austin.bufferingStartTime) / 1000);
            Austin.bufferingDuration += (bufferingEndTime - Austin.bufferingStartTime) / 1000;
            Austin.bufferingStartTime = 0;
        }
        Austin.fire(Austin.EVENTS.onStallEnd, data);
    }
    static playerSubtitleAddedHandler(data) {
        if (data && data.subtitle && data.subtitle.id) {
            Austin.logger.info('Subtitle added id:' + data.subtitle.id);
            let cc = Austin.cc;
            cc['CCChannel'] = data.subtitle.id;
            Austin.logger.info('Setting first Subtitle:' + data.subtitle.id);
            Austin.applyCC(cc);
        }
    }
    static playerMetadataHandler(metadata) {
        Austin.playerMetadataEventCount++;
        if ((AustinConstants.PLATFORM.IOS !== AustinUtils.getPlatForm()) || AustinConfig.PLAYER.PTS_BASED_PROGRESS_UPDATION_ENABLED) {
            Austin.updatePlaybackTime(metadata);
            Austin.core.resetEventFailedCount();
            if ((Austin.player.params[AustinConstants.STREAMING.SEGMENT_DURATION] === 2) && (Austin.isContentDVR()) && !Austin.playbackPaused) {
                RenewableTimer.setTimer(() => {
                    Austin.logger.info('Incrementing playbackTime only in playing state');
                    Austin.playbackTime = Austin.playbackTime + 1000;
                }, 1000);
            }
        }
    }
    /**
     * This should be called internally every-time when streamStart is attempted, whether result is success or failure
     * For successful attempt isSuccess should be true otherwise false
     * @param isSuccess
     * @param userAborted : boolean, true if user called stopStreaming/disconnect before rendering of 1st frame
     * @hidden
     */
    static streamStartAnalyticsHandler(isSuccess, userAborted) {
        Austin.logger.debug('streamStartAnalyticsHandler++');
        PerformanceTimer.markEnd(PerformanceTimer.metrics.PLAYER_PLAY);
        PerformanceTimer.markEnd(PerformanceTimer.metrics.STREAM_START);
        Austin.firstFrameRenderedTime = new Date().getTime();
        Austin.logger.info('FirstFrame Rendered Time: ' + Austin.firstFrameRenderedTime);
        //Even in failure logging timeTillPlay and frameRenderSuccessAt to know time user waited
        let timeTillPlay = PerformanceTimer.getTime(PerformanceTimer.metrics.STREAM_START).pop();
        Austin.streamingData[AnalyticsHelperConstants.timeTillPlay] = timeTillPlay;
        Austin.streamingData[AnalyticsHelperConstants.frameRenderSuccessAt] = new Date();
        Austin.streamingData[AnalyticsHelperConstants.resolutionAtStart] = Austin.libInfo.streamInfo.width
            + 'x' + Austin.libInfo.streamInfo.height;
        let errorMessage = Austin.analytics.getAnalyticProperty(AnalyticsHelperConstants.errorMessage);
        let streamType = Austin.core.getStreamingType();
        let message = 'strm:' + streamType;
        message = message + ':contType:' + Austin.contentType;
        message = message + ':discCnt:' + Austin.discontinuityCount;
        message = message + ':metaCnt:' + Austin.playerMetadataEventCount;
        message = message + ':mode:' + Austin.core.getConnectionMode();
        message = message + ':time:' + PerformanceTimer.getTime(PerformanceTimer.metrics.CONNECT).pop();
        message = message + ':sparcs:' + PerformanceTimer.getTime(PerformanceTimer.metrics.SPARCS_LOOKUP).pop();
        let rmTime = PerformanceTimer.getTime(PerformanceTimer.metrics.RI_CREATION).pop();
        if (rmTime) {
            message = message + ':rm:' + rmTime;
        }
        if (isSuccess) {
            if (timeTillPlay > 99) {
                Austin.streamingData[AnalyticsHelperConstants.timeTillPlay] = 100;
                timeTillPlay = '100(' + timeTillPlay + ')';
            }
            message = message + ':1stFrame:' + timeTillPlay;
            message = message + ':boxPlay:' + PerformanceTimer.getTime(PerformanceTimer.metrics.BOX_PLAY).pop();
            message = message + ':boxReady:' + PerformanceTimer.getTime(PerformanceTimer.metrics.BOX_READY).pop();
            message = message + ':bmPlay:' + PerformanceTimer.getTime(PerformanceTimer.metrics.PLAYER_PLAY).pop();
            if (Austin.isDashOnWeb()) {
                message = message + ':DRM1:' + PerformanceTimer.getTime(PerformanceTimer.metrics.WIDEVINE_LICENCE_REQ1).pop();
                message = message + ':DRM2:' + PerformanceTimer.getTime(PerformanceTimer.metrics.WIDEVINE_LICENCE_REQ2).pop();
            }
            let segs1stFrame = Austin.debugInfo.pop();
            if (segs1stFrame && segs1stFrame.segmentCnt) {
                message = message + ':aud:' + segs1stFrame.segmentCnt.aud + ':vid:' + segs1stFrame.segmentCnt.vid;
            }
            if (Austin.segmentsInfo && Austin.segmentsInfo.length > 0) {
                Austin.segmentsInfo.forEach((e) => {
                    message = message + ':' + e.url + ':' + e.dlTime;
                });
            }
        }
        Austin.logger.info('outcome 0 perfomance timing ' + message);
        Austin.analytics.appendAnalyticProperty(AnalyticsHelperConstants.errorMessage, message);
        Austin.setAnalyticsStreamingData(isSuccess, userAborted);
        // Default data for SLINGNET_CONNECTION which will be send if user closes the tab
        if (isSuccess) {
            Austin.analytics.setAnalyticProperty(AnalyticsHelperConstants.errorMessage, errorMessage);
            //For all failure paths stopStreamingInternal is called just after streamStartAnalyticsHandler
            // which forms payload for SLINGNET_CONNECTION
            Austin.analytics.setDisconnectMethod(AnalyticsHelperConstants.analytics_disconnect_method.client_window_closed);
            Austin.analytics.setAnalyticsPayload(AnalyticsHelperConstants.SLINGNET_CONNECTION);
        }
    }
    static firstFrameRenderHandler(data) {
        Austin.logger.info('firstFrameRenderHandler : ' + JSON.stringify(data));
        let firstFrameReason = data.reason;
        Austin.segmentManager.setMaxParallelReq(2);
        Austin.firstFrameRendered = true;
        Austin.logger.info('segInfo : ' + JSON.stringify(Austin.segmentsInfo));
        Austin.logSegmentInfo = false;
        setTimeout(() => {
            Austin.logger.info('firstFrameReason : ' + firstFrameReason);
            switch (firstFrameReason) {
                case AustinConstants.STREAMING.FIRST_FRAME.STREAM_START:
                    // These are only for playback start 1st frame rendering
                    Austin.debugInfo.push(data);
                    Austin.streamStartAnalyticsHandler(true);
                    Austin.segmentsInfo = [];
                    Austin.debugInfo = [];
                    break;
                case AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY:
                    if (Austin.playbackPaused) {
                        Austin.pause().then(() => {
                            Austin.logger.info('Pausing after unload');
                        });
                    }
            }
            if (Austin.core.getSessionId() !== '') {
                Austin.setStatus(AustinConstants.BOX.STATUS.STREAMING);
            }
        }, 0);
    }
    /**
     * set the player to be used.
     * By default Bitmovin player will be used.
     * @param {string} playerType
     * @hidden
     */
    static initializePlayer(playerType) {
        try {
            const defaultPlayer = AustinUtils.isDeviceChromeCast() ? AustinConstants.PLAYER.CHROMECAST : AustinConstants.PLAYER.BITMOVIN;
            Austin.player = PlayerManager.getPlayer(playerType ? playerType : defaultPlayer);
            if (Austin.player) {
                Austin.segmentManager = new SegmentManager(this);
                //Subscribing to player events
                Austin.player.subscribe(AustinEvents.PLAYER_ERROR, Austin.playerErrorHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_WARNING, Austin.playerWarningHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_MEDIA_DOWNLOAD_FINISHED, Austin.playerDownLoadFinishedHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_PAUSE, Austin.playerPauseHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_PLAYING, Austin.playerPlayHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_READY, Austin.playerReadyHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_SEEKED_OR_TIMESHIFTED, Austin.playerSeekedOrTimeShiftedHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_STALL_START, Austin.playerStallStartHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_STALL_END, Austin.playerStallEndHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_SUBTITLE_ADDED, Austin.playerSubtitleAddedHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_FIRST_FRAME_RENDERED, Austin.firstFrameRenderHandler);
                Austin.player.subscribe(AustinEvents.PLAYER_METADATA, Austin.playerMetadataHandler);
                this.libInfo.playerType = playerType;
                this.libInfo.playerVersion = this.player.getVersion();
                let sdkClient;
                let clientId;
                Austin.logger.info('playerVersion ' + this.libInfo.playerVersion);
                if (this.libInfo.playerVersion && this.libInfo.playerVersion.indexOf('8.78.0') !== -1) {
                    clientId = this.analytics.getAnalyticProperty(AnalyticsHelperConstants.clientId);
                    if (/android|tablet|ipad|iphone/.test(clientId)) {
                        clientId = 'html5-nav';
                    }
                    sdkClient = 'html5-web';
                }
                else {
                    if (AustinUtils.isAndroid()) {
                        sdkClient = 'html5-native-android';
                    }
                    if (AustinUtils.isIos()) {
                        sdkClient = 'html5-native-ios';
                    }
                }
                if (sdkClient && clientId === 'html5-nav') {
                    this.analytics.setAnalyticProperty(AnalyticsHelperConstants.clientId, sdkClient);
                }
                if (this.analytics.getAnalyticProperty(AnalyticsHelperConstants.hostBrowserName) === 'NAV') {
                    this.analytics.setAnalyticProperty(AnalyticsHelperConstants.hostBrowserName, sdkClient);
                }
                if (this.analytics.getAnalyticProperty(AnalyticsHelperConstants.osName) === 'NAV') {
                    this.analytics.setAnalyticProperty(AnalyticsHelperConstants.osName, sdkClient);
                }
            }
        }
        catch (e) {
            Austin.logger.warn('Exception' + JSON.stringify(e));
        }
    }
    /**
     * This method is used to get the channel list available on the AirTv Box.
     * <br/>Promise will be resolved with JSON object or rejected with reason as
     * <pre>
     *     1. notConnected
     * </pre>
     *
     * A sample channel list returned on promise resolve is,
     * <pre>
     * e.g:
     *  '{'channels': [
     *      {'name':'BBC1','number':'1-1','frequency':'80','signalstrength':'76'},
     *      {'name':'BBC2','number':'2-1','frequency':'80','signalstrength':'76'},
     *      ........]
     *   }'
     * </pre>
     *
     *
     * @returns {Promise<object|IAustinError>}
     */
    static getChannels() {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                Austin.core.getChannels().then((data) => {
                    resolve(data);
                }).catch((reason) => {
                    Austin.logger.warn('getChannels failed : ' + JSON.stringify(reason));
                    reject(reason);
                });
            }
            else {
                Austin.logger.warn('getChannels failed : ' + AustinErrors.NOT_CONNECTED);
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     *  returns the program information about the currently playing channel
     * @returns {Promise<T>}
     */
    static getProgramInfo(internal) {
        return new Promise((resolve, reject) => {
            if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STREAMING || (internal && Austin.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING)) {
                if (Austin.programInfo) {
                    resolve(Austin.programInfo);
                }
                else {
                    Austin.core.getProgramInfo().then((data) => {
                        Austin.logger.info('getProgramInfo response: ' + JSON.stringify(data));
                        if (internal) {
                            resolve(data);
                            return;
                        }
                        if (AustinConfig.AUSTIN.PROGRAM_INFO_FETCH_INTERVAL) {
                            Austin.programInfo = data.program_info;
                            let programInfoHandler = () => {
                                if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STREAMING) {
                                    Austin.core.getProgramInfo().then((resp) => {
                                        Austin.programInfo = resp.program_info;
                                        Austin.programInfoTimer = setTimeout(programInfoHandler, AustinConfig.AUSTIN.PROGRAM_INFO_FETCH_INTERVAL);
                                    }).catch((reason) => {
                                        Austin.programInfo = null;
                                        Austin.programInfoContent = null;
                                    });
                                }
                                else {
                                    Austin.programInfo = null;
                                    Austin.programInfoTimer = null;
                                }
                            };
                            if (!Austin.programInfoTimer) {
                                Austin.programInfoTimer = setTimeout(programInfoHandler, AustinConfig.AUSTIN.PROGRAM_INFO_FETCH_INTERVAL);
                            }
                        }
                        resolve(Austin.programInfo);
                    }).catch((reason) => {
                        Austin.programInfo = null;
                        Austin.logger.warn('getProgramInfo failed : ' + JSON.stringify(reason));
                        reject(reason);
                    });
                }
            }
            else {
                Austin.logger.warn('getProgramInfo failed : ' + AustinErrors.NOT_STREAMING);
                reject({ reason: AustinErrors.NOT_STREAMING });
            }
        });
    }
    /**
     * This API does a content Change to the new channel number or dvr-recording passed in the params.
     *
     * @param params
     * @returns {Promise<void|IAustinError>}
     * <br/>Promise is resolved or rejected with error object with reason timeout
     * @hidden
     */
    static changeContent(params) {
        return new Promise((resolve, reject) => {
            //Depending on paused-playing state of client and box, handle all 4 scenarios
            if (Austin.playbackPaused) {
                Austin.playbackPaused = false;
                if (Austin.waitingForPause) {
                    Austin.waitingForPause = false;
                    resolve(Austin.changeContent(params));
                }
                else {
                    Austin.core.resume()
                        .then(() => {
                        // Resuming player for HLS, for dash it will be resumed after discontinuity for new content
                        if (AustinConstants.STREAMING.STREAMING_TYPE_HLS === Austin.core.getStreamingType()) {
                            Austin.player.play();
                        }
                        resolve(Austin.changeContent(params));
                    })
                        .catch((reason) => {
                        Austin.player.pause();
                        Austin.playbackPaused = true;
                        Austin.debugInfo.push(new Date().toISOString() + 'resumeCmdFailedBeforeContentChangePlayerPaused');
                        reject(reason);
                    });
                }
            }
            else {
                if (Austin.waitingForResume) {
                    Austin.waitingForResume = false;
                    Austin.core.resume()
                        .then(() => resolve(Austin.changeContent(params)))
                        .catch((reason) => {
                        Austin.player.pause();
                        Austin.playbackPaused = true;
                        Austin.debugInfo.push(new Date().toISOString() + 'resumeCmdFailedBeforeContentChangeWaitingForResume');
                        reject(reason);
                    });
                }
                else {
                    Austin.core.changeContent(params).then(() => {
                        Austin.logger.info('content change success response');
                        resolve();
                    }).catch((error) => {
                        Austin.logger.warn('content change error response' + JSON.stringify(error));
                        reject(error);
                    });
                }
            }
        });
    }
    /**
     * This API is used for changing the streaming quality
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. noStreamingFound
     * </pre>
     * @param {string} quality  - streaming quality, valid values are AUTO, HIGH, MEDIUM and LOW.
     * @returns {Promise<void|IAustinError>}
     */
    static changeQuality(quality) {
        switch (quality) {
            case AustinConstants.QUALITY_LEVELS.AUTO:
            case AustinConstants.QUALITY_LEVELS.HIGH:
            case AustinConstants.QUALITY_LEVELS.LOW:
            case AustinConstants.QUALITY_LEVELS.MEDIUM:
                break;
            default:
                Austin.logger.warn('Failed to identify streaming profile. Switching to auto.');
                quality = AustinConstants.QUALITY_LEVELS.AUTO;
        }
        return new Promise((resolve, reject) => {
            //Change only while streaming
            if (Austin.isStreaming()) {
                if (Austin.qualityLevel !== quality) {
                    Austin.core.setEncodeParams(quality).then(() => {
                        Austin.qualityLevel = quality;
                        Austin.logger.info('changeQuality success : ');
                        resolve();
                    }).catch((reason) => {
                        Austin.logger.error('changeQuality failed : ' + JSON.stringify(reason));
                        reject(reason);
                    });
                }
                else {
                    Austin.logger.warn('Same quality is already set');
                    resolve();
                }
            }
            else {
                Austin.logger.error('changeQuality failed : ' + AustinErrors.NOT_CONNECTED);
                reject(Austin.errorWithSessionInfo({ reason: AustinErrors.NO_STREAMING_FOUND, info: { api: 'changeQuality' } }));
            }
        });
    }
    /**
     * Resume the playback after pause.
     * For quick resume do not send any request to Box
     * (pause is also not sent to Box while client player is building buffer)
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. noStreamingFound
     *     2. notAllowedHddNotConnected
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static resume(internal) {
        Austin.logger.info('User called resume internal: ' + internal);
        return new Promise((resolve, reject) => {
            if (Austin.player && Austin.libInfo.status === AustinConstants.BOX.STATUS.STREAMING) {
                if (Austin.core.isHddConnected()) {
                    //This is added as safety if client sends resume is playing state.
                    Austin.waitingForResume = false;
                    if (Austin.player.isPaused()) {
                        if (AustinUtils.isAndroid() || AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) {
                            Austin.androidBufferLevelAtPauseFired = 0;
                            Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER);
                        }
                        if (Austin.isContentDVR()) {
                            RenewableTimer.resume();
                            Austin.logger.info('Started the pause Timer');
                        }
                        Austin.player.play();
                        Austin.playbackPaused = false;
                        if (Austin.waitingForPause) {
                            Austin.waitingForPause = false;
                            Austin.logger.info('resume :: Skipping pause command and resuming from austin');
                            Austin.segmentManager.handlePauseResumeTransition();
                            resolve();
                        }
                        else {
                            Austin.logger.info('resume :: Has to call Box resume');
                            if (internal || AustinUtils.isAndroid() ||
                                AustinConstants.STREAMING.STREAMING_TYPE_HLS === Austin.core.getStreamingType()) {
                                Austin.boxResume();
                            }
                            else {
                                if (Austin.segmentManager.isPaused()) {
                                    Austin.segmentManager.resume();
                                }
                                Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.BM_PLAYER_FORWARD_BUFFER);
                                Austin.logger.info('resume :: Box resume command will be send by networkInterceptor');
                                Austin.waitingForResume = true;
                                Austin.segmentManager.setPipelineResumingStatus(true);
                            }
                        }
                    }
                    else {
                        Austin.playbackPaused = false; //Syncing the flag as defensive programming
                        resolve();
                    }
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NO_STREAMING_FOUND });
            }
        });
    }
    /**
     * Call Box resume API, on error it revert back playback to paused state
     * @hidden
     */
    static boxResume() {
        Austin.core.resume()
            .then(() => Austin.logger.info('boxResume success'))
            .catch((error) => {
            Austin.player.pause();
            Austin.playbackPaused = true;
            Austin.logger.error('boxResume failed' + JSON.stringify(error));
            error.info = error.info || {};
            error.info['extraMessage'] = 'Box resume failed, so auto pausing';
            Austin.fire(Austin.EVENTS.onInfo, {
                type: 'warning',
                reason: error.reason,
                info: error.info
            });
        });
        Austin.waitingForResume = false;
    }
    /**
     * Pause the playback.
     * It waits for the client player buffer to be completed before firing pause command to Box
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. noStreamingFound
     *     2. notAllowedHddNotConnected
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static pause() {
        return new Promise((resolve, reject) => {
            if (Austin.player && Austin.libInfo.status === AustinConstants.BOX.STATUS.STREAMING) {
                if (Austin.core.isHddConnected()) {
                    if (!Austin.firstFrameRendered && AustinConstants.STREAMING.STREAMING_TYPE_HLS === Austin.core.getStreamingType()) {
                        Austin.logger.info('By Passing pause and auto resuming');
                        reject(Austin.errorWithSessionInfo({
                            reason: AustinErrors.API_FAILED,
                            info: { api: 'pause', extraMessage: 'firstFrameNotRendered' }
                        }));
                        return;
                    }
                    if (Austin.player.isPaused()) {
                        Austin.playbackPaused = true; //Syncing the flag as defensive programming
                    }
                    else {
                        Austin.pauseInternal();
                    }
                    //Pause is resolved just after UI pause success, box pause happens in background
                    resolve();
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NO_STREAMING_FOUND });
            }
        });
    }
    /**
     * @hidden
     */
    static pauseInternal() {
        Austin.player.pause();
        Austin.playbackPaused = true;
        if (Austin.waitingForResume) {
            Austin.waitingForResume = false;
            Austin.logger.info('Skipping resume command and pausing from austin');
        }
        else {
            Austin.logger.info('pauseInternal called');
            // Note: time to pause Box should be precise
            // If Box is paused before, bitmovin will keep requesting segment till buffer-limit and will get 404
            // if Box is paused late, lebo-flush discontinuity will come while client player is in paused state
            if (AustinUtils.isAndroid() || AustinUtils.isFireTV() || AustinUtils.isAndroidTV()) {
                Austin.androidBufferLevelAtPauseFired = Austin.getVideoBufferLength();
                if (Austin.bufferBarData.remaining < AustinConfig.ANDROID_DVR_END_THRESHOLD_REM_TIME_FOR_FIRING_PAUSE && Austin.isContentDVR()) {
                    Austin.logger.info('EndofDVR Pause');
                    Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, AustinConfig.ANDROID_FORWARD_BUFFER_LEVEL_AT_PAUSE);
                    Austin.corePause();
                    return;
                }
                Austin.logger.info('androidBufferLevelAtPauseFired' + Austin.androidBufferLevelAtPauseFired);
                let maxBufferLevelAtPause = Austin.getMaxForwardBufLevelAtPause();
                Austin.logger.info('Pause maxBufferLevelAtPause:' + maxBufferLevelAtPause);
                if (Austin.androidBufferLevelAtPauseFired > maxBufferLevelAtPause) {
                    if (Austin.isContentDVR()) {
                        Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, 20);
                    }
                    else {
                        Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, 45);
                    }
                    Austin.logger.info('Pausing since android buffer reached');
                    Austin.corePause();
                }
                else {
                    Austin.waitingForPause = true;
                }
            }
            else if (Austin.segmentManager.isLookUpLimitReached()) {
                if (Austin.segmentManager.getActiveRequestsCount()) {
                    Austin.waitingForPause = true;
                }
                else {
                    Austin.corePause();
                }
            }
            else if (Austin.segmentManager.getActiveRequestsCount()) {
                Austin.waitingForPause = true;
            }
            else {
                Austin.corePause();
            }
            if (Austin.isContentDVR()) {
                RenewableTimer.pause();
                Austin.logger.info('Ending update timer');
            }
        }
    }
    /**
     * @hidden
     */
    static corePause() {
        Austin.logger.info('Calling Box pause');
        Austin.core.pause()
            .then(() => Austin.logger.log('Box pause success'))
            .catch((error) => {
            Austin.logger.warn('Box pause failed ' + JSON.stringify(error));
            Austin.player.play();
            Austin.playbackPaused = false;
            error.info = error.info || {};
            error.info['extraMessage'] = 'Box pause failed, so auto resuming';
            Austin.fire(Austin.EVENTS.onInfo, {
                type: 'warning',
                reason: error.reason,
                info: error.info
            });
        });
    }
    /**
     * Seek the playback by given time relative to current playback position.
     * Ex: seek(600) will seek 10 minutes forward, seek(-30) will seek back by 30 seconds.
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. noStreamingFound
     *     2. notAllowedHddNotConnected
     * </pre>
     * @param time -  number of seconds to seek relative to current playback position.
     * @returns {Promise<void|IAustinError>}
     */
    static seek(time, internal) {
        return new Promise((resolve, reject) => {
            if (Austin.player) {
                Austin.seekTime = (time > 0) ? time * 1000 : 0;
                if (Austin.core.isHddConnected()) {
                    Austin.logger.info('Test: Seek API, Austin.playbackPaused ' + Austin.playbackPaused + ' Austin.waitingForPause ' + Austin.waitingForPause + ' time ' + time);
                    //Depending on paused-playing state of client and box, handle all 4 scenarios
                    if (Austin.playbackPaused) {
                        Austin.playbackPaused = false;
                        if (Austin.waitingForPause) {
                            Austin.waitingForPause = false;
                            resolve(Austin.seek(time));
                        }
                        else {
                            Austin.core.resume()
                                .then(() => {
                                if (AustinUtils.isAndroid()) {
                                    Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, 90);
                                }
                                resolve(Austin.seek(time));
                            })
                                .catch((reason) => {
                                Austin.player.pause();
                                Austin.playbackPaused = true;
                                reject(reason);
                            });
                        }
                    }
                    else {
                        if (Austin.waitingForResume) {
                            Austin.waitingForResume = false;
                            Austin.core.resume()
                                .then(() => {
                                if (AustinUtils.isAndroid()) {
                                    Austin.player.setBufferLevel(AustinConstants.PLAYER.FORWARD_BUFFER_DURATION, 90);
                                }
                                resolve(Austin.seek(time));
                            })
                                .catch((reason) => {
                                Austin.player.pause();
                                Austin.playbackPaused = true;
                                reject(reason);
                            });
                        }
                        else {
                            Austin.seekPos = time;
                            if (Austin.isDashOnWeb()) {
                                let bmPlayer = this.player.getPlayer();
                                let range = bmPlayer.getSeekableRange();
                                let currTime = bmPlayer.getCurrentTime('absolutetime');
                                Austin.logger.info('Test: range.start  ' + range.start + ' range end ' + range.end + ' diff ' + (range.end - range.start) + ' currTime: ' + currTime);
                                if (!internal && range && (range.start && range.start !== -1) &&
                                    (range.end && range.end !== -1) && (range.end - range.start > 10)) {
                                    let seekableBackward = range.start && currTime - range.start || 0;
                                    let seekableForward = range.end && range.end - currTime || 0;
                                    Austin.logger.info('Test: currentTime(absolute): ' + currTime + ' seekableBackward: ' + seekableBackward + ' seekableForward: ' + seekableForward);
                                    Austin.logger.info('Test: getMaxTimeShift: ' + bmPlayer.getMaxTimeShift('austin') + ' getTimeShift: ' + bmPlayer.getTimeShift('austin'));
                                    Austin.seekWithinBuffered = false;
                                    if (time < 0) {
                                        let audLevel = this.player.getAudioBufferLength(true);
                                        let vidLevel = this.player.getVideoBufferLength(true);
                                        Austin.logger.info('Test: audBackwardBufLevel ' + audLevel + ' vidBackwardBufLevel: ' + vidLevel);
                                        //seek back
                                        if (seekableBackward && seekableBackward - (time * -1) > 0) {
                                            if (audLevel > (time * -1) && vidLevel > (time * -1)) {
                                                Austin.logger.info('Test: OK Seek backward within buffered data time:  ' + time);
                                                Austin.seekWithinBuffered = true;
                                            }
                                            else {
                                                Austin.logger.info('Test: seekable range ok, but not enough buffer on backward, issuing box seek: ' + time);
                                            }
                                        }
                                    }
                                    else if (time > 0) {
                                        let audLevel = this.player.getAudioBufferLength();
                                        let vidLevel = this.player.getVideoBufferLength();
                                        Austin.logger.info('Test: audForwardBufLevel ' + audLevel + ' vidForwardBufLevel: ' + vidLevel);
                                        //seek forward
                                        if (seekableForward && (seekableForward - time) > 0) {
                                            if (audLevel > time && vidLevel > time) {
                                                Austin.logger.info('Test: Seek forward within buffered data time:  ' + time);
                                                Austin.seekWithinBuffered = true;
                                            }
                                            else {
                                                Austin.logger.info('Test: seekable range ok, but not enough buffer on forward, issuing box seek: ' + time);
                                            }
                                        }
                                    }
                                }
                                if (Austin.seekWithinBuffered) {
                                    let bmPlayer = this.player.getPlayer();
                                    let currTime = bmPlayer.getCurrentTime('absolutetime');
                                    Austin.logger.info('Test: Calling BM seek API ime:  ' + time);
                                    this.player.seek(currTime + time);
                                    if (!Austin.seekTriggered) {
                                        Austin.fireSeekStart();
                                        Austin.seekTriggered = true;
                                    }
                                    Austin.playbackTime = Austin.playbackTime + (time * 1000);
                                    Austin.inBufferSeekDuration = Austin.inBufferSeekDuration + (time * 1000);
                                    resolve();
                                    return;
                                }
                                else {
                                    Austin.inBufferSeekDuration = 0;
                                }
                            }
                            else if (AustinUtils.isAndroid() || AustinUtils.isAndroidTV() || AustinUtils.isFireTV()) {
                                let bmTimeShift = 0;
                                let bmPlayer = this.player.getPlayer();
                                let timeShift = bmPlayer.getTimeShift('austin');
                                let maxTimeShift = bmPlayer.getMaxTimeShift('austin');
                                Austin.logger.info('Test: getMaxTimeShift: ' + maxTimeShift + ' getTimeShift: ' + timeShift);
                                Austin.seekWithinBuffered = false;
                                if (time < 0) {
                                    let vidLevel = this.player.getVideoBufferLength(true);
                                    if (Austin.androidBackwardBuffer > 14 && vidLevel > (time * -1) && Austin.androidBackwardBuffer > (time * -1)) {
                                        bmTimeShift = timeShift + time;
                                        Austin.androidBackwardBuffer += time;
                                        Austin.seekWithinBuffered = true;
                                        Austin.logger.info('Android bakward buffer : ' + Austin.androidBackwardBuffer);
                                    }
                                    else {
                                        Austin.logger.info('Test: seekable range ok, but not enough buffer on backward, issuing box seek: ' + time);
                                        Austin.androidBackwardBuffer = 0;
                                    }
                                }
                                else if (time > 0) {
                                    let audLevel = this.player.getAudioBufferLength();
                                    let vidLevel = this.player.getVideoBufferLength();
                                    Austin.logger.info('Test: audForwardBufLevel ' + audLevel + ' vidForwardBufLevel: ' + vidLevel);
                                    //seek forward
                                    if (timeShift * -1 > time) {
                                        if (audLevel > time && vidLevel > time &&
                                            (audLevel < (AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER + 10) || vidLevel < (AustinConfig.ANDROID_BM_PLAYER_FORWARD_BUFFER + 10))) {
                                            bmTimeShift = timeShift + time;
                                            Austin.logger.info('Test: Seek forward within buffered data time:  ' + time + ' timeShifting to ' + bmTimeShift);
                                            Austin.seekWithinBuffered = true;
                                            if (Austin.androidBackwardBuffer < AustinConfig.BM_PLAYER_BACKWARD_BUFFER) {
                                                if (Austin.androidBackwardBuffer + time < AustinConfig.BM_PLAYER_BACKWARD_BUFFER) {
                                                    Austin.androidBackwardBuffer += time;
                                                }
                                                else {
                                                    Austin.androidBackwardBuffer = AustinConfig.BM_PLAYER_BACKWARD_BUFFER;
                                                }
                                            }
                                            Austin.androidBufferLevelAtPauseFired -= time;
                                            Austin.logger.info('Updating androidBufferLevelAtPauseFired:' + Austin.androidBufferLevelAtPauseFired);
                                        }
                                        else {
                                            Austin.logger.info('Test: seekable range ok, but not enough buffer on forward, issuing box seek: ' + time);
                                            Austin.androidBackwardBuffer = 0;
                                        }
                                    }
                                }
                                if (Austin.seekWithinBuffered && !Austin.fireBoxSeekinPaused) {
                                    Austin.logger.info('Android in buffer Calling BM timeShift API time:  ' + time + ' bmTimeShift ' + bmTimeShift);
                                    Austin.player.timeShift(bmTimeShift);
                                    Austin.playbackTime = Austin.playbackTime + (time * 1000);
                                    Austin.inBufferSeekDuration = Austin.inBufferSeekDuration + (time * 1000);
                                    if (!Austin.seekTriggered) {
                                        Austin.fireSeekStart();
                                        Austin.seekTriggered = true;
                                    }
                                    resolve();
                                    return;
                                }
                                else {
                                    Austin.androidBufferLevelAtPauseFired = 0;
                                }
                            }
                            //const seekPosition = Math.round((time - Austin.getCurrentTime() / 1000) + Austin.getVideoBufferLength());
                            Austin.segmentManager.setTransition(true);
                            Austin.core.seek(Austin.player.getCurrentPTS(), time).then(() => {
                                if (Austin.player.isPaused() && (AustinUtils.isAndroid() || Austin.isDashOnWeb())) {
                                    Austin.playbackTime = Austin.playbackTime + (time * 1000);
                                }
                                if (!Austin.seekTriggered) {
                                    Austin.fireSeekStart();
                                    Austin.seekTriggered = true;
                                }
                                Austin.fireBoxSeekinPaused = false;
                                Austin.userTriggeredDiscontinuityWaiting = true;
                                resolve();
                            }).catch((e) => {
                                Austin.seekPos = null;
                                reject(Austin.errorWithSessionInfo({
                                    reason: AustinErrors.API_FAILED,
                                    info: e
                                }));
                            });
                        }
                    }
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NO_STREAMING_FOUND });
            }
        });
    }
    static fireSeekStart() {
        Austin.fire(Austin.EVENTS.onSeekStarted, {
            type: 'seek'
        });
    }
    static checkAndTriggerSeek() {
        if (Austin.segmentManager && Austin.isDashOnWeb() && Austin.seekWithinBuffered) {
            Austin.seekWithinBuffered = false;
            Austin.logger.info('Test: seek within seekable range, BM requesting  older segment: issuing internal seek  to ' + Austin.seekPos);
            Austin.seek(Austin.seekPos, true).then(() => {
                Austin.logger.info('Test: seek resolved after seek in seekable attempt');
            }).catch((reason) => {
                Austin.logger.info('Test: seek rejected  after seek in seekable attempt ' + JSON.stringify(reason));
            });
        }
    }
    /**
     * Sends IR commands to box
     *
     * @param keyCodes
     * @returns {Promise<any>}
     */
    static sendIRCommand(keyCodes) {
        return new Promise((resolve, reject) => {
            Austin.segmentManager.setTransition(true);
            if (keyCodes.constructor === Array && keyCodes.length) {
                //Depending on paused-playing state of client and box, handle all 4 scenarios
                if (Austin.playbackPaused) {
                    Austin.playbackPaused = false;
                    if (Austin.waitingForPause) {
                        Austin.waitingForPause = false;
                        Austin.sendIRInternal(keyCodes).then(() => {
                            resolve();
                        }).catch((e) => {
                            //Have to go back to pause or pending pause state
                            if (Austin.segmentManager.getActiveRequestsCount()) {
                                Austin.waitingForPause = true;
                            }
                            else {
                                Austin.corePause();
                            }
                            reject(e);
                        });
                    }
                    else {
                        Austin.core.resume()
                            .then(() => resolve(Austin.sendIRInternal(keyCodes)))
                            .catch((reason) => {
                            Austin.player.pause();
                            Austin.playbackPaused = true;
                            reject(reason);
                        });
                    }
                }
                else {
                    if (Austin.waitingForResume) {
                        Austin.waitingForResume = false;
                        Austin.core.resume()
                            .then(() => resolve(Austin.sendIRInternal(keyCodes)))
                            .catch((reason) => {
                            Austin.player.pause();
                            Austin.playbackPaused = true;
                            reject(reason);
                        });
                    }
                    else {
                        Austin.sendIRInternal(keyCodes).then(() => {
                            resolve();
                        }).catch((e) => reject(e));
                    }
                }
            }
            else {
                reject({ reason: AustinErrors.INVALID_PARAMS });
            }
        });
    }
    /**
     * This is helper method to avoid recursion if sendIRCommand is fired in paused state
     * @hidden
     */
    static sendIRInternal(keyCodes) {
        return new Promise((resolve, reject) => {
            Austin.core.sendIRCommand(keyCodes).then(() => {
                Austin.userTriggeredDiscontinuityWaiting = true;
            }).catch((e) => {
                reject(Austin.errorWithSessionInfo({
                    reason: AustinErrors.API_FAILED,
                    info: e
                }));
            });
        });
    }
    static doSeekOrTimeShiftOnDiscontinuity() {
        Austin.segmentManager.setTransition(false);
        Austin.segmentManager.flushSegmentsStore(Austin.discontinuityCount);
        if (AustinConfig.PLAYER.BITMOVIN.TIMESHIFT_ON_DISCONTINUITY) {
            // Timeshifting  to positive value (suggested by Bitmovin) to flush the underlying MSE buffers.
            Austin.player.timeShift(30);
        }
        else {
            Austin.player.seek(0.001);
        }
        Austin.pendingSegmentsRequests = 0;
        Austin.inBufferSeekDuration = 0;
    }
    /**
     * This method handles stream discontinuity by unloading and loading player
     * @hidden
     */
    static boxDiscontinuityHandler(data) {
        if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STOPPING_STREAMING) {
            Austin.logger.info('Ignoring discontinuity because box stopStreaming is in-progress');
            return;
        }
        //HLS path discontinuity count will not be there in event response
        if (AustinConstants.STREAMING.STREAMING_TYPE_HLS === Austin.core.getStreamingType()) {
            Austin.discontinuityCount++;
        }
        else {
            Austin.discontinuityCount = data.info.discontinuity_count;
        }
        Austin.fire(Austin.EVENTS.onInfo, {
            type: 'discontinuity',
            reason: data.info.reason,
            time: Austin.getCurrentTime(),
            count: Austin.discontinuityCount
        });
        Austin.logger.info('boxDiscontinuityHandler: ' + Austin.discontinuityCount + ' Paused: ' + (Austin.player ? Austin.player.isPaused() : ''));
        if (Austin.player) {
            Austin.androidBackwardBuffer = 0;
            let discontinuityTime = new Date().getTime();
            Austin.logger.info('discontinuity time: ' + discontinuityTime);
            let tDiff = discontinuityTime - Austin.firstFrameRenderedTime;
            Austin.firstFrameRenderedTime = Austin.firstFrameRenderedTime - Austin.seekTime;
            Austin.logger.info('updated firstframeTime: ' + Austin.firstFrameRenderedTime);
            Austin.logger.info('time diff : ' + tDiff);
            if (Austin.player.isPaused()) {
                let issueSeek = true;
                if (Austin.waitingForPause) {
                    Austin.logger.info('Bitmovin paused and waitingForPause true');
                    Austin.waitingForPause = false;
                    Austin.playbackPaused = true;
                }
                else if (Austin.seekPos || (0 === Austin.seekPos)) {
                    // Handling seek and content change discontinuity
                    Austin.seekPos = null;
                    Austin.logger.info('Bitmovin paused and Received Seek discontinuity');
                }
                else {
                    Austin.logger.info('Bitmovin paused and waitingForPause false');
                    if (Austin.playbackPaused) {
                        Austin.logger.warn('Bitmovin paused, playbackPaused true, Got discontinuity after firing pause to box');
                        issueSeek = false;
                    }
                    else {
                        Austin.logger.info('Bitmovin paused and playbackPaused false');
                        //This path will be taken for IR commands if fired in paused state
                        //For this box is resumed but UI player remains in paused state till next discontinuity
                    }
                }
                if (issueSeek) {
                    if (Austin.unloadLoadOnDiscontinuity) {
                        Austin.unLoadLoad(AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY);
                    }
                    else if (AustinUtils.isAndroid() && tDiff <= 50000) {
                        Austin.logger.info('Doing unload-load elapsed time since play < 50 sec, PBTime : ' + Austin.playbackTime);
                        Austin.waitingForPause = true;
                        Austin.playbackPaused = true;
                        Austin.unLoadLoad(AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY);
                    }
                    else {
                        Austin.waitingForPause = true;
                        Austin.playbackPaused = true;
                        Austin.doSeekOrTimeShiftOnDiscontinuity();
                    }
                }
                else {
                    let reason = Austin.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING ?
                        AustinConstants.STREAMING.FIRST_FRAME.STREAM_START : AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY;
                    Austin.unLoadLoad(reason);
                }
            }
            else {
                Austin.logger.info('Bitmovin not paused ');
                if (Austin.waitingForResume) {
                    Austin.waitingForResume = false;
                    Austin.resume(true);
                }
                if (Austin.unloadLoadOnDiscontinuity) {
                    let reason = Austin.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING ?
                        AustinConstants.STREAMING.FIRST_FRAME.STREAM_START : AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY;
                    Austin.unLoadLoad(reason);
                }
                else if (AustinUtils.isAndroid() && tDiff <= 50000) {
                    Austin.logger.info('Doing unload-load elapsed time since play < 50 sec, PBTime : ' + Austin.playbackTime);
                    Austin.unLoadLoad(AustinConstants.STREAMING.FIRST_FRAME.DISCONTINUITY);
                }
                else {
                    Austin.doSeekOrTimeShiftOnDiscontinuity();
                }
                Austin.seekPos = null;
            }
            return;
        }
    }
    /**
     * This method unload the current player and load new player
     * Input is optional. It will be present while changing content as channel Number/DVR id
     * @param reason
     * @hidden
     */
    static unLoadLoad(reason) {
        if (AustinConstants.STREAMING.STREAMING_TYPE_HLS === Austin.core.getStreamingType()) {
            if (Austin.libInfo.status === AustinConstants.BOX.STATUS.STARTING_STREAMING) {
                Austin.logger.info('Ignoring discontinuity in STARTING_STREAMING');
                return;
            }
            if (!Austin.userTriggeredDiscontinuityWaiting) {
                Austin.logger.info('Ignore Non-User triggered discontinuity on HLS  : ' + Austin.playbackTime + ' for ' + reason);
                return;
            }
            else {
                Austin.userTriggeredDiscontinuityWaiting = false;
            }
        }
        Austin.handlingDiscontinuity = true;
        Austin.segmentManager.flushSegmentsStore(Austin.discontinuityCount);
        const snapshot = Austin.player.getSnapshot();
        if (snapshot && snapshot.data) {
            Austin.poster = snapshot.data;
        }
        Austin.logger.info('Player Unloading at : ' + Austin.playbackTime + ' for ' + reason);
        Austin.playerError = false;
        Austin.player.unloadLoad(reason).then(() => {
            if (Austin.seekTriggered) {
                Austin.seekTriggered = false;
                Austin.fire(Austin.EVENTS.onSeekEnded, {
                    type: 'seek'
                });
            }
            if (Austin.playbackPaused && AustinUtils.isAndroid()) {
                Austin.pause().then(() => {
                    Austin.logger.info('Pausing after seek completed within first 50 sec');
                });
            }
            Austin.pendingSegmentsRequests = 0;
            Austin.androidBackwardBuffer = 0;
            Austin.androidBufferLevelAtPauseFired = 0;
            Austin.handlingDiscontinuity = false;
            Austin.player.subscribe(AustinEvents.PLAYER_SUBTITLE_ADDED, Austin.playerSubtitleAddedHandler);
        }).catch((err) => {
            Austin.handlingDiscontinuity = false;
            Austin.pendingSegmentsRequests = 0;
            Austin.logger.info('Rejected Player Unloading at : ' + Austin.playbackTime + ' for ' + reason + 'error' + JSON.stringify(err));
        });
    }
    /**
     * Returns true if current streaming playback is in full screen mode.
     * @returns {boolean}
     */
    static isFullScreen() {
        return this.player && this.player.isFullScreen();
    }
    /**
     * Exit from full-screen view
     */
    static exitFullScreen() {
        this.player && this.player.fullScreenExit();
    }
    /**
     * Switch to full-screen view
     */
    static showFullScreen() {
        this.player && this.player.fullScreenEnter();
    }
    /**
     * Returns true if the streaming playback audio is muted
     * @returns {boolean}
     */
    static isMuted() {
        return this.player && this.player.isMuted();
    }
    /**
     * Mutes the player
     */
    static mute() {
        this.player && this.player.mute();
    }
    /**
     * UnMutes the player
     */
    static unMute() {
        this.player && this.player.unMute();
    }
    /**
     * Sets volume
     * @param {number} volume Accepted range is 0 - 100 (0 means mute, 100 means full volume)
     */
    static setVolume(volume) {
        this.player && this.player.setVolume(volume);
    }
    /**
     * gets the current volume
     * @returns {number}
     */
    static getVolume() {
        return this.player && this.player.getVolume();
    }
    /**
     * Gives HDD is connected or not
     * @returns boolean
     */
    static isHddConnected() {
        return Austin.core.isHddConnected();
    }
    /**
     * Gives Player is paused or not
     * @returns boolean
     */
    static isPaused() {
        if (Austin.player) {
            return Austin.playbackPaused;
        }
    }
    /**
     * Gives average streaming bitrate for session
     * @returns {number}
     */
    static getAverageBitrate() {
        return parseFloat((Austin.libInfo.streamInfo.count ? (Austin.libInfo.streamInfo.total / Austin.libInfo.streamInfo.count) : 0).toFixed(2));
    }
    static getMaxTimeShift() {
        return Austin.getDuration();
    }
    static getTimeShift() {
        return Austin.getDuration();
    }
    /**
     * Returns a copy of the current CEA-708/608 CC (Closed Caption) values in json structure.
     * <pre>
     *  {
     *   CCVisible: false,    // boolean; cc enabled or not
     *   CCCustomize: false,  // boolean; cc settings enabled enabled or not
     *   CCChannel: '',       // string; current CC channel selected
     *   CCList: [],          // array; available CC channel list
     *   CCFontColor: '',     // string; cc font colour
     *   CCFontSize: '',      // number; cc font size in %(default) or px eg: 120px/120
     *   CCFontStyle: '',     // string; cc font style
     *   CCFontEdgeStyle: '', // string; cc font edge style
     *   CCFontEdgeColor: '', // string; cc font edge colour
     *   CCFontOpacity: '',   // string; cc font opacity
     *   CCBGColor: '',       // string; cc background colour
     *   CCBGOpacity: '',     // string; cc background opacity
     *   CCWindowColor: '',   // string; cc window color
     *   CCFontWeight: '',    // string; cc font weight
     *   CCTextShadow: ''     // string; cc text shadow in CSS text-shadow format
     *  }
     * </pre>
     *
     * Various customization values supported are as per
     * <a href="https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html">CEA-708/608</a>
     * <br/>Valid colour values:
     * <pre>
     *  1. black
     *  2. white
     *  3. red
     *  4. green
     *  5. blue
     *  6. yellow
     *  7. magenta
     *  8. cyan
     * </pre>
     *
     * <br/>Valid font style values:
     * <pre>
     *   1. sans serif (default)
     *   2. Casual
     *   3. cursive
     *   4. SmallCaps
     *   5. Monospaced Serif
     *   6. Proportional Serif
     *   7. Monospaced sans Serif
     *   8. Proportional sans Serif
     * </pre>
     *
     * <br>Valid font Opacity values:
     * <pre>
     *   1. Default
     *   2. Opaque
     *   3. cursive
     *   4. SmallCaps
     *   5. Monospaced Serif
     * </pre>
     *
     * <br/>Valid font Background Opacity values:
     * <pre>
     *   1. 0.0  - opaque
     *   2. 0.5  - Translucent
     *   3. 1.0  - Transparent
     * </pre>
     *
     * <br/>Valid font weight values:
     * <pre>
     *   1. normal
     *   2. bold
     * </pre>
     *
     * @returns {object}
     */
    static getCC() {
        return JSON.parse(JSON.stringify(Austin.cc));
    }
    /**
     * Sets CC (Closed Captions) params passed in ccParams argument
     * @param {ccparams}
     * @see [[getCC]] for allowed cc settings
     */
    static applyCC(ccParams) {
        let cc = Austin.cc;
        if (ccParams['CCFontSize'] !== undefined) {
            cc.CCFontSize = ccParams['CCFontSize'];
        }
        if (ccParams['CCFontStyle'] !== undefined) {
            cc.CCFontStyle = ccParams['CCFontStyle'];
        }
        if (ccParams['CCFontColor'] !== undefined) {
            cc.CCFontColor = ccParams['CCFontColor'];
        }
        if (ccParams['CCFontOpacity'] !== undefined) {
            cc.CCFontOpacity = ccParams['CCFontOpacity'];
        }
        if (ccParams['CCFontEdgeStyle'] !== undefined) {
            cc.CCFontEdgeStyle = ccParams['CCFontEdgeStyle'];
        }
        if (ccParams['CCBGColor'] !== undefined) {
            cc.CCBGColor = ccParams['CCBGColor'];
        }
        if (ccParams['CCBGOpacity'] !== undefined) {
            cc.CCBGOpacity = ccParams['CCBGOpacity'];
        }
        if (ccParams['CCFontEdgeColor'] !== undefined) {
            cc.CCFontEdgeColor = ccParams['CCFontEdgeColor'];
        }
        if (ccParams['CCCustomize'] !== undefined) {
            cc.CCCustomize = ccParams['CCCustomize'];
        }
        if (ccParams['CCVisible'] !== undefined) {
            cc.CCVisible = ccParams['CCVisible'];
        }
        if (ccParams['CCFontWeight'] !== undefined) {
            cc.CCFontWeight = ccParams['CCFontWeight'];
        }
        if (ccParams['CCTextShadow'] !== undefined) {
            cc.CCTextShadow = ccParams['CCTextShadow'];
        }
        if (cc.CCVisible && !cc['CCCustomize']) {
            Austin.ccDefault.CCVisible = cc.CCVisible;
            Austin.ccDefault.CCCustomize = cc.CCCustomize;
            cc = Austin.ccDefault;
            Austin.cc = JSON.parse(JSON.stringify(cc));
        }
        Austin.player.applyCC(cc);
    }
    /**
     * set log level for Austin and Bitmovin player
     * @param level
     * log level
     * @see [[ILog]] for valid log level string values
     */
    static setLogLevel(level) {
        AustinUtils.setLogLevel(level);
        if (Austin.player) {
            Austin.player.setLogLevel(level);
        }
    }
    // ************ DVR ****************************************
    /**
     * Fetches DVR recordings.
     * A sample queryParams:
     * <pre>
     *  {
     *      req_total_size: boolean, // true - include all entries in the query result else use start_idx and size
     *      start_idx: number,       // starting index from which the DVR list will start in the query result
     *      size: number,            // number of entries to be fetched
     *      sort_key: number         // sort order for the query result
     *  }
     * </pre>
     * <pre>
     *  Accepted values for sort_key,
     *      0  - No Sort
     *      1  - Sort Event Name, A to Z
     *      2  - Sort Event Name, Z to A
     *      3  - Sort MPAA Rating, G to NR/AO
     *      4  - Sort MPAA Rating, NR/AO to G
     *      5  - Sort Video Type, HD to SD
     *      6  - Sort Video Type, SD to HD
     *      7  - Sort Recorded Time, Newest to Oldest
     *      8  - Sort Recorded Time, Oldest to Newest
     *      9  - Sort Event Duration, Shortest to Longest
     *      10 - Sort Event Duration, Longest to Shortest
     *      11 - Sort Protection, Not Protected to Protected
     *      12 - Sort Protection, Protected to Not Protected
     * </pre>
     * Response resolved to JSON
     * <pre>
     * {
     *     recordings: Array of dvr recording with details,
     *     count: total counts of dvr recording
     * }
     * </pre>
     * or Promise rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     *
     * @param queryParams {any} query parameters while fetching all dvr recordings.
     *
     * @returns {Promise<void|IAustinError>}
     */
    static getDvrRecordings(queryParams) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.getDvrRecordings(JSON.parse(JSON.stringify(queryParams)))
                        .then((data) => resolve(data))
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Modify all mentioned DVR Recordings.
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. apiFailed
     *     2. notConnected
     *     3. notAllowedHddNotConnected
     * </pre>
     * @param {Array<string>} recordingIds If recordingIds is :
     *  1. non Array:   API rejected with reason as apiFailed
     *  2. Empty array and array with combination of invalid: considered as SUCCESS.
     *  3. For 2 valid ids, both are getting modified
     * @param {boolean} protecting new protecting status for recordings
     *
     * @returns {Promise<void|IAustinError>}
     */
    static modifyDvrRecordings(recordingIds, protecting) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.modifyDvrRecordings(recordingIds, protecting)
                        .then(() => resolve())
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Deletes all mentioned DVR Recordings.
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     * @param recordingIds: Array<string>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static deleteDvrRecordings(recordingIds) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.deleteDvrRecordings(recordingIds)
                        .then(() => resolve())
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Create new timers
     * <pre>
     *     Sample input params :
     *     {
     *          airing_guid: 'bcff8daa956b517d9d9820c8767599b8',
     *          channel_guid: '71f529b9e13a5c938e64d5dd328e258b';
     *          eventCount: 1,          // number of events to record
     *          frequency: 'once' ,     // 'once'/ 'new'/ 'all'
     *          minutesEarly: 0,
     *          minutesLate: 0,
     *          priority: 1,
     *          protection: true
     *     }
     * </pre>
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     *
     * @returns {Promise<void|IAustinError>}
     */
    static createTimer(params) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.createTimer(JSON.parse(JSON.stringify(params)))
                        .then(() => resolve())
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Create new timers
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     * @param sortKey: string, accepted values : 'priority'/'title'
     *
     * @returns {Promise<void|IAustinError>}
     */
    static getTimers(sortKey) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.getTimers(sortKey)
                        .then((timersList) => resolve(timersList))
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Delete global timers with mentioned ids
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     * @param timerIds:  Array<string>
     * @param forced: boolean
     *
     * @returns {Promise<void|IAustinError>}
     */
    static deleteDvrTimers(timerIds, forced) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.deleteTimers(timerIds, forced)
                        .then((result) => resolve(result))
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Fetches all daily schedules
     * If client is passing global timerId, schedules for only that is fetched
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     * @param params: Object {timerId: string, hideSkipped: boolean}
     *
     * @returns {Promise<void|IAustinError>}
     */
    static getRecordingSchedules(params) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.getRecordingSchedules(params)
                        .then((result) => resolve(result))
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Skip mentioned daily schedule
     * <br/>Promise is resolved or rejected with error object with reason as
     * <pre>
     *     1. notConnected
     *     2. notAllowedHddNotConnected
     * </pre>
     * @param scheduleIds: Array of scheduleIds
     *
     * @returns {Promise<void|IAustinError>}
     */
    static skipRecordingSchedule(scheduleIds) {
        return new Promise((resolve, reject) => {
            if (Austin.isConnected()) {
                if (Austin.core.isHddConnected()) {
                    Austin.core.skipRecordingSchedules(scheduleIds)
                        .then((result) => resolve(result))
                        .catch((reason) => reject(reason));
                }
                else {
                    reject({ reason: AustinErrors.NOT_ALLOWED_HDD_NOT_CONNECTED });
                }
            }
            else {
                reject({ reason: AustinErrors.NOT_CONNECTED });
            }
        });
    }
    /**
     * Sends TV remote key to box
     *
     * @param  params: Object {remoteKey: string, remoteReceiverId: string}
     * @returns {Promise<any>}
     */
    static tvRemoteKey(params) {
        return new Promise((resolve, reject) => {
            resolve(Austin.core.tvRemoteKey(params.remoteKey, params.remoteReceiverId));
        });
    }
}
Austin.appConfig = {
    env: AustinConstants.ENV_PROD,
};
Austin.libInfo = {
    name: '@sling/austinjs',
    version: '3.0.99',
    appVersion: '',
    status: AustinConstants.BOX.STATUS.DISCONNECTED,
    playerType: null,
    playerVersion: null,
    streamInfo: null
};
Austin.bufferBarData = {};
Austin.connectionSessionId = '';
Austin.playerInstanceId = '';
Austin.contentType = AustinConstants.STREAMING.CONTENT_TYPE.NONE;
Austin.duration = null;
Austin.sessionDuration = 0;
Austin.discontinuityCount = 0;
Austin.eventManager = AustinEventManager.getInstance();
Austin.handlingDiscontinuity = false;
Austin.player = null;
Austin.initialized = false;
Austin.logger = new AustinLogger('Austin');
// These playback info will be used to handle discontinuity while paused/seeking/channelChange
Austin.pendingSegmentsRequests = 0;
Austin.playerMetadataEventCount = 0;
Austin.logSegmentInfo = false;
Austin.segmentsInfo = null;
Austin.playbackPaused = false; //If pause is pending after unload-load this flag will be different than player isPaused() API
Austin.playbackTime = 0; // In ms
Austin.previousPlayedTime = 0;
Austin.playerError = false;
Austin.qualityLevel = '';
Austin.waitingForPause = false;
Austin.fireBoxSeekinPaused = false;
Austin.waitingForResume = false;
Austin.seekPos = null;
Austin.seekWithinBuffered = false;
Austin.androidBufferLevelAtPauseFired = 0;
Austin.androidPauseAtEndOfDVR = false;
Austin.inBufferSeekDuration = 0;
Austin.androidBackwardBuffer = 0;
//streamingData for analytics
Austin.streamingData = Object.create(null);
Austin.unloadLoadOnDiscontinuity = false;
Austin.userTriggeredDiscontinuityWaiting = false;
Austin.seekTriggered = false;
Austin.uuid = '';
//cached program Information got from get_program_info
Austin.programInfo = null;
Austin.programInfoContent = null;
Austin.programInfoTimer = null;
Austin.androidPauseTimer = null;
Austin.downloadTimeSec = 0;
Austin.debugInfo = [];
Austin.stallStartCount = 0;
Austin.stallEndCount = 0;
Austin.trickFlushCount = 0;
Austin.connectParams = null;
Austin.bufferingCount = 0;
Austin.bufferingDuration = 0;
Austin.bufferingStartTime = 0;
Austin.firstFrameRendered = false;
Austin.firstFrameRenderedTime = 0;
Austin.seekTime = 0;
Austin.segmentDownloadStatus = {
    COMPLETED: 200,
    NOT_FOUND: 404,
    GONE: 410
};
Austin.cc = {
    CCVisible: false,
    CCCustomize: false,
    CCChannel: '',
    CCList: [],
    CCFontColor: '',
    CCFontSize: '100',
    CCFontStyle: '',
    CCFontEdgeStyle: '',
    CCFontEdgeColor: '',
    CCFontOpacity: '',
    CCBGColor: '',
    CCBGOpacity: '',
    CCWindowColor: '',
    CCFontWeight: 'normal',
    CCTextShadow: ''
};
Austin.ccDefault = null;
/**
 * APP_EVENTS - events that Application can subscribe to.
 */
Austin.EVENTS = {
    /**
     * This event will be fired when there is a state change in Austin. eg: connecting -> connected
     */
    onStatusChange: 'onStatusChange',
    /**
     * This event will be fired when there is an error occurred in Austin
     */
    onError: 'onError',
    /**
     * This event will be fired when there is an info message available in Austin. eg: stream discontinuity
     */
    onInfo: 'onInfo',
    /**
     * This event will be fired when a box pop-up has to be shown to user.
     * Popup will have type, message, buttons(optional) and input(optional).
     * Buttons will have list of button each having a text, url and a payload.
     * Sample popUp data :
     * <pre>
     * {
     *      'type': 'generic'/'dismiss'/'info'/'landing_page',
     *      'message': 'Your request can only be carried out in Live mode..Switch to live mode now?',
     *      'buttons': [...buttonInfo], //list of buttonInfo, Sample json has been listed below
     *      'input': {
     *          'type': 'text'/'password',
     *          'placeholder': 'placeholder text'
     *          }
     *  }
     *  </pre>
     *
     *   a.) 'generic' is for multiple use cases like when user dvr streaming is about to reach end,
     *  user tries to switch channel in delayedLive mode, user has to enter password for locked channel etc. <br/>
     *   b.) 'dismiss' is for dismissing any active popup. <br/>
     *   c.) 'info' does not have to show any popup. For this a notification can be shown to user if required. <br/>
     *   d.) 'landing_page' show the status to all tuners and giver user option to join any tuner. <br/>
     *
     * For few pop-up event data, input details will be available when user is required to give input like password, channel etc.
     * Once user click on a popup button, popUpUserAction API is called with exactly same button details and user input if required.
     *
     * <br/>Sample json for buttonInfo
     * <pre>
     *     {    text: "START OVER",
     *          url: "START_OVER/rest/v1/receiverid/:_receiverid?correlationid=:_correlationid",
     *          payload: "START_OVER&creator=0" }
     * </pre>
     */
    onPopUp: 'onPopUp',
    /**
     * This event will be fired on Buffering start
     */
    onStallStart: 'onStallStart',
    /**
     * This event will be fired on Buffering complete
     */
    onStallEnd: 'onStallEnd',
    /**
     * This event will be fired on pausing the playback
     */
    onPause: 'onPause',
    /**
     * This event will be fired on starting the streaming playback
     */
    onPlaying: 'onPlaying',
    /**
     * This event will be fired on when Austin is ready to playback
     */
    onReady: 'onReady',
    /**
     * This event will be fired on time progress of the playback
     */
    onTimeUpdate: 'onTimeUpdate',
    /**
     * This event will be fired on connecting Hard Disk to Box
     */
    onHddConnected: 'onHddConnected',
    /**
     * This event will be fired on pairing Hard Disk with Box
     */
    onHddPaired: 'onHddPaired',
    /**
     * this event will be fired on dis-connecting Hard Disk from Box
     */
    onHddDisconnected: 'onHddDisconnected',
    /**
     * This event will be fired when recording is enabled with Hard Disk connected to Box
     */
    onHddRecordingEnabled: 'onHddRecordingEnabled',
    /**
     * This event will be fired when seek is called
     */
    onSeekStarted: 'onSeekStarted',
    /**
     * This event will be fired when seek is success and playback starts
     */
    onSeekEnded: 'onSeekEnded'
};

export default Austin;
export { AustinConstants, AustinErrors, AustinLogger, RenewableTimer };
